webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(379);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__app__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignment_instructions__ = __webpack_require__(405);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__assignment_instructions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assignment_photo__ = __webpack_require__(408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__assignment_photo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assignment__ = __webpack_require__(411);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__assignment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__book__ = __webpack_require__(414);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__book__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bricks__ = __webpack_require__(416);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__bricks__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__button__ = __webpack_require__(420);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__child__ = __webpack_require__(422);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__child__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__design__ = __webpack_require__(424);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__design__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dragzone__ = __webpack_require__(426);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__dragzone__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dropzone__ = __webpack_require__(428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__dropzone__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__favorite_picker_photo__ = __webpack_require__(429);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_11__favorite_picker_photo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__favorite_picker__ = __webpack_require__(431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_12__favorite_picker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__graphic__ = __webpack_require__(433);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_13__graphic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__initializer__ = __webpack_require__(435);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_14__initializer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__loader__ = __webpack_require__(440);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_15__loader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__login__ = __webpack_require__(442);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_16__login__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__logo__ = __webpack_require__(444);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_17__logo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__maker__ = __webpack_require__(446);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_18__maker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__menu_item__ = __webpack_require__(448);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_19__menu_item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__menu__ = __webpack_require__(450);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_20__menu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__moment_edit__ = __webpack_require__(458);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_21__moment_edit__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__moment_photo__ = __webpack_require__(464);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_22__moment_photo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__moment_text__ = __webpack_require__(471);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_23__moment_text__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__moment_warning__ = __webpack_require__(474);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_24__moment_warning__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__moment__ = __webpack_require__(476);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_25__moment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__my_orders__ = __webpack_require__(478);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_26__my_orders__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__notifications__ = __webpack_require__(480);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_27__notifications__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__notification__ = __webpack_require__(482);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_28__notification__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__order__ = __webpack_require__(484);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_29__order__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__order_unfinished__ = __webpack_require__(486);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_30__order_unfinished__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pagination_page__ = __webpack_require__(487);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_31__pagination_page__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pagination__ = __webpack_require__(489);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_32__pagination__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__photo__ = __webpack_require__(493);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_33__photo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__profile__ = __webpack_require__(495);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_34__profile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__reset_password__ = __webpack_require__(497);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_35__reset_password__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__save_success__ = __webpack_require__(499);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_36__save_success__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__sidebar_content__ = __webpack_require__(500);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_37__sidebar_content__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__sidebar__ = __webpack_require__(502);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_38__sidebar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__slider__ = __webpack_require__(504);
/* unused harmony reexport Slider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__spread__ = __webpack_require__(506);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_40__spread__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__widget__ = __webpack_require__(508);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_41__widget__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__giftcard__ = __webpack_require__(510);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_42__giftcard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__spread_extra_buttons__ = __webpack_require__(512);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_43__spread_extra_buttons__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__form__ = __webpack_require__(516);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_44__form__; });
//export { default as PickBook } from './pick-book';
















































/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INITIALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL_INITIALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ACTIVE_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ACTIVE_SPREAD; });
/* harmony export (immutable) */ __webpack_exports__["i"] = reducer;
/* harmony export (immutable) */ __webpack_exports__["f"] = cancelInitialize;
/* harmony export (immutable) */ __webpack_exports__["j"] = initialize;
/* harmony export (immutable) */ __webpack_exports__["p"] = setInitializing;
/* harmony export (immutable) */ __webpack_exports__["u"] = setUIState;
/* harmony export (immutable) */ __webpack_exports__["e"] = activateDropzone;
/* harmony export (immutable) */ __webpack_exports__["h"] = deactivateDropzone;
/* harmony export (immutable) */ __webpack_exports__["n"] = setDragging;
/* harmony export (immutable) */ __webpack_exports__["o"] = setDraggingPreview;
/* harmony export (immutable) */ __webpack_exports__["v"] = updateDimensions;
/* harmony export (immutable) */ __webpack_exports__["k"] = openPicker;
/* harmony export (immutable) */ __webpack_exports__["g"] = closePicker;
/* harmony export (immutable) */ __webpack_exports__["t"] = setSidebar;
/* harmony export (immutable) */ __webpack_exports__["l"] = setActiveOrder;
/* harmony export (immutable) */ __webpack_exports__["m"] = setActiveSpread;
/* harmony export (immutable) */ __webpack_exports__["q"] = setNotification;
/* harmony export (immutable) */ __webpack_exports__["r"] = setOrderValidation;
/* harmony export (immutable) */ __webpack_exports__["s"] = setPreview;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_reducers_user__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_reducers_orders__ = __webpack_require__(15);





var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var SET_UI_STATE = 'kroost/app/SET_UI_STATE';
var DROPZONE_ACTIVATE = 'kroost/app/DROPZONE_ACTIVATE';
var DROPZONE_DEACTIVATE = 'kroost/app/DROPZONE_DEACTIVATE';
var PICKER_ACTIVE = 'kroost/app/PICKER_ACTIVE';
var PICKER_DEACTIVE = 'kroost/app/PICKER_DEACTIVE';
var UPDATE_DIMENSIONS = 'kroost/app/UPDATE_DIMENSIONS';
var SET_SIDEBAR = 'kroost/app/SET_SIDEBAR';
var SET_DRAGGING = 'kroost/app/SET_DRAGGING';
var SET_DRAGGING_PREVIEW = 'kroost/app/SET_DRAGGING_PREVIEW';
var SET_NOTIFICATION = 'kroost/app/SET_NOTIFICATION';
var SET_ORDER_VALIDATION = 'kroost/app/SET_ORDER_VALIDATION';
var SET_PREVIEW = 'kroost/app/SET_PREVIEW';

var INITIALIZE = 'kroost/app/INITIALIZE';
var CANCEL_INITIALIZE = 'kroost/app/CANCEL_INITIALIZE';
var SET_ACTIVE_ORDER = 'kroost/app/SET_ACTIVE_ORDER';
var SET_ACTIVE_SPREAD = 'kroost/app/SET_ACTIVE_SPREAD';

// Initial routing state
var initialState = __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]({
  dimensions: {
    width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
    height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  },
  picker: {
    active: false
  },
  dropzone: {
    active: false
  },
  initializing: true,
  giftcard: null,
  isDragging: false,
  draggingPreview: false,
  activeBookId: null,
  activeOrderId: null,
  activeSpreadIds: {},
  sidebar: 'photos',
  sidebarParams: {},
  notifications: {},
  orderValidation: {},
  ui: {
    initializing: true,
    validating: false
  },
  previews: {}
});

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1_redux_reducers_user__["c" /* LOGOUT */]:
      return state.set('activeOrderId', null);
    case DROPZONE_ACTIVATE:
      return state.setIn(['dropzone', 'active'], true);
    case DROPZONE_DEACTIVATE:
      return state.setIn(['dropzone', 'active'], false);
    case SET_DRAGGING:
      return state.set('isDragging', action.dragging).set('draggingPreview', action.dragging === false ? false : state.get('draggingPreview'));
    case SET_DRAGGING_PREVIEW:
      return state.set('draggingPreview', action.moment);
    case UPDATE_DIMENSIONS:
      return state.mergeIn(['dimensions'], {
        width: action.width,
        height: action.height
      });
    case PICKER_ACTIVE:
      return state.setIn(['picker', 'active'], true);
    case PICKER_DEACTIVE:
      return state.setIn(['picker', 'active'], false);
    case SET_SIDEBAR:
      return state.set('sidebar', action.item).set('sidebarParams', action.params);
    case SET_ACTIVE_ORDER:
      return state.set('activeOrderId', action.id);
    case SET_ACTIVE_SPREAD:
      return state.setIn(['activeSpreadIds', state.get('activeOrderId')], action.spread);
    case __WEBPACK_IMPORTED_MODULE_2_redux_reducers_orders__["g" /* RENAME_ID */]:
      {
        var order = state.getIn(['activeSpreadIds', action.oldId]);

        // Rename active order
        var newState = state.set('activeOrderId', state.get('activeOrderId') === action.oldId ? action.newId : state.get('activeOrderId'));

        if (!order) {
          return newState;
        }

        return newState.deleteIn(['activeSpreadIds', action.oldId]).setIn(['activeSpreadIds', action.newId], order);
      }
    case SET_NOTIFICATION:
      if (action.notification) {
        return state.setIn(['notifications', action.key], action.notification);
      } else {
        return state.deleteIn(['notifications', action.key]);
      }
    case SET_ORDER_VALIDATION:
      return state.setIn(['orderValidation', state.get('activeOrderId'), action.validationType], __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"](action.validation));
    case SET_UI_STATE:
      return state.setIn(['ui', action.name], action.value);
    case SET_PREVIEW:
      return state.setIn(['previews', action.orderId, action.momentId], __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"](action.preview));
    default:
      return state;
  }
}

function cancelInitialize() {
  return {
    type: CANCEL_INITIALIZE
  };
}

function initialize() {
  var bookId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var orderId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var createOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return {
    type: INITIALIZE,
    bookId: bookId,
    orderId: orderId,
    createOrder: createOrder
  };
}

function setInitializing(initializing) {
  return {
    type: SET_UI_STATE,
    name: 'initializing',
    value: initializing
  };
}

function setUIState(name, value) {
  return {
    type: SET_UI_STATE,
    name: name,
    value: value
  };
}

function activateDropzone() {
  return {
    type: DROPZONE_ACTIVATE
  };
}

function deactivateDropzone() {
  return {
    type: DROPZONE_DEACTIVATE
  };
}

function setDragging(dragging) {
  return {
    type: SET_DRAGGING,
    dragging: dragging
  };
}

function setDraggingPreview(moment) {
  return {
    type: SET_DRAGGING_PREVIEW,
    moment: moment
  };
}

function updateDimensions(width, height) {
  return {
    type: UPDATE_DIMENSIONS,
    width: width,
    height: height
  };
}

function openPicker() {
  return {
    type: PICKER_ACTIVE
  };
}

function closePicker() {
  return {
    type: PICKER_DEACTIVE
  };
}

function setSidebar(item) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: SET_SIDEBAR,
    item: item,
    params: params
  };
}

function setActiveOrder(id) {
  return {
    type: SET_ACTIVE_ORDER,
    id: id
  };
}

function setActiveSpread(spread) {
  return {
    type: SET_ACTIVE_SPREAD,
    spread: spread
  };
}

function setNotification(key, notification) {
  return {
    type: SET_NOTIFICATION,
    key: key,
    notification: notification
  };
}

function setOrderValidation(validationType, validation) {
  return {
    type: SET_ORDER_VALIDATION,
    validationType: validationType,
    validation: validation
  };
}

function setPreview(orderId, momentId, preview) {
  return {
    type: SET_PREVIEW,
    orderId: orderId,
    momentId: momentId,
    preview: preview
  };
}

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectLocationState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getActiveOrderId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getActiveSpreadId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getActiveSpreadName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getActiveBookId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getOrderValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isUploading; });
/* unused harmony export getSidebar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return forcedSidebar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_selectors_books__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_selectors_orders__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_selectors_user__ = __webpack_require__(25);







var selectLocationState = function selectLocationState() {
  var prevRoutingState = void 0;
  var prevRoutingStateJS = void 0;

  return function (state) {
    var routingState = state.get('route'); // or state.route

    if (!routingState.equals(prevRoutingState)) {
      prevRoutingState = routingState;
      prevRoutingStateJS = routingState.toJS();
    }

    return prevRoutingStateJS;
  };
};

var getActiveOrderId = function getActiveOrderId(state) {
  return state.getIn(['app', 'activeOrderId'], null);
};
var getActiveSpreadId = function getActiveSpreadId(state) {
  var firstSpread = __WEBPACK_IMPORTED_MODULE_2_redux_selectors_books__["d" /* getCurrentBookSpreads */](state).getIn([0, 'id']);
  return state.getIn(['app', 'activeSpreadIds', getActiveOrderId(state)]) || firstSpread;
};
var getActiveSpreadName = function getActiveSpreadName(state) {
  var book = __WEBPACK_IMPORTED_MODULE_2_redux_selectors_books__["b" /* getCurrentBook */](state);
  var activeSpreadId = getActiveSpreadId(state);
  var spread = book.get('spreads').find(function (spread) {
    return spread.get('id') === activeSpreadId;
  });

  return spread.get('label');
};
var getActiveBookId = function getActiveBookId(state) {
  return state.getIn(['orders', getActiveOrderId(state), 'book'], null);
};

var getOrderValidation = function getOrderValidation(state) {
  return state.getIn(['app', 'orderValidation', getActiveOrderId(state)], __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]());
};

var isUploading = function isUploading(state) {
  return state.getIn(['app', 'ui', 'is_uploading'], false);
};

var getSidebar = function getSidebar(state) {
  return state.getIn(['app', 'sidebar']);
};

var forcedSidebar = __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([getSidebar, getActiveOrderId, __WEBPACK_IMPORTED_MODULE_3_redux_selectors_orders__["a" /* canEdit */], __WEBPACK_IMPORTED_MODULE_4_redux_selectors_user__["c" /* isAuthenticated */], __WEBPACK_IMPORTED_MODULE_3_redux_selectors_orders__["g" /* getChildName */], __WEBPACK_IMPORTED_MODULE_3_redux_selectors_orders__["e" /* getChildBirthday */]], function (sidebar, orderId, canEdit, authenticated, name, birthday) {
  if (orderId && (!sidebar || sidebar === 'photos') && !canEdit) {
    sidebar = 'order';
  } else if (!orderId && (!sidebar || sidebar === 'photos')) {
    sidebar = 'myOrders';
  } else if (orderId && canEdit && (!name || !birthday)) {
    sidebar = sidebar === 'saveSuccess' ? sidebar : 'child';
  }

  if (sidebar === 'login' && authenticated) {
    sidebar = 'profile';
  } else if (sidebar === 'profile' && !authenticated) {
    sidebar = 'login';
  }

  return sidebar || 'photos';
});

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REGISTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOGOUT; });
/* unused harmony export SET_TOKEN */
/* unused harmony export UPDATE_CHILDREN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_CHILD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPDATE_PROFILE; });
/* unused harmony export UPDATE_ANALYTICS_PROFILE */
/* unused harmony export FAILED_LOGIN */
/* unused harmony export FAILED_REGISTER */
/* unused harmony export FAILED_PASSWORD_RESET */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REQUEST_RESET_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RESET_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TRACK_EVENT; });
/* harmony export (immutable) */ __webpack_exports__["l"] = reducer;
/* harmony export (immutable) */ __webpack_exports__["p"] = login;
/* harmony export (immutable) */ __webpack_exports__["r"] = register;
/* harmony export (immutable) */ __webpack_exports__["s"] = requestResetPassword;
/* harmony export (immutable) */ __webpack_exports__["t"] = resetPassword;
/* harmony export (immutable) */ __webpack_exports__["q"] = logout;
/* harmony export (immutable) */ __webpack_exports__["u"] = setAuthToken;
/* harmony export (immutable) */ __webpack_exports__["j"] = clearAuthToken;
/* harmony export (immutable) */ __webpack_exports__["x"] = updateProfile;
/* harmony export (immutable) */ __webpack_exports__["w"] = updateChildren;
/* harmony export (immutable) */ __webpack_exports__["i"] = addChild;
/* unused harmony export updateAnalyticsProfile */
/* harmony export (immutable) */ __webpack_exports__["k"] = clearProfile;
/* harmony export (immutable) */ __webpack_exports__["m"] = failedLogin;
/* harmony export (immutable) */ __webpack_exports__["o"] = failedRegister;
/* harmony export (immutable) */ __webpack_exports__["n"] = failedPasswordReset;
/* harmony export (immutable) */ __webpack_exports__["v"] = trackEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var LOGIN = 'kroost/user/LOGIN';
var REGISTER = 'kroost/user/REGISTER';
var LOGOUT = 'kroost/user/LOGOUT';
var SET_TOKEN = 'kroost/user/SET_TOKEN';
var UPDATE_CHILDREN = 'kroost/user/UPDATE_CHILDREN';
var ADD_CHILD = 'kroost/user/ADD_CHILD';
var UPDATE_PROFILE = 'kroost/user/UPDATE_PROFILE';
var UPDATE_ANALYTICS_PROFILE = 'kroost/user/UPDATE_ANALYTICS_PROFILE';
var FAILED_LOGIN = 'kroost/user/FAILED_LOGIN';
var FAILED_REGISTER = 'kroost/user/FAILED_REGISTER';
var FAILED_PASSWORD_RESET = 'kroost/user/FAILED_PASSWORD_RESET';
var REQUEST_RESET_PASSWORD = 'kroost/user/REQUEST_RESET_PASSWORD';
var RESET_PASSWORD = 'kroost/user/RESET_PASSWORD';
var TRACK_EVENT = 'kroost/user/TRACK_EVENT';

// Initial routing state
var initialState = __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]({
  token: null,
  profile: null,
  children: null,
  loading: false,
  failedLogin: null,
  failedRegister: null,
  failedPasswordReset: false
});

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case SET_TOKEN:
      return state.set('token', action.token || null).set('loading', false).set('failedLogin', false).set('failedRegister', false).set('failedPasswordReset', false);
    case REGISTER:
      return state.set('loading', true);
    case UPDATE_PROFILE:
      return state.set('profile', action.profile ? __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"](action.profile) : null);
    case UPDATE_CHILDREN:
      return state.set('children', action.children ? __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"](action.children) : null);
    case FAILED_LOGIN:
      return state.set('failedLogin', action.code || null);
    case FAILED_REGISTER:
      return state.set('failedRegister', action.code || null);
    case FAILED_PASSWORD_RESET:
      return state.set('failedPasswordReset', true);
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
}

function login(email, password) {
  return {
    type: LOGIN,
    email: email,
    password: password
  };
}

function register(first_name, email, password) {
  var successScreen = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'myOrders';

  return {
    type: REGISTER,
    first_name: first_name,
    email: email,
    password: password,
    successScreen: successScreen
  };
}

function requestResetPassword(email) {
  return {
    type: REQUEST_RESET_PASSWORD,
    email: email
  };
}

function resetPassword(user_id, token, password) {
  return {
    type: RESET_PASSWORD,
    user_id: user_id,
    token: token,
    password: password
  };
}

function logout() {
  return {
    type: LOGOUT
  };
}

function setAuthToken(token) {
  return {
    type: SET_TOKEN,
    token: token
  };
}

function clearAuthToken() {
  return {
    type: SET_TOKEN
  };
}

function updateProfile(profile) {
  return {
    type: UPDATE_PROFILE,
    profile: profile
  };
}

function updateChildren(children) {
  return {
    type: UPDATE_CHILDREN,
    children: children
  };
}

function addChild(name, birthday) {
  return {
    type: ADD_CHILD,
    name: name,
    birthday: birthday
  };
}

function updateAnalyticsProfile() {
  return {
    type: UPDATE_ANALYTICS_PROFILE
  };
}

function clearProfile() {
  return {
    type: UPDATE_PROFILE
  };
}

function failedLogin(code) {
  return {
    type: FAILED_LOGIN,
    code: code
  };
}

function failedRegister(code) {
  return {
    type: FAILED_REGISTER,
    code: code
  };
}

function failedPasswordReset() {
  return {
    type: FAILED_PASSWORD_RESET
  };
}

function trackEvent(event, data) {
  return {
    type: TRACK_EVENT,
    event: event,
    data: data
  };
}

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_ORDERS; });
/* unused harmony export CREATE_ORDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RENAME_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return START_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return START_PAYMENT_RENEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPDATE_TRANSFORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PICK_MOMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FINISH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ENABLE_EXTRA_SPREAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISABLE_EXTRA_SPREAD; });
/* harmony export (immutable) */ __webpack_exports__["q"] = reducer;
/* harmony export (immutable) */ __webpack_exports__["y"] = setAll;
/* harmony export (immutable) */ __webpack_exports__["o"] = add;
/* harmony export (immutable) */ __webpack_exports__["u"] = getOrders;
/* harmony export (immutable) */ __webpack_exports__["p"] = createOrder;
/* harmony export (immutable) */ __webpack_exports__["w"] = renameId;
/* harmony export (immutable) */ __webpack_exports__["z"] = setOption;
/* harmony export (immutable) */ __webpack_exports__["x"] = save;
/* harmony export (immutable) */ __webpack_exports__["A"] = startPayment;
/* harmony export (immutable) */ __webpack_exports__["t"] = finish;
/* harmony export (immutable) */ __webpack_exports__["B"] = startPaymentRenew;
/* harmony export (immutable) */ __webpack_exports__["v"] = pickMoment;
/* harmony export (immutable) */ __webpack_exports__["D"] = updateTransform;
/* harmony export (immutable) */ __webpack_exports__["C"] = updateText;
/* harmony export (immutable) */ __webpack_exports__["s"] = enableExtraSpread;
/* harmony export (immutable) */ __webpack_exports__["r"] = disableExtraSpread;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_reducers_photos__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_reducers_user__ = __webpack_require__(14);





var SAVE = 'kroost/orders/SAVE';
var SET_ORDERS = 'kroost/orders/SET_ORDERS';
var GET_ORDERS = 'kroost/orders/GET_ORDERS';
var CREATE_ORDER = 'kroost/orders/CREATE_ORDER';
var RENAME_ID = 'kroost/orders/RENAME_ID';
var ADD_ORDER = 'kroost/orders/ADD_ORDER';
var SET_OPTION = 'kroost/orders/SET_OPTION';
var START_PAYMENT = 'kroost/orders/START_PAYMENT';
var START_PAYMENT_RENEW = 'kroost/orders/START_PAYMENT_RENEW';
var UPDATE_TRANSFORM = 'kroost/orders/UPDATE_TRANSFORM';
var UPDATE_TEXT = 'kroost/orders/UPDATE_TEXT';
var PICK_MOMENT = 'kroost/orders/PICK_MOMENT';
var FINISH = 'kroost/orders/FINISH';
var ENABLE_EXTRA_SPREAD = 'kroost/orders/ENABLE_EXTRA_SPREAD';
var DISABLE_EXTRA_SPREAD = 'kroost/orders/DISABLE_EXTRA_SPREAD';

// Initial routing state
var initialState = __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]({});

var initialTransform = __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]({
  width: 1,
  x: 0,
  y: 0
});

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case SET_ORDERS:
      return state.merge(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"](action.orders));
    case ADD_ORDER:
      return state.set(action.id, __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"](action.order));
    case RENAME_ID:
      {
        var order = state.get(action.oldId);

        if (!order) {
          return state;
        }

        return state.delete(action.oldId).set(action.newId, order.delete('local'));
      }
    case SET_OPTION:
      {
        var path = [action.orderId, action.option];
        if (Array.isArray(action.option)) {
          path = [action.orderId].concat(action.option);
        }
        return state.setIn(path, action.value);
      }

    /**
     * Photo edits
     */
    case __WEBPACK_IMPORTED_MODULE_1_redux_reducers_photos__["e" /* TOGGLE_SAVED */]:
    case __WEBPACK_IMPORTED_MODULE_1_redux_reducers_photos__["d" /* TOGGLE_FAVORITE */]:
      {
        var _path = action.type === __WEBPACK_IMPORTED_MODULE_1_redux_reducers_photos__["e" /* TOGGLE_SAVED */] ? [action.orderId, 'saved'] : [action.orderId, 'favorites', action.currentSpread];
        return state.updateIn(_path, __WEBPACK_IMPORTED_MODULE_0_immutable__["List"](), function (saved) {
          var index = saved.findIndex(function (savedSimpleId) {
            return savedSimpleId === action.simpleId;
          });
          return index === -1 ? saved.push(action.simpleId) : saved.delete(index);
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1_redux_reducers_photos__["c" /* SET_UPLOAD */]:
      return state.setIn([action.orderId, 'uploads', action.simpleId], __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"](action.upload));

    /**
     * Moment edits
     */
    case PICK_MOMENT:
      return state.setIn([action.orderId, 'picked', action.momentId], __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]({
        simpleId: action.simpleId,
        transform: initialTransform
      }));
    case UPDATE_TRANSFORM:
      return state.mergeIn([action.orderId, 'picked', action.momentId, 'transform'], __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"](action.transform));
    case UPDATE_TEXT:
      if (action.text === null) {
        return state.deleteIn([action.orderId, 'picked', action.momentId]);
      } else {
        return state.setIn([action.orderId, 'picked', action.momentId, 'text'], action.text);
      }

    /**
     * Extra spreads
     */
    case ENABLE_EXTRA_SPREAD:
      return state.updateIn([action.orderId, 'extra_spreads'], __WEBPACK_IMPORTED_MODULE_0_immutable__["List"](), function (extras) {
        return extras.indexOf(action.spreadId) === -1 ? extras.push(action.spreadId) : extras;
      });
    case DISABLE_EXTRA_SPREAD:
      return state.updateIn([action.orderId, 'extra_spreads'], __WEBPACK_IMPORTED_MODULE_0_immutable__["List"](), function (extras) {
        return extras.filter(function (spreadId) {
          return spreadId !== action.spreadId;
        });
      });
    case __WEBPACK_IMPORTED_MODULE_2_redux_reducers_user__["c" /* LOGOUT */]:
      return __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]({});
    default:
      return state;
  }
}

function setAll(orders) {
  return {
    type: SET_ORDERS,
    orders: orders
  };
}

function add(id, order) {
  return {
    type: ADD_ORDER,
    id: id,
    order: order
  };
}

function getOrders() {
  return {
    type: GET_ORDERS
  };
}

function createOrder(_ref) {
  var _ref$book = _ref.book,
      book = _ref$book === undefined ? null : _ref$book,
      _ref$name = _ref.name,
      name = _ref$name === undefined ? '' : _ref$name,
      _ref$birthday = _ref.birthday,
      birthday = _ref$birthday === undefined ? '' : _ref$birthday,
      _ref$onlyWhenEmpty = _ref.onlyWhenEmpty,
      onlyWhenEmpty = _ref$onlyWhenEmpty === undefined ? false : _ref$onlyWhenEmpty,
      _ref$redirect = _ref.redirect,
      redirect = _ref$redirect === undefined ? false : _ref$redirect,
      _ref$pushHistory = _ref.pushHistory,
      pushHistory = _ref$pushHistory === undefined ? true : _ref$pushHistory;

  return {
    type: CREATE_ORDER,
    book: book,
    name: name,
    birthday: birthday,
    onlyWhenEmpty: onlyWhenEmpty,
    redirect: redirect,
    pushHistory: pushHistory
  };
}

function renameId(oldId, newId) {
  return {
    type: RENAME_ID,
    oldId: oldId,
    newId: newId
  };
}

function setOption(orderId, option, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  return {
    type: SET_OPTION,
    orderId: orderId,
    option: option,
    value: value,
    options: options
  };
}

function save() {
  return {
    type: SAVE
  };
}

function startPayment(orderId) {
  return {
    type: START_PAYMENT,
    orderId: orderId
  };
}

function finish(orderId) {
  return {
    type: FINISH,
    orderId: orderId
  };
}

function startPaymentRenew(orderId) {
  return {
    type: START_PAYMENT_RENEW,
    orderId: orderId
  };
}

function pickMoment(orderId, momentId, simpleId) {
  return {
    type: PICK_MOMENT,
    orderId: orderId,
    momentId: momentId,
    simpleId: simpleId
  };
}

function updateTransform(orderId, momentId, transform) {
  return {
    type: UPDATE_TRANSFORM,
    orderId: orderId,
    momentId: momentId,
    transform: transform
  };
}

function updateText(orderId, momentId, text) {
  return {
    type: UPDATE_TEXT,
    orderId: orderId,
    momentId: momentId,
    text: text
  };
}

function enableExtraSpread(orderId, spreadId) {
  return {
    type: ENABLE_EXTRA_SPREAD,
    orderId: orderId,
    spreadId: spreadId
  };
}

function disableExtraSpread(orderId, spreadId) {
  return {
    type: DISABLE_EXTRA_SPREAD,
    orderId: orderId,
    spreadId: spreadId
  };
}

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getOrderToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getOrderUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getExtraSpreadIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAmount; });
/* unused harmony export getTerms */
/* unused harmony export getBookId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getChildBirthday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getChildName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getChildId; });
/* unused harmony export getOrderState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getOrderStateMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isWaitingForPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canRenewPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isWaitingForOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isWithGiftcard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_selectors_app__ = __webpack_require__(10);





var ALLOWED_EDIT = ['creating'];
var PAYMENT_WAITING = ['payment_waiting'];
var ALLOWED_RENEW_PAYMENT = ['payment_failed'];
var WAITING_FOR_ORDER = ['payment_success', 'shipping_waiting', 'shipping_send', 'shipping_received', 'refund'];

var STATE_MESSAGE = {
  payment_waiting: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    kroostApp.strings.paymentWaitingMessage
  ),
  payment_failed: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    kroostApp.strings.paymentFailedMessage
  ),
  payment_success: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    kroostApp.strings.paymentSuccessMessagePart1,
    ' ',
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    kroostApp.strings.greetings,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    kroostApp.strings.teamKroost
  ),
  shipping_waiting: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    kroostApp.strings.paymentSuccessMessagePart1,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    kroostApp.strings.greetings,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    kroostApp.strings.teamKroost
  ),
  shipping_send: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    kroostApp.strings.shippingSendMessagePart1,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    kroostApp.strings.greetings,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    kroostApp.strings.teamKroost
  ),
  shipping_received: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    kroostApp.strings.shippingReceivedMessage,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    kroostApp.strings.greetings,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    kroostApp.strings.teamKroost
  )
};

var getOrder = function getOrder(state) {
  return state.getIn(['orders', __WEBPACK_IMPORTED_MODULE_2_redux_selectors_app__["c" /* getActiveOrderId */](state)], __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]());
};
var getOrderToken = function getOrderToken(state) {
  return getOrder(state).get('token', null);
};
var getOrderUser = function getOrderUser(state) {
  return getOrder(state).get('user', null);
};
var getExtraSpreadIds = function getExtraSpreadIds(state) {
  return getOrder(state).get('extra_spreads', []);
};

var getAddress = function getAddress(state) {
  return getOrder(state).get('address', __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]());
};
var getAmount = function getAmount(state) {
  var amount = getOrder(state).get('amount', 1);
  return amount > 0 ? amount : 1;
};
var getTerms = function getTerms(state) {
  return getOrder(state).get('terms', false);
};

var getBookId = function getBookId(state) {
  return getOrder(state).getIn(['book']);
};
var getChildBirthday = function getChildBirthday(state) {
  return getOrder(state).getIn(['child', 'birthday']);
};
var getChildName = function getChildName(state) {
  return getOrder(state).getIn(['child', 'name']);
};
var getChildId = function getChildId(state) {
  return getOrder(state).getIn(['child', 'id']);
};

var getOrderState = function getOrderState(state) {
  return getOrder(state).get('state', 'creating');
};
var getOrderStateMessage = function getOrderStateMessage(state) {
  return STATE_MESSAGE[getOrder(state).get('state', 'creating')] || null;
};
var canEdit = function canEdit(state) {
  return ALLOWED_EDIT.indexOf(getOrder(state).get('state')) > -1;
};
var isWaitingForPayment = function isWaitingForPayment(state) {
  return PAYMENT_WAITING.indexOf(getOrder(state).get('state')) > -1;
};
var canRenewPayment = function canRenewPayment(state) {
  return ALLOWED_RENEW_PAYMENT.indexOf(getOrder(state).get('state')) > -1;
};
var isWaitingForOrder = function isWaitingForOrder(state) {
  return WAITING_FOR_ORDER.indexOf(getOrder(state).get('state')) > -1;
};
var isWithGiftcard = function isWithGiftcard(state) {
  return getOrder(state).get('giftcard');
};

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAllBooks */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentBook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getYearOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getPrintType; });
/* unused harmony export isCalendar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCurrentBookSpreads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentBookDesigns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getSpreadInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAvailableMoments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getExtraSpreadIdAfter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isExtraSpread; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_toDate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_toDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_toDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_selectors_orders__ = __webpack_require__(17);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var getAllBooks = function getAllBooks(state) {
  return state.get('books', __WEBPACK_IMPORTED_MODULE_1_immutable__["List"]());
};
var getSpreadId = function getSpreadId(state, spreadId) {
  return spreadId || __WEBPACK_IMPORTED_MODULE_3_redux_selectors_app__["d" /* getActiveSpreadId */](state);
};
var getWithExtras = function getWithExtras(state, withExtras) {
  return withExtras || false;
};

var getCurrentBook = __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([getAllBooks, __WEBPACK_IMPORTED_MODULE_3_redux_selectors_app__["b" /* getActiveBookId */]], function (books, bookId) {
  return books && books.find && books.find(function (book) {
    return book.get('id') === bookId;
  }) || __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]();
});

var getYearOffset = __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([getCurrentBook], function (book) {
  return book.get('calendar_year_offset', 0);
});

var getPrintType = function getPrintType(state) {
  return getCurrentBook(state).get('print_type') || 'book';
};

var isCalendar = function isCalendar(book) {
  return book.get('book_type') === 'calendar';
};

var getCurrentBookSpreads = __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([getCurrentBook, __WEBPACK_IMPORTED_MODULE_4_redux_selectors_orders__["h" /* getExtraSpreadIds */], __WEBPACK_IMPORTED_MODULE_4_redux_selectors_orders__["e" /* getChildBirthday */], getWithExtras, getYearOffset], function (book, extraSpreadIds, childBirthday, withExtras, yearOffset) {
  var spreads = book.get('spreads', __WEBPACK_IMPORTED_MODULE_1_immutable__["List"]());

  if (isCalendar(book)) {
    var groupedSpreads = book.get('spreads').toJS().reduce(function (carry, spread) {
      if (spread.month > -1) {
        if (spread.month === 0) {
          carry.calendarStartIndex = carry.normal.length - 1;
        }

        if (!(spread.month in carry.months)) {
          carry.months[spread.month] = [];
        }

        carry.months[spread.month].push(spread);
      } else {
        carry.normal.push(spread);
      }

      return carry;
    }, {
      calendarStartIndex: 0,
      normal: [],
      months: []
    });

    var birthday = childBirthday ? __WEBPACK_IMPORTED_MODULE_2_date_fns_toDate___default.a(childBirthday) : new Date();

    var birthdayMonth = new Date(birthday.getFullYear(), birthday.getMonth());

    var end = groupedSpreads.months.slice(0, birthday.getMonth());
    var beginning = groupedSpreads.months.slice(birthday.getMonth());

    var monthSpreads = beginning.concat(end, [beginning[0]]).reduce(function (carry, monthSpreads, monthIndex) {
      var monthDate = new Date(birthdayMonth);
      monthDate.setFullYear(birthdayMonth.getFullYear() + yearOffset);
      monthDate.setMonth(birthdayMonth.getMonth() + monthIndex);

      var year = monthDate.getFullYear();

      carry.push.apply(carry, monthSpreads.map(function (monthSpread, monthSpreadIndex) {
        return _extends({}, monthSpread, {
          monthIndex: monthIndex,
          monthSpreadIndex: monthSpreadIndex,
          actualId: monthSpread.id,
          id: monthSpread.id + '.' + year,
          label: monthSpread.label + ' (' + year + ')',
          isMonthSpread: true,
          spreadDate: monthDate,
          moments: monthSpread.moments.map(function (moment) {
            return _extends({}, moment, {
              id: moment.id + '.' + year
            });
          })
        });
      }));

      return carry;
    }, []);

    var spreadsStart = groupedSpreads.normal.slice(0, groupedSpreads.calendarStartIndex + 1);
    var spreadsEnd = groupedSpreads.normal.slice(groupedSpreads.calendarStartIndex + 1);

    spreads = __WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"](spreadsStart.concat(monthSpreads, spreadsEnd));
  }

  return withExtras ? spreads : spreads.filter(function (spread) {
    return spread.get('type') === 'default' || extraSpreadIds.indexOf(spread.get('id')) > -1;
  });
});

var getCurrentBookSpreadsWithExtras = function getCurrentBookSpreadsWithExtras(state) {
  return getCurrentBookSpreads(state, true);
};

var getCurrentBookDesigns = __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([getCurrentBook], function (book) {
  return book.get('designs', __WEBPACK_IMPORTED_MODULE_1_immutable__["List"]());
});

var getSpreadInfo = __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([getCurrentBookSpreads, getSpreadId], function (spreads, spreadId) {
  return spreads.find(function (spread) {
    return spread.get('id') === spreadId;
  }) || __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]();
});

var getAvailableMoments = __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([getCurrentBookSpreads, getSpreadId], function (spreads, spreadId) {
  var spread = spreads.find(function (spread) {
    return spread.get('id') === spreadId;
  }) || __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]();
  var moments = spread.get('moments', __WEBPACK_IMPORTED_MODULE_1_immutable__["List"]()); //.filter(moment => moment.get('type') === 'photo');

  return moments;
});

var getExtraSpreadIdAfter = __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([getCurrentBookSpreadsWithExtras, getSpreadId, __WEBPACK_IMPORTED_MODULE_4_redux_selectors_orders__["h" /* getExtraSpreadIds */]], function (spreads, spreadId, extraSpreadIds) {
  var currentSpreadIndex = spreads.findIndex(function (spread) {
    return spread.get('id') === spreadId;
  });
  var nextSpread = spreads.get(currentSpreadIndex + 1);
  var alreadyUsed = nextSpread ? extraSpreadIds.indexOf(nextSpread.get('id')) > -1 : false;

  return !alreadyUsed && nextSpread && nextSpread.get('type') === 'extra' ? nextSpread.get('id') : null;
});

var isExtraSpread = __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([getCurrentBookSpreads, getSpreadId], function (spreads, spreadId) {
  var currentSpread = spreads.find(function (spread) {
    return spread.get('id') === spreadId;
  });
  return currentSpread && currentSpread.get('type') === 'extra';
});

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getToken */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isAuthenticated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getChildren; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var getToken = function getToken(state) {
  return state.getIn(['user', 'token'], null);
};
var getProfile = function getProfile(state) {
  return state.getIn(['user', 'profile'], null);
};

var isAuthenticated = __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([getToken], function (token) {
  return token !== null;
});

var getChildren = function getChildren(state) {
  return state.getIn(['user', 'children'], []);
};

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = uploadUrl;
/* unused harmony export request */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_helpers_auth__ = __webpack_require__(90);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var isSet = function isSet(value) {
  return value !== null && typeof value !== 'undefined';
};

var queryParams = function queryParams(params) {
  return Object.keys(params).map(function (k) {
    return isSet(params[k]) ? encodeURIComponent(k) + '=' + encodeURIComponent(params[k]) : null;
  }).filter(function (value) {
    return value !== null;
  }).join('&');
};

var REMOVE_SLASHES = /^\/|\/$/g;
var removeSlashes = function removeSlashes(string) {
  return string.replace(REMOVE_SLASHES, '');
};

function uploadUrl(orderUID, uploadUID, token, user) {
  return API_HOST + 'media/get/' + orderUID + '/' + uploadUID + '?token=' + token + '&user=' + user;
}

function request(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // Body
  if (options && options.body) {
    options.method = options.method || 'POST';

    var body = options.body;
    options.body = new FormData();
    Object.keys(body).forEach(function (key) {
      if (isSet(body[key])) {
        options.body.append(key, body[key]);
      }
    });
  }

  if (options.params) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + queryParams(options.params);
    delete options.params;
  }

  // p('Requesting: ', url, options.params);
  return fetch(url, options).then(function (response) {
    if (!response.ok) {
      throw response.status;
    }

    return response.json();
  }).catch(function (error) {
    return Promise.reject(error);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (function (endpoint) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var doAuth = options.auth === true;

  var url = API_HOST;
  url += removeSlashes(endpoint);

  // Set useragent
  options.headers = _extends({}, options.headers || {});

  // Do everything through Auth if available
  if (doAuth) {
    var accessToken = __WEBPACK_IMPORTED_MODULE_0_helpers_auth__["b" /* getToken */]();
    options.headers.Authorization = 'Bearer ' + accessToken;
  }

  return request(url, options);
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD; });
/* unused harmony export FILTER */
/* unused harmony export SET_ALL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_EXIF_TEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TOGGLE_SAVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TOGGLE_FAVORITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATE_PREVIEW; });
/* harmony export (immutable) */ __webpack_exports__["h"] = reducer;
/* harmony export (immutable) */ __webpack_exports__["g"] = add;
/* unused harmony export addTestPhotos */
/* harmony export (immutable) */ __webpack_exports__["i"] = setAll;
/* unused harmony export filter */
/* harmony export (immutable) */ __webpack_exports__["l"] = toggleSaved;
/* harmony export (immutable) */ __webpack_exports__["k"] = toggleFavorite;
/* harmony export (immutable) */ __webpack_exports__["j"] = setUpload;
/* harmony export (immutable) */ __webpack_exports__["m"] = updatePreview;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_reducers_orders__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__(14);





var ADD = 'kroost/photos/ADD';
var FILTER = 'kroost/photos/FILTER';
var SET_ALL = 'kroost/photos/SET_ALL';
var ADD_EXIF_TEST = 'kroost/photos/ADD_EXIF_TEST';

var SET_UPLOAD = 'kroost/photos/SET_UPLOAD';
var TOGGLE_SAVED = 'kroost/photos/TOGGLE_SAVED';
var TOGGLE_FAVORITE = 'kroost/photos/TOGGLE_FAVORITE';
var UPDATE_PREVIEW = 'kroost/photos/UPDATE_PREVIEW';

// Initial routing state
var initialState = __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]({});

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case SET_ALL:
      return state.update(action.orderId, __WEBPACK_IMPORTED_MODULE_0_immutable__["List"](), function (photos) {
        return photos.concat(action.photos).groupBy(function (x) {
          return x.get('simpleId');
        }).map(function (x) {
          return x.first();
        }).toList();
      });
    case __WEBPACK_IMPORTED_MODULE_1_redux_reducers_orders__["g" /* RENAME_ID */]:
      {
        var photos = state.get(action.oldId);

        if (!photos) {
          return state;
        }

        return state.delete(action.oldId).set(action.newId, photos);
      }
    case __WEBPACK_IMPORTED_MODULE_2__user__["c" /* LOGOUT */]:
      return __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]({});
    default:
      return state;
  }
}

function add(photos) {
  return {
    type: ADD,
    photos: photos
  };
}

function addTestPhotos(items) {
  return {
    type: ADD_EXIF_TEST,
    items: items
  };
}

function setAll(orderId, photos) {
  return {
    type: SET_ALL,
    orderId: orderId,
    photos: photos
  };
}

function filter() {
  return {
    type: FILTER
  };
}

function toggleSaved(orderId, simpleId) {
  return {
    type: TOGGLE_SAVED,
    orderId: orderId,
    simpleId: simpleId
  };
}

function toggleFavorite(orderId, currentSpread, simpleId) {
  return {
    type: TOGGLE_FAVORITE,
    orderId: orderId,
    currentSpread: currentSpread,
    simpleId: simpleId
  };
}

function setUpload(orderId, simpleId, upload) {
  return {
    type: SET_UPLOAD,
    orderId: orderId,
    simpleId: simpleId,
    upload: upload
  };
}

function updatePreview(orderId, momentId) {
  return {
    type: UPDATE_PREVIEW,
    orderId: orderId,
    momentId: momentId
  };
}

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentDesign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDesigns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSpreadDimensions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDesignSpreads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSpreadDesign; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_selectors_orders__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__books__ = __webpack_require__(18);







var getCurrentDesign = function getCurrentDesign(state) {
  return __WEBPACK_IMPORTED_MODULE_3_redux_selectors_orders__["i" /* getOrder */](state).get('design', null);
};

var getDesigns = function getDesigns(state) {
  return state.get('designs', __WEBPACK_IMPORTED_MODULE_1_immutable__["List"]());
};

var getSpreadDimensions = __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([getCurrentDesign, getDesigns], function (designId, designs) {
  var design = designs.find(function (design) {
    return design.get('id') === designId;
  });
  return (design ? design.get('spread') : null) || __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]();
});

var getDesignSpreads = __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([getCurrentDesign, getDesigns, __WEBPACK_IMPORTED_MODULE_4__books__["d" /* getCurrentBookSpreads */]], function (designId, designs, bookSpreads) {
  var design = designs.find(function (design) {
    return design.get('id') === designId;
  });

  if (design) {
    return __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"](bookSpreads.map(function (bookSpread) {
      var spread = design.getIn(['spreads', bookSpread.get('actualId')]);

      if (spread) {
        var newMoments = spread.get('moments').map(function (moment) {
          return moment.set('id', moment.get('id') + '.' + bookSpread.get('spreadDate').getFullYear());
        });

        return [bookSpread.get('id'), spread.set('moments', newMoments)];
      }

      return [bookSpread.get('id'), design.getIn(['spreads', bookSpread.get('id')])];
    }).filter(function (spread) {
      return spread;
    }));
  }

  return __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]();
});

var getSpreadDesign = __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([getDesignSpreads, __WEBPACK_IMPORTED_MODULE_2_redux_selectors_app__["d" /* getActiveSpreadId */]], function (designSpreads, spreadId) {
  return designSpreads.get(spreadId, __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]());
});

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dashToCamelCase */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return randomString; });
/* unused harmony export prefixed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return stringToCSSObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return transformWithPrefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return specialText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_helpers_time__ = __webpack_require__(56);


var vendorSpecificProperties = ['animation', 'animationDelay', 'animationDirection', 'animationDuration', 'animationFillMode', 'animationIterationCount', 'animationName', 'animationPlayState', 'animationTimingFunction', 'transform', 'transformOrigin', 'transformStyle', 'transition', 'transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction'];

var prefix = function () {
  var styles = window.getComputedStyle(document.documentElement);

  var prefixString = Array.prototype.slice.call(styles).join('');
  var standardPrefixString = prefixString.match(/-(moz|webkit|ms)-/);
  var operaPrefixString = prefixString.match(styles.OLink === '' && ['', 'o']);
  var prefixMatch = standardPrefixString || operaPrefixString;

  var prefix = prefixMatch ? prefixMatch[1] : '';

  if (prefix !== 'ms') {
    prefix = '' + prefix.charAt(0).toUpperCase() + prefix.slice(1);
  }

  return prefix || '';
}();

var STRING_TO_CAMEL = /-([a-z])/g;
var dashToCamelCase = function dashToCamelCase(s) {
  return s.replace(STRING_TO_CAMEL, function (g) {
    return g[1].toUpperCase();
  });
};

var randomString = function randomString() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  return (Math.random().toString(36).substring(2, 2 + length) + '0'.repeat(length)).substring(0, length);
};

var prefixed = function prefixed(key) {
  if (vendorSpecificProperties.indexOf(key) > -1) {
    return prefix + key[0].toUpperCase() + key.substr(1);
  }

  return key;
};

var stringToCSSObject = function stringToCSSObject(string) {
  var style = {};

  try {
    var css = string.split('\n');
    css.forEach(function (value) {
      if (value) {
        var _value$split = value.split(':'),
            k = _value$split[0],
            v = _value$split[1];

        var key = prefixed(dashToCamelCase(k));

        style[key] = v.replace(';', '');
      }
    });
  } catch (e) {
    pe(e, '"' + string + '" could not be converted to CSS');
  }

  return style;
};

var transformWithPrefix = prefix ? prefix + 'Transform' : 'transform';

var specialText = function specialText(text, name, birthday, options) {
  var placeholder = options.get('placeholder_text');
  var specialType = options.getIn(['special_text', 'special_text'], false);
  var date_format = 'D' + (kroostApp.language === 'de' ? '.' : '') + ' MMMM YYYY';

  var _text = text || '';
  if (typeof text === 'undefined') {
    _text = (placeholder || '').replace(/{name}/gi, name).replace(/{birthday}/gi, __WEBPACK_IMPORTED_MODULE_0_helpers_time__["e" /* formatBirthday */](birthday, date_format));
  }

  if (specialType === 'name') {
    _text = name;
  } else if (specialType === 'birthday') {
    _text = __WEBPACK_IMPORTED_MODULE_0_helpers_time__["e" /* formatBirthday */](birthday, date_format);
  } else if (specialType === 'name_first_letter') {
    _text = name[0];
  }

  return _text;
};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"row":"row_3oVzD","radio":"radio_1jNTS","checkbox":"checkbox_3y4fz","group":"group_2HE03","select":"select_2fH4A","singleSelect":"singleSelect_ibBtA","input":"input_ijetW","full":"full_nGoYd","large":"large_1mfOl","half":"half_2AoaV","medium":"medium_3a2M6","third":"third_6TXGT","quarter":"quarter_XjbIK","small":"small_2CbNp","arrow":"arrow_fKdcv","invalid":"invalid_2Z_Ry","error":"error_aaFcO","hide":"hide_1d1Nf","datepicker":"datepicker_DzxgW"};

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);


// configure, create, and export the project's history instance
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default.a({}));

/***/ }),
/* 54 */,
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return onEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return interval; });
/* unused harmony export debounce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(21);


var _marked2 = [debounce].map(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark);




/**
 * Listen to element events
 * @param source
 * @param eventName
 * @param init
 * @param throttle
 */
var onEvent = function onEvent(source, eventName) {
  var init = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var throttle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;
  return __WEBPACK_IMPORTED_MODULE_1_redux_saga__["c" /* eventChannel */](function (emitter) {
    var _timeout = void 0;

    source.addEventListener(eventName, function (e) {
      if (throttle) {
        if (_timeout) clearTimeout(_timeout);
        _timeout = setTimeout(function () {
          emitter(e);
        }, throttle);
      } else {
        emitter(e);
      }
    });

    if (init) {
      init();
    }

    return function () {
      source.removeEventListener(eventName, emitter);
    };
  });
};

var interval = function interval(every) {
  var initialTrigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  return __WEBPACK_IMPORTED_MODULE_1_redux_saga__["c" /* eventChannel */](function (emitter) {
    var check = 0;
    var iv = setInterval(function () {
      return emitter(check++);
    }, every * 1000);

    // Trigger first emit after creation
    if (initialTrigger) {
      setTimeout(function () {
        return emitter(check++);
      }, 0);
    }

    return function () {
      return clearInterval(iv);
    };
  });
};

function debounce(pattern, saga, ms) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var _marked, delayedSaga, task, action;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function debounce$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          delayedSaga = function delayedSaga(action) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function delayedSaga$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_1_redux_saga__["b" /* delay */], ms);

                  case 2:
                    _context.next = 4;
                    return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */].apply(undefined, [saga, action].concat(args));

                  case 4:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _marked[0], this);
          };

          _marked = [delayedSaga].map(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark);
          task = void 0;

        case 3:
          if (false) {
            _context2.next = 15;
            break;
          }

          _context2.next = 6;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* take */](pattern);

        case 6:
          action = _context2.sent;

          if (!task) {
            _context2.next = 10;
            break;
          }

          _context2.next = 10;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["c" /* cancel */](task);

        case 10:
          _context2.next = 12;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* fork */](delayedSaga, action);

        case 12:
          task = _context2.sent;
          _context2.next = 3;
          break;

        case 15:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2[0], this);
}

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = exifDateToDate;
/* harmony export (immutable) */ __webpack_exports__["a"] = dateToExifDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = dateToWords;
/* harmony export (immutable) */ __webpack_exports__["c"] = exifDateInRange;
/* harmony export (immutable) */ __webpack_exports__["e"] = formatBirthday;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_differenceInDays__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_differenceInDays___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_differenceInDays__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_differenceInMonths__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_differenceInMonths___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_differenceInMonths__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_isWithinInterval__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_isWithinInterval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_isWithinInterval__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_addSeconds__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_addSeconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_addSeconds__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_toDate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_toDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_toDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_format__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_locale_nl__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_locale_nl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_locale_nl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_locale_de__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_locale_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_locale_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_locale_en_US__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_locale_en_US___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_locale_en_US__);











function exifDateToDate(datestring) {
  if (!datestring) return null;

  var _datestring$split = datestring.split(' '),
      d = _datestring$split[0],
      t = _datestring$split[1];

  var date = d.replace(/:/gi, '-') + ' ' + t;

  return __WEBPACK_IMPORTED_MODULE_4_date_fns_toDate___default.a(date);
}

function dateToExifDate(date) {
  if (!date) return null;
  return __WEBPACK_IMPORTED_MODULE_5_date_fns_format___default.a(date, 'YYYY:MM:DD HH:mm:ss');
}

function dateToWords(childBirthday, datestring) {
  if (!datestring) return '';

  var childBirthDate = __WEBPACK_IMPORTED_MODULE_4_date_fns_toDate___default.a(childBirthday);
  var compareDate = exifDateToDate(datestring);
  compareDate.setHours(0);
  compareDate.setMinutes(0);
  compareDate.setSeconds(0);

  var daysDifference = __WEBPACK_IMPORTED_MODULE_0_date_fns_differenceInDays___default.a(compareDate, childBirthDate);
  var monthsDifference = __WEBPACK_IMPORTED_MODULE_1_date_fns_differenceInMonths___default.a(compareDate, childBirthDate);

  if (daysDifference > 365) {
    var year = Math.floor(monthsDifference / 12);
    var months = monthsDifference - year * 12;
    return year + kroostApp.strings.year + ' ' + (months > 0 ? months + (months !== 1 ? ' ' + kroostApp.strings.monthsPlural : kroostApp.strings.months) : '');
  } else if (monthsDifference >= 3) {
    return monthsDifference + ' ' + (monthsDifference > 1 ? kroostApp.strings.monthsPlural : kroostApp.strings.months);
  } else if (daysDifference > 7) {
    var weeks = Math.floor(daysDifference / 7) + 1;
    return weeks + ' ' + (weeks > 1 ? kroostApp.strings.weekPlural : kroostApp.strings.week);
  } else if (daysDifference > -7 && daysDifference < 0) {
    return '- ' + Math.abs(daysDifference) + ' ' + (daysDifference > 1 ? kroostApp.strings.days : kroostApp.strings.day);
  } else if (daysDifference < 0) {
    var _weeks = Math.floor(Math.abs(daysDifference) / 7) + 1;
    return '- ' + _weeks + ' ' + (_weeks > 1 ? kroostApp.strings.weekPlural : kroostApp.strings.week);
  } else if (daysDifference === 0) {
    return kroostApp.strings.birthday;
  }

  return daysDifference + 1 + ' ' + (daysDifference > 0 ? kroostApp.strings.days : kroostApp.strings.day);
}

function exifDateInRange(childBirthday, datestring, rangeStart, rangeEnd) {
  var compareDate = exifDateToDate(datestring);
  var start = __WEBPACK_IMPORTED_MODULE_3_date_fns_addSeconds___default.a(childBirthday, rangeStart);
  var end = __WEBPACK_IMPORTED_MODULE_3_date_fns_addSeconds___default.a(childBirthday, rangeEnd);

  if (start < end) {
    return __WEBPACK_IMPORTED_MODULE_2_date_fns_isWithinInterval___default.a(compareDate, { start: start, end: end });
  }

  return __WEBPACK_IMPORTED_MODULE_2_date_fns_isWithinInterval___default.a(compareDate, { start: end, end: start });
}

function formatBirthday(childBirthday, dateFormat) {
  var parsed = __WEBPACK_IMPORTED_MODULE_4_date_fns_toDate___default.a(childBirthday);
  var languages = {
    nl: __WEBPACK_IMPORTED_MODULE_6_date_fns_locale_nl___default.a,
    de: __WEBPACK_IMPORTED_MODULE_7_date_fns_locale_de___default.a,
    en: __WEBPACK_IMPORTED_MODULE_8_date_fns_locale_en_US___default.a
  };

  return isNaN(parsed.getTime()) ? '' : __WEBPACK_IMPORTED_MODULE_5_date_fns_format___default.a(parsed, dateFormat, { locale: languages[kroostApp.language] });
}

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPhotos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPicked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getUploads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFavorites; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getSaved; });
/* unused harmony export getSelection */
/* unused harmony export getFilterParams */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFilteredForPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getPickedMoments; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_selectors_orders__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_selectors_books__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_time__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_api__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_toDate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_toDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_toDate__);










var getPhotos = function getPhotos(state) {
  return state.getIn(['photos', __WEBPACK_IMPORTED_MODULE_4_redux_selectors_app__["c" /* getActiveOrderId */](state)], __WEBPACK_IMPORTED_MODULE_1_immutable__["List"]());
};

var getPicked = function getPicked(state) {
  return state.getIn(['orders', __WEBPACK_IMPORTED_MODULE_4_redux_selectors_app__["c" /* getActiveOrderId */](state), 'picked'], __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]());
};

var getUploads = function getUploads(state) {
  return state.getIn(['orders', __WEBPACK_IMPORTED_MODULE_4_redux_selectors_app__["c" /* getActiveOrderId */](state), 'uploads'], __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]());
};

var getFavorites = function getFavorites(state) {
  return state.getIn(['orders', __WEBPACK_IMPORTED_MODULE_4_redux_selectors_app__["c" /* getActiveOrderId */](state), 'favorites', __WEBPACK_IMPORTED_MODULE_4_redux_selectors_app__["d" /* getActiveSpreadId */](state)], __WEBPACK_IMPORTED_MODULE_1_immutable__["List"]());
};

var getSaved = function getSaved(state) {
  return state.getIn(['orders', __WEBPACK_IMPORTED_MODULE_4_redux_selectors_app__["c" /* getActiveOrderId */](state), 'saved'], __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]());
};

var getSelection = __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([__WEBPACK_IMPORTED_MODULE_3_redux_selectors_books__["g" /* getSpreadInfo */], __WEBPACK_IMPORTED_MODULE_2_redux_selectors_orders__["e" /* getChildBirthday */], __WEBPACK_IMPORTED_MODULE_3_redux_selectors_books__["h" /* getYearOffset */]], function (spreadInfo, childBirthdayString, yearOffset) {
  var rangeStart = spreadInfo.get('filter_range_start', 0);
  var rangeEnd = spreadInfo.get('filter_range_end', 0) + 86400; // End of the day
  var childBirthday = childBirthdayString ? __WEBPACK_IMPORTED_MODULE_7_date_fns_toDate___default.a(childBirthdayString) : null;

  if (spreadInfo.get('isMonthSpread')) {
    var index = spreadInfo.get('monthIndex');
    var d = new Date(childBirthday);
    d.setFullYear(d.getFullYear() + yearOffset);
    d.setMonth(childBirthday.getMonth() + index);
    d.setDate(1);

    rangeStart = (new Date(d).getTime() - childBirthday.getTime()) / 1000;

    var d2 = new Date(childBirthday);
    d2.setFullYear(d2.getFullYear() + yearOffset);
    d2.setMonth(childBirthday.getMonth() + index + 1);
    d2.setDate(0);

    rangeEnd = (new Date(d2).getTime() - childBirthday.getTime()) / 1000;
  }

  return {
    childBirthday: childBirthday,
    rangeStart: rangeStart,
    rangeEnd: rangeEnd
  };
});

var getFilterParams = function getFilterParams(filterType) {
  return __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([__WEBPACK_IMPORTED_MODULE_4_redux_selectors_app__["c" /* getActiveOrderId */], getSaved, getFavorites], function (activeOrderId, saved, favorites) {
    if (filterType === 'saved') {
      return saved;
    } else if (filterType === 'favorites') {
      return favorites;
    }

    return null;
  });
};

var getFilteredForPage = function getFilteredForPage(filterType) {
  return __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([getPhotos, getFilterParams(filterType), getUploads, getPicked, getSelection, __WEBPACK_IMPORTED_MODULE_4_redux_selectors_app__["c" /* getActiveOrderId */], __WEBPACK_IMPORTED_MODULE_2_redux_selectors_orders__["k" /* getOrderToken */], __WEBPACK_IMPORTED_MODULE_2_redux_selectors_orders__["l" /* getOrderUser */]], function (photos, filterParam, uploads, picked, selection, orderId, orderToken, orderUser) {
    var filter = null;

    switch (filterType) {
      case 'saved':
        filter = function filter(photo) {
          return filterParam.indexOf(photo.get('simpleId')) > -1;
        };
        break;
      case 'favorites':
        filter = function filter(photo) {
          return filterParam.indexOf(photo.get('simpleId')) > -1;
        };
        break;
      default:
        break;
    }

    // Picked photos by simpleId
    var pickedById = picked.reduce(function (carry, value) {
      if (value.get('simpleId')) {
        if (!(value.get('simpleId') in carry)) {
          carry[value.get('simpleId')] = 0;
        }

        carry[value.get('simpleId')]++;
      }

      return carry;
    }, {});

    if (filter) {
      photos = photos.filter(filter);
    }

    return photos.map(function (photo) {
      var uploadUID = uploads.getIn([photo.get('simpleId'), 'uid'], null);
      var photoDate = photo.get('exif', {}).DateTime;
      var childBirthday = selection.childBirthday,
          rangeStart = selection.rangeStart,
          rangeEnd = selection.rangeEnd;


      var isSelection = photoDate && childBirthday ? __WEBPACK_IMPORTED_MODULE_5_helpers_time__["c" /* exifDateInRange */](childBirthday, photoDate, rangeStart, rangeEnd) : false;

      return photo.merge({
        uid: uploadUID,
        isSelection: isSelection,
        useCount: pickedById[photo.get('simpleId')] || 0,
        uploadUrl: uploadUID ? __WEBPACK_IMPORTED_MODULE_6_helpers_api__["b" /* uploadUrl */](orderId, uploadUID, orderToken, orderUser) : null
      });
    }).sortBy(function (photo) {
      return photo.get('exif', {}).DateTime || photo.get('exif', {}).lastModified || '9999-' + photo.get('simpleId');
    }).sortBy(function (photo) {
      return !photo.get('isSelection');
    });
  });
};

var getPickedMoments = __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([getPicked, getUploads, getPhotos, __WEBPACK_IMPORTED_MODULE_4_redux_selectors_app__["c" /* getActiveOrderId */], __WEBPACK_IMPORTED_MODULE_2_redux_selectors_orders__["k" /* getOrderToken */], __WEBPACK_IMPORTED_MODULE_2_redux_selectors_orders__["l" /* getOrderUser */]], function (picked, uploads, photos, orderId, orderToken, orderUser) {
  return picked.map(function (pick) {
    var simpleId = pick.get('simpleId');
    var uploadUID = uploads.getIn([simpleId, 'uid'], null);
    var photo = photos.find(function (photo) {
      return photo.get('simpleId') === simpleId;
    }, null);

    return pick.set('photo', photo ? photo.merge({
      uid: uploadUID,
      uploadUrl: uploadUID ? __WEBPACK_IMPORTED_MODULE_6_helpers_api__["b" /* uploadUrl */](orderId, uploadUID, orderToken, orderUser) : null
    }) : null);
  });
});

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECK; });
/* unused harmony export CHECKED */
/* harmony export (immutable) */ __webpack_exports__["d"] = reducer;
/* harmony export (immutable) */ __webpack_exports__["b"] = check;
/* harmony export (immutable) */ __webpack_exports__["c"] = checked;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var CHECK = 'kroost/giftcards/CHECK';
var CHECKED = 'kroost/giftcards/CHECKED';

// Initial routing state
var initialState = __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]({
  checking: false,
  code: null,
  valid: [],
  invalid: []
});

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case CHECK:
      return state.set('checking', true);
    case CHECKED:
      return state.set('code', action.valid ? action.code : null).update(action.valid ? 'valid' : 'invalid', function (items) {
        return items.push(action.code);
      }).set('checking', false);
    default:
      return state;
  }
}

function check(code) {
  return {
    type: CHECK,
    code: code
  };
}

function checked(code) {
  var valid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return {
    type: CHECKED,
    code: code,
    valid: valid
  };
}

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return readyCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return readyCheckDone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_selectors_user__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_selectors_books__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_selectors_photos__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_selectors_design__ = __webpack_require__(32);









var getStats = function getStats(state) {
  return state.getIn(['stats', __WEBPACK_IMPORTED_MODULE_3_redux_selectors_app__["c" /* getActiveOrderId */](state)], __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]());
};

var _calculateProgress = function _calculateProgress(spreads, designSpreads, photos, picked) {
  var progress = {};

  spreads.forEach(function (spread) {
    var designSpread = designSpreads.get(spread.get('id'));
    var moments = spread.get('moments', __WEBPACK_IMPORTED_MODULE_1_immutable__["List"]());
    var total = moments.count();
    var touched = 0;

    if (designSpread) {
      designSpread.get('moments').forEach(function (moment) {
        var currentSpreadMoment = spread.get('moments').find(function (m) {
          return m.get('id') == moment.get('id');
        });

        var isText = currentSpreadMoment.get('type') === 'text';
        var userSet = picked.get(moment.get('id'), null);
        var hasPhoto = userSet ? photos.find(function (photo) {
          return photo.get('simpleId') === userSet.get('simpleId');
        }) : false;

        var specialText = moment.getIn(['options', 'special_text']);

        if ((hasPhoto || isText) && userSet !== null || specialText) {
          touched++;
        }
      });
    }

    progress[spread.get('id')] = {
      total: total,
      touched: touched,
      seen: touched > 0,
      partial: touched > 0 && touched < total,
      done: total === touched
    };
  });

  // Spread has been seen
  //

  return __WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"](progress);
};

var calculateProgress = __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([__WEBPACK_IMPORTED_MODULE_4_redux_selectors_books__["d" /* getCurrentBookSpreads */], __WEBPACK_IMPORTED_MODULE_6_redux_selectors_design__["b" /* getDesignSpreads */], __WEBPACK_IMPORTED_MODULE_5_redux_selectors_photos__["c" /* getPhotos */], __WEBPACK_IMPORTED_MODULE_5_redux_selectors_photos__["d" /* getPicked */]], function (spreads, designSpreads, photos, picked) {
  return _calculateProgress(spreads, designSpreads, photos, picked);
});

var readyCheck = __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([__WEBPACK_IMPORTED_MODULE_4_redux_selectors_books__["d" /* getCurrentBookSpreads */], __WEBPACK_IMPORTED_MODULE_6_redux_selectors_design__["b" /* getDesignSpreads */], __WEBPACK_IMPORTED_MODULE_5_redux_selectors_photos__["c" /* getPhotos */], __WEBPACK_IMPORTED_MODULE_3_redux_selectors_app__["c" /* getActiveOrderId */], __WEBPACK_IMPORTED_MODULE_5_redux_selectors_photos__["d" /* getPicked */], __WEBPACK_IMPORTED_MODULE_5_redux_selectors_photos__["g" /* getUploads */], __WEBPACK_IMPORTED_MODULE_3_redux_selectors_app__["g" /* isUploading */], __WEBPACK_IMPORTED_MODULE_2_redux_selectors_user__["c" /* isAuthenticated */]], function (spreads, designSpreads, photos, orderId, picked, uploads, uploading, authenticated) {
  // Every spread filled in
  var progress = _calculateProgress(spreads, designSpreads, photos, picked);
  var done = !progress.isEmpty() && progress.every(function (spread) {
    return spread.get('done');
  }) && orderId !== null;

  // Seems done, but doesn't have any photos
  var noPhotos = false;

  var uploadQueue = [];
  picked.forEach(function (pick) {
    if (pick.get('simpleId') && !uploads.get(pick.get('simpleId'))) {
      uploadQueue.push(pick.get('simpleId'));
    }
  });

  return {
    all: done && authenticated && !uploading,
    uploading: uploading || uploadQueue.length > 0,
    noPhotos: noPhotos,
    done: done,
    authenticated: authenticated
  };
});

var readyCheckDone = __WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"]([readyCheck], function (check) {
  return check.done;
});

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = setToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = getToken;
/* unused harmony export clearToken */
/* harmony export (immutable) */ __webpack_exports__["a"] = decodeToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jwt_decode__);


var KEY = 'token';

var _token = null;

function setToken(token) {
  if (token) {
    _token = token;
    localStorage.setItem(KEY, token);
  } else {
    clearToken();
  }
}

function getToken() {
  return _token || localStorage.getItem(KEY);
}

function clearToken() {
  _token = null;
  localStorage.removeItem(KEY);
}

function decodeToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default.a(token);
}

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return limitTransform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRotationFromOrientation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFlipFromOrientation; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var MM_PER_INCH = 25.4;
var MIN_DOTS_PER_MM = 100 / MM_PER_INCH; // 100 dpi minimum
var DPI_WARNING_AT = 100;

var limitTransform = function limitTransform(exif, transform, scale, momentWidth, momentHeight) {
  var newDragged = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var newZoom = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;

  var imageOriginalWidth = exif.width || exif.PixelXDimension;
  var imageOriginalHeight = exif.height || exif.PixelYDimension;

  var totalPx = imageOriginalWidth / transform.width;
  var areaMM = momentWidth / scale;

  var dpi = totalPx / areaMM * MM_PER_INCH;

  var newTransform = _extends({}, transform, {
    dpi: dpi,
    lowDpi: dpi < DPI_WARNING_AT
  });

  var ratio = exif.ratio || imageOriginalHeight / imageOriginalWidth;
  var momentRatio = momentHeight / momentWidth;

  var zoom = transform.width + newZoom;
  var maxLimitZoom = imageOriginalWidth / (momentWidth / scale) / MIN_DOTS_PER_MM;

  var minZoomLimit = ratio < momentRatio ? momentHeight / ratio / momentWidth // Landscape
  : 1; // Portrait

  // Keep zoom in range
  newTransform.width = Math.max(minZoomLimit, Math.min(zoom, maxLimitZoom));

  var imageWidth = momentWidth * newTransform.width;
  var imageHeight = imageWidth * ratio;

  var _ref = newDragged || [],
      _ref$ = _ref[0],
      x = _ref$ === undefined ? 0 : _ref$,
      _ref$2 = _ref[1],
      y = _ref$2 === undefined ? 0 : _ref$2;

  var _transform$x = transform.x,
      transformX = _transform$x === undefined ? 0 : _transform$x,
      _transform$y = transform.y,
      transformY = _transform$y === undefined ? 0 : _transform$y;

  // Calculate image size based on new zoom

  if (newZoom) {
    imageWidth = momentWidth * newTransform.width;
    imageHeight = imageWidth * ratio;
  }

  // Y
  var draggedY = y / imageHeight + transformY;
  var minDiffY = imageHeight / 2 - momentHeight / 2;
  var minLimitOffsetY = minDiffY / imageHeight;
  var maxDiffY = momentHeight / 2 - imageHeight / 2;
  var maxLimitOffsetY = maxDiffY / imageHeight;

  // X
  var draggedX = x / imageWidth + transformX;
  var minDiffX = imageWidth / 2 - momentWidth / 2;
  var minLimitOffsetX = minDiffX / imageWidth;
  var maxDiffX = momentWidth / 2 - imageWidth / 2;
  var maxLimitOffsetX = maxDiffX / imageWidth;

  // Keep transform in range
  newTransform.x = draggedX ? Math.max(Math.min(draggedX, minLimitOffsetX), maxLimitOffsetX) : 0;
  newTransform.y = draggedY ? Math.max(Math.min(draggedY, minLimitOffsetY), maxLimitOffsetY) : 0;

  return newTransform;
};

var getRotationFromOrientation = function getRotationFromOrientation(orientation) {
  switch (orientation) {
    case 'left-bottom':
    case 'left-top':
      return -90;
    case 'right-top':
    case 'right-bottom':
      return 90;
    case 'bottom-right':
    case 'bottom-left':
      return 180;
  }

  return 0;
};

var getFlipFromOrientation = function getFlipFromOrientation(orientation) {
  switch (orientation) {
    case 'top-right':
    case 'bottom-left':
    case 'left-top':
    case 'right-bottom':
      return 1;
  }

  return 0;
};

/***/ }),
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LANGUAGE_MAP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__languages___ = __webpack_require__(267);


// import * as Sentry from '@sentry/browser'

var defaultLanguage = {
  showSelectOption: true,
  countryCode: 'netherlands',
  selectOption: 'NL',
  language: 'nl',
  domainExtension: 'nl'
};

var mimeTypes = ['image/jpeg', 'image/jpg', 'image/png'];

// if countryCode needs to be changed keep it mind that it also has
// to change on the helper: {project-root}/web/app/mu-plugins/kroost/helpers.php
var LANGUAGE_MAP = [defaultLanguage, {
  showSelectOption: true,
  countryCode: 'belgium',
  selectOption: 'BE',
  language: 'nl',
  domainExtension: 'be'
}, {
  showSelectOption: true,
  countryCode: 'germany',
  selectOption: 'DE',
  language: 'de',
  domainExtension: 'de'
}, {
  showSelectOption: true,
  countryCode: 'austria',
  selectOption: 'AT',
  language: 'de',
  domainExtension: 'at'
}, {
  //this is false because we dont have a country relative to the .com domain
  showSelectOption: false,
  countryCode: 'english',
  selectOption: 'EN',
  language: 'en',
  domainExtension: 'com'
}];

// Get the TLD from the URL
function getTld(url) {
  try {
    var hostname = new URL(url).hostname;
    // Extract TLD from hostname
    var parts = hostname.split('.');
    var tld = parts.length > 1 ? parts.pop() : '';
    return tld;
  } catch (error) {
    return null;
  }
}

var getLanguage = function getLanguage(href, query) {
  var params = new URLSearchParams(query);
  var tld = params.has('lang') ? params.get('lang') : getTld(href);

  // Get the language and if we have a result then update the default language
  var tldLanguage = LANGUAGE_MAP.find(function (singleLanguage) {
    return singleLanguage.domainExtension === tld;
  });
  return tldLanguage || defaultLanguage;
};

var _getLanguage = getLanguage(window.location.href, window.location.search),
    language = _getLanguage.language,
    selectOption = _getLanguage.selectOption,
    domainExtension = _getLanguage.domainExtension;

// Set the global language variable


global.kroostApp = {
  language: language,
  country: selectOption,
  strings: window.APP_TEXTS || __WEBPACK_IMPORTED_MODULE_1__languages___["a" /* default */][language],
  domainExtension: domainExtension,
  dropZoneAccept: mimeTypes
};

global.URL = window.URL || window.webkitURL;
(function () {
  'use strict';

  if (!('toBlob' in HTMLCanvasElement.prototype)) {
    Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
      value: function value(callback, type, quality) {
        var binStr = atob(this.toDataURL(type, quality).split(',')[1]),
            len = binStr.length,
            arr = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
          arr[i] = binStr.charCodeAt(i);
        }
        callback(new Blob([arr], { type: type || 'image/png' }));
      }
    });
  }
})();

global.p = function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (false) {
    var _console;

    args = args.map(function (arg) {
      return arg instanceof Iterable ? ['immutable', arg.toJS(), arg] : arg;
    });
    (_console = console).debug.apply(_console, args);
  }
};

global.pe = function (error, message) {
  // if (!process.env.DEBUG) {
  //   Sentry.captureException(error)
  // }

  if (message) {
    console.error(message);
    console.error(error);
  }
};

global.API_HOST = "/wp-json/kroost/";

// if (!process.env.DEBUG) {
//   Sentry.init({
//     dsn: 'https://ef4e19e9b64c4cd19968c45e7424d04a@sentry.io/1526216'
//   })
// }
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27)))

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  loadingFirstMessage: 'Momentje, de designer wordt geladen.',
  checking: 'Checking...',
  cash: 'Verzilveren',
  toLogin: 'Naar inloggen',
  payoff: 'voor als je later groot bent',
  login: 'Log in',
  loginForgot: 'vergeten',
  loginIntro: 'Maak eerst een account aan of log in als je er al één hebt.',
  loginFailed: 'Login mislukt',
  loginNoAccount: 'Ik heb nog geen account',
  loginSendNew: 'Stuur mij een nieuwe login',
  accountCreate: 'Maak account aan',
  accountAlready: ' Al een account? Log hier in',
  voucherPersonalCode: 'Ik heb een persoonlijke code',
  voucherIntro: 'Voer je persoonlijke code in. Je vindt de code achter op je voucher of in de bevestigingse-mail.',
  voucherInvalid: 'Voer een geldige code in van 15 tekens inclusief de koppelstreepjes. Bijvoorbeeld 2Wpa-SFtB-999c.',
  backToLogin: 'Terug naar het login scherm',
  passwordRequest: 'Stuur mij een nieuwe login',
  passwordRequestSend: 'Er is een email verstuurd met verdere instructies.',
  passwordRequestRemember: 'Weet je je wachtwoord weer?',
  childIntro: 'Vul als eerste de naam en geboortedatum van je kind in. Ze worden alvast voor je ingevoegd.',
  menuAccount: 'account',
  menuOrder: 'bestel',
  menuChild: 'kind',
  menuDesigns: 'designs',
  menuPhotos: 'bewerk',
  menuHelp: 'help',
  photosChooseMore: "Kies meer foto's",
  photosChoose: 'Kies je foto’s',
  assignmentSelectPhotosFirst: 'Lees eerst je foto’s in',
  assignmentSelectPhotos: "Lees foto's in",
  assignmentClose: 'Sluit fotorol',
  notificationReady: "Hoera! Je bent klaar. --- Kijk alle tekst en foto's goed na.",
  notificationGoToOrder: 'Naar bestellen',
  orderUnfinishedFirstPart: 'Je kan nog niet bestellen. Voeg eerst overal de foto’s en tekst toe. Als je nog een geel bolletje ziet dan moet je nog iets toevoegen. Zijn alle bolletjes groen, kijk je werk nog wel even goed na.',
  orderUnfinishedSecondPart: ' Veel plezier!',
  orderIntro: 'Geef je adres op.',

  kidSectionTtitle: 'Kind',
  childBookTargetInput: 'Dit boek is voor:',
  childBookStartButtonOption1: 'Voeg een kind toe',
  childBookStartButtonOption2: 'Voeg nog een kind toe',
  childBookTargetOption1: 'Voor wie ga je het boek maken:',
  childBookTargetOption2: 'Of maak het voor je andere kind:',
  childFormInputNameLabel: 'Roepnaam',
  childFormInputNamePlaceholder: 'Roepnaam van je kind',
  childFormInputLettersInformation: 'Kan niet langer dan 12 karakters zijn',
  childFormInputDateLabel: 'Geboortedatum',
  backButton: 'Terug',
  getStartedButton: 'Aan de slag',

  cameraRollTab: 'fotorol',
  pinupTab: 'prikbord',
  savedPhotosInformation: "Bewaarde foto's om bij andere opdrachten te gebruiken",

  designInformations: 'Probeer de designs maar uit. Je werk gaat niet verloren.',

  photoDoesntUploadAlert: 'Er is 1 foto niet geupload omdat deze te groot is (max 60mb) of niet in het JPG formaat is',
  photoDoesntUploadAlertPlural: "Er zijn {rejectedFiles} foto's niet geupload omdat deze te groot zijn (max 60mb) of niet in het JPG formaat zijn",
  callToUseThePhotos: 'Laat los om je foto’s te gebruiken',

  personalGiftCodeLabel: 'Je persoonlijke code',
  cachedVoucherTitle: 'Voucher verzilveren',

  loginCredentialsTitle: 'Log in op je account',
  loginEmailInputLabel: 'E-mailadres',
  loginErrorMessage: 'Je kan niet inloggen met beheerder account',
  loginPasswordInput: 'Wachtwoord',
  forgotPasswordSectionTitle: 'Wachtwoord vergeten',
  forgotPasswordEmailPlaceholder: 'Jouw e-mail adres',
  makeAccountTitleStep1: 'Account aanmaken (1/2)',
  signupFirstNameInputLabel: 'Je eigen voornaam',
  signupFirstNamePlaceholder: 'Voornaam',
  signupEmailInputLabel: 'Je e-mailadres',
  signupPasswordInputLabel: 'Kies een wachtwoord',
  acceptPrivacyStatementFirstPart: 'Ik ga akkoord met de ',
  acceptPrivacyStatementSecondPart: 'algemene voorwaarden en de privacy statement',

  smallScreensMessage1: 'Helaas is Kroost nog niet beschikbaar voor mobiel of kleinere apparaten.',
  smallScreensMessage2: 'Zit je toch op je laptop of desktop? Maak je browser scherm zo groot mogelijk.',

  rotate: 'Roteren',
  mirror: 'Spiegelen',
  zoomIn: 'Inzoomen',
  zoomOut: 'Uitzoomen',

  warningToAdjustPhotoPart1: 'Voor een goede afdrukkwaliteit moet je deze foto aanpassen.',
  warningToAdjustPhotoPart2: 'Wat kan ik doen?',

  logout: 'log uit',
  account: 'Account',
  loading: 'Aan het laden...',
  openNewBook: 'Open een nieuw boek',

  logout2: 'Uitloggen',

  notReadyMessagePart1: 'Voordat je kunt bestellen, moet je',
  notReadyMessagePart2: 'een account aanmaken',
  notReadyMessagePart3: ", zodat wij de foto's kunnen verwerken",
  uploadingPhotosMessage: "Nog niet alle foto's zijn geupload",
  loading2: 'Laden...',
  backToPay: 'terug naar betalen',
  surname: 'Achternaam',
  street: 'Straat',
  houseNumber: 'Huisnummer',
  postCode: 'Postcode',
  city: 'Woonplaats',
  country: 'Land',
  phone: 'Telefoon nummer',
  amount: 'Aantal',
  warningMessageBeforeForNoChanges: 'Je kan deze bestelling niet meer aanpassen',
  fillTheFieldsMessage: 'vul de rode velden om verder te gaan',
  checking2: 'Controleren...',
  orderComplete: 'Bestelling afronden',
  orderTitle: 'Bestellen',

  preferdName: ' Roepnaam',
  dateOfBirth: 'Geboren op (verwacht)',
  makeYourBook: 'Maak jouw boek',

  failedUploadWarning: "Er gaat helaas iets mis gegaan bij het uploaden van de foto's. Mocht dit blijven gebeuren, neem dan aub contact met ons op",
  uploandingFaliedMessage: 'Uploaden van {fileName} is mislukt',
  feedbackUploadingMessage: '{fileName} wordt geupload',
  uploadSuccessMessage: '{fileName} is geupload',

  usedPhotoMessageSingular: 'Deze foto wordt op 1 plek gebruikt',
  usedPhotoMessagePlural: 'Deze foto wordt op {count} plekken gebruikt',

  newPasswordLabel: 'Nieuw wachtwoord',
  newPasswordPlaceholder: 'Jouw nieuwe wachtwoord',
  formErrorMessage: ' Reset mislukt, de link is maar 24 uur geldig. Vraag opnieuw aan.',
  passwordButtonSubmit: 'Pas wachtwoord aan',

  saveSuccessTitle: 'Account aanmaken (2/2)',
  enterTheNameOfChildButton: 'Vul de naam in van je kind',
  saveSuccessMessagePart1: 'Je account is aangemaakt. Alle wijzigingen worden automatisch en direct opgeslagen.',
  saveSuccessMessagePart2: 'Veel plezier!',
  netherlands: 'Nederland',
  belgium: 'België',
  germany: 'Duitsland',
  austria: 'Oostenrijk',
  paymentWaitingMessage: 'De betaling is afgebroken of mislukt. Ga terug naar betalen om opnieuw af te rekenenen.',
  paymentFailedMessage: 'De betaling is afgebroken of mislukt. Ga terug naar betalen om opnieuw af te rekenenen.',
  paymentSuccessMessagePart1: 'We gaan voor je aan de slag. Check je mail voor de bevestiging. Nog even wachten en dan genieten!',
  greetings: 'Vrolijke groet,',
  teamKroost: 'team Kroost',
  shippingSendMessagePart1: 'Je bestelling is met brievenbuspost verzonden. Je hoeft dus niet thuis te blijven. Nog even wachten en dan kan het genieten beginnen!',
  shippingReceivedMessage: '  Je bestelling is afgeleverd. Geniet ervan!',
  mergingPhotos: "{mergedPhotos} van de {photos} foto's ingelezen",
  doneNotificationMessage: "{mergedPhotos} foto's ingelezen",
  notUsedPhotosMessage: " - {notused} negeert",
  year: 'jaar',
  months: 'maand',
  monthsPlural: "maanden",
  day: "dag",
  days: "dagen",
  week: "week",
  weekPlural: "weken",
  birthday: "Geboortedag!"

});

/***/ }),
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GET_BOOK */
/* unused harmony export GET_BOOKS */
/* unused harmony export SET_BOOK */
/* unused harmony export SET_BOOKS */
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* unused harmony export getBook */
/* unused harmony export getBooks */
/* harmony export (immutable) */ __webpack_exports__["b"] = setAll;
/* unused harmony export set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var GET_BOOK = 'kroost/book/GET_BOOK';
var GET_BOOKS = 'kroost/book/GET_BOOKS';
var SET_BOOK = 'kroost/book/SET_BOOK';
var SET_BOOKS = 'kroost/book/SET_BOOKS';

// Initial routing state
var initialState = __WEBPACK_IMPORTED_MODULE_0_immutable__["List"]();

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case SET_BOOK:
      return state.push(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"](action.book));
    case SET_BOOKS:
      return __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"](action.books);
    default:
      return state;
  }
}

function getBook(id) {
  return {
    type: GET_BOOK,
    id: id
  };
}

function getBooks() {
  return {
    type: GET_BOOKS
  };
}

function setAll(books) {
  return {
    type: SET_BOOKS,
    books: books
  };
}

function set(book) {
  return {
    type: SET_BOOK,
    book: book
  };
}

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ADD_DESIGN */
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
/* harmony export (immutable) */ __webpack_exports__["a"] = add;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var ADD_DESIGN = 'kroost/design/ADD_DESIGN';

// Initial routing state
var initialState = __WEBPACK_IMPORTED_MODULE_0_immutable__["List"]();

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case ADD_DESIGN:
      return state.push(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"](action.design));
    default:
      return state;
  }
}

function add(design) {
  return {
    type: ADD_DESIGN,
    design: design
  };
}

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FILL */
/* unused harmony export ADD_SPREAD_STATE */
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
/* harmony export (immutable) */ __webpack_exports__["a"] = addSpreadStat;
/* harmony export (immutable) */ __webpack_exports__["c"] = fill;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var FILL = 'kroost/stats/FILL';
var ADD_SPREAD_STATE = 'kroost/stats/ADD_SPREAD_STATE';

// Initial routing state
var initialState = __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]({
  spreads: {}
});

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case ADD_SPREAD_STATE:
      return state.setIn([action.orderId, 'spreads', action.spreadId, action.name], action.value);
    case FILL:
      return state.set(action.orderId, __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"](action.stats));
    default:
      return state;
  }
}

function addSpreadStat(orderId, spreadId, name, value) {
  return {
    type: ADD_SPREAD_STATE,
    orderId: orderId,
    spreadId: spreadId,
    name: name,
    value: value
  };
}

function fill(orderId, stats) {
  return {
    type: FILL,
    orderId: orderId,
    stats: stats
  };
}

/***/ }),
/* 156 */,
/* 157 */,
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export preloadBookImages */
/* harmony export (immutable) */ __webpack_exports__["b"] = getBooks;
/* harmony export (immutable) */ __webpack_exports__["a"] = saga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_image_preloader__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_image_preloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_image_preloader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_api__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_reducers_books__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_selectors_books__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_saga__ = __webpack_require__(43);


var _marked = [preloadBookImages, getBooks, saga].map(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark);












function preloadBookImages(_ref) {
  var id = _ref.id;
  var existingBook;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function preloadBookImages$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](__WEBPACK_IMPORTED_MODULE_5_redux_selectors_books__["b" /* getCurrentBook */]);

        case 3:
          existingBook = _context.sent;

          if (!(!id || !existingBook)) {
            _context.next = 6;
            break;
          }

          return _context.abrupt('return');

        case 6:

          // Preload images
          setTimeout(function () {
            var images = [];
            existingBook.get('spreads', []).forEach(function (spread) {
              spread.get('inspiration', []).forEach(function (inspiration) {
                if (images.indexOf(inspiration.getIn(['image', 'url'])) === -1) {
                  images.push(inspiration.getIn(['image', 'url']));
                }
              });
            });

            var preloader = new __WEBPACK_IMPORTED_MODULE_2_image_preloader___default.a();
            preloader.preload.apply(preloader, images).then(function () {
              p('Preloaded book images!', id);
            });
          }, 2000);
          _context.next = 12;
          break;

        case 9:
          _context.prev = 9;
          _context.t0 = _context['catch'](0);

          pe(_context.t0, 'failed preloadBookImages');

        case 12:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[0, 9]]);
}

function getBooks() {
  var books;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getBooks$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_3_helpers_api__["a" /* default */], 'books/get/all');

        case 3:
          books = _context2.sent;
          _context2.next = 6;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_4_redux_reducers_books__["b" /* setAll */](books));

        case 6:
          _context2.next = 8;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.get('books');
          });

        case 8:
          return _context2.abrupt('return', _context2.sent);

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2['catch'](0);

          pe(_context2.t0, 'failed getBooks');
          return _context2.abrupt('return', currentBooks);

        case 15:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[0, 11]]);
}

function saga() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_6__reducers_app__["c" /* SET_ACTIVE_ORDER */], preloadBookImages);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

/***/ }),
/* 159 */,
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["d"] = getSingleOrder;
/* harmony export (immutable) */ __webpack_exports__["c"] = getOrders;
/* harmony export (immutable) */ __webpack_exports__["a"] = createNewOrder;
/* unused harmony export saveOrder */
/* unused harmony export startPayment */
/* unused harmony export finishOrder */
/* unused harmony export startPaymentRenew */
/* unused harmony export saveOnOnline */
/* unused harmony export validateOrderForm */
/* harmony export (immutable) */ __webpack_exports__["e"] = setSpecialTexts;
/* unused harmony export setDefaultText */
/* unused harmony export pollPaymentStatus */
/* harmony export (immutable) */ __webpack_exports__["b"] = saga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_api__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_saga__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_history__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers_string__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_selectors_user__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_selectors_design__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_selectors_orders__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux_selectors_stats__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux_reducers_photos__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_time__ = __webpack_require__(56);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _marked = [getSingleOrder, getOrders, createNewOrder, saveOrder, saveOnChange, setHasChanged, trackOrderActions, startPayment, finishOrder, startPaymentRenew, saveOnOnline, validateOrderForm, setSpecialTexts, setDefaultText, pollPaymentStatus, saga].map(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark);




// import * as Sentry from '@sentry/browser'

















var SAVE_THROTTLE = 5000;
var VALIDATION_THROTTLE = 2000;

var hasChangesToSave = false;

function getSingleOrder(_ref) {
  var id = _ref.id,
      _ref$force = _ref.force,
      force = _ref$force === undefined ? false : _ref$force;
  var authenticated, existingOrder, order;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getSingleOrder$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_9_redux_selectors_user__["c" /* isAuthenticated */](state);
          });

        case 3:
          authenticated = _context.sent;

          if (!(id && authenticated)) {
            _context.next = 25;
            break;
          }

          _context.next = 7;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['orders', id]);
          });

        case 7:
          existingOrder = _context.sent;

          if (!(force || !existingOrder)) {
            _context.next = 24;
            break;
          }

          _context.next = 11;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["u" /* setUIState */]('loading_orders', true));

        case 11:
          _context.next = 13;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_4_helpers_api__["a" /* default */], 'orders/get/' + id, {
            auth: true
          });

        case 13:
          order = _context.sent;

          if (!order) {
            _context.next = 17;
            break;
          }

          _context.next = 17;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["o" /* add */](id, order));

        case 17:
          _context.next = 19;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["u" /* setUIState */]('loading_orders', false));

        case 19:
          _context.next = 21;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['orders', id]);
          });

        case 21:
          return _context.abrupt('return', _context.sent);

        case 24:
          return _context.abrupt('return', existingOrder);

        case 25:
          _context.next = 32;
          break;

        case 27:
          _context.prev = 27;
          _context.t0 = _context['catch'](0);

          pe(_context.t0);

          _context.next = 32;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["v" /* trackEvent */]('error', {
            type: 'getSingleOrder',
            id: id,
            e: _context.t0.toString()
          }));

        case 32:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[0, 27]]);
}

function getOrders() {
  var authenticated, orders, ids;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getOrders$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_9_redux_selectors_user__["c" /* isAuthenticated */](state);
          });

        case 3:
          authenticated = _context2.sent;

          if (!authenticated) {
            _context2.next = 22;
            break;
          }

          _context2.next = 7;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["u" /* setUIState */]('loading_orders', true));

        case 7:
          if (!hasChangesToSave) {
            _context2.next = 10;
            break;
          }

          _context2.next = 10;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](saveOrder);

        case 10:
          _context2.next = 12;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_4_helpers_api__["a" /* default */], 'orders/all', {
            auth: true
          });

        case 12:
          orders = _context2.sent;
          ids = Object.keys(orders);

          if (!(ids.length > 0)) {
            _context2.next = 17;
            break;
          }

          _context2.next = 17;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["y" /* setAll */](orders));

        case 17:
          _context2.next = 19;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["u" /* setUIState */]('loading_orders', false));

        case 19:
          _context2.next = 21;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.get('orders');
          });

        case 21:
          return _context2.abrupt('return', _context2.sent);

        case 22:
          _context2.next = 29;
          break;

        case 24:
          _context2.prev = 24;
          _context2.t0 = _context2['catch'](0);

          pe(_context2.t0);

          _context2.next = 29;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["v" /* trackEvent */]('error', {
            type: 'getOrders',
            e: _context2.t0.toString()
          }));

        case 29:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[0, 24]]);
}

/**
 * Create order if it doesn't exist, or when multiple orders are available, ask the user
 */
function createNewOrder(_ref2) {
  var _ref2$book = _ref2.book,
      book = _ref2$book === undefined ? null : _ref2$book,
      _ref2$name = _ref2.name,
      name = _ref2$name === undefined ? '' : _ref2$name,
      _ref2$birthday = _ref2.birthday,
      birthday = _ref2$birthday === undefined ? '' : _ref2$birthday,
      _ref2$onlyWhenEmpty = _ref2.onlyWhenEmpty,
      onlyWhenEmpty = _ref2$onlyWhenEmpty === undefined ? true : _ref2$onlyWhenEmpty,
      _ref2$redirect = _ref2.redirect,
      redirect = _ref2$redirect === undefined ? false : _ref2$redirect,
      _ref2$pushHistory = _ref2.pushHistory,
      pushHistory = _ref2$pushHistory === undefined ? true : _ref2$pushHistory;
  var existingOrders, id, activeBookId, currentBook, designId, first_name, order;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createNewOrder$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.get('orders', __WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]());
          });

        case 3:
          existingOrders = _context3.sent;

          if (!(existingOrders.count() === 0 || !onlyWhenEmpty)) {
            _context3.next = 24;
            break;
          }

          id = __WEBPACK_IMPORTED_MODULE_7_helpers_string__["a" /* randomString */]();
          activeBookId = book;

          if (book) {
            _context3.next = 11;
            break;
          }

          _context3.next = 10;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_8_redux_selectors_app__["b" /* getActiveBookId */](state);
          });

        case 10:
          activeBookId = _context3.sent;

        case 11:
          _context3.next = 13;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.get('books').find(function (book) {
              return book.get('id') === activeBookId;
            });
          });

        case 13:
          currentBook = _context3.sent;
          designId = currentBook.get('default_design');
          _context3.next = 17;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_9_redux_selectors_user__["b" /* getProfile */](state).get('first_name');
          });

        case 17:
          first_name = _context3.sent;
          order = {
            local: true,
            design: designId,
            book: activeBookId,
            user: 0,
            amount: 1,
            terms: false,
            state: 'creating',
            child: {
              name: name,
              birthday: birthday
            },
            uploads: {},
            favorites: {},
            address: {
              first_name: first_name,
              country: global.kroostApp.country
            },
            picked: {},
            saved: [],
            extra_spreads: []
          };
          _context3.next = 21;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["o" /* add */](id, order));

        case 21:
          if (!id) {
            _context3.next = 24;
            break;
          }

          if (pushHistory) {
            __WEBPACK_IMPORTED_MODULE_6_helpers_history__["a" /* default */][redirect ? 'push' : 'replace']('/' + activeBookId + '/' + id);
          }
          return _context3.abrupt('return', id);

        case 24:
          _context3.next = 31;
          break;

        case 26:
          _context3.prev = 26;
          _context3.t0 = _context3['catch'](0);

          pe(_context3.t0);

          _context3.next = 31;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["v" /* trackEvent */]('error', {
            type: 'createNewOrder',
            e: _context3.t0.toString()
          }));

        case 31:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[0, 26]]);
}

function saveOrder() {
  var authenticated, editable, orderData, local, uid, response, orderUID, tracking_data;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saveOrder$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_9_redux_selectors_user__["c" /* isAuthenticated */](state);
          });

        case 3:
          authenticated = _context4.sent;
          _context4.next = 6;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_11_redux_selectors_orders__["a" /* canEdit */](state);
          });

        case 6:
          editable = _context4.sent;

          if (!(authenticated && editable)) {
            _context4.next = 31;
            break;
          }

          _context4.next = 10;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            var order = __WEBPACK_IMPORTED_MODULE_11_redux_selectors_orders__["i" /* getOrder */](state).toJS();

            // try {
            //   if (!order.uploads) {
            //     const debugData = JSON.stringify({
            //       activeOrderId: state.getIn(['app', 'activeOrderId'])
            //     })
            //     Sentry.captureMessage('Order somehow reset: ' + debugData)
            //   }
            // } catch (e) {
            //   pe(e)
            // }

            return _extends({
              uid: __WEBPACK_IMPORTED_MODULE_8_redux_selectors_app__["c" /* getActiveOrderId */](state)
            }, order, {
              //child: null,
              local: order.local || false,
              uploads: JSON.stringify(order.uploads),
              favorites: JSON.stringify(order.favorites),
              picked: JSON.stringify(order.picked),
              saved: JSON.stringify(order.saved),
              extra_spreads: JSON.stringify(order.extra_spreads || []),
              stats: JSON.stringify(__WEBPACK_IMPORTED_MODULE_12_redux_selectors_stats__["b" /* getStats */](state).toJS()),
              address: JSON.stringify(order.address),
              child_id: __WEBPACK_IMPORTED_MODULE_11_redux_selectors_orders__["f" /* getChildId */](state),
              child_name: __WEBPACK_IMPORTED_MODULE_11_redux_selectors_orders__["g" /* getChildName */](state),
              child_birthday: __WEBPACK_IMPORTED_MODULE_11_redux_selectors_orders__["e" /* getChildBirthday */](state)
            });
          });

        case 10:
          orderData = _context4.sent;
          local = orderData.local, uid = orderData.uid;
          _context4.next = 14;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_4_helpers_api__["a" /* default */], 'orders/save', {
            method: 'post',
            auth: true,
            body: orderData
          });

        case 14:
          response = _context4.sent;

          if (!response) {
            _context4.next = 28;
            break;
          }

          orderUID = response.uid, tracking_data = response.tracking_data;

          if (!local) {
            _context4.next = 21;
            break;
          }

          _context4.next = 20;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["w" /* renameId */](uid, orderUID));

        case 20:
          __WEBPACK_IMPORTED_MODULE_6_helpers_history__["a" /* default */].replace(__WEBPACK_IMPORTED_MODULE_6_helpers_history__["a" /* default */].location.pathname.replace(uid, orderUID));

        case 21:
          if (!tracking_data) {
            _context4.next = 24;
            break;
          }

          _context4.next = 24;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["v" /* trackEvent */]('order-create', _extends({
            orderUID: orderUID
          }, tracking_data)));

        case 24:
          _context4.next = 26;
          return orderUID;

        case 26:
          _context4.next = 31;
          break;

        case 28:
          console.warn('Something went wrong with saving order');
          // Sentry.captureMessage('Something went wrong with saving order')

          _context4.next = 31;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["v" /* trackEvent */]('error', {
            type: 'saveOrder 1',
            orderData: JSON.stringify(orderData)
          }));

        case 31:
          _context4.next = 41;
          break;

        case 33:
          _context4.prev = 33;
          _context4.t0 = _context4['catch'](0);

          pe(_context4.t0);

          // Force logout when we get 4xx error while saving

          if (!(_context4.t0 >= 400 && _context4.t0 < 500)) {
            _context4.next = 39;
            break;
          }

          _context4.next = 39;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["q" /* logout */]());

        case 39:
          _context4.next = 41;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["v" /* trackEvent */]('error', {
            type: 'saveOrder 2',
            e: _context4.t0.toString()
          }));

        case 41:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[0, 33]]);
}

function saveOnChange() {
  var initializing;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saveOnChange$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          if (false) {
            _context5.next = 12;
            break;
          }

          _context5.next = 3;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['app', 'ui', 'initializing'], true);
          });

        case 3:
          initializing = _context5.sent;

          if (!(!initializing && hasChangesToSave)) {
            _context5.next = 8;
            break;
          }

          hasChangesToSave = false;
          _context5.next = 8;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](saveOrder);

        case 8:
          _context5.next = 10;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga__["b" /* delay */](SAVE_THROTTLE);

        case 10:
          _context5.next = 0;
          break;

        case 12:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function setHasChanged() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setHasChanged$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          hasChangesToSave = true;

        case 1:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

function trackOrderActions(_ref3) {
  var type = _ref3.type,
      rest = _objectWithoutProperties(_ref3, ['type']);

  var event, data, orderId, currentSpread, simpleId, typeSaved, saved, index, value;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function trackOrderActions$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          event = void 0;
          data = void 0;
          _context7.t0 = type;
          _context7.next = _context7.t0 === __WEBPACK_IMPORTED_MODULE_15_redux_reducers_photos__["e" /* TOGGLE_SAVED */] ? 6 : _context7.t0 === __WEBPACK_IMPORTED_MODULE_15_redux_reducers_photos__["d" /* TOGGLE_FAVORITE */] ? 6 : _context7.t0 === __WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["c" /* ENABLE_EXTRA_SPREAD */] ? 15 : _context7.t0 === __WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["b" /* DISABLE_EXTRA_SPREAD */] ? 18 : _context7.t0 === __WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["i" /* SET_OPTION */] ? 21 : 23;
          break;

        case 6:
          orderId = rest.orderId, currentSpread = rest.currentSpread, simpleId = rest.simpleId;
          typeSaved = type === __WEBPACK_IMPORTED_MODULE_15_redux_reducers_photos__["e" /* TOGGLE_SAVED */];
          _context7.next = 10;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(typeSaved ? ['orders', orderId, 'saved'] : ['orders', orderId, 'favorites', currentSpread]);
          });

        case 10:
          saved = _context7.sent;
          index = saved.findIndex(function (savedSimpleId) {
            return savedSimpleId === simpleId;
          });


          event = index === -1 ? typeSaved ? 'photo_unpinned' : 'photo_deselected' : typeSaved ? 'photo_pinned' : 'photo_selected';

          data = {};
          return _context7.abrupt('break', 23);

        case 15:
          event = 'spread_added';
          data = {};

          return _context7.abrupt('break', 23);

        case 18:
          event = 'spread_removed';
          data = {};
          return _context7.abrupt('break', 23);

        case 21:
          if (rest.option === 'child') {
            // Same selected do nothing
            value = rest.value.toJS();

            if (rest.options.previousId !== value.id) {
              event = 'child_changed';
              data = {
                child_id: value.id,
                child_name: value.name,
                child_dob: value.birthday
              };
            }
          }

          return _context7.abrupt('break', 23);

        case 23:
          if (!event) {
            _context7.next = 26;
            break;
          }

          _context7.next = 26;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["v" /* trackEvent */](event, data));

        case 26:
          _context7.next = 33;
          break;

        case 28:
          _context7.prev = 28;
          _context7.t1 = _context7['catch'](0);

          pe(_context7.t1);

          _context7.next = 33;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["v" /* trackEvent */]('error', {
            type: 'trackOrderActions',
            e: _context7.t1.toString()
          }));

        case 33:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[0, 28]]);
}

function startPayment(_ref4) {
  var orderId = _ref4.orderId;
  var validation, allTrue, paymentInfo;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function startPayment$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["u" /* setUIState */]('failed_validating', false));

        case 2:
          _context8.next = 4;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["u" /* setUIState */]('validating', true));

        case 4:
          _context8.prev = 4;
          _context8.next = 7;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](saveOrder);

        case 7:
          _context8.next = 9;
          return validateOrderForm({ option: ['address'] });

        case 9:
          _context8.next = 11;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['app', 'orderValidation', __WEBPACK_IMPORTED_MODULE_8_redux_selectors_app__["c" /* getActiveOrderId */](state)]);
          });

        case 11:
          validation = _context8.sent;
          allTrue = validation.every(function (value) {
            return value === true;
          });

          if (!allTrue) {
            _context8.next = 22;
            break;
          }

          _context8.next = 16;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["u" /* setUIState */]('payment_forwarding', true));

        case 16:
          _context8.next = 18;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_4_helpers_api__["a" /* default */], 'orders/pay/' + orderId, {
            auth: true
          });

        case 18:
          paymentInfo = _context8.sent;


          if (paymentInfo) {
            window.location = paymentInfo.paymentUrl;
          }
          _context8.next = 24;
          break;

        case 22:
          _context8.next = 24;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["u" /* setUIState */]('failed_validating', true));

        case 24:
          _context8.next = 31;
          break;

        case 26:
          _context8.prev = 26;
          _context8.t0 = _context8['catch'](4);

          pe(_context8.t0);

          _context8.next = 31;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["v" /* trackEvent */]('error', {
            type: 'startPayment',
            e: _context8.t0.toString()
          }));

        case 31:
          _context8.next = 33;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["u" /* setUIState */]('validating', false));

        case 33:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[4, 26]]);
}

function finishOrder(_ref5) {
  var orderId = _ref5.orderId;
  var validation, allTrue, finishInfo;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function finishOrder$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["u" /* setUIState */]('failed_validating', false));

        case 2:
          _context9.next = 4;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["u" /* setUIState */]('validating', true));

        case 4:
          _context9.prev = 4;
          _context9.next = 7;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](saveOrder);

        case 7:
          _context9.next = 9;
          return validateOrderForm({ option: ['address'] });

        case 9:
          _context9.next = 11;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['app', 'orderValidation', __WEBPACK_IMPORTED_MODULE_8_redux_selectors_app__["c" /* getActiveOrderId */](state)]);
          });

        case 11:
          validation = _context9.sent;
          allTrue = validation.every(function (value) {
            return value === true;
          });

          if (!allTrue) {
            _context9.next = 22;
            break;
          }

          _context9.next = 16;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_4_helpers_api__["a" /* default */], 'orders/finish/' + orderId, {
            auth: true
          });

        case 16:
          finishInfo = _context9.sent;

          if (!finishInfo) {
            _context9.next = 20;
            break;
          }

          _context9.next = 20;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["o" /* add */](orderId, finishInfo));

        case 20:
          _context9.next = 24;
          break;

        case 22:
          _context9.next = 24;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["u" /* setUIState */]('failed_validating', true));

        case 24:
          _context9.next = 31;
          break;

        case 26:
          _context9.prev = 26;
          _context9.t0 = _context9['catch'](4);

          pe(_context9.t0);

          _context9.next = 31;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["v" /* trackEvent */]('error', {
            type: 'finishError',
            e: _context9.t0.toString()
          }));

        case 31:
          _context9.next = 33;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["u" /* setUIState */]('validating', false));

        case 33:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this, [[4, 26]]);
}

function startPaymentRenew(_ref6) {
  var orderId = _ref6.orderId;
  var reset;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function startPaymentRenew$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["u" /* setUIState */]('resetting_state', true));

        case 2:
          _context10.prev = 2;
          _context10.next = 5;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_4_helpers_api__["a" /* default */], 'orders/reset/' + orderId, {
            auth: true
          });

        case 5:
          reset = _context10.sent;

          if (!reset) {
            _context10.next = 11;
            break;
          }

          _context10.next = 9;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["t" /* setSidebar */]('order'));

        case 9:
          _context10.next = 11;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](getSingleOrder, { id: orderId, force: true });

        case 11:
          _context10.next = 18;
          break;

        case 13:
          _context10.prev = 13;
          _context10.t0 = _context10['catch'](2);

          pe(_context10.t0);

          _context10.next = 18;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["v" /* trackEvent */]('error', {
            type: 'startPaymentRenew',
            e: _context10.t0.toString()
          }));

        case 18:
          _context10.next = 20;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["u" /* setUIState */]('resetting_state', false));

        case 20:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this, [[2, 13]]);
}

/**
 * Force save after coming online
 */
function saveOnOnline() {
  var onOnlineChannel;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saveOnOnline$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_5_helpers_saga__["b" /* onEvent */], window, 'online');

        case 2:
          onOnlineChannel = _context11.sent;

        case 3:
          if (false) {
            _context11.next = 10;
            break;
          }

          _context11.next = 6;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* take */](onOnlineChannel);

        case 6:
          _context11.next = 8;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](setHasChanged);

        case 8:
          _context11.next = 3;
          break;

        case 10:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this);
}

/**
 * Validate order form
 */
function validateOrderForm(_ref7) {
  var option = _ref7.option;
  var address, validated;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function validateOrderForm$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;

          if (!(Array.isArray(option) && option[0] === 'address')) {
            _context12.next = 11;
            break;
          }

          _context12.next = 4;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_11_redux_selectors_orders__["c" /* getAddress */](state);
          });

        case 4:
          address = _context12.sent;
          _context12.next = 7;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_4_helpers_api__["a" /* default */], 'orders/validate/address', {
            method: 'post',
            body: {
              address: JSON.stringify(address.toJS())
            }
          });

        case 7:
          validated = _context12.sent;

          if (!validated) {
            _context12.next = 11;
            break;
          }

          _context12.next = 11;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["r" /* setOrderValidation */]('address', validated));

        case 11:
          _context12.next = 16;
          break;

        case 13:
          _context12.prev = 13;
          _context12.t0 = _context12['catch'](0);

          pe(_context12.t0, 'failed validateOrderForm');

        case 16:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this, [[0, 13]]);
}

/**
 * When changing special text (or setting active order)
 */
function setSpecialTexts(_ref8) {
  var option = _ref8.option,
      type = _ref8.type;

  var child, name, orderId, _name, birthday, spreadDesigns, set, item, _set$item, momentId, text;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setSpecialTexts$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.prev = 0;
          child = void 0, name = void 0;

          try {
            child = option[0];
            name = option[1];
          } catch (e) {}

          if (!(child === 'child' && (name === 'name' || name === 'birthday') || type === __WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["c" /* SET_ACTIVE_ORDER */])) {
            _context13.next = 32;
            break;
          }

          _context13.prev = 4;
          _context13.next = 7;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_8_redux_selectors_app__["c" /* getActiveOrderId */](state);
          });

        case 7:
          orderId = _context13.sent;
          _context13.next = 10;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_11_redux_selectors_orders__["g" /* getChildName */](state);
          });

        case 10:
          _name = _context13.sent;
          _context13.next = 13;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_11_redux_selectors_orders__["e" /* getChildBirthday */](state);
          });

        case 13:
          birthday = _context13.sent;
          _context13.next = 16;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_10_redux_selectors_design__["b" /* getDesignSpreads */](state);
          });

        case 16:
          spreadDesigns = _context13.sent;
          set = [];


          spreadDesigns.forEach(function (spreadDesign) {
            spreadDesign ? spreadDesign.get('moments', []).forEach(function (moment) {
              if (moment.getIn(['options', 'special_text'], false)) {
                set.push({
                  momentId: moment.get('id'),
                  text: __WEBPACK_IMPORTED_MODULE_7_helpers_string__["b" /* specialText */]('', _name, birthday, moment.getIn(['options']))
                });
              }
            }) : null;
          });

          _context13.t0 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(set);

        case 20:
          if ((_context13.t1 = _context13.t0()).done) {
            _context13.next = 27;
            break;
          }

          item = _context13.t1.value;
          _set$item = set[item], momentId = _set$item.momentId, text = _set$item.text;
          _context13.next = 25;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["C" /* updateText */](orderId, momentId, text));

        case 25:
          _context13.next = 20;
          break;

        case 27:
          _context13.next = 32;
          break;

        case 29:
          _context13.prev = 29;
          _context13.t2 = _context13['catch'](4);

          pe(_context13.t2, 'failed setSpecialTexts');

        case 32:
          _context13.next = 37;
          break;

        case 34:
          _context13.prev = 34;
          _context13.t3 = _context13['catch'](0);

          pe(_context13.t3);

        case 37:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this, [[0, 34], [4, 29]]);
}

/**
 * When first time on a spread, check and see if default text need to be saved/set
 */
function setDefaultText(_ref9) {
  var options = _ref9.options;

  var order, orderId, spreadDesign, name, birthday, date_format, set, item, _set$item2, _momentId, _text;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setDefaultText$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.prev = 0;
          _context14.next = 3;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_11_redux_selectors_orders__["i" /* getOrder */](state);
          });

        case 3:
          order = _context14.sent;
          _context14.next = 6;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_8_redux_selectors_app__["c" /* getActiveOrderId */](state);
          });

        case 6:
          orderId = _context14.sent;
          _context14.next = 9;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_10_redux_selectors_design__["d" /* getSpreadDesign */](state);
          });

        case 9:
          spreadDesign = _context14.sent;
          _context14.next = 12;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_11_redux_selectors_orders__["g" /* getChildName */](state);
          });

        case 12:
          name = _context14.sent;
          _context14.next = 15;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_11_redux_selectors_orders__["e" /* getChildBirthday */](state);
          });

        case 15:
          birthday = _context14.sent;
          date_format = 'D MMMM YYYY';
          set = [];


          spreadDesign && spreadDesign.get('moments', []).forEach(function (moment) {
            var text = moment.getIn(['options', 'placeholder_text'], '').replace(/{name}/gi, name).replace(/{birthday}/gi, __WEBPACK_IMPORTED_MODULE_17__helpers_time__["e" /* formatBirthday */](birthday, date_format));
            var momentId = moment.get('id');
            var overwrite = false;

            // Compare current to previous, if they match, we can overwrite the placeholder_text again
            if (options && 'previousName' in options && 'previousBirthDay' in options) {
              var previousText = moment.getIn(['options', 'placeholder_text'], '').replace(/{name}/gi, options.previousName || '').replace(/{birthday}/gi, options.previousBirthDay ? __WEBPACK_IMPORTED_MODULE_17__helpers_time__["e" /* formatBirthday */](options.previousBirthDay, date_format) : '');

              var currentPicked = order.getIn(['picked', momentId, 'text']);
              overwrite = previousText === currentPicked;
            }

            if (!order.getIn(['picked', momentId]) && text && moment.getIn(['options', 'placeholder_text_remove_on_edit']) === false || overwrite) {
              set.push({ momentId: momentId, text: text });
            }
          });

          _context14.t0 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(set);

        case 20:
          if ((_context14.t1 = _context14.t0()).done) {
            _context14.next = 27;
            break;
          }

          item = _context14.t1.value;
          _set$item2 = set[item], _momentId = _set$item2.momentId, _text = _set$item2.text;
          _context14.next = 25;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["C" /* updateText */](orderId, _momentId, _text));

        case 25:
          _context14.next = 20;
          break;

        case 27:
          _context14.next = 32;
          break;

        case 29:
          _context14.prev = 29;
          _context14.t2 = _context14['catch'](0);

          pe(_context14.t2, 'failed setDefaultText');

        case 32:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this, [[0, 29]]);
}

/**
 * Poll current order if state is payment_waiting
 */
function pollPaymentStatus() {
  var onPaymentPoll, isWaiting, orderUID, orderState;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function pollPaymentStatus$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_5_helpers_saga__["a" /* interval */], 5);

        case 2:
          onPaymentPoll = _context15.sent;

        case 3:
          if (false) {
            _context15.next = 21;
            break;
          }

          _context15.next = 6;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* take */](onPaymentPoll);

        case 6:
          _context15.next = 8;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_11_redux_selectors_orders__["n" /* isWaitingForPayment */](state);
          });

        case 8:
          isWaiting = _context15.sent;

          if (!isWaiting) {
            _context15.next = 19;
            break;
          }

          _context15.next = 12;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_8_redux_selectors_app__["c" /* getActiveOrderId */](state);
          });

        case 12:
          orderUID = _context15.sent;
          _context15.next = 15;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_4_helpers_api__["a" /* default */], 'orders/check-payment/' + orderUID, {
            auth: true
          });

        case 15:
          orderState = _context15.sent;

          if (!(orderState !== 'payment_waiting')) {
            _context15.next = 19;
            break;
          }

          _context15.next = 19;
          return getSingleOrder({ id: orderUID, force: true });

        case 19:
          _context15.next = 3;
          break;

        case 21:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this);
}

function saga() {
  var saveActions;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saga$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["c" /* SET_ACTIVE_ORDER */], getSingleOrder);

        case 2:
          _context16.next = 4;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["e" /* GET_ORDERS */], getOrders);

        case 4:
          _context16.next = 6;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["d" /* FINISH */], finishOrder);

        case 6:
          _context16.next = 8;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["k" /* START_PAYMENT */], startPayment);

        case 8:
          _context16.next = 10;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["l" /* START_PAYMENT_RENEW */], startPaymentRenew);

        case 10:
          _context16.next = 12;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_app__["d" /* SET_ACTIVE_SPREAD */], setDefaultText);

        case 12:
          _context16.next = 14;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["m" /* UPDATE_TEXT */], setDefaultText);

        case 14:
          _context16.next = 16;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["i" /* SET_OPTION */], setDefaultText);

        case 16:
          _context16.next = 18;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* throttle */](VALIDATION_THROTTLE, __WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["i" /* SET_OPTION */], setSpecialTexts);

        case 18:
          _context16.next = 20;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* throttle */](VALIDATION_THROTTLE, __WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["i" /* SET_OPTION */], validateOrderForm);

        case 20:
          _context16.next = 22;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */](saveOnOnline);

        case 22:
          _context16.next = 24;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */](pollPaymentStatus);

        case 24:
          saveActions = [__WEBPACK_IMPORTED_MODULE_15_redux_reducers_photos__["e" /* TOGGLE_SAVED */], __WEBPACK_IMPORTED_MODULE_15_redux_reducers_photos__["d" /* TOGGLE_FAVORITE */], __WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["f" /* PICK_MOMENT */], __WEBPACK_IMPORTED_MODULE_15_redux_reducers_photos__["c" /* SET_UPLOAD */], __WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["f" /* PICK_MOMENT */], __WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["h" /* SAVE */], __WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["h" /* UPDATE_PROFILE */], __WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["n" /* UPDATE_TRANSFORM */], __WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["m" /* UPDATE_TEXT */], __WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["i" /* SET_OPTION */], __WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["c" /* ENABLE_EXTRA_SPREAD */], __WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["b" /* DISABLE_EXTRA_SPREAD */]];
          _context16.next = 27;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](saveActions, setHasChanged);

        case 27:
          _context16.next = 29;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */]([__WEBPACK_IMPORTED_MODULE_15_redux_reducers_photos__["d" /* TOGGLE_FAVORITE */], __WEBPACK_IMPORTED_MODULE_15_redux_reducers_photos__["e" /* TOGGLE_SAVED */], __WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["c" /* ENABLE_EXTRA_SPREAD */], __WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["b" /* DISABLE_EXTRA_SPREAD */], __WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["d" /* FINISH */], __WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["i" /* SET_OPTION */]], trackOrderActions);

        case 29:
          _context16.next = 31;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */](saveOnChange);

        case 31:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[15], this);
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27)))

/***/ }),
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDesignOnChange */
/* harmony export (immutable) */ __webpack_exports__["b"] = getDesign;
/* harmony export (immutable) */ __webpack_exports__["a"] = saga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_api__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_image_preloader__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_image_preloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_image_preloader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_selectors_design__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_reducers_designs__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_reducers_orders__ = __webpack_require__(15);


var _marked = [getDesignOnChange, getDesign, saga].map(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark);











function getDesignOnChange(_ref) {
  var option = _ref.option;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getDesignOnChange$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;

          if (!(option === 'design')) {
            _context.next = 4;
            break;
          }

          _context.next = 4;
          return getDesign({});

        case 4:
          _context.next = 9;
          break;

        case 6:
          _context.prev = 6;
          _context.t0 = _context['catch'](0);

          pe(_context.t0, 'failed getDesignOnChange');

        case 9:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[0, 6]]);
}

/**
 * Get design if not available
 */
function getDesign(_ref2) {
  var designId = _ref2.designId;
  var design, newDesign;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getDesign$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;

          if (!designId) {
            _context2.next = 5;
            break;
          }

          _context2.t0 = designId;
          _context2.next = 8;
          break;

        case 5:
          _context2.next = 7;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_4_redux_selectors_design__["a" /* getCurrentDesign */](state);
          });

        case 7:
          _context2.t0 = _context2.sent;

        case 8:
          designId = _context2.t0;
          _context2.next = 11;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_4_redux_selectors_design__["c" /* getDesigns */](state).find(function (design) {
              return design.get('id') === designId;
            });
          });

        case 11:
          design = _context2.sent;

          if (!(designId && !design)) {
            _context2.next = 19;
            break;
          }

          _context2.next = 15;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_2_helpers_api__["a" /* default */], 'designs/get/' + designId);

        case 15:
          newDesign = _context2.sent;
          _context2.next = 18;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_5_redux_reducers_designs__["a" /* add */](newDesign));

        case 18:

          // Preload images
          setTimeout(function () {
            var images = [];
            Object.keys(newDesign.spreads).forEach(function (key) {
              newDesign.spreads[key].graphics.forEach(function (graphic) {
                if (images.indexOf(graphic.image) === -1) {
                  images.push(graphic.image);
                }
              });
              newDesign.spreads[key].moments.forEach(function (moment) {
                try {
                  var url = moment.options.placeholder_image.url;
                  if (images.indexOf(url) === -1) {
                    images.push(url);
                  }
                } catch (e) {}
              });
            });

            var preloader = new __WEBPACK_IMPORTED_MODULE_3_image_preloader___default.a();
            preloader.preload.apply(preloader, images).then(function () {
              p('Preloaded design images!');
            });
          }, 2000);

        case 19:
          _context2.next = 24;
          break;

        case 21:
          _context2.prev = 21;
          _context2.t1 = _context2['catch'](0);

          pe(_context2.t1, 'failed getDesign');

        case 24:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[0, 21]]);
}

function saga() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_7_redux_reducers_orders__["i" /* SET_OPTION */], getDesignOnChange);

        case 2:
          _context3.next = 4;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_6_redux_reducers_app__["c" /* SET_ACTIVE_ORDER */], getDesign);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = localStoragePull;
/* harmony export (immutable) */ __webpack_exports__["c"] = localStoragePush;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearLocalStorage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers_auth__ = __webpack_require__(90);



var initialState = __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"]();
var storage = {
  token: {
    path: ['user', 'token'],
    temp: null,
    getter: __WEBPACK_IMPORTED_MODULE_1_helpers_auth__["b" /* getToken */],
    setter: __WEBPACK_IMPORTED_MODULE_1_helpers_auth__["c" /* setToken */]
  },
  activeSpreadIds: {
    path: ['app', 'activeSpreadIds'],
    temp: null
  }
};

function localStoragePull() {
  Object.keys(storage).forEach(function (key) {
    var value = storage[key].getter ? storage[key].getter() : JSON.parse(localStorage.getItem(key));
    if (value) {
      storage[key].temp = __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"](value);
      initialState = initialState.setIn(storage[key].path, storage[key].temp);
    }
  });

  return initialState;
}

function localStoragePush(store) {
  store.subscribe(function () {
    var state = store.getState();

    var updating = [];
    var removing = [];

    Object.keys(storage).forEach(function (key) {
      var _storage$key = storage[key],
          path = _storage$key.path,
          temp = _storage$key.temp;

      var currentValue = state.getIn(path);

      if (temp !== currentValue) {
        if (storage[key].setter) {
          updating.push(key);
          storage[key].setter(currentValue);
        } else {
          if (currentValue && (!storage[key].doSet || storage[key].doSet(state))) {
            updating.push(key);
            localStorage.setItem(key, JSON.stringify(currentValue));
          } else {
            removing.push(key);
            localStorage.removeItem(key);
          }
        }
        storage[key].temp = currentValue;
      }
    });

    if (updating.length > 0 || removing.length > 0) {
      p('Writing to localStorage', 'updating: [', updating.join(', '), '] removing: [', removing.join(', '), ']');
    }
  });
}

function clearLocalStorage() {
  Object.keys(storage).forEach(function (key) {
    localStorage.removeItem(key);
  });
}

/***/ }),
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Heart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Heart(props) {
  var styles = props.height ? { height: props.height } : null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({
      preserveAspectRatio: "xMidYMid",
      viewBox: "0 0 35 30",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      style: styles,
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "translate(-15.000000, -329.000000)", fill: "#1B1B1B" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { transform: "translate(0.000000, 329.000000)" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            { transform: "translate(15.000000, 0.000000)" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M32.1464286,15.2614286 C32.1464286,15.2621429 32.1457143,15.2628571 32.145,15.2635714 L19.6885714,29.0914286 C19.1671429,29.6764286 18.4635714,30 17.7092857,30 L17.7078571,30 C16.9542857,30 16.2514286,29.6764286 15.7285714,29.0892857 L3.27571429,15.2635714 C3.275,15.2628571 3.275,15.2621429 3.27428571,15.2614286 C-0.152142857,11.7664286 -0.145714286,6.10571429 3.29785714,2.62285714 C4.97214286,0.931428571 7.19642857,0 9.56214286,0 C11.9285714,0 14.1528571,0.931428571 15.8257143,2.62285714 C15.8285714,2.625 15.8292857,2.62857143 15.8314286,2.63071429 C15.8342857,2.63357143 15.8378571,2.63428571 15.8407143,2.63714286 L17.71,4.64071429 L19.5807143,2.63714286 C19.5835714,2.635 19.5871429,2.63357143 19.5892857,2.63142857 C19.5921429,2.62857143 19.5928571,2.625 19.595,2.62285714 C21.2685714,0.931428571 23.4928571,0 25.8585714,0 C28.225,0 30.4492857,0.931428571 32.1221429,2.62285714 C35.5635714,6.10571429 35.57,11.7664286 32.1464286,15.2614286 Z M31.1185714,3.63142857 C29.7135714,2.21142857 27.8457143,1.42857143 25.8585714,1.42857143 C23.8735714,1.42857143 22.0071429,2.21 20.6014286,3.62857143 L18.225,6.17285714 C18.22,6.17785714 18.2128571,6.17928571 18.2078571,6.185 C18.2021429,6.19071429 18.2007143,6.19785714 18.195,6.20357143 C18.1521429,6.24357143 18.1014286,6.26642857 18.0521429,6.29428571 C18.0257143,6.30928571 18.0035714,6.33142857 17.9757143,6.34285714 C17.89,6.37785714 17.8,6.39714286 17.7092857,6.39714286 C17.6185714,6.39714286 17.5285714,6.37785714 17.4435714,6.34285714 C17.415,6.33142857 17.3921429,6.30857143 17.365,6.29357143 C17.3164286,6.26571429 17.2657143,6.24357143 17.2235714,6.20357143 C17.2178571,6.19785714 17.2164286,6.19071429 17.2107143,6.185 C17.2057143,6.17928571 17.1985714,6.17785714 17.1935714,6.17285714 L14.8164286,3.62571429 C13.4114286,2.20928571 11.5464286,1.42857143 9.56214286,1.42857143 C7.575,1.42857143 5.70714286,2.21142857 4.30142857,3.63142857 C1.4,6.56642857 1.4,11.3435714 4.30214286,14.2792857 C4.30642857,14.2835714 4.30785714,14.29 4.31214286,14.2942857 C4.31571429,14.2985714 4.32071429,14.3 4.32428571,14.3035714 L16.78,28.1321429 C17.0335714,28.4157143 17.3621429,28.5714286 17.7085714,28.5714286 L17.7092857,28.5714286 C18.0564286,28.5714286 18.3857143,28.4164286 18.6371429,28.1342857 L31.0964286,14.3035714 C31.1,14.3 31.105,14.2985714 31.1085714,14.2942857 C31.1128571,14.29 31.1142857,14.2835714 31.1185714,14.2792857 C34.0185714,11.3435714 34.0185714,6.56642857 31.1185714,3.63142857 Z",
              id: "Shape"
            })
          )
        )
      )
    )
  );
}

/***/ }),
/* 172 */,
/* 173 */,
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(175);


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "container", function() { return container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isWidgetContainer", function() { return isWidgetContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_create__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_nl__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_nl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_nl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__languages_nl__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fonts_Alijt_stylesheet_scss__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fonts_Alijt_stylesheet_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__fonts_Alijt_stylesheet_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fonts_Andrea_stylesheet_scss__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fonts_Andrea_stylesheet_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__fonts_Andrea_stylesheet_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fonts_Baskerville_stylesheet_scss__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fonts_Baskerville_stylesheet_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__fonts_Baskerville_stylesheet_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fonts_BrandonGrotesque_stylesheet_scss__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fonts_BrandonGrotesque_stylesheet_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__fonts_BrandonGrotesque_stylesheet_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fonts_EmilysCandy_stylesheet_scss__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fonts_EmilysCandy_stylesheet_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__fonts_EmilysCandy_stylesheet_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fonts_FiraSans_stylesheet_scss__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fonts_FiraSans_stylesheet_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__fonts_FiraSans_stylesheet_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fonts_Luna_stylesheet_scss__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fonts_Luna_stylesheet_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__fonts_Luna_stylesheet_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__fonts_PlayfairDisplay_stylesheet_scss__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__fonts_PlayfairDisplay_stylesheet_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__fonts_PlayfairDisplay_stylesheet_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__fonts_Professor_stylesheet_scss__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__fonts_Professor_stylesheet_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__fonts_Professor_stylesheet_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__fonts_ProximaNova_stylesheet_scss__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__fonts_ProximaNova_stylesheet_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__fonts_ProximaNova_stylesheet_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__fonts_Quicksand_stylesheet_scss__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__fonts_Quicksand_stylesheet_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__fonts_Quicksand_stylesheet_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__fonts_Rollerscript_stylesheet_scss__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__fonts_Rollerscript_stylesheet_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__fonts_Rollerscript_stylesheet_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__fonts_RubikDirt_stylesheet_scss__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__fonts_RubikDirt_stylesheet_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__fonts_RubikDirt_stylesheet_scss__);


 //this needs to be here because it needs to be loaded before redux






















var initialState = window.__data || {};
var store = __WEBPACK_IMPORTED_MODULE_4__redux_create__["a" /* default */](initialState);

var container = document.getElementById('app');
var isWidgetContainer = container && 'widget' in container.dataset;

__WEBPACK_IMPORTED_MODULE_5_react_intl__["b" /* addLocaleData */]([].concat(__WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_nl___default.a));

// addLocaleData(nl);
// addLocaleData({
// 	locale: 'nl',
// 	parentLocale: 'nl',
// });
// const { locale, messages } = window.App;
var Root = function Root() {
  return isWidgetContainer ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* IntlProvider */],
    { locale: 'nl', message: __WEBPACK_IMPORTED_MODULE_7__languages_nl__["a" /* default */] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["R" /* Widget */], null)
  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_redux__["a" /* Provider */],
    { store: store },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* IntlProvider */],
      { locale: 'nl' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["a" /* App */], null)
    )
  );
};

/* harmony default export */ __webpack_exports__["default"] = (Root);

if (!module.hot && container) {
  __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Root, null), container);
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(176)(module)))

/***/ }),
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nl__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en__ = __webpack_require__(269);




/* harmony default export */ __webpack_exports__["a"] = ({
  nl: __WEBPACK_IMPORTED_MODULE_1__nl__["a" /* default */],
  de: __WEBPACK_IMPORTED_MODULE_0__de__["a" /* default */],
  en: __WEBPACK_IMPORTED_MODULE_2__en__["a" /* default */],
  at: __WEBPACK_IMPORTED_MODULE_0__de__["a" /* default */],
  be: __WEBPACK_IMPORTED_MODULE_1__nl__["a" /* default */]
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  loadingFirstMessage: 'Einen Moment bitte, der Designer lädt...',
  checking: 'Überprüfen...',
  cash: 'Einlösen',
  toLogin: 'Anmelden',
  payoff: 'Jedes Kind verdient eine Geschichte',
  login: 'Anmelden',
  loginForgot: 'vergessen',
  loginIntro: 'Hier kannst du ein Konto erstellen. Falls du bereits eines hast, melde dich weiter unten direkt an.',
  loginFailed: 'Anmeldung fehlgeschlagen',
  loginNoAccount: 'Ich habe noch kein Konto',
  loginSendNew: 'Neues Passwort anfordern',
  accountCreate: 'Konto erstellen',
  accountAlready: 'Schon ein Konto? Hier anmelden',
  voucherPersonalCode: 'Ich habe einen persönlichen Code',
  voucherIntro: 'Gib deinen persönlichen Code ein. Du findest den Code in der Bestätigungsmail.',
  voucherInvalid: 'Gib einen gültigen Code mit 15 Zeichen ein, einschließlich der Bindestriche. Zum Beispiel 2Wpa-SFtB-999c.',
  backToLogin: 'Zurück zum Anmeldeschirm',
  passwordRequest: 'Neues Passwort anfordern',
  passwordRequestSend: 'Eine E-Mail mit weiteren Anweisungen wurde versendet.',
  passwordRequestRemember: 'Ist dir dein Passwort wieder eingefallen?',
  childIntro: 'Gib zuerst den Namen und das Geburtsdatum deines Kindes ein. Sie werden bereits auf einigen Seiten für dich eingefügt.',
  menuAccount: 'Konto',
  menuOrder: 'Bestellen',
  menuChild: 'Kind',
  menuDesigns: 'Designs',
  menuPhotos: 'Bearbeiten',
  menuHelp: 'Hilfe',
  photosChooseMore: 'Weitere Fotos auswählen',
  photosChoose: 'Fotos auswählen',
  assignmentSelectPhotosFirst: 'Lies zuerst deine Fotos ein',
  assignmentSelectPhotos: 'Fotos einlesen',
  assignmentClose: 'Zurück',
  notificationReady: 'Hurra! du bist fertig. Kontrolliere bitte alle Texte und Fotos noch einmal gründlich.',
  notificationGoToOrder: 'Zur Bestellung',
  orderUnfinishedFirstPart: 'Du kannst noch nicht bestellen. Füge erst überall Fotos und Texte hinzu. Wenn du noch ein gelbes Symbol siehst, fehlt noch etwas. Wenn alle Symbole grün sind, überprüfe noch einmal alles.',
  orderUnfinishedSecondPart: 'Viel Spaß',
  orderIntro: 'Gib die Adresse ein, an die wir dein Fotoalbum senden sollen.',

  kidSectionTtitle: 'Kind',
  childBookTargetInput: 'Dieses Fotoalbum ist für:',
  childBookStartButtonOption1: 'Füge ein Kind hinzu',
  childBookStartButtonOption2: 'Ein weiteres Kind hinzufügen',
  childBookTargetOption1: 'Für wen möchtest du das Fotoalbum gestalten:',
  childBookTargetOption2: 'Oder erstelle es für ein anderes Kind:',
  childFormInputNameLabel: 'Vorname',
  childFormInputNamePlaceholder: 'Vorname deines Kindes',
  childFormInputLettersInformation: 'Du kannst maximal 12 Zeichen eingeben.',
  childFormInputDateLabel: 'Geburtsdatum',
  backButton: 'Zurück',
  getStartedButton: "Los geht's",

  cameraRollTab: 'Meine Fotos',
  pinupTab: 'Pinnwand',
  savedPhotosInformation: 'Gespeicherte Fotos, die bei anderen Aufgaben verwendet werden können',

  designInformations: 'Probier die Designs aus. Deine Arbeit geht nicht verloren.',

  photoDoesntUploadAlert: 'Ein Foto wurde nicht hochgeladen, weil es zu groß ist (maximal 60 MB) oder nicht im JPG-Format vorliegt.',
  photoDoesntUploadAlertPlural: 'Es wurden {rejectedFiles} Fotos nicht hochgeladen, weil sie zu groß sind (maximal 60 MB) oder nicht im JPG-Format vorliegen.',
  callToUseThePhotos: 'Lasse los, um deine Fotos zu verwenden',

  personalGiftCodeLabel: 'Persönlicher Code',
  cachedVoucherTitle: 'Code einlösen',

  loginCredentialsTitle: 'Anmelden',
  loginEmailInputLabel: 'E-Mail-Adresse',
  loginErrorMessage: 'Du kannst dich nicht mit einem Administrator-Konto anmelden',
  loginPasswordInput: 'Passwort',
  forgotPasswordSectionTitle: 'Passwort vergessen',
  forgotPasswordEmailPlaceholder: 'Gib deine E-Mail-Adresse ein',
  makeAccountTitleStep1: 'Konto erstellen (1/2)',
  signupFirstNameInputLabel: 'Vorname',
  signupFirstNamePlaceholder: 'Gib deinen Vornamen ein',
  signupEmailInputLabel: 'E-Mail-Adresse',
  signupPasswordInputLabel: 'Passwort',
  acceptPrivacyStatementFirstPart: 'Ich stimme den ',
  acceptPrivacyStatementSecondPart: 'Allgemeinen Geschäftsbedingungen und Datenschutzerklärung zu.',

  smallScreensMessage1: 'Leider ist Kroost noch nicht für Mobilgeräte oder kleinere Geräte verfügbar.',
  smallScreensMessage2: 'Bist du auf deinem Laptop oder Desktop? Mach den Bildschirm deines Browsers so groß wie möglich.',

  rotate: 'Drehen',
  mirror: 'Spiegeln',
  zoomIn: 'Vergrößern',
  zoomOut: 'Verkleinern',

  warningToAdjustPhotoPart1: 'Um eine gute Druckqualität zu erzielen, musst du dieses Foto anpassen.',
  warningToAdjustPhotoPart2: 'Was kann ich tun?',

  logout: 'Abmelden',
  account: 'Konto',
  loading: 'Wird geladen...',
  openNewBook: 'Ein neues Buch öffnen',

  logout2: 'Abmelden',

  notReadyMessagePart1: 'Bevor du bestellen kannst, musst du ',
  notReadyMessagePart2: 'ein Konto erstellen',
  notReadyMessagePart3: ', damit wir die Fotos verarbeiten können',
  uploadingPhotosMessage: 'Noch nicht alle Fotos wurden hochgeladen',
  loading2: 'Alben werden geladen...',
  backToPay: 'Zurück zur Bezahlung',
  surname: 'Nachname',
  street: 'Straße',
  houseNumber: 'Hausnummer',
  postCode: 'Postleitzahl',
  city: 'Wohnort',
  country: 'Land',
  phone: 'Telefonnummer',
  amount: 'Menge',
  warningMessageBeforeForNoChanges: 'Du kannst diese Bestellung nicht mehr ändern',
  fillTheFieldsMessage: 'Bitte fülle die rot markierten Pflichtfelder aus.',
  checking2: 'Überprüfung...',
  orderComplete: 'Bestellung abschicken',
  orderTitle: 'Bestellen',

  preferdName: ' Vorname',
  dateOfBirth: 'Geboren am (voraussichtlich)',
  makeYourBook: 'Gestalte dein Buch',

  failedUploadWarning: 'Beim Hochladen der Fotos ist leider ein Fehler aufgetreten. Wenn dies weiterhin passiert, kontaktiere uns bitte.',
  uploandingFaliedMessage: 'Das Hochladen von {fileName} ist fehlgeschlagen',
  feedbackUploadingMessage: '{fileName} wird hochgeladen',
  uploadSuccessMessage: '{fileName} wurde hochgeladen',

  usedPhotoMessageSingular: 'Dieses Foto wurde auf 1 Seite verwendet',
  usedPhotoMessagePlural: 'Dieses Foto wurde auf {count} Seiten verwendet',

  newPasswordLabel: 'Neues Passwort',
  newPasswordPlaceholder: 'Dein neues Passwort',
  formErrorMessage: ' Das Zurücksetzen ist fehlgeschlagen, der Link ist nur 24 Stunden gültig. Fordere ihn erneut an.',
  passwordButtonSubmit: 'Passwort ändern',

  saveSuccessTitle: 'Konto erstellen (2/2)',
  enterTheNameOfChildButton: 'Trage den Namen deines Kindes ein',
  saveSuccessMessagePart1: 'Dein Konto wurde erstellt. Alle Änderungen, die du in deinem Fotoalbum vornimmst, werden automatisch sofort gespeichert.',
  saveSuccessMessagePart2: 'Viel Spaß!',
  netherlands: 'Niederlande',
  belgium: 'Belgien',
  germany: 'Deutschland',
  austria: 'Österreich',
  paymentWaitingMessage: 'Die Zahlung wurde abgebrochen oder ist fehlgeschlagen. Gehe zurück zur Zahlung, um erneut zu bezahlen.',
  paymentFailedMessage: 'Die Zahlung wurde abgebrochen oder ist fehlgeschlagen. Gehe zurück zur Zahlung, um erneut zu bezahlen.',
  paymentSuccessMessagePart1: 'Vielen Dank für deine Bestellung - wir machen uns sofort an die Arbeit! Unsere Bestellbestätigung findest du in deinem E-Mail-Postfach. Noch ein wenig Geduld, und schon bald hältst du dein neues Fotoalbum in den Händen!',
  greetins: 'Fröhliche Grüße,',
  teamKroost: 'dein Kroost-Team',
  shippingSendMessagePart1: 'Deine Bestellung wird innerhalb von 10 Tagen geliefert. Noch ein bisschen warten und dann kann der Genuss beginnen!',
  shippingReceivedMessage: '  Deine Bestellung wurde zugestellt. Viel Spaß damit!',
  mergingPhotos: '{mergedPhotos} von den {photos} fotos eingelesen',
  doneNotificationMessage: '{mergedPhotos} Fotos eingelesen',
  notUsedPhotosMessage: ' - {notused} ignoriert',
  year: 'Jahr',
  months: 'Monat',
  monthsPlural: 'Monate',
  day: 'Tag',
  days: 'Tage',
  week: 'Woche',
  weekPlural: 'Wochen',
  birthday: 'Geburtstag!'
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  loadingFirstMessage: 'Just a moment, the designer is loading.',
  checking: 'Checking...',
  cash: 'Cash',
  toLogin: 'Go to login',
  payoff: 'for when you grow up',
  login: 'Log in',
  loginForgot: 'forgot',
  loginIntro: 'First, create an account or log in if you already have one.',
  loginFailed: 'Login failed',
  loginNoAccount: 'I don’t have an account',
  loginSendNew: 'Send me a new login',
  accountCreate: 'Create an account',
  accountAlready: ' Already have an account? Log in here',
  voucherPersonalCode: 'I have a personal code',
  voucherIntro: 'Enter your personal code. You can find the code on the back of your voucher or in the confirmation email.',
  voucherInvalid: 'Enter a valid code of 15 characters including dashes. For example, 2Wpa-SFtB-999c.',
  backToLogin: 'Back to login screen',
  passwordRequest: 'Send me a new login',
  passwordRequestSend: 'An email has been sent with further instructions.',
  passwordRequestRemember: 'Remember your password?',
  childIntro: 'First, enter the name and birthdate of your child. They will already be added for you.',
  menuAccount: 'account',
  menuOrder: 'order',
  menuChild: 'child',
  menuDesigns: 'designs',
  menuPhotos: 'edit',
  menuHelp: 'help',
  photosChooseMore: 'Choose more photos',
  photosChoose: 'Choose your photos',
  assignmentSelectPhotosFirst: 'Read your photos first',
  assignmentSelectPhotos: 'Read photos',
  assignmentClose: 'Close film roll',
  notificationReady: 'Hooray! You are done. --- Double-check all text and photos carefully.',
  notificationGoToOrder: 'Go to order',
  orderUnfinishedFirstPart: 'You cannot order yet. First, add photos and text everywhere. If you still see a yellow dot, you need to add something. If all dots are green, double-check your work. Have fun!',
  orderUnfinishedSecondPart: ' Have fun !',
  orderIntro: 'Enter your address.',

  kidSectionTtitle: 'Child',
  childBookTargetInput: 'This book is for:',
  childBookStartButtonOption1: 'Add a child',
  childBookStartButtonOption2: 'Add another child',
  childBookTargetOption1: 'Who are you making the book for:',
  childBookTargetOption2: 'Or make it for your other child:',
  childFormInputNameLabel: 'First Name',
  childFormInputNamePlaceholder: 'Your child’s first name',
  childFormInputLettersInformation: 'Cannot be longer than 12 characters',
  childFormInputDateLabel: 'Date of Birth',
  backButton: 'Back',
  getStartedButton: 'Get started',

  cameraRollTab: 'Camera roll',
  pinupTab: 'Pinboard',
  savedPhotosInformation: 'Saved photos to use in other assignments',

  designInformations: 'Try out the designs. Your work won’t be lost.',

  photoDoesntUploadAlert: 'One photo was not uploaded because it is too large (max 60 MB) or not in JPG format.',
  photoDoesntUploadAlertPlural: 'There are {rejectedFiles} photos not uploaded because they are too large (max 60 MB) or not in JPG format.',
  callToUseThePhotos: 'Release to use your photos',

  personalGiftCodeLabel: 'Your personal code',
  cachedVoucherTitle: 'Redeem voucher',

  loginCredentialsTitle: 'Log in to your account',
  loginEmailInputLabel: 'Email address',
  loginErrorMessage: 'You cannot log in with an administrator account',
  loginPasswordInput: 'Password',
  forgotPasswordSectionTitle: 'Forgot Password',
  forgotPasswordEmailPlaceholder: 'Your email address',
  makeAccountTitleStep1: 'Create Account (1/2)',
  signupFirstNameInputLabel: 'Your First Name',
  signupFirstNamePlaceholder: 'First Name',
  signupEmailInputLabel: 'Your email address',
  signupPasswordInputLabel: 'Choose a password',
  acceptPrivacyStatementFirstPart: 'I agree to the ',
  acceptPrivacyStatementSecondPart: 'terms and privacy statement',

  smallScreensMessage1: 'Unfortunately, Kroost is not available for mobile or smaller devices yet.',
  smallScreensMessage2: 'Are you on your laptop or desktop? Make your browser screen as large as possible.',

  rotate: 'Rotate',
  mirror: 'Mirror',
  zoomIn: 'Zoom In',
  zoomOut: 'Zoom Out',

  warningToAdjustPhotoPart1: 'To achieve good print quality, you need to adjust this photo.',
  warningToAdjustPhotoPart2: 'What can I do?',

  logout: 'Log out',
  account: 'Account',
  loading: 'Loading...',
  openNewBook: 'Open a new book',

  logout2: 'Logout',

  notReadyMessagePart1: 'Before you can order, you need to ',
  notReadyMessagePart2: 'create an account',
  notReadyMessagePart3: ', so we can process the photos',
  uploadingPhotosMessage: 'Not all photos have been uploaded yet',
  loading2: 'Loading...',
  backToPay: 'Back to payment',
  surname: 'Surname',
  street: 'Street',
  houseNumber: 'House Number',
  postCode: 'Postcode',
  city: 'City',
  country: 'Country',
  phone: 'Phone Number',
  amount: 'Amount',
  warningMessageBeforeForNoChanges: 'You can no longer modify this order',
  fillTheFieldsMessage: 'Fill the red fields to proceed',
  checking2: 'Checking...',
  orderComplete: 'Complete Order',
  orderTitle: 'Order',

  preferdName: ' Preferred Name',
  dateOfBirth: 'Born on (expected)',
  makeYourBook: 'Make Your Book',

  failedUploadWarning: 'Unfortunately, something went wrong with uploading the photos. If this continues to happen, please contact us.',
  uploandingFaliedMessage: 'Uploading {fileName} failed',
  feedbackUploadingMessage: '{fileName} is being uploaded',
  uploadSuccessMessage: '{fileName} has been uploaded',

  usedPhotoMessageSingular: 'This photo is used in 1 place',
  usedPhotoMessagePlural: 'This photo is used in {count} places',

  newPasswordLabel: 'New password',
  newPasswordPlaceholder: 'Your new password',
  formErrorMessage: ' Password reset failed, the link is only valid for 24 hours. Request again.',
  passwordButtonSubmit: 'Change password',

  saveSuccessTitle: 'Create Account (2/2)',
  enterTheNameOfChildButton: 'Enter your child’s name',
  saveSuccessMessagePart1: 'Your account has been created. All changes are automatically and immediately saved.',
  saveSuccessMessagePart2: 'Enjoy!',
  netherlands: 'Netherlands',
  belgium: 'Belgium',
  germany: 'Germany',
  austria: 'Austria',
  paymentWaitingMessage: 'The payment has been aborted or failed. Go back to payment to pay again.',
  paymentFailedMessage: 'The payment has been aborted or failed. Go back to payment to pay again.',
  paymentSuccessMessagePart1: 'We are working on it for you. Check your email for confirmation. Just a little more waiting, then enjoy!',
  greetings: 'Cheerful greetings,',
  teamKroost: 'Team Kroost',
  shippingSendMessagePart1: "Your order has been sent by letter post. So, you don't have to stay at home. Just a little more waiting, then you can start enjoying!",
  shippingReceivedMessage: '  Your order has been delivered. Enjoy!',
  mergingPhotos: '{mergedPhotos} out of the {photos} photos read',
  doneNotificationMessage: '{mergedPhotos} photos read',
  notUsedPhotosMessage: ' - {notused} ignored',
  year: 'year',
  months: 'month',
  monthsPlural: 'months',
  day: 'day',
  days: 'days',
  week: 'week',
  weekPlural: 'weeks',
  birthday: 'Birthday!'
});

/***/ }),
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configureStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sagas__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_localstorage_sync__ = __webpack_require__(166);






// import * as Sentry from '@sentry/browser'

var sagaMiddleware = __WEBPACK_IMPORTED_MODULE_2_redux_saga__["a" /* default */]();
var runningSagas = [];

var _store = null;

var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || __WEBPACK_IMPORTED_MODULE_0_redux__["c" /* compose */];

function configureStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (_store) {
    return _store;
  }

  // Get items from storage and merge in initial state
  var localStorageState = __WEBPACK_IMPORTED_MODULE_5_helpers_localstorage_sync__["b" /* localStoragePull */]();
  var immutableState = __WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"](initialState).merge(localStorageState);

  _store = __WEBPACK_IMPORTED_MODULE_0_redux__["d" /* createStore */](__WEBPACK_IMPORTED_MODULE_3__reducers__["a" /* default */], immutableState, composeEnhancers(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */](sagaMiddleware)));

  // Create hook for async sagas
  var startSagas = function startSagas(sagas) {
    runningSagas.forEach(function (task) {
      return task.cancel();
    });
    runningSagas = sagas.map(function (saga) {
      return sagaMiddleware.run(saga);
    });
  };
  startSagas(__WEBPACK_IMPORTED_MODULE_4__sagas__["a" /* default */]);

  // Push to localstorage
  __WEBPACK_IMPORTED_MODULE_5_helpers_localstorage_sync__["c" /* localStoragePush */](_store);

  if (false) {
    module.hot.accept('./reducers', function () {
      var nextRootReducer = require('./reducers').default;
      _store.replaceReducer(nextRootReducer);
    });
    module.hot.accept('./sagas', function () {
      var nextSagas = require('./sagas').default;
      startSagas(nextSagas);
    });
  }

  return _store;
}

/***/ }),
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__photos__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__books__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__designs__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__orders__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stats__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__giftcards__ = __webpack_require__(66);











/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"]({
  app: __WEBPACK_IMPORTED_MODULE_1__app__["i" /* default */],
  user: __WEBPACK_IMPORTED_MODULE_2__user__["l" /* default */],
  photos: __WEBPACK_IMPORTED_MODULE_3__photos__["h" /* default */],
  books: __WEBPACK_IMPORTED_MODULE_4__books__["a" /* default */],
  designs: __WEBPACK_IMPORTED_MODULE_5__designs__["b" /* default */],
  orders: __WEBPACK_IMPORTED_MODULE_6__orders__["q" /* default */],
  stats: __WEBPACK_IMPORTED_MODULE_7__stats__["b" /* default */],
  giftcards: __WEBPACK_IMPORTED_MODULE_8__giftcards__["d" /* default */]
}));

/***/ }),
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__photos__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__moments__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__design__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__books__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__orders__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stats__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__analytics__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__giftcards__ = __webpack_require__(356);











/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_0__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__user__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__photos__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__moments__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__design__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__books__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__orders__["b" /* default */], __WEBPACK_IMPORTED_MODULE_7__stats__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__analytics__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__giftcards__["a" /* default */]]);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dimensionUpdater */
/* harmony export (immutable) */ __webpack_exports__["a"] = saga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_history__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_saga__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_reducers_user__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_selectors_books__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_selectors_user__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_sagas_books__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_sagas_orders__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_sagas_design__ = __webpack_require__(165);


var _marked = [init, dimensionUpdater, saga].map(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark);

















function init(_ref) {
  var bookId = _ref.bookId,
      orderId = _ref.orderId,
      createOrder = _ref.createOrder;

  var authenticated, hadOrderId, books, _order, orders, book, name, birthday, order, _orders, designId, firstSpread, activeSpread, location;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function init$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_7_redux_selectors_user__["c" /* isAuthenticated */](state);
          });

        case 2:
          authenticated = _context.sent;
          hadOrderId = orderId;
          _context.next = 6;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["l" /* setActiveOrder */](orderId));

        case 6:
          _context.next = 8;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_8_redux_sagas_books__["b" /* getBooks */]);

        case 8:
          books = _context.sent;


          // If only 1 book available, pick the first
          if (books && books.count() === 1 && !bookId) {
            bookId = books.getIn([0, 'id']);
          }

          // Only get order when authenticated

          if (!authenticated) {
            _context.next = 22;
            break;
          }

          if (!orderId) {
            _context.next = 17;
            break;
          }

          _context.next = 14;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_9_redux_sagas_orders__["d" /* getSingleOrder */], { id: orderId });

        case 14:
          _order = _context.sent;

          orderId = _order ? orderId : null;
          bookId = _order ? bookId : null;

        case 17:
          if (!(!orderId && !createOrder)) {
            _context.next = 22;
            break;
          }

          _context.next = 20;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_9_redux_sagas_orders__["c" /* getOrders */]);

        case 20:
          orders = _context.sent;

          // Pick first when only single order is returned
          if (orders && orders.count() > 1) {
            orderId = orders.keySeq().first();
          }

        case 22:
          if (!createOrder) {
            _context.next = 27;
            break;
          }

          book = createOrder.book, name = createOrder.name, birthday = createOrder.birthday;
          _context.next = 26;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_9_redux_sagas_orders__["a" /* createNewOrder */], {
            book: book,
            name: name,
            birthday: birthday,
            onlyWhenEmpty: false,
            pushHistory: false
          });

        case 26:
          orderId = _context.sent;

        case 27:
          _context.next = 29;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['orders', orderId]);
          });

        case 29:
          order = _context.sent;

          if (order) {
            _context.next = 36;
            break;
          }

          orderId = null;

          // Set orderId of latest book
          _context.next = 34;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.get('orders');
          });

        case 34:
          _orders = _context.sent;

          if (_orders && _orders.count() > 0) {
            orderId = _orders.keySeq().first();
          }

        case 36:
          if (!orderId) {
            _context.next = 45;
            break;
          }

          _context.next = 39;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['orders', orderId, 'design']);
          });

        case 39:
          designId = _context.sent;
          _context.next = 42;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_10_redux_sagas_design__["b" /* getDesign */], { designId: designId });

        case 42:
          _context.next = 44;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['orders', orderId, 'book']);
          });

        case 44:
          bookId = _context.sent;

        case 45:
          _context.next = 47;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["l" /* setActiveOrder */](orderId));

        case 47:
          if (!orderId) {
            _context.next = 50;
            break;
          }

          _context.next = 50;
          return __WEBPACK_IMPORTED_MODULE_9_redux_sagas_orders__["e" /* setSpecialTexts */]({ type: __WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["c" /* SET_ACTIVE_ORDER */] });

        case 50:
          _context.next = 52;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_6_redux_selectors_books__["d" /* getCurrentBookSpreads */](state).getIn([0, 'id']);
          });

        case 52:
          firstSpread = _context.sent;
          _context.next = 55;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['app', 'activeSpreadIds', orderId], firstSpread);
          });

        case 55:
          activeSpread = _context.sent;
          _context.next = 58;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["m" /* setActiveSpread */](activeSpread));

        case 58:
          _context.next = 60;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["p" /* setInitializing */](false));

        case 60:
          location = '/';

          if (bookId && orderId) {
            location = '/' + bookId + '/' + orderId;
          }

          if (hadOrderId && orderId !== hadOrderId || location && __WEBPACK_IMPORTED_MODULE_2_helpers_history__["a" /* default */].location.pathname.substring(0, location.length) !== location) {
            __WEBPACK_IMPORTED_MODULE_2_helpers_history__["a" /* default */].replace(location);
          }

          // Start listening to profile update
          _context.next = 65;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_5_redux_reducers_user__["h" /* UPDATE_PROFILE */], __WEBPACK_IMPORTED_MODULE_9_redux_sagas_orders__["c" /* getOrders */]);

        case 65:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function dimensionUpdater() {
  var onResizeChannel, width, height;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function dimensionUpdater$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_3_helpers_saga__["b" /* onEvent */], window, 'resize', null, 50);

        case 2:
          onResizeChannel = _context2.sent;

        case 3:
          if (false) {
            _context2.next = 18;
            break;
          }

          _context2.next = 6;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* take */](onResizeChannel);

        case 6:
          _context2.prev = 6;
          width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
          height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
          _context2.next = 11;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["v" /* updateDimensions */](width, height));

        case 11:
          _context2.next = 16;
          break;

        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2['catch'](6);

          pe(_context2.t0, 'failed dimension update');

        case 16:
          _context2.next = 3;
          break;

        case 18:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[6, 13]]);
}

function saga() {
  var workerTask;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */](dimensionUpdater);

        case 2:
          if (false) {
            _context3.next = 12;
            break;
          }

          _context3.next = 5;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["b" /* INITIALIZE */], init);

        case 5:
          workerTask = _context3.sent;
          _context3.next = 8;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* take */](__WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["a" /* CANCEL_INITIALIZE */]);

        case 8:
          _context3.next = 10;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* cancel */](workerTask);

        case 10:
          _context3.next = 2;
          break;

        case 12:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

/***/ }),
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export passwordReset */
/* unused harmony export requestPasswordReset */
/* unused harmony export doRegister */
/* unused harmony export doLogin */
/* unused harmony export doLogout */
/* unused harmony export getProfile */
/* harmony export (immutable) */ __webpack_exports__["a"] = saga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_differenceInMinutes__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_differenceInMinutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_differenceInMinutes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_saga__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_api__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_auth__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_localstorage_sync__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers_history__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducers_orders__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selectors_orders__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__selectors_app__ = __webpack_require__(10);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _marked = [passwordReset, requestPasswordReset, doRegister, doLogin, doLogout, getProfile, doGetChildren, addChild, updateChild, updateChildTrack, refreshToken, refreshTokenTimer, saga].map(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark);

















var RESET_OFFSET = 60; // reset token when it expires in an hour or less
var CHECK_INTERVAL = 10; // Seconds to check if the token is expired

function passwordReset(_ref) {
  var user_id = _ref.user_id,
      resetToken = _ref.token,
      password = _ref.password;

  var _ref2, token, profile;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function passwordReset$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_4_helpers_api__["a" /* default */], 'user/password-reset', {
            body: {
              user_id: user_id,
              token: resetToken,
              password: password
            }
          });

        case 3:
          _ref2 = _context.sent;
          token = _ref2.token;
          profile = _ref2.profile;

          if (token) {
            _context.next = 11;
            break;
          }

          _context.next = 9;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["n" /* failedPasswordReset */]());

        case 9:
          _context.next = 18;
          break;

        case 11:
          _context.next = 13;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["u" /* setAuthToken */](token));

        case 13:
          _context.next = 15;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["x" /* updateProfile */](profile));

        case 15:
          _context.next = 17;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_8_redux_reducers_app__["t" /* setSidebar */]('myOrders'));

        case 17:

          __WEBPACK_IMPORTED_MODULE_7_helpers_history__["a" /* default */].replace('/');

        case 18:
          _context.next = 23;
          break;

        case 20:
          _context.prev = 20;
          _context.t0 = _context['catch'](0);

          pe(_context.t0);

        case 23:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[0, 20]]);
}

function requestPasswordReset(_ref3) {
  var email = _ref3.email;
  var req;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function requestPasswordReset$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_4_helpers_api__["a" /* default */], 'user/password-request', {
            body: {
              email: email
            }
          });

        case 3:
          req = _context2.sent;
          _context2.next = 9;
          break;

        case 6:
          _context2.prev = 6;
          _context2.t0 = _context2['catch'](0);

          pe(_context2.t0);

        case 9:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[0, 6]]);
}

function doRegister(_ref4) {
  var first_name = _ref4.first_name,
      email = _ref4.email,
      password = _ref4.password,
      successScreen = _ref4.successScreen;

  var giftcard, _ref5, code, token, profile, orderId, bookId;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function doRegister$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['giftcards', 'code'], null);
          });

        case 3:
          giftcard = _context3.sent;
          _context3.next = 6;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_4_helpers_api__["a" /* default */], 'user/register', {
            body: {
              first_name: first_name,
              email: email,
              password: password,
              giftcard: giftcard
            }
          });

        case 6:
          _ref5 = _context3.sent;
          code = _ref5.code;
          token = _ref5.token;
          profile = _ref5.profile;
          orderId = _ref5.orderId;
          bookId = _ref5.bookId;

          if (!code) {
            _context3.next = 17;
            break;
          }

          _context3.next = 15;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["o" /* failedRegister */](code));

        case 15:
          _context3.next = 28;
          break;

        case 17:
          _context3.next = 19;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["u" /* setAuthToken */](token));

        case 19:
          _context3.next = 21;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["x" /* updateProfile */](profile));

        case 21:
          if (!orderId) {
            _context3.next = 26;
            break;
          }

          _context3.next = 24;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_8_redux_reducers_app__["f" /* cancelInitialize */]());

        case 24:
          _context3.next = 26;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_8_redux_reducers_app__["j" /* initialize */](bookId, orderId, false, 'saveSuccess'));

        case 26:
          _context3.next = 28;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_8_redux_reducers_app__["t" /* setSidebar */](successScreen));

        case 28:
          _context3.next = 33;
          break;

        case 30:
          _context3.prev = 30;
          _context3.t0 = _context3['catch'](0);

          pe(_context3.t0);

        case 33:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[0, 30]]);
}

function doLogin(_ref6) {
  var email = _ref6.email,
      password = _ref6.password;

  var giftcard, _ref7, code, token, profile, bookId, orderId;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function doLogin$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['giftcards', 'code'], null);
          });

        case 3:
          giftcard = _context4.sent;
          _context4.next = 6;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_4_helpers_api__["a" /* default */], 'user/login', {
            body: {
              email: email,
              password: password,
              giftcard: giftcard
            }
          });

        case 6:
          _ref7 = _context4.sent;
          code = _ref7.code;
          token = _ref7.token;
          profile = _ref7.profile;
          bookId = _ref7.bookId;
          orderId = _ref7.orderId;

          if (!code) {
            _context4.next = 17;
            break;
          }

          _context4.next = 15;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["m" /* failedLogin */](code));

        case 15:
          _context4.next = 32;
          break;

        case 17:
          _context4.next = 19;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["u" /* setAuthToken */](token));

        case 19:
          _context4.next = 21;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["x" /* updateProfile */](profile));

        case 21:
          if (!orderId) {
            _context4.next = 30;
            break;
          }

          _context4.next = 24;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_8_redux_reducers_app__["f" /* cancelInitialize */]());

        case 24:
          _context4.next = 26;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_8_redux_reducers_app__["j" /* initialize */](bookId, orderId, false, 'saveSuccess'));

        case 26:
          _context4.next = 28;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_8_redux_reducers_app__["t" /* setSidebar */]('photos'));

        case 28:
          _context4.next = 32;
          break;

        case 30:
          _context4.next = 32;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_8_redux_reducers_app__["t" /* setSidebar */]('myOrders'));

        case 32:
          _context4.next = 37;
          break;

        case 34:
          _context4.prev = 34;
          _context4.t0 = _context4['catch'](0);

          pe(_context4.t0);

        case 37:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[0, 34]]);
}

function doLogout() {
  var email;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function doLogout$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['user', 'email'], null);
          });

        case 3:
          email = _context5.sent;
          _context5.next = 6;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["v" /* trackEvent */]('logged_out', {
            email: email
          }));

        case 6:
          _context5.next = 8;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["j" /* clearAuthToken */]());

        case 8:
          _context5.next = 10;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["k" /* clearProfile */]());

        case 10:

          __WEBPACK_IMPORTED_MODULE_6_helpers_localstorage_sync__["a" /* clearLocalStorage */]();
          _context5.next = 16;
          break;

        case 13:
          _context5.prev = 13;
          _context5.t0 = _context5['catch'](0);

          pe(_context5.t0);

        case 16:
          _context5.prev = 16;

          if ("undefined" !== 'development' && window && window.location) {
            window.location.replace('https://kroost.nl');
          } else {
            __WEBPACK_IMPORTED_MODULE_7_helpers_history__["a" /* default */].replace('/');
            window.onbeforeunload = null;
            window.location.reload();
          }
          return _context5.finish(16);

        case 19:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this, [[0, 13, 16, 19]]);
}

function getProfile() {
  var token, profile;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getProfile$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['user', 'token'], null);
          });

        case 3:
          token = _context6.sent;

          if (!token) {
            _context6.next = 10;
            break;
          }

          _context6.next = 7;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_4_helpers_api__["a" /* default */], 'user/profile', {
            auth: true
          });

        case 7:
          profile = _context6.sent;
          _context6.next = 10;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["x" /* updateProfile */](profile));

        case 10:
          _context6.next = 18;
          break;

        case 12:
          _context6.prev = 12;
          _context6.t0 = _context6['catch'](0);

          pe(_context6.t0);

          // Force logout when we get 4xx error while saving

          if (!(_context6.t0 >= 400 && _context6.t0 < 500)) {
            _context6.next = 18;
            break;
          }

          _context6.next = 18;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["q" /* logout */]());

        case 18:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this, [[0, 12]]);
}

function doGetChildren() {
  var token, children;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function doGetChildren$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['user', 'token'], null);
          });

        case 3:
          token = _context7.sent;

          if (!token) {
            _context7.next = 10;
            break;
          }

          _context7.next = 7;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_4_helpers_api__["a" /* default */], 'user/children', {
            auth: true
          });

        case 7:
          children = _context7.sent;
          _context7.next = 10;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["w" /* updateChildren */](children));

        case 10:
          _context7.next = 15;
          break;

        case 12:
          _context7.prev = 12;
          _context7.t0 = _context7['catch'](0);

          pe(_context7.t0);

        case 15:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[0, 12]]);
}

function addChild(_ref8) {
  var name = _ref8.name,
      birthday = _ref8.birthday;
  var token, newChild, orderId, child;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function addChild$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['user', 'token'], null);
          });

        case 3:
          token = _context8.sent;

          if (!token) {
            _context8.next = 18;
            break;
          }

          _context8.next = 7;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_4_helpers_api__["a" /* default */], 'user/child_add', {
            method: 'post',
            auth: true,
            body: { name: name, birthday: birthday }
          });

        case 7:
          newChild = _context8.sent;
          _context8.next = 10;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['app', 'activeOrderId']);
          });

        case 10:
          orderId = _context8.sent;
          _context8.next = 13;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['orders', orderId, 'child']);
          });

        case 13:
          child = _context8.sent;
          _context8.next = 16;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_10__reducers_orders__["z" /* setOption */](orderId, 'child', __WEBPACK_IMPORTED_MODULE_11_immutable__["fromJS"](newChild), {
            previousId: child.get('id'),
            previousName: child.get('name'),
            previousBirthDay: child.get('birthday')
          }));

        case 16:
          _context8.next = 18;
          return doGetChildren();

        case 18:
          _context8.next = 23;
          break;

        case 20:
          _context8.prev = 20;
          _context8.t0 = _context8['catch'](0);

          pe(_context8.t0);

        case 23:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[0, 20]]);
}

function updateChild(_ref9) {
  var option = _ref9.option,
      orderId = _ref9.orderId,
      value = _ref9.value,
      rest = _objectWithoutProperties(_ref9, ['option', 'orderId', 'value']);

  var updateKey, order, id, children, newChildren;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateChild$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          if (!(option.length === 2 && option[0] === 'child' && (option[1] === 'name' || option[1] === 'birthday'))) {
            _context9.next = 12;
            break;
          }

          updateKey = option[1];
          _context9.next = 4;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](__WEBPACK_IMPORTED_MODULE_12__selectors_orders__["i" /* getOrder */]);

        case 4:
          order = _context9.sent;
          id = order.getIn(['child', 'id']);
          _context9.next = 8;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['user', 'children']);
          });

        case 8:
          children = _context9.sent;
          newChildren = children.toJS().map(function (child) {
            var _extends2;

            return child.id === id ? _extends({}, child, (_extends2 = {}, _extends2[updateKey] = value, _extends2)) : child;
          });
          _context9.next = 12;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["w" /* updateChildren */](newChildren));

        case 12:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this);
}

function updateChildTrack(_ref10) {
  var option = _ref10.option,
      orderId = _ref10.orderId,
      value = _ref10.value,
      rest = _objectWithoutProperties(_ref10, ['option', 'orderId', 'value']);

  var updateKey, order, id, children, newChildren, newChild;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateChildTrack$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          if (!(option.length === 2 && option[0] === 'child' && (option[1] === 'name' || option[1] === 'birthday'))) {
            _context10.next = 14;
            break;
          }

          console.log('updateChildTrack');
          updateKey = option[1];
          _context10.next = 5;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['orders', orderId], __WEBPACK_IMPORTED_MODULE_11_immutable__["Map"]());
          });

        case 5:
          order = _context10.sent;
          id = order.getIn(['child', 'id']);
          _context10.next = 9;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['user', 'children']);
          });

        case 9:
          children = _context10.sent;
          newChildren = children.toJS().map(function (child) {
            var _extends3;

            return child.id === id ? _extends({}, child, (_extends3 = {}, _extends3[updateKey] = value, _extends3)) : child;
          });
          newChild = newChildren.find(function (child) {
            return child.id === id;
          });
          _context10.next = 14;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["v" /* trackEvent */]('child_edited', {
            child_id: newChild.id,
            child_name: newChild.name,
            child_dob: newChild.birthday
          }));

        case 14:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

function refreshToken(_ref11) {
  var decodedToken = _ref11.decodedToken;

  var _decodedToken$data, refresh_token, user_id, _ref12, valid, newToken;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function refreshToken$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.prev = 0;
          _decodedToken$data = decodedToken.data, refresh_token = _decodedToken$data.refresh_token, user_id = _decodedToken$data.user_id;
          _context11.next = 4;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_4_helpers_api__["a" /* default */], 'user/token/refresh', {
            auth: true,
            body: {
              onlyWhenExpired: false,
              refresh_token: refresh_token,
              user_id: user_id
            }
          });

        case 4:
          _ref12 = _context11.sent;
          valid = _ref12.valid;
          newToken = _ref12.token;

          if (!newToken) {
            _context11.next = 12;
            break;
          }

          _context11.next = 10;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["u" /* setAuthToken */](newToken));

        case 10:
          _context11.next = 15;
          break;

        case 12:
          if (valid) {
            _context11.next = 15;
            break;
          }

          _context11.next = 15;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["q" /* logout */]());

        case 15:
          _context11.next = 20;
          break;

        case 17:
          _context11.prev = 17;
          _context11.t0 = _context11['catch'](0);

          pe(_context11.t0);

        case 20:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this, [[0, 17]]);
}

function refreshTokenTimer() {
  var chan, token, decodedToken, exp, expiresInMinutes;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function refreshTokenTimer$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_3_helpers_saga__["a" /* interval */], CHECK_INTERVAL);

        case 2:
          chan = _context12.sent;

        case 3:
          if (false) {
            _context12.next = 24;
            break;
          }

          _context12.next = 6;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* take */](chan);

        case 6:
          _context12.prev = 6;
          _context12.next = 9;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['user', 'token'], null);
          });

        case 9:
          token = _context12.sent;

          if (!token) {
            _context12.next = 17;
            break;
          }

          decodedToken = __WEBPACK_IMPORTED_MODULE_5_helpers_auth__["a" /* decodeToken */](token);
          exp = decodedToken.exp;
          expiresInMinutes = __WEBPACK_IMPORTED_MODULE_2_date_fns_differenceInMinutes___default.a(new Date(exp * 1000), new Date());

          if (!(expiresInMinutes < RESET_OFFSET)) {
            _context12.next = 17;
            break;
          }

          _context12.next = 17;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](refreshToken, {
            decodedToken: decodedToken,
            forceRefresh: true
          });

        case 17:
          _context12.next = 22;
          break;

        case 19:
          _context12.prev = 19;
          _context12.t0 = _context12['catch'](6);

          pe(_context12.t0);

        case 22:
          _context12.next = 3;
          break;

        case 24:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this, [[6, 19]]);
}

function saga() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saga$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["e" /* REQUEST_RESET_PASSWORD */], requestPasswordReset);

        case 2:
          _context13.next = 4;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["f" /* RESET_PASSWORD */], passwordReset);

        case 4:
          _context13.next = 6;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["d" /* REGISTER */], doRegister);

        case 6:
          _context13.next = 8;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["b" /* LOGIN */], doLogin);

        case 8:
          _context13.next = 10;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["c" /* LOGOUT */], doLogout);

        case 10:
          _context13.next = 12;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["h" /* UPDATE_PROFILE */], doGetChildren);

        case 12:
          _context13.next = 14;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_9_redux_reducers_user__["a" /* ADD_CHILD */], addChild);

        case 14:
          _context13.next = 16;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_10__reducers_orders__["i" /* SET_OPTION */], updateChild);

        case 16:
          _context13.next = 18;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* throttle */](10000, __WEBPACK_IMPORTED_MODULE_10__reducers_orders__["i" /* SET_OPTION */], updateChildTrack);

        case 18:
          _context13.next = 20;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */](getProfile);

        case 20:
          _context13.next = 22;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */](refreshTokenTimer);

        case 22:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this);
}

/***/ }),
/* 349 */,
/* 350 */,
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getExif */
/* unused harmony export updatePreview */
/* unused harmony export uploadImage */
/* unused harmony export uploadQueued */
/* harmony export (immutable) */ __webpack_exports__["a"] = saga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_exifreader_dist_exif_reader__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_exifreader_dist_exif_reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_exifreader_dist_exif_reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_saga__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_api__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers_photo__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers_time__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_selectors_user__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_selectors_orders__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux_selectors_photos__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux_reducers_photos__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__ = __webpack_require__(14);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _marked = [loadExif, getExif, createPreview, updatePreview, uploadImage, uploadQueued, urlAsFile, getExifTest, saga].map(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





















var EXIF_SAVE_KEYS = ['DateTime', 'Orientation'];
var PROCESS_AT_ONCE = 5;
var PREVIEW_SIZE = 256;
var RESIZE_STEP = 0.5;

var orientation = {
  support: false
};

(function () {
  // black 2x1 JPEG, with the following meta information set:
  // EXIF Orientation: 6 (Rotated 90° CCW)
  var testImageURL = 'data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAA' + 'AAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBA' + 'QEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQE' + 'BAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAEAAgMBEQACEQEDEQH/x' + 'ABKAAEAAAAAAAAAAAAAAAAAAAALEAEAAAAAAAAAAAAAAAAAAAAAAQEAAAAAAAAAAAAAAAA' + 'AAAAAEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8H//2Q==';
  var img = document.createElement('img');
  img.onload = function () {
    orientation.support = img.width === 1 && img.height === 2;
  };
  img.src = testImageURL;
})();

var getExifHeight = function getExifHeight(exif) {
  try {
    if (!exif.PixelYDimension) {
      throw 'PixelYDimension not found';
    }

    return getExifValue(exif.PixelYDimension);
  } catch (e) {
    if (!exif.ImageLength) {
      throw 'ImageLength not found';
    }

    return getExifValue(exif.ImageLength);
  }
};

var getExifWidth = function getExifWidth(exif) {
  try {
    if (!exif.PixelXDimension) {
      throw 'PixelXDimension not found';
    }

    return getExifValue(exif.PixelXDimension);
  } catch (e) {
    if (!exif.ImageWidth) {
      throw 'ImageWidth not found';
    }

    return getExifValue(exif.ImageWidth);
  }
};

var getExifValue = function getExifValue(exif) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unknown';
  return exif ? exif.description || exif.value || fallback : fallback;
};
var createSimpleId = function createSimpleId(file) {
  return file.name + '-' + file.type + '-' + file.lastModified + '-' + file.size;
};
var createExifId = function createExifId(exif, file) {
  return exif.DateTime ? getExifValue(exif.Make, 'make') + '-' + getExifValue(exif.Model, 'model') + '-' + getExifValue(exif.DateTime, 'datetime') + '-' + file.name + '-' + file.size : null;
};

/**
 * toBlob Promise, so we can use it as generator
 * @param canvas
 * @returns {Promise}
 */
function canvasToBlob(canvas) {
  return new Promise(function (resolve) {
    canvas.toBlob(function (blob) {
      resolve(blob);
    });
  });
}

/**
 * Get exif data from jpg
 * @param file
 * @returns {Promise}
 */
function loadExif(file) {
  var reader, onLoad, event, exif, allTags, removeOrientation, _ref, preview, dimensions, _ref2, _preview, _dimensions;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadExif$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          reader = new FileReader();
          _context.next = 3;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_5_helpers_saga__["b" /* onEvent */], reader, 'load', function () {
            // Only read first 128KB of the file for EXIF
            reader.readAsArrayBuffer(file);
          });

        case 3:
          onLoad = _context.sent;
          _context.next = 6;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* take */](onLoad);

        case 6:
          event = _context.sent;
          exif = {};
          _context.prev = 8;
          allTags = __WEBPACK_IMPORTED_MODULE_4_exifreader_dist_exif_reader__["load"](event.target.result);


          EXIF_SAVE_KEYS.forEach(function (tag) {
            if (allTags[tag]) {
              exif[tag] = getExifValue(allTags[tag]);
            }
          });

          // Use file date if no exif is found
          exif.lastModified = __WEBPACK_IMPORTED_MODULE_8_helpers_time__["a" /* dateToExifDate */](file.lastModified);

          // Check if exif data contains width and height
          removeOrientation = false;
          _context.prev = 13;

          if (!(!allTags.Orientation || allTags.Orientation.description === 'Undefined')) {
            _context.next = 18;
            break;
          }

          throw new Error('Orientation is not set.');

        case 18:
          exif.width = getExifWidth(allTags);
          exif.height = getExifHeight(allTags);
          exif.ratio = exif.height / exif.width;

        case 21:
          _context.next = 27;
          break;

        case 23:
          _context.prev = 23;
          _context.t0 = _context['catch'](13);

          console.error(_context.t0, 'No dimensions found');
          removeOrientation = true;

        case 27:
          _context.next = 29;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */](createPreview, file, true, exif);

        case 29:
          _ref = _context.sent;
          preview = _ref.preview;
          dimensions = _objectWithoutProperties(_ref, ['preview']);


          if (removeOrientation && exif.Orientation) {
            delete exif.Orientation;
          }

          return _context.abrupt('return', {
            file: file,
            preview: preview,
            exif: _extends({}, exif, dimensions),
            exifId: createExifId(allTags, file)
          });

        case 36:
          _context.prev = 36;
          _context.t1 = _context['catch'](8);

          if (['No Exif data', 'string is not iterable'].indexOf(_context.t1.message) > -1) {
            console.warn('No EXIF data for', file.name);
          } else {
            if (['Invalid image format'].indexOf(_context.t1.message) === -1) {
              pe(_context.t1);
            }
            console.warn('Error for', file.name, exif, _context.t1);
          }

          // const dimensions = yield call(getImageDimensions, file);
          _context.next = 41;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */](createPreview, file, true, exif);

        case 41:
          _ref2 = _context.sent;
          _preview = _ref2.preview;
          _dimensions = _objectWithoutProperties(_ref2, ['preview']);
          return _context.abrupt('return', {
            file: file,
            preview: _preview,
            exif: _extends({}, exif, _dimensions || {}),
            exifId: null
          });

        case 45:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[8, 36], [13, 23]]);
}

function getExif(_ref3) {
  var photos = _ref3.photos;

  var orderId, existingPhotos, existingSimpleIds, cleanedPhotos, mergedPhotos, notificationKey, _mergedPhotos, photoChunk, exifs, newPhotos, currentPhotos, existingExifIds, notUsed, doneNotification;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getExif$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_9_redux_selectors_app__["c" /* getActiveOrderId */](state);
          });

        case 3:
          orderId = _context2.sent;
          _context2.next = 6;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_12_redux_selectors_photos__["c" /* getPhotos */](state);
          });

        case 6:
          existingPhotos = _context2.sent;
          existingSimpleIds = existingPhotos.map(function (photo) {
            return photo.get('simpleId');
          });
          cleanedPhotos = photos.filter(function (photo) {
            return existingSimpleIds.indexOf(createSimpleId(photo)) === -1;
          });
          mergedPhotos = [];
          notificationKey = 'exif' + Math.random();

        case 11:
          if (!(cleanedPhotos.length > 0)) {
            _context2.next = 22;
            break;
          }

          _context2.next = 14;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_15_redux_reducers_app__["q" /* setNotification */](notificationKey, kroostApp.strings.mergingPhotos.replace('{mergedPhotos}', mergedPhotos.length, '{photos}', photos.length)));

        case 14:
          photoChunk = cleanedPhotos.splice(0, PROCESS_AT_ONCE);

          // Get exif for all new photos

          _context2.next = 17;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["a" /* all */](photoChunk.map(function (photo) {
            return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */](loadExif, photo);
          }));

        case 17:
          exifs = _context2.sent;


          // Find current photos and merge them with the new exif data
          newPhotos = exifs.map(function (photo) {
            return __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"](_extends({}, photo, {
              simpleId: createSimpleId(photo.file)
            }));
          });


          (_mergedPhotos = mergedPhotos).push.apply(_mergedPhotos, newPhotos);
          _context2.next = 11;
          break;

        case 22:
          _context2.next = 24;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_12_redux_selectors_photos__["c" /* getPhotos */](state);
          });

        case 24:
          currentPhotos = _context2.sent;
          existingExifIds = currentPhotos.map(function (photo) {
            return photo.get('exifId');
          });


          mergedPhotos = mergedPhotos.filter(function (photo) {
            return photo.get('exifId') === null || existingExifIds.indexOf(photo.get('exifId')) === -1;
          });
          notUsed = photos.length - mergedPhotos.length;

          // Notification

          doneNotification = kroostApp.strings.doneNotificationMessage.replace('{mergedPhotos}', mergedPhotos.length) + (notUsed > 0 ? kroostApp.strings.notUsedPhotosMessage.replace('{notused}', notUsed) : '');
          _context2.next = 31;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_15_redux_reducers_app__["q" /* setNotification */](notificationKey, doneNotification));

        case 31:
          _context2.next = 33;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["v" /* trackEvent */]('photos_imported', {
            no_of_photos: photos.length,
            no_of_photos_ignored: photos.length - mergedPhotos.length
          }));

        case 33:
          _context2.next = 35;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_photos__["i" /* setAll */](orderId, mergedPhotos));

        case 35:
          _context2.next = 37;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga__["b" /* delay */](3000);

        case 37:
          _context2.next = 39;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_15_redux_reducers_app__["q" /* setNotification */](notificationKey, null));

        case 39:
          _context2.next = 44;
          break;

        case 41:
          _context2.prev = 41;
          _context2.t0 = _context2['catch'](0);

          pe(_context2.t0, 'failed getExif');

        case 44:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[0, 41]]);
}

function createPreview(file, initial, exif) {
  var resizeWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : PREVIEW_SIZE;
  var userRotate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var isFile, img, onLoad, canvas, ctx, nativeRotateAndFlip, originalRotate, originalFlip, dimensions, hasRatioChange, widthIndex, heightIndex, widthMismatch, heightMisMatch, exifRatio, imgRatio, differentDimensions, ratioChanged, ignoreRotation, fallbackWidth, fallbackHeight, originalWidth, originalHeight, rotate, width, height, flip, ratio, blob;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createPreview$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          isFile = file instanceof File;
          img = new Image();

          img.setAttribute('crossOrigin', 'anonymous');

          _context3.next = 6;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_5_helpers_saga__["b" /* onEvent */], img, 'load', function () {
            img.src = isFile ? URL.createObjectURL(file) : file;
          });

        case 6:
          onLoad = _context3.sent;
          _context3.next = 9;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* take */](onLoad);

        case 9:
          canvas = document.createElement('canvas'), ctx = canvas.getContext('2d');
          nativeRotateAndFlip = orientation.support && isFile;
          originalRotate = __WEBPACK_IMPORTED_MODULE_7_helpers_photo__["b" /* getRotationFromOrientation */](exif.Orientation);
          originalFlip = __WEBPACK_IMPORTED_MODULE_7_helpers_photo__["a" /* getFlipFromOrientation */](exif.Orientation);

          // When still a file, and there is no rotation set in exif, use the width and height of what the browsers gives back
          // This fixes issue #129

          dimensions = [img.width, img.height];
          hasRatioChange = [0, 180, -180].indexOf(originalRotate) === -1;
          widthIndex = !hasRatioChange ? 0 : 1;
          heightIndex = widthIndex === 0 ? 1 : 0;
          widthMismatch = isFile && dimensions[widthIndex] !== exif.width;
          heightMisMatch = isFile && dimensions[heightIndex] !== exif.height;
          exifRatio = exif.width / exif.height;
          imgRatio = img.width / img.height;
          differentDimensions = isFile && initial && ([exif.width, exif.height].indexOf(img.width) === -1 || [exif.width, exif.height].indexOf(img.height) === -1);
          ratioChanged = differentDimensions || exifRatio > 1 !== imgRatio > 1;

          // Ignore rotation when file doesn't match exif data

          ignoreRotation = false;

          if (widthMismatch || heightMisMatch) {
            ignoreRotation = true;
          }

          fallbackWidth = !ignoreRotation ? exif.width : img.width;
          fallbackHeight = !ignoreRotation ? exif.height : img.height;
          originalWidth = originalRotate === 0 && isFile || nativeRotateAndFlip ? img.width : fallbackWidth;
          originalHeight = originalRotate === 0 && isFile || nativeRotateAndFlip ? img.height : fallbackHeight;

          // Files are expected to have the correct orientation already

          if (isFile) {
            _context3.next = 36;
            break;
          }

          _context3.t0 = originalRotate;
          _context3.next = _context3.t0 === 90 ? 33 : _context3.t0 === -90 ? 33 : 36;
          break;

        case 33:
          originalWidth = exif.height;
          originalHeight = exif.width;
          return _context3.abrupt('break', 36);

        case 36:
          rotate = (userRotate !== null ? userRotate : 0) + (isFile && !nativeRotateAndFlip ? originalRotate : 0);
          width = originalWidth;
          height = originalHeight;
          flip = false;
          _context3.t1 = rotate;
          _context3.next = _context3.t1 === 90 ? 43 : _context3.t1 === -90 ? 43 : _context3.t1 === 270 ? 43 : 47;
          break;

        case 43:
          height = originalWidth;
          width = originalHeight;
          flip = true;
          return _context3.abrupt('break', 47);

        case 47:
          ratio = height / width;

          canvas.width = resizeWidth;
          canvas.height = resizeWidth * ratio;

          ctx.translate(canvas.width / 2, canvas.height / 2);
          ctx.rotate(rotate * Math.PI / 180);

          // Mirror image
          if (isFile && originalFlip && nativeRotateAndFlip) {
            ctx.scale(-1, 1);
          }

          if (flip) {
            ctx.drawImage(img, -canvas.height / 2, -canvas.width / 2, canvas.height, canvas.width);
          } else {
            ctx.drawImage(img, -canvas.width / 2, -canvas.height / 2, canvas.width, canvas.height);
          }

          _context3.next = 56;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */](canvasToBlob, canvas);

        case 56:
          blob = _context3.sent;


          if (isFile) {
            URL.revokeObjectURL(img.src);
          }

          return _context3.abrupt('return', _extends({
            ratio: height / width,
            rotate: rotate,
            flipped: originalFlip,
            preview: URL.createObjectURL(blob)
          }, ignoreRotation && ratioChanged || userRotate !== null || !exif.width || !exif.height ? {
            height: height,
            width: width
          } : {}, initial ? {
            _height: height,
            _width: width
          } : {}));

        case 61:
          _context3.prev = 61;
          _context3.t2 = _context3['catch'](0);

          pe(_context3.t2, 'Failed creating image preview');

          _context3.next = 66;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["v" /* trackEvent */]('error', {
            type: 'createPreview',
            e: _context3.t2.toString()
          }));

        case 66:
          return _context3.abrupt('return', {});

        case 67:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[0, 61]]);
}

function updatePreview(_ref4) {
  var orderId = _ref4.orderId,
      momentId = _ref4.momentId;
  var uploads, photos, order, picked, simpleId, rotate, photo, file, exif, uploadUID, existingPreview, newPreview;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updatePreview$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_12_redux_selectors_photos__["g" /* getUploads */](state);
          });

        case 3:
          uploads = _context4.sent;
          _context4.next = 6;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_12_redux_selectors_photos__["c" /* getPhotos */](state);
          });

        case 6:
          photos = _context4.sent;
          _context4.next = 9;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_11_redux_selectors_orders__["i" /* getOrder */](state);
          });

        case 9:
          order = _context4.sent;
          picked = order.getIn(['picked', momentId], null);

          if (!picked) {
            _context4.next = 30;
            break;
          }

          simpleId = picked.get('simpleId');
          rotate = picked.getIn(['transform', 'rotate'], 0) || null;
          photo = photos.find(function (photo) {
            return photo.get('simpleId') === simpleId;
          });

          if (!photo) {
            _context4.next = 30;
            break;
          }

          file = photo.get('file');
          exif = photo.get('exif');

          // File not available, use uploaded image

          if (!file) {
            uploadUID = uploads.getIn([simpleId, 'uid']);

            file = __WEBPACK_IMPORTED_MODULE_6_helpers_api__["b" /* uploadUrl */](orderId, uploadUID, order.get('token'), order.get('user'));
          }

          _context4.next = 21;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['app', 'previews', orderId, momentId]);
          });

        case 21:
          existingPreview = _context4.sent;
          _context4.next = 24;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */](createPreview, file, false, exif, 768, rotate);

        case 24:
          newPreview = _context4.sent;


          // Has existing preview?
          if (existingPreview && existingPreview.get('copy') !== true) {
            URL.revokeObjectURL(existingPreview.get('preview'));
          }

          _context4.next = 28;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_15_redux_reducers_app__["o" /* setDraggingPreview */](null));

        case 28:
          _context4.next = 30;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_15_redux_reducers_app__["s" /* setPreview */](orderId, momentId, newPreview));

        case 30:
          _context4.next = 37;
          break;

        case 32:
          _context4.prev = 32;
          _context4.t0 = _context4['catch'](0);

          pe(_context4.t0, 'Failed updatePreview');

          _context4.next = 37;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["v" /* trackEvent */]('error', {
            type: 'updatePreview',
            e: _context4.t0.toString()
          }));

        case 37:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[0, 32]]);
}

var failCounter = 0;

function uploadImage(_ref5) {
  var simpleId = _ref5.simpleId,
      _ref5$notifyDelay = _ref5.notifyDelay,
      notifyDelay = _ref5$notifyDelay === undefined ? 1000 : _ref5$notifyDelay;
  var authenticated, order, upload, photo, fileName, orderId, imageUID;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function uploadImage$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_10_redux_selectors_user__["c" /* isAuthenticated */](state);
          });

        case 3:
          authenticated = _context5.sent;
          _context5.next = 6;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_11_redux_selectors_orders__["i" /* getOrder */](state);
          });

        case 6:
          order = _context5.sent;
          upload = order.getIn(['uploads', simpleId]);

          if (!(authenticated && !upload)) {
            _context5.next = 48;
            break;
          }

          _context5.next = 11;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_12_redux_selectors_photos__["c" /* getPhotos */](state).find(function (photo) {
              return photo.get('simpleId') === simpleId;
            });
          });

        case 11:
          photo = _context5.sent;

          if (!photo) {
            _context5.next = 48;
            break;
          }

          fileName = photo.get('file').name;
          _context5.next = 16;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_15_redux_reducers_app__["q" /* setNotification */]('upload', kroostApp.strings.feedbackUploadingMessage.replace('{fileName}', fileName)));

        case 16:
          _context5.next = 18;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["v" /* trackEvent */]('upload-image-start', {
            fileName: fileName
          }));

        case 18:
          _context5.next = 20;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_9_redux_selectors_app__["c" /* getActiveOrderId */](state);
          });

        case 20:
          orderId = _context5.sent;
          _context5.prev = 21;
          _context5.next = 24;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_6_helpers_api__["a" /* default */], 'media/upload/', {
            auth: true,
            body: {
              file: photo.get('file'),
              order: orderId
            }
          });

        case 24:
          imageUID = _context5.sent;

          if (imageUID) {
            _context5.next = 27;
            break;
          }

          throw new Error('Failed upload');

        case 27:
          _context5.next = 29;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_photos__["j" /* setUpload */](orderId, photo.get('simpleId'), {
            uid: imageUID,
            exifId: photo.get('exifId'),
            exif: photo.get('exif', {})
          }));

        case 29:
          _context5.next = 31;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_15_redux_reducers_app__["q" /* setNotification */]('upload', kroostApp.strings.uploadSuccessMessage.replace('{fileName}', fileName)));

        case 31:
          failCounter = 0;

          _context5.next = 34;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["v" /* trackEvent */]('upload-image-success', {
            imageUID: imageUID,
            fileName: fileName
          }));

        case 34:
          _context5.next = 43;
          break;

        case 36:
          _context5.prev = 36;
          _context5.t0 = _context5['catch'](21);
          _context5.next = 40;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_15_redux_reducers_app__["q" /* setNotification */]('upload', kroostApp.strings.uploandingFaliedMessage.replace('{fileName}', fileName)));

        case 40:
          _context5.next = 42;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["v" /* trackEvent */]('upload-image-failed', {
            fileName: fileName,
            e: _context5.t0.toString()
          }));

        case 42:

          failCounter++;

        case 43:
          if (!(notifyDelay > 0)) {
            _context5.next = 48;
            break;
          }

          _context5.next = 46;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga__["b" /* delay */](notifyDelay);

        case 46:
          _context5.next = 48;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_15_redux_reducers_app__["q" /* setNotification */]('upload', null));

        case 48:
          _context5.next = 56;
          break;

        case 50:
          _context5.prev = 50;
          _context5.t1 = _context5['catch'](0);

          pe(_context5.t1);

          _context5.next = 55;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["v" /* trackEvent */]('error', {
            type: 'uploadImage',
            e: _context5.t1.toString()
          }));

        case 55:
          failCounter++;

        case 56:

          if (failCounter === 3) {
            alert(kroostApp.strings.failedUploadWarning);
            window.onbeforeunload = null;
            window.location.reload();
          }

        case 57:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this, [[0, 50], [21, 36]]);
}

/**
 * Upload any images that are set, but don't have an upload ID yet
 */
function uploadQueued() {
  var _this = this;

  var authenticated, isUploading, order;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function uploadQueued$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          if (false) {
            _context7.next = 25;
            break;
          }

          _context7.prev = 1;
          _context7.next = 4;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_10_redux_selectors_user__["c" /* isAuthenticated */](state);
          });

        case 4:
          authenticated = _context7.sent;
          _context7.next = 7;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['app', 'ui', 'is_uploading'], false);
          });

        case 7:
          isUploading = _context7.sent;

          if (!(authenticated && !isUploading)) {
            _context7.next = 14;
            break;
          }

          _context7.next = 11;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_11_redux_selectors_orders__["i" /* getOrder */](state);
          });

        case 11:
          order = _context7.sent;

          if (order.get('local', false)) {
            _context7.next = 14;
            break;
          }

          return _context7.delegateYield(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var picked, uploads, queue, needsToProcess, simpleId;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    picked = order.get('picked', __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]());
                    uploads = order.get('uploads', __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]());
                    queue = [];

                    picked.forEach(function (pick) {
                      if (pick.get('simpleId') && !uploads.get(pick.get('simpleId'))) {
                        queue.push(pick.get('simpleId'));
                      }
                    });

                    needsToProcess = queue.length > 0;

                    if (!needsToProcess) {
                      _context6.next = 8;
                      break;
                    }

                    _context6.next = 8;
                    return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_15_redux_reducers_app__["u" /* setUIState */]('is_uploading', true));

                  case 8:
                    if (!(queue.length > 0)) {
                      _context6.next = 14;
                      break;
                    }

                    simpleId = queue.shift();
                    _context6.next = 12;
                    return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */](uploadImage, { simpleId: simpleId, notifyDelay: 0 });

                  case 12:
                    _context6.next = 8;
                    break;

                  case 14:
                    if (!needsToProcess) {
                      _context6.next = 21;
                      break;
                    }

                    _context6.next = 17;
                    return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_15_redux_reducers_app__["u" /* setUIState */]('is_uploading', false));

                  case 17:
                    _context6.next = 19;
                    return __WEBPACK_IMPORTED_MODULE_2_redux_saga__["b" /* delay */](2000);

                  case 19:
                    _context6.next = 21;
                    return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_15_redux_reducers_app__["q" /* setNotification */]('upload', null));

                  case 21:
                  case 'end':
                    return _context6.stop();
                }
              }
            }, _callee, _this);
          })(), 't0', 14);

        case 14:
          _context7.next = 16;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga__["b" /* delay */](1000);

        case 16:
          _context7.next = 23;
          break;

        case 18:
          _context7.prev = 18;
          _context7.t1 = _context7['catch'](1);

          pe(_context7.t1);

          _context7.next = 23;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_16_redux_reducers_user__["v" /* trackEvent */]('error', {
            type: 'uploadQueued',
            e: _context7.t1.toString()
          }));

        case 23:
          _context7.next = 0;
          break;

        case 25:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[5], this, [[1, 18]]);
}

function urlAsFile(name, url) {
  var req, onLoad, b;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function urlAsFile$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          req = new XMLHttpRequest();
          _context8.next = 3;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_5_helpers_saga__["b" /* onEvent */], req, 'load', function () {
            req.open('GET', url);
            req.responseType = 'arraybuffer';
            req.send();
          });

        case 3:
          onLoad = _context8.sent;
          _context8.next = 6;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* take */](onLoad);

        case 6:
          b = new Blob([req.response]);
          return _context8.abrupt('return', new File([b], name));

        case 8:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[6], this);
}

var uniqueIds = {};

function getExifTest(_ref6) {
  var items = _ref6.items;

  var _items$shift, name, url, _uploadUrl, fileBlob, photo, uniqueId, def, rotated, uploaded, uploadedRotated;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getExifTest$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;

        case 1:
          if (!(items.length > 0)) {
            _context9.next = 32;
            break;
          }

          _items$shift = items.shift(), name = _items$shift.name, url = _items$shift.url, _uploadUrl = _items$shift.uploadUrl;
          _context9.next = 5;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */](urlAsFile, name, url);

        case 5:
          fileBlob = _context9.sent;
          _context9.next = 8;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */](loadExif, fileBlob);

        case 8:
          photo = _context9.sent;
          uniqueId = photo.exif.width + '-' + photo.exif.height + '-' + photo.exif.Orientation + '-' + photo.exif.rotate + '-' + photo.exif.flipped;

          // Don't test the same types of exif images

          if (uniqueId in uniqueIds) {
            _context9.next = 14;
            break;
          }

          uniqueIds[uniqueId] = name;
          _context9.next = 16;
          break;

        case 14:
          p('Already a test for this file: ', name, uniqueIds[uniqueId]);
          return _context9.abrupt('continue', 1);

        case 16:
          _context9.next = 18;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */](createPreview, fileBlob, false, photo.exif, 200, 0);

        case 18:
          def = _context9.sent;
          _context9.next = 21;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */](createPreview, fileBlob, false, photo.exif, 200, 90);

        case 21:
          rotated = _context9.sent;
          _context9.next = 24;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */](createPreview, _uploadUrl, false, photo.exif, 200, 0);

        case 24:
          uploaded = _context9.sent;
          _context9.next = 27;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */](createPreview, _uploadUrl, false, photo.exif, 200, 90);

        case 27:
          uploadedRotated = _context9.sent;
          _context9.next = 30;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_photos__["i" /* setAll */]('EXIF_TEST', [__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"](_extends({
            name: name,
            url: url
          }, photo, {
            simpleId: createSimpleId(photo.file),
            test: {
              default: def,
              rotated: rotated,
              uploaded: uploaded,
              uploadedRotated: uploadedRotated
            }
          }))]));

        case 30:
          _context9.next = 1;
          break;

        case 32:
          _context9.next = 37;
          break;

        case 34:
          _context9.prev = 34;
          _context9.t0 = _context9['catch'](0);

          pe(_context9.t0, 'Failed getExifTest');

        case 37:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[7], this, [[0, 34]]);
}

function saga() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_photos__["a" /* ADD */], getExif);

        case 2:
          _context10.next = 4;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_photos__["f" /* UPDATE_PREVIEW */], updatePreview);

        case 4:
          _context10.next = 6;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_14_redux_reducers_orders__["f" /* PICK_MOMENT */], updatePreview);

        case 6:
          _context10.next = 8;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_13_redux_reducers_photos__["b" /* ADD_EXIF_TEST */], getExifTest);

        case 8:
          _context10.next = 10;
          return __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["d" /* fork */](uploadQueued);

        case 10:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[8], this);
}

/***/ }),
/* 352 */,
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fillFromOrder */
/* unused harmony export fillFromOrders */
/* harmony export (immutable) */ __webpack_exports__["a"] = saga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_reducers_photos__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_reducers_orders__ = __webpack_require__(15);


var _marked = [fillFromOrder, fillFromOrders, saga].map(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark);







function fillFromOrder(_ref) {
  var id = _ref.id;
  var order, uploads, orderPhotos;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fillFromOrder$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['orders', id], __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]());
          });

        case 3:
          order = _context.sent;
          uploads = order.get('uploads', __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]());

          if (!(uploads && uploads.count() > 0)) {
            _context.next = 11;
            break;
          }

          orderPhotos = uploads.map(function (upload, simpleId) {
            return __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]({
              simpleId: simpleId,
              exif: upload.get('exif', __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]()).toJS(),
              exifId: upload.get('exifId')
            });
          });
          _context.next = 9;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_3_redux_reducers_photos__["i" /* setAll */](id, orderPhotos.toList()));

        case 9:
          _context.next = 13;
          break;

        case 11:
          _context.next = 13;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_3_redux_reducers_photos__["i" /* setAll */](id, __WEBPACK_IMPORTED_MODULE_1_immutable__["List"]()));

        case 13:
          _context.next = 18;
          break;

        case 15:
          _context.prev = 15;
          _context.t0 = _context['catch'](0);

          pe(_context.t0, 'failed setting photos from order');

        case 18:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[0, 15]]);
}

function fillFromOrders(_ref2) {
  var orders = _ref2.orders;
  var orderIds;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fillFromOrders$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          orderIds = Object.keys(orders);
          _context2.next = 3;
          return orderIds.map(function (orderId) {
            return fillFromOrder({ id: orderId });
          });

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function saga() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_4_redux_reducers_orders__["a" /* ADD_ORDER */], fillFromOrder);

        case 2:
          _context3.next = 4;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_4_redux_reducers_orders__["j" /* SET_ORDERS */], fillFromOrders);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addSpreadStats */
/* unused harmony export fillFromOrder */
/* harmony export (immutable) */ __webpack_exports__["a"] = saga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_saga__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_reducers_stats__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_reducers_orders__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_selectors_app__ = __webpack_require__(10);


var _marked = [addSpreadStats, fillFromOrder, forceSaveInterval, saga].map(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark);












var FORCE_SAVE_INTERVAL = 60;

/**
 * Mark spreads as seen when visiting it
 * @param spread
 */
function addSpreadStats(_ref) {
  var spread = _ref.spread;
  var orderId;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function addSpreadStats$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */](function (state) {
            return __WEBPACK_IMPORTED_MODULE_7_redux_selectors_app__["c" /* getActiveOrderId */](state);
          });

        case 3:
          orderId = _context.sent;
          _context.next = 6;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_5_redux_reducers_stats__["a" /* addSpreadStat */](orderId, spread, 'last_seen', Math.round(Date.now() / 1000)));

        case 6:
          _context.next = 11;
          break;

        case 8:
          _context.prev = 8;
          _context.t0 = _context['catch'](0);

          pe(_context.t0);

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[0, 8]]);
}

/**
 * Put order stats in it's own state
 * @param id
 */
function fillFromOrder(_ref2) {
  var id = _ref2.id;
  var order, orderStats;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fillFromOrder$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['orders', id], __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]());
          });

        case 3:
          order = _context2.sent;
          orderStats = order.get('stats');

          if (!orderStats) {
            _context2.next = 8;
            break;
          }

          _context2.next = 8;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_5_redux_reducers_stats__["c" /* fill */](id, orderStats));

        case 8:
          _context2.next = 13;
          break;

        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2['catch'](0);

          pe(_context2.t0);

        case 13:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[0, 10]]);
}

/**
 * Force save every minute
 */
function forceSaveInterval() {
  var chan;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function forceSaveInterval$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_3_helpers_saga__["a" /* interval */], FORCE_SAVE_INTERVAL, false);

        case 2:
          chan = _context3.sent;

        case 3:
          if (false) {
            _context3.next = 16;
            break;
          }

          _context3.next = 6;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* take */](chan);

        case 6:
          _context3.prev = 6;
          _context3.next = 9;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_6_redux_reducers_orders__["x" /* save */]());

        case 9:
          _context3.next = 14;
          break;

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3['catch'](6);

          pe(_context3.t0);

        case 14:
          _context3.next = 3;
          break;

        case 16:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[6, 11]]);
}

function saga() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["d" /* SET_ACTIVE_SPREAD */], addSpreadStats);

        case 2:
          _context4.next = 4;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["c" /* SET_ACTIVE_ORDER */], fillFromOrder);

        case 4:
          _context4.next = 6;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_6_redux_reducers_orders__["a" /* ADD_ORDER */], fillFromOrder);

        case 6:
          _context4.next = 8;
          return __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* fork */](forceSaveInterval);

        case 8:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = saga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_selectors_user__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_reducers_user__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_reducers_orders__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_api__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_giftcards__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selectors_design__ = __webpack_require__(32);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _marked = [doTrack, logErrors, saga].map(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark);



// import * as Sentry from '@sentry/browser'











var UPDATE_THROTTLE = 30000;

// function * doUpdateAnalyticsProfile () {
//   yield delay(1000) //
//
//   try {
//     const token = yield select(state => state.getIn(['user', 'token'], null))
//
//     if (token) {
//       const profile = yield select(state => getProfile(state))
//       const analyticsData = yield call(request, 'user/analytics-profile', {
//         auth: true
//       })
//
//       // Sentry.configureScope(scope => {
//       //   scope.setUser({
//       //     id: profile.get('id'),
//       //     username: profile.get('first_name'),
//       //     email: profile.get('email')
//       //   })
//       // })
//     }
//   } catch (e) {
//     pe(e)
//   }
// }

function doTrack(_ref) {
  var event = _ref.event,
      _ref$data = _ref.data,
      data = _ref$data === undefined ? {} : _ref$data;
  var orderId, activeBookId, activeSpreadId, activeSpreadName, order, bookIdentifier, design, childId;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function doTrack$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](__WEBPACK_IMPORTED_MODULE_9__selectors_app__["c" /* getActiveOrderId */]);

        case 3:
          orderId = _context.sent;
          _context.next = 6;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](__WEBPACK_IMPORTED_MODULE_9__selectors_app__["b" /* getActiveBookId */]);

        case 6:
          activeBookId = _context.sent;
          _context.next = 9;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](__WEBPACK_IMPORTED_MODULE_9__selectors_app__["d" /* getActiveSpreadId */]);

        case 9:
          activeSpreadId = _context.sent;
          _context.next = 12;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](__WEBPACK_IMPORTED_MODULE_9__selectors_app__["e" /* getActiveSpreadName */]);

        case 12:
          activeSpreadName = _context.sent;
          _context.next = 15;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.getIn(['orders', orderId]);
          });

        case 15:
          order = _context.sent;
          _context.next = 18;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.get('books').find(function (book) {
              return book.get('id') === activeBookId;
            }).get('identifier');
          });

        case 18:
          bookIdentifier = _context.sent;
          _context.next = 21;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */](function (state) {
            return state.get('designs').find(function (design) {
              return design.get('id') === __WEBPACK_IMPORTED_MODULE_10__selectors_design__["a" /* getCurrentDesign */](state);
            });
          });

        case 21:
          design = _context.sent;
          childId = order.getIn(['child', 'id']);
          _context.next = 25;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_6_helpers_api__["a" /* default */], 'user/track', {
            method: 'post',
            auth: true,
            body: {
              event: event,
              data: JSON.stringify(_extends({
                order_id: orderId,
                child_id: childId,
                product_id: bookIdentifier,
                design_id: design.get('identifier'),
                spread_id: activeSpreadId,
                spread_name: activeSpreadName
              }, data))
            }
          });

        case 25:
          _context.next = 30;
          break;

        case 27:
          _context.prev = 27;
          _context.t0 = _context['catch'](0);

          pe(_context.t0);

        case 30:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[0, 27]]);
}

function logErrors() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function logErrors$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          window.onerror = function (msg, url, line, column, error) {
            pe(error);
            return false;
          };

        case 1:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function saga() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */](logErrors);

        case 2:
          _context3.next = 4;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_4_redux_reducers_user__["g" /* TRACK_EVENT */], doTrack);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export checkGiftcard */
/* harmony export (immutable) */ __webpack_exports__["a"] = saga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_api__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_reducers_giftcards__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__ = __webpack_require__(9);


var _marked = [checkGiftcard, saga].map(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark);








function checkGiftcard(_ref) {
  var code = _ref.code;
  var valid;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function checkGiftcard$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */](__WEBPACK_IMPORTED_MODULE_2_helpers_api__["a" /* default */], 'giftcards/check', {
            body: {
              code: code
            }
          });

        case 3:
          valid = _context.sent;
          _context.next = 6;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_3_redux_reducers_giftcards__["c" /* checked */](code, valid));

        case 6:
          if (!valid) {
            _context.next = 9;
            break;
          }

          _context.next = 9;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */](__WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["t" /* setSidebar */]('registration'));

        case 9:
          _context.next = 14;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](0);

          pe(_context.t0);

        case 14:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[0, 11]]);
}

function saga() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */](__WEBPACK_IMPORTED_MODULE_3_redux_reducers_giftcards__["a" /* CHECK */], checkGiftcard);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

/***/ }),
/* 357 */,
/* 358 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return App; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_webfontloader__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_webfontloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_webfontloader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_history__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_exif_test__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_scss__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_scss__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












__WEBPACK_IMPORTED_MODULE_2_webfontloader___default.a.load({
  google: {
    families: ['Roboto:300,400,700']
  }
});

var App = function (_React$PureComponent) {
  _inherits(App, _React$PureComponent);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  App.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Router */],
      { history: __WEBPACK_IMPORTED_MODULE_3_helpers_history__["a" /* default */] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Switch */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */], { path: '/exif-test', component: __WEBPACK_IMPORTED_MODULE_5_components_exif_test__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */], {
          path: '/reset-password/:user_id/:token',
          component: __WEBPACK_IMPORTED_MODULE_4_components__["L" /* ResetPassword */]
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */], { path: '/create', component: __WEBPACK_IMPORTED_MODULE_4_components__["q" /* Initializer */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */], { path: '/giftcard', component: __WEBPACK_IMPORTED_MODULE_4_components__["q" /* Initializer */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */], { path: '/:bookId?/:orderId?', component: __WEBPACK_IMPORTED_MODULE_4_components__["q" /* Initializer */] })
      )
    );
  };

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (undefined); // eslint-disable-line no-undefined

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssignmentInstructions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_selectors_books__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_icons_info__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_scss__);
var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var AssignmentInstructions = (_dec = __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](function (state) {
  return {
    spreadInfo: __WEBPACK_IMPORTED_MODULE_2_redux_selectors_books__["g" /* getSpreadInfo */](state)
  };
}), _dec(_class = function (_React$PureComponent) {
  _inherits(AssignmentInstructions, _React$PureComponent);

  function AssignmentInstructions(p) {
    _classCallCheck(this, AssignmentInstructions);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, p));

    _this.state = {
      closed: p.closed === true
    };
    _this._toggle = _this._toggle.bind(_this);
    return _this;
  }

  AssignmentInstructions.prototype._toggle = function _toggle() {
    this.setState({ closed: !this.state.closed });
  };

  AssignmentInstructions.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.closed !== nextProps.closed) {
      this.setState({
        closed: nextProps.closed
      });
    }
  };

  AssignmentInstructions.prototype.render = function render() {
    var _cx;

    var _props = this.props,
        _props$className = _props.className,
        className = _props$className === undefined ? '' : _props$className,
        spreadInfo = _props.spreadInfo;

    var inspiration = spreadInfo.get('inspiration');

    var spreadLabel = spreadInfo && spreadInfo.get('label');

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: className },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h2',
        null,
        spreadLabel
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.toggle },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.circle, onClick: this._toggle },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_icons_info__["a" /* default */], {
            size: 21,
            style: {
              fill: this.state.closed ? '#444' : '#000'
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.instructions, (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.closed] = this.state.closed, _cx)) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.text },
          spreadInfo.get('assignment')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.inspiration },
          inspiration ? inspiration.map(function (insp, nr) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: nr, className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.image },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: insp.getIn(['image', 'url']), title: insp.get('label') })
            );
          }).toArray() : null
        )
      )
    );
  };

  return AssignmentInstructions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class);


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Info;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Info(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({
      preserveAspectRatio: "xMidYMid",
      viewBox: "0 0 47.656 48",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M40.666,40.970 C36.162,45.503 30.173,48.000 23.803,48.000 C17.432,48.000 11.443,45.503 6.939,40.970 C-2.359,31.612 -2.359,16.386 6.939,7.030 C11.443,2.497 17.432,-0.000 23.803,-0.000 C30.173,-0.000 36.162,2.497 40.666,7.030 C45.172,11.562 47.653,17.588 47.653,24.000 C47.653,30.410 45.172,36.437 40.666,40.970 ZM39.261,8.444 C35.132,4.288 29.642,2.000 23.803,2.000 C17.963,2.000 12.473,4.288 8.344,8.444 C-0.179,17.021 -0.179,30.977 8.344,39.556 C12.473,43.712 17.963,46.000 23.803,46.000 C29.642,46.000 35.132,43.712 39.261,39.556 C43.391,35.401 45.666,29.876 45.666,24.000 C45.666,18.123 43.391,12.598 39.261,8.444 ZM26.785,38.000 L20.823,38.000 C20.274,38.000 19.829,37.552 19.829,37.000 C19.829,36.447 20.274,36.000 20.823,36.000 L22.656,36.000 L22.656,22.000 L20.823,22.000 C20.274,22.000 19.829,21.552 19.829,21.000 C19.829,20.448 20.274,20.000 20.823,20.000 L23.804,20.000 C24.353,20.000 24.798,20.448 24.798,21.000 C24.798,21.108 24.772,21.206 24.738,21.300 C24.717,21.366 24.689,21.425 24.656,21.484 L24.656,36.000 L26.785,36.000 C27.334,36.000 27.779,36.447 27.779,37.000 C27.779,37.552 27.334,38.000 26.785,38.000 ZM23.617,16.000 C21.973,16.000 20.635,14.655 20.635,13.000 C20.635,11.346 21.973,10.000 23.617,10.000 C25.261,10.000 26.598,11.346 26.598,13.000 C26.598,14.655 25.261,16.000 23.617,16.000 ZM23.617,12.000 C23.069,12.000 22.623,12.449 22.623,13.000 C22.623,13.552 23.069,14.000 23.617,14.000 C24.164,14.000 24.610,13.552 24.610,13.000 C24.610,12.449 24.164,12.000 23.617,12.000 Z" })
  );
}

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"toggle":"toggle_3sLH2","circle":"circle_1Smbi","instructions":"instructions_uUAza","inspiration":"inspiration_3qCb2","image":"image_1PXOr","text":"text_1nh8h","closed":"closed_d5Naj"};

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssignmentPhoto; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_icons_favorite__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_icons_is_saved__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_scss__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var AssignmentPhoto = function (_React$PureComponent) {
  _inherits(AssignmentPhoto, _React$PureComponent);

  function AssignmentPhoto() {
    var _temp, _this, _ret;

    _classCallCheck(this, AssignmentPhoto);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.toggleFavorite = function () {
      var _this$props = _this.props,
          orderId = _this$props.orderId,
          currentSpread = _this$props.currentSpread,
          photo = _this$props.photo;

      _this.props.toggleFavorite(orderId, currentSpread, photo.get('simpleId'));
    }, _this.toggleKeep = function () {
      var _this$props2 = _this.props,
          orderId = _this$props2.orderId,
          photo = _this$props2.photo;

      _this.props.toggleSaved(orderId, photo.get('simpleId'));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  AssignmentPhoto.prototype.render = function render() {
    var _cx, _cx2, _cx3;

    var _props = this.props,
        className = _props.className,
        photo = _props.photo,
        childBirthday = _props.childBirthday,
        _props$isSaved = _props.isSaved,
        isSaved = _props$isSaved === undefined ? false : _props$isSaved,
        _props$isFavorite = _props.isFavorite,
        isFavorite = _props$isFavorite === undefined ? false : _props$isFavorite,
        isMonthSpread = _props.isMonthSpread;

    var _photo$get = photo.get('exif', {}),
        ratio = _photo$get.ratio;

    var classes = __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(className || '', __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.photo, (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.selection] = photo.get('isSelection'), _cx[__WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.active] = isFavorite || isSaved, _cx));

    var sizer = {
      paddingBottom: ratio * 100 + '%'
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.inner, style: sizer },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["J" /* Photo */], {
          className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.image,
          backgroundImage: true,
          photo: photo,
          callback: this.toggleFavorite,
          childBirthday: childBirthday,
          dateFormat: isMonthSpread ? 'MMMM YYYY' : null,
          showUseCount: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.actions },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components__["g" /* Button */],
            {
              className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.action, __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.fav, (_cx2 = {}, _cx2[__WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.active] = isFavorite, _cx2)),
              fill: true,
              ripple: false,
              active: isFavorite,
              fillClass: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.fill,
              onClick: this.toggleFavorite },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_icons_favorite__["a" /* default */], null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components__["g" /* Button */],
            {
              className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.action, __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.pin, (_cx3 = {}, _cx3[__WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.active] = isSaved, _cx3)),
              fill: true,
              ripple: false,
              active: isSaved,
              fillClass: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.fill,
              onClick: this.toggleKeep },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_icons_is_saved__["a" /* default */], null)
          )
        )
      )
    );
  };

  return AssignmentPhoto;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Pin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Pin(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ preserveAspectRatio: "xMidYMid", viewBox: "0 0 47.844 47.938" }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M47.150,19.300 C45.720,19.745 44.232,19.970 42.731,19.970 C41.247,19.970 39.796,19.754 38.415,19.335 L28.236,29.536 C30.116,33.779 30.456,38.630 29.026,43.241 C28.922,43.575 28.652,43.830 28.312,43.914 C28.233,43.933 28.154,43.943 28.074,43.943 C27.813,43.943 27.558,43.840 27.369,43.650 L16.527,32.787 L1.699,47.646 C1.504,47.841 1.249,47.939 0.994,47.939 C0.739,47.939 0.484,47.841 0.289,47.646 C-0.100,47.256 -0.100,46.624 0.289,46.233 L15.118,31.375 L4.277,20.513 C4.030,20.266 3.931,19.907 4.014,19.567 C4.098,19.228 4.352,18.957 4.686,18.853 C6.564,18.268 8.516,17.971 10.488,17.971 C13.244,17.971 15.905,18.558 18.351,19.643 L28.568,9.409 C27.727,6.617 27.682,3.595 28.584,0.692 C28.688,0.358 28.959,0.103 29.298,0.020 C29.633,-0.064 29.995,0.035 30.241,0.283 L47.559,17.639 C47.807,17.887 47.906,18.246 47.822,18.585 C47.738,18.925 47.483,19.196 47.150,19.300 ZM18.243,21.800 C18.181,21.780 18.125,21.749 18.066,21.716 C15.731,20.585 13.159,19.969 10.488,19.969 C9.284,19.969 8.090,20.092 6.919,20.335 L27.547,41.003 C28.745,35.253 27.005,29.280 22.816,25.082 C21.460,23.723 19.912,22.632 18.243,21.800 ZM20.216,20.600 C21.660,21.440 23.014,22.455 24.226,23.668 C25.434,24.879 26.452,26.226 27.285,27.663 L36.393,18.535 C34.877,17.816 33.472,16.849 32.251,15.626 C31.021,14.393 30.070,12.969 29.353,11.447 L20.216,20.600 ZM30.087,2.955 C29.388,7.041 30.687,11.232 33.661,14.213 C36.082,16.638 39.303,17.973 42.731,17.973 C43.458,17.973 44.179,17.912 44.891,17.791 L30.087,2.955 Z" })
  );
}

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"photo":"photo_ydnxe","inner":"inner_3pMwY","action":"action_1NqHf","fill":"fill_1EeVv","image":"image_r8B1z","selection":"selection_39168","actions":"actions_2k3gV","pin":"pin_1XlxM","fav":"fav_2Fn2P","active":"active_1SaJl"};

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Assignment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_icons_close__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_reducers_photos__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_selectors_photos__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_selectors_books__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_selectors_orders__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_scss__);
var _dec, _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var DEFAULT_FILTER = 'all';
var FILTERS = [{
  id: 'all',
  label: kroostApp.strings.cameraRollTab,
  message: function message(photos, uploadButton) {
    return photos.count() === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.noPhotos },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        uploadButton
      )
    ) : null;
  }
}, {
  id: 'saved',
  label: kroostApp.strings.pinupTab,
  message: function message(photos) {
    return photos.count() === 0 ? kroostApp.strings.savedPhotosInformation : null;
  }
}];

var allForPage = __WEBPACK_IMPORTED_MODULE_7_redux_selectors_photos__["b" /* getFilteredForPage */]('all');

var Assignment = (_dec = __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](function (state) {
  return {
    appWidth: state.getIn(['app', 'dimensions', 'width']),
    all: allForPage(state),
    favorites: __WEBPACK_IMPORTED_MODULE_7_redux_selectors_photos__["a" /* getFavorites */](state),
    saved: __WEBPACK_IMPORTED_MODULE_7_redux_selectors_photos__["f" /* getSaved */](state),
    currentSpread: __WEBPACK_IMPORTED_MODULE_8_redux_selectors_app__["d" /* getActiveSpreadId */](state),
    spreadInfo: __WEBPACK_IMPORTED_MODULE_9_redux_selectors_books__["g" /* getSpreadInfo */](state),
    childBirthday: __WEBPACK_IMPORTED_MODULE_10_redux_selectors_orders__["e" /* getChildBirthday */](state)
  };
}, {
  setSidebar: __WEBPACK_IMPORTED_MODULE_6_redux_reducers_app__["t" /* setSidebar */],
  toggleSaved: __WEBPACK_IMPORTED_MODULE_5_redux_reducers_photos__["l" /* toggleSaved */],
  toggleFavorite: __WEBPACK_IMPORTED_MODULE_5_redux_reducers_photos__["k" /* toggleFavorite */]
}), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
  _inherits(Assignment, _React$PureComponent);

  function Assignment() {
    _classCallCheck(this, Assignment);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Assignment.prototype.componentDidMount = function componentDidMount() {
    this.props.setSidebar('photos');
  };

  Assignment.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        currentSpread = _props.currentSpread,
        spreadInfo = _props.spreadInfo,
        _props$match$params$f = _props.match.params.filter,
        filter = _props$match$params$f === undefined ? DEFAULT_FILTER : _props$match$params$f,
        childBirthday = _props.childBirthday,
        toggleSaved = _props.toggleSaved,
        toggleFavorite = _props.toggleFavorite,
        appWidth = _props.appWidth,
        allPhotos = _props.all,
        favorites = _props.favorites,
        saved = _props.saved;
    var _context = this.context,
        bookId = _context.bookId,
        orderId = _context.orderId;

    var isMonthSpread = spreadInfo.get('isMonthSpread', false);

    var photos = filter === 'saved' ? allPhotos.filter(function (photo) {
      return saved.indexOf(photo.get('simpleId')) > -1;
    }) : allPhotos;

    var uploadButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_components__["g" /* Button */],
      { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.selectFilesButton, cta: true, onClick: this.context.selectFiles },
      kroostApp.strings.assignmentSelectPhotos
    );
    var message = FILTERS.find(function (f) {
      return f.id === filter;
    }).message(photos, uploadButton);

    var assignmentPhotos = photos ? photos.map(function (photo) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["d" /* AssignmentPhoto */], {
        key: photo.get('simpleId'),
        currentSpread: currentSpread,
        photo: photo,
        isFavorite: favorites.indexOf(photo.get('simpleId')) > -1,
        isSaved: filter === 'saved' || saved.indexOf(photo.get('simpleId')) > -1,
        childBirthday: childBirthday,
        isMonthSpread: isMonthSpread,
        orderId: orderId,
        toggleSaved: toggleSaved,
        toggleFavorite: toggleFavorite,
        className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.photo
      });
    }).toArray() : [];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.assignment },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_components__["g" /* Button */],
        { to: '/' + bookId + '/' + orderId, className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.close, fillClass: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.buttonFill },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_icons_close__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          kroostApp.strings.assignmentClose
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.sidebar },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["c" /* AssignmentInstructions */], { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.instructions, closed: false }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["E" /* Notifications */], null)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.picker },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.header },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.tabs },
            FILTERS.map(function (f) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* NavLink */],
                {
                  key: f.id,
                  to: '/' + bookId + '/' + orderId + '/assignment/' + f.id,
                  replace: true,
                  className: f.id === filter ? __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.active : null },
                f.label,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.count },
                  _this2.props[f.id].count()
                )
              );
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.upload },
            uploadButton
          )
        ),
        message ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.message },
          message
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.photos },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["f" /* Bricks */], { key: appWidth, lazyLoad: true, photos: assignmentPhotos })
        )
      )
    );
  };

  return Assignment;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent), _class2.contextTypes = {
  selectFiles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  bookId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  orderId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _temp)) || _class);


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Close;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Close(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({
      height: "38",
      viewBox: "0 0 38 38",
      width: "38",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      d: "m19 37c9.9411255 0 18-8.0588745 18-18s-8.0588745-18-18-18-18 8.0588745-18 18 8.0588745 18 18 18zm-7.5-10.5 15-15m-15 0 15 15",
      fill: "none",
      stroke: "#000",
      strokeColor: "red",
      strokeLinecap: "round",
      strokeWidth: "1.7"
    })
  );
}

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"assignment":"assignment_1m1kG","sidebar":"sidebar_2h4dz","instructions":"instructions_Ub7ei","close":"close_32-ee","selectFilesButton":"selectFilesButton_zn6qG","picker":"picker_18Xvr","noPhotos":"noPhotos_37typ","help":"help_2DsCT","header":"header_2aHOk","tip":"tip_2JneU","tabs":"tabs_3IEHo","active":"active_1eEOb","upload":"upload_1EJ8r","message":"message_1fed5","photos":"photos_6_oMN","photo":"photo_2zNRj","buttonFill":"buttonFill_30b3z"};

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Book; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_selectors_orders__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_scss__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_scss__);
var _dec, _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var Book = (_dec = __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](function (state) {
  return {
    appWidth: state.getIn(['app', 'dimensions', 'width']),
    appHeight: state.getIn(['app', 'dimensions', 'height']),
    currentSpread: __WEBPACK_IMPORTED_MODULE_3_redux_selectors_app__["d" /* getActiveSpreadId */](state),
    bookId: __WEBPACK_IMPORTED_MODULE_3_redux_selectors_app__["b" /* getActiveBookId */](state),
    canEdit: __WEBPACK_IMPORTED_MODULE_4_redux_selectors_orders__["a" /* canEdit */](state)
  };
}), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
  _inherits(Book, _React$PureComponent);

  function Book() {
    _classCallCheck(this, Book);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Book.prototype.getChildContext = function getChildContext() {
    return {
      canEdit: this.props.canEdit
    };
  };

  Book.prototype.render = function render() {
    var _props = this.props,
        currentSpread = _props.currentSpread,
        canEdit = _props.canEdit,
        bookId = _props.bookId;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.book },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["P" /* Spread */], { id: currentSpread }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["H" /* Pagination */], { key: 'book-' + bookId }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["H" /* Pagination */], { arrowsOnly: true }),
      canEdit ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["Q" /* SpreadExtraButtons */], { id: currentSpread }) : null
    );
  };

  return Book;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent), _class2.childContextTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
}, _temp)) || _class);


/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"book":"book_2UGjt","maximize":"maximize_J4ARK"};

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BricksLayout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bricks_js__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_infinite_scroller__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_infinite_scroller__);
var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ITEMS_PER_PAGE = 40;

var BricksLayout = (_temp = _class = function (_React$Component) {
  _inherits(BricksLayout, _React$Component);

  function BricksLayout(props, context) {
    _classCallCheck(this, BricksLayout);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.loadMore = function () {
      _this.setState(function (state) {
        return {
          page: state.page + 1
        };
      });
    };

    _this.state = {
      page: 1
    };
    return _this;
  }

  BricksLayout.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        packed = _props.packed,
        sizes = _props.sizes,
        _props$photos = _props.photos,
        photos = _props$photos === undefined ? [] : _props$photos,
        position = _props.position,
        columns = _props.columns;


    this.instance = __WEBPACK_IMPORTED_MODULE_1_bricks_js__["a" /* default */]({
      container: this.masonryContainer,
      packed: packed,
      sizes: columns ? [{ columns: columns, gutter: 0 }] : sizes,
      position: position
    });

    if (photos.length > 0) {
      this.instance.pack();
    }
  };

  BricksLayout.prototype.componentWillUnmount = function componentWillUnmount() {
    this.masonryContainer.removeAttribute('style');
    this.masonryContainer = null;
  };

  BricksLayout.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _props2 = this.props,
        packed = _props2.packed,
        sizes = _props2.sizes,
        _props2$photos = _props2.photos,
        photos = _props2$photos === undefined ? [] : _props2$photos,
        position = _props2.position,
        columns = _props2.columns;
    var page = this.state.page;


    this.instance = __WEBPACK_IMPORTED_MODULE_1_bricks_js__["a" /* default */]({
      container: this.masonryContainer,
      packed: packed,
      sizes: columns ? [{ columns: columns, gutter: 0 }] : sizes,
      position: position
    });
    this.instance.pack();

    if ((prevProps.photos || []).length === 0 && photos.length > 0) {
      this.instance.pack();
    } else if (page !== prevState.page || (prevProps.photos || []).length !== photos.length) {
      this.instance.update();
    }
  };

  BricksLayout.prototype.render = function render() {
    var _this2 = this;

    var _props3 = this.props,
        className = _props3.className,
        lazyLoad = _props3.lazyLoad,
        style = _props3.style,
        _props3$photos = _props3.photos,
        photos = _props3$photos === undefined ? [] : _props3$photos;
    var page = this.state.page;


    if (lazyLoad) {
      var visiblePhotos = photos.slice(0, ITEMS_PER_PAGE * page);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_infinite_scroller___default.a,
        { loadMore: this.loadMore, hasMore: photos.length > visiblePhotos.length, useWindow: false },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { ref: function ref(c) {
              return _this2.masonryContainer = c;
            }, className: className, style: style },
          visiblePhotos
        )
      );
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { ref: function ref(c) {
            return _this2.masonryContainer = c;
          }, className: className, style: style },
        photos
      );
    }
  };

  return BricksLayout;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.defaultProps = {
  className: '',
  packed: 'data-packed',
  position: true,
  sizes: [
  //{ columns: 2, gutter: 0 },
  //{ mq: '768px', columns: 3, gutter: 0 },
  { columns: 4, gutter: 0 }],
  style: {}
}, _temp);


/***/ }),
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2, _initialiseProps;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Button = (_temp2 = _class = function (_React$PureComponent) {
  _inherits(Button, _React$PureComponent);

  function Button() {
    var _temp, _this, _ret;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Button.prototype.render = function render() {
    var _cx;

    var _props = this.props,
        ripple = _props.ripple,
        cta = _props.cta,
        fullWidth = _props.fullWidth,
        secondary = _props.secondary,
        _props$simple = _props.simple,
        simple = _props$simple === undefined ? false : _props$simple,
        fill = _props.fill,
        white = _props.white,
        fillClass = _props.fillClass,
        activeClassName = _props.activeClassName,
        active = _props.active,
        disabled = _props.disabled,
        leftAlign = _props.leftAlign,
        rest = _objectWithoutProperties(_props, ['ripple', 'cta', 'fullWidth', 'secondary', 'simple', 'fill', 'white', 'fillClass', 'activeClassName', 'active', 'disabled', 'leftAlign']);

    var props = _extends({}, rest, {
      onClick: this.onClick,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(this.props.className || null, (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.simple] = simple, _cx[__WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.secondary] = secondary, _cx[__WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.fullWidth] = fullWidth, _cx[__WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.button] = !ripple, _cx[__WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.rippleButton] = ripple, _cx[__WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.fillButton] = fill, _cx[__WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.white] = white, _cx[__WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.cta] = cta, _cx[__WEBPACK_IMPORTED_MODULE_3_classnames___default.a(activeClassName, __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.active)] = active, _cx[__WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.disabled] = disabled, _cx[__WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.leftAlign] = leftAlign, _cx))
    });

    var fillElement = fill ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.buttonFill, fillClass) }) : null;

    var ButtonType = 'a';
    if (this.props.type === 'submit') {
      ButtonType = 'button';
    }

    return this.props.to ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],
      _extends({}, props, { activeClassName: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(activeClassName, __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.active) }),
      this.props.children,
      fillElement
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ButtonType,
      props,
      this.props.children,
      fillElement
    );
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent), _class.defaultProps = {
  ripple: true
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onClick = function (e) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    if (_this2.props.ripple && !_this2.props.active) {
      var el = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this2);

      var button = el.getBoundingClientRect(),
          x = e.clientX - button.left,
          y = e.clientY - button.top;

      var size = Math.sqrt(Math.pow(button.height, 2) + Math.pow(button.width, 2)) * 2;

      var ripple = document.createElement('div');
      ripple.className = __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.ripple, _this2.props.fillClass);
      ripple.style.height = size + 'px';
      ripple.style.width = size + 'px';
      ripple.style.top = y + 'px';
      ripple.style.left = x + 'px';

      ripple.addEventListener('animationend', function () {
        el.removeChild(ripple);
      });

      setTimeout(function () {
        el.appendChild(ripple);
        requestAnimationFrame(function () {
          return ripple.classList.add(__WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.active);
        });
      }, 17);
    }

    if (_this2.props.onClick) {
      var _props2;

      (_props2 = _this2.props).onClick.apply(_props2, [e].concat(args));
    }
  };
}, _temp2);


/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"button_2Tf4i","simple":"simple_3wUBp","secondary":"secondary_3Hsjm","cta":"cta_10JNR","white":"white_30HBC","fullWidth":"fullWidth_-lrjp","leftAlign":"leftAlign_3s2FS","disabled":"disabled_qZ79l","rippleButton":"rippleButton_3FuOU button_2Tf4i","fillButton":"fillButton_7WDHB button_2Tf4i","ripple":"ripple_HN_1l","ripple-fill":"ripple-fill_3VEtZ","active":"active_1aDlh","buttonFill":"buttonFill_3sKst"};

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Child; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_selectors_orders__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_reducers_orders__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_reducers_user__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_selectors_user__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var Child = (_dec = __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](function (state, props) {
  return {
    orderId: __WEBPACK_IMPORTED_MODULE_5_redux_selectors_app__["c" /* getActiveOrderId */](state),
    // books: state.getIn(['books'], List()),
    // book: props.name !== undefined ? props.book : getBookId(state),
    children: __WEBPACK_IMPORTED_MODULE_9__redux_selectors_user__["a" /* getChildren */](state),
    id: props.id !== undefined ? props.id : __WEBPACK_IMPORTED_MODULE_4_redux_selectors_orders__["f" /* getChildId */](state),
    name: props.name !== undefined ? props.name : __WEBPACK_IMPORTED_MODULE_4_redux_selectors_orders__["g" /* getChildName */](state),
    birthday: props.birthday !== undefined ? props.birthday : __WEBPACK_IMPORTED_MODULE_4_redux_selectors_orders__["e" /* getChildBirthday */](state)
  };
}, {
  setOption: __WEBPACK_IMPORTED_MODULE_6_redux_reducers_orders__["z" /* setOption */],
  setSidebar: __WEBPACK_IMPORTED_MODULE_3_redux_reducers_app__["t" /* setSidebar */],
  addChild: __WEBPACK_IMPORTED_MODULE_7_redux_reducers_user__["i" /* addChild */]
}), _dec(_class = function (_React$PureComponent) {
  _inherits(Child, _React$PureComponent);

  function Child(props, context) {
    _classCallCheck(this, Child);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props, context));

    _this.onNameChange = function (e) {
      var input = e.currentTarget;
      var _this$props = _this.props,
          setOption = _this$props.setOption,
          orderId = _this$props.orderId,
          onChange = _this$props.onChange,
          previousName = _this$props.name,
          previousBirthDay = _this$props.birthday;
      var addNew = _this.state.addNew;


      if (onChange) {
        onChange('name', input.value);
      } else if (addNew) {
        _this.setState({
          addNew: _extends({}, addNew, {
            name: input.value
          })
        });
      } else {
        setOption(orderId, ['child', 'name'], input.value, {
          previousName: previousName,
          previousBirthDay: previousBirthDay
        });
      }
    };

    _this.onDateChange = function (date) {
      var _this$props2 = _this.props,
          setOption = _this$props2.setOption,
          orderId = _this$props2.orderId,
          onChange = _this$props2.onChange,
          previousBirthDay = _this$props2.birthday,
          previousName = _this$props2.name;
      var addNew = _this.state.addNew;


      if (onChange) {
        onChange('birthday', date);
      } else if (addNew) {
        _this.setState({
          addNew: _extends({}, addNew, {
            birthday: date
          })
        });
      } else {
        setOption(orderId, ['child', 'birthday'], date, {
          previousName: previousName,
          previousBirthDay: previousBirthDay
        });
      }
    };

    _this.toPhotos = function () {
      var addNew = _this.state.addNew;


      if (addNew) {
        var name = addNew.name,
            birthday = addNew.birthday;

        _this.props.addChild(name, birthday);

        _this.setState({
          selectedId: null,
          addNew: null
        });
      }

      _this.props.setSidebar('photos');
    };

    _this.selectChild = function (e) {
      var _this$props3 = _this.props,
          setOption = _this$props3.setOption,
          orderId = _this$props3.orderId,
          previousBirthDay = _this$props3.birthday,
          previousName = _this$props3.name,
          previousId = _this$props3.id,
          children = _this$props3.children;

      var childId = e.currentTarget.dataset.id;

      var selectedChild = children.find(function (child) {
        return child.get('id') === childId;
      });

      if (selectedChild) {
        setOption(orderId, 'child', selectedChild, {
          previousId: previousId,
          previousName: previousName,
          previousBirthDay: previousBirthDay
        });

        _this.setState({
          selectedId: childId,
          addNew: null
        });
      }
    };

    _this.toAddChild = function () {
      _this.setState({
        addNew: {
          name: '',
          birthday: ''
        }
      });
    };

    _this.toChild = function () {
      _this.setState({
        selectedId: null,
        addNew: null
      });

      _this.props.setSidebar('child');
    };

    _this.state = {
      selectedId: null,
      addNew: props.children.count() === 0 ? {
        name: '',
        birthday: ''
      } : null
    };
    return _this;
  }

  Child.prototype.componentWillMount = function componentWillMount() {
    this.props.setSidebar('child');
  };

  Child.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        _props$id = _props.id,
        id = _props$id === undefined ? '' : _props$id,
        _props$name = _props.name,
        name = _props$name === undefined ? '' : _props$name,
        _props$birthday = _props.birthday,
        birthday = _props$birthday === undefined ? '' : _props$birthday,
        _props$asSidebar = _props.asSidebar,
        asSidebar = _props$asSidebar === undefined ? true : _props$asSidebar,
        children = _props.children;
    var _state = this.state,
        selectedId = _state.selectedId,
        addNew = _state.addNew;


    var Wrapper = asSidebar ? __WEBPACK_IMPORTED_MODULE_2_components__["O" /* SidebarContent */] : 'div';

    if (addNew) {
      id = null;
      name = addNew.name;
      birthday = addNew.birthday;
    } else if (!selectedId) {
      var currentChild = children.find(function (child) {
        return child.get('id') === id;
      });
      var otherChildren = children.filter(function (child) {
        return child.get('id') !== id;
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Wrapper,
        { title: kroostApp.strings.kidSectionTtitle },
        currentChild ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          kroostApp.strings.childBookTargetInput,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["g" /* Button */],
            { onClick: this.selectChild, 'data-id': currentChild.get('id'), fullWidth: true, secondary: true, white: true, leftAlign: true },
            currentChild.get('name')
          )
        ) : null,
        otherChildren.count() > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          !!currentChild && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
          ),
          !currentChild ? kroostApp.strings.childBookTargetOption1 : kroostApp.strings.childBookTargetOption2,
          otherChildren.map(function (child) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_components__["g" /* Button */],
              {
                key: child.get('id'),
                onClick: _this2.selectChild,
                'data-id': child.get('id'),
                fullWidth: true,
                secondary: true,
                white: true,
                leftAlign: true },
              child.get('name')
            );
          })
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components__["g" /* Button */],
          { onClick: this.toAddChild, fullWidth: true, secondary: true },
          otherChildren ? kroostApp.strings.childBookStartButtonOption2 : kroostApp.strings.childBookStartButtonOption1
        )
      );
    }

    if (selectedId) {
      var selectedChild = children.find(function (child) {
        return child.get('id') === selectedId;
      });
      if (selectedChild) {
        id = selectedChild.get('id');
        name = selectedChild.get('name');
        birthday = selectedChild.get('birthday');
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Wrapper,
      { title: kroostApp.strings.kidSectionTtitle },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        kroostApp.strings.childIntro
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Input, {
        name: 'name',
        type: 'text',
        label: kroostApp.strings.childFormInputNameLabel,
        placeholder: kroostApp.strings.childFormInputNamePlaceholder,
        value: name,
        maxLength: '12',
        onChange: this.onNameChange
      }),
      name.length === 12 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        kroostApp.strings.childFormInputLettersInformation
      ) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].DatePicker, {
        name: 'birthday',
        className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.birthday,
        label: kroostApp.strings.childFormInputDateLabel,
        value: birthday,
        onChange: this.onDateChange
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
        { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.actions },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components__["g" /* Button */],
          { cta: true, className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.go, disabled: !name || !birthday, onClick: this.toPhotos },
          kroostApp.strings.getStartedButton
        )
      ),
      asSidebar ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
        { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.actions },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components__["g" /* Button */],
          { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.back, onClick: this.toChild },
          kroostApp.strings.backButton
        )
      ) : null
    );
  };

  return Child;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class);


/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"birthday":"birthday_3R9ej","go":"go_3muoB","back":"back_3gXWw"};

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Design; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_reducers_orders__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_selectors_design__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_selectors_books__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);
var _dec, _class, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var Design = (_dec = __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](function (state) {
  return {
    designId: __WEBPACK_IMPORTED_MODULE_4_redux_selectors_design__["a" /* getCurrentDesign */](state),
    designs: __WEBPACK_IMPORTED_MODULE_5_redux_selectors_books__["c" /* getCurrentBookDesigns */](state)
  };
}, {
  setOption: __WEBPACK_IMPORTED_MODULE_3_redux_reducers_orders__["z" /* setOption */]
}), _dec(_class = (_temp2 = _class2 = function (_React$PureComponent) {
  _inherits(Design, _React$PureComponent);

  function Design() {
    var _temp, _this, _ret;

    _classCallCheck(this, Design);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.select = function (e) {
      var orderId = _this.context.orderId;

      var id = parseInt(e.currentTarget.dataset.id);
      _this.props.setOption(orderId, 'design', id);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Design.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        designId = _props.designId,
        designs = _props.designs;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_components__["O" /* SidebarContent */],
      { innerClassName: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.designs, title: 'Designs' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.notes },
        kroostApp.strings.designInformations
      ),
      designs.map(function (d) {
        var _cx;

        var classes = __WEBPACK_IMPORTED_MODULE_7_classnames___default.a(__WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.book, (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.active] = designId === d.get('id'), _cx));

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: d.get('id'), className: classes, 'data-id': d.get('id'), onClick: _this2.select },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
            className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.thumbnail,
            style: {
              backgroundImage: 'url(' + d.getIn(['thumbnail', 'url']) + ')'
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.label },
            d.get('name')
          )
        );
      }).toArray()
    );
  };

  return Design;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent), _class2.contextTypes = {
  orderId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _temp2)) || _class);


/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"designs":"designs_2BguW","notes":"notes_c0oH7","book":"book_3FLJz","active":"active_1-kOs","thumbnail":"thumbnail_3sqaS","label":"label_3YgGS"};

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dragzone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_reducers_photos__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var MAX_UPLOAD = 64 * 1000 * 1000;

var Dragzone = (_dec = __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](function (state) {
  return {
    dropzoneActive: state.getIn(['app', 'dropzone', 'active'], false),
    draggingPhoto: state.getIn(['app', 'isDragging'], false)
  };
}, {
  setDragging: __WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["n" /* setDragging */],
  activateDropzone: __WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["e" /* activateDropzone */],
  deactivateDropzone: __WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["h" /* deactivateDropzone */],
  addPhotos: __WEBPACK_IMPORTED_MODULE_5_redux_reducers_photos__["g" /* add */],
  openPicker: __WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["k" /* openPicker */],
  closePicker: __WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["g" /* closePicker */],
  setNotification: __WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["q" /* setNotification */]
}), _dec(_class = function (_React$PureComponent) {
  _inherits(Dragzone, _React$PureComponent);

  function Dragzone() {
    var _temp, _this, _ret;

    _classCallCheck(this, Dragzone);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.onDrop = function (acceptedFiles, rejectedFiles) {
      _this.props.addPhotos(acceptedFiles);
      _this.props.deactivateDropzone();

      if (acceptedFiles.length > 0) {
        _this.props.openPicker();
      }

      if (rejectedFiles.length > 0) {
        if (rejectedFiles.length === 1) {
          _this.props.setNotification('rejectedFiles', kroostApp.strings.photoDoesntUploadAlert);
          console.log(rejectedFiles);
        } else {
          _this.props.setNotification('rejectedFiles', kroostApp.strings.photoDoesntUploadAlertPlural.replace('{rejectedFiles}', rejectedFiles.length));
        }
        setTimeout(function () {
          _this.props.setNotification('rejectedFiles', null);
        }, 5000);
      }
    }, _this.onDragEnter = function () {
      if (!_this.props.dropzoneActive) {
        _this.props.activateDropzone();
      }
    }, _this.onDragLeave = function () {
      if (_this.props.dropzoneActive) {
        _this.props.deactivateDropzone();
      }
    }, _this.onPhotoDragLeave = function (e) {
      e = e ? e : window.event;
      var from = e.relatedTarget || e.toElement;
      if (!from || from.nodeName == 'HTML') {
        _this.props.setDragging(false);
      }
    }, _this.onDragOver = function (e) {
      _this.draggingPhoto.style.transform = 'translate3d(' + e.clientX + 'px, ' + e.clientY + 'px, 0)';
    }, _this.onMouseUp = function () {
      _this.props.setDragging(false);
    }, _this.doNothing = function () {
      return false;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Dragzone.prototype.render = function render() {
    var _cx,
        _this2 = this;

    var _props = this.props,
        dropzoneActive = _props.dropzoneActive,
        draggingPhoto = _props.draggingPhoto;

    var classes = __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.dropzone, (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.active] = dropzoneActive, _cx));

    var dragzoneProps = {};
    if (draggingPhoto) {
      dragzoneProps.onMouseOut = this.onPhotoDragLeave;
      dragzoneProps.onMouseMove = this.onDragOver;
      dragzoneProps.onMouseUp = this.onMouseUp;
    }

    var accept = kroostApp.dropZoneAccept || ['image/*'];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_components__["k" /* Dropzone */],
      {
        ref: function ref(c) {
          return _this2.dropzone = c;
        },
        className: classes,
        onDragEnter: this.props.disabled ? this.doNothing : this.onDragEnter,
        onDragLeave: this.props.disabled ? this.doNothing : this.onDragLeave,
        onDrop: this.props.disabled ? this.doNothing : this.onDrop,
        maxSize: MAX_UPLOAD,
        accept: accept.join(',') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.message },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { style: { backgroundColor: 'red' } },
          kroostApp.strings.callToUseThePhotos
        )
      ),
      draggingPhoto ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["J" /* Photo */], {
        ref: function ref(c) {
          return _this2.draggingPhoto = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(c);
        },
        className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.draggingPhoto,
        photo: draggingPhoto
      }) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({ className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.dragzone }, dragzoneProps),
        this.props.children
      )
    );
  };

  return Dragzone;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class);


/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dropzone":"dropzone_2aNpE","active":"active_3HDwg","message":"message_1LdDu","dragzone":"dragzone_26iAk","draggingPhoto":"draggingPhoto_2vVAc"};

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dropzone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;

var Dropzone = (_temp2 = _class = function (_React$PureComponent) {
  _inherits(Dropzone, _React$PureComponent);

  function Dropzone() {
    var _temp, _this, _ret;

    _classCallCheck(this, Dropzone);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.onDragOver = function (e) {
      e.preventDefault();
      e.stopPropagation();

      try {
        e.dataTransfer.dropEffect = 'copy';
      } catch (err) {
        // continue regardless of error
      }

      return false;
    }, _this.onDrop = function (e) {
      e.preventDefault();

      var droppedFiles = e.dataTransfer ? e.dataTransfer.files : e.target.files;
      var dataTransferItems = e.dataTransfer && e.dataTransfer.items ? e.dataTransfer.items : [];
      var files = [];

      // Add files
      var filesLength = droppedFiles.length;
      for (var i = 0; i < filesLength; i++) {
        files.push(droppedFiles[i]);
      }

      // Walk directories
      var walkers = [];
      var itemsLength = dataTransferItems.length;
      for (var _i = 0; _i < itemsLength; _i++) {
        var item = dataTransferItems[_i];

        if (typeof item.webkitGetAsEntry === 'function') {
          (function () {
            var entry = item.webkitGetAsEntry();

            if (entry && entry.isDirectory) {
              walkers.push(new Promise(function (resolve) {
                _this.walkDirectory(entry.filesystem.root, function (walkedFiles) {
                  files = files.concat(walkedFiles);
                  resolve();
                });
              }));
            }
          })();
        }
      }

      Promise.all(walkers).then(function () {
        var acceptedFiles = [];
        var rejectedFiles = [];

        files.forEach(function (file) {
          if (!_this.fileAccepted(file) || file.size > _this.props.maxSize) {
            rejectedFiles.push(file);
          } else {
            acceptedFiles.push(file);
          }
        });

        _this.props.onDrop(acceptedFiles, rejectedFiles, e);
      });

      return false;
    }, _this.fileAccepted = function (file) {
      var accept = _this.props.accept;


      if (file && accept) {
        var acceptedFilesArray = Array.isArray(accept) ? accept : accept.split(',');
        var fileName = file.name || '';
        var mimeType = file.type || '';
        var baseMimeType = mimeType.replace(/\/.*$/, '');

        return acceptedFilesArray.some(function (type) {
          var validType = type.trim();
          if (validType.charAt(0) === '.') {
            return fileName.toLowerCase().endsWith(validType.toLowerCase());
          } else if (/\/\*$/.test(validType)) {
            // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, '');
          }
          return mimeType === validType;
        });
      }

      return true;
    }, _this.open = function () {
      _this.fileInputEl.value = null;
      _this.fileInputEl.click();
    }, _this.walkDirectory = function (directory, callback) {
      var results = [];

      if (directory === null) {
        return callback(results);
      }

      return _this.readEntries(directory, function (err, result) {
        if (err) {
          return callback(err);
        }

        var entries = result.slice();

        var processEntry = function processEntry() {
          var current = entries.shift();

          if (current === undefined) {
            return callback(results);
          }

          if (current.isDirectory) {
            return _this.walkDirectory(current, function (nestedResults) {
              results = results.concat(nestedResults);
              processEntry();
            });
          }

          return current.file(function (file) {
            results.push(file);
            return processEntry();
          }, processEntry);
        };

        return processEntry();
      });
    }, _this.readEntries = function (directory, callback, readerSupplied) {
      var entries = [];
      // reader should not be present on initial call
      var reader = readerSupplied || directory.createReader();

      return reader.readEntries(function (results) {
        if (!results.length) {
          return callback(null, entries);
        }

        entries = entries.concat(_this.toArray(results));
        return _this.readEntries(directory, function (err, additionalEntries) {
          if (err) {
            return callback(err);
          }

          entries = entries.concat(additionalEntries);
          return callback(null, entries);
        }, reader);
      }, callback);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Dropzone.prototype.getChildContext = function getChildContext() {
    return {
      selectFiles: this.open
    };
  };

  Dropzone.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (supportMultiple) {
      ['webkitdirectory', 'mozdirectory', 'msdirectory', 'odirectory', 'directory'].forEach(function (attribute) {
        _this2.directoryInputEl.setAttribute(attribute, true);
      });
    }
  };

  Dropzone.prototype.toArray = function toArray(obj) {
    return Array.prototype.slice.call(obj || [], 0);
  };

  Dropzone.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        accept = _props.accept,
        maxSize = _props.maxSize,
        props = _objectWithoutProperties(_props, ['accept', 'maxSize']);

    var inputAttributes = {
      accept: accept,
      type: 'file',
      style: { display: 'none' },
      multiple: supportMultiple,
      onChange: this.onDrop
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      _extends({}, props, { onDragOver: this.onDragOver, onDrop: this.onDrop }),
      this.props.children,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, inputAttributes, { ref: function ref(el) {
          return _this3.directoryInputEl = el;
        } })),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, inputAttributes, { ref: function ref(el) {
          return _this3.fileInputEl = el;
        } }))
    );
  };

  return Dropzone;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent), _class.PropTypes = {
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _class.defaultProps = {
  maxSize: Infinity
}, _class.childContextTypes = {
  selectFiles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, _temp2);


/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FavoritePickerPhoto; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_scss__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var FavoritePickerPhoto = function (_React$PureComponent) {
  _inherits(FavoritePickerPhoto, _React$PureComponent);

  function FavoritePickerPhoto() {
    var _temp, _this, _ret;

    _classCallCheck(this, FavoritePickerPhoto);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.onMouseDown = function (e) {
      var photo = _this.props.photo;


      _this.props.setDragging(photo);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  FavoritePickerPhoto.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        photo = _props.photo,
        childBirthday = _props.childBirthday,
        isMonthSpread = _props.isMonthSpread;

    var _photo$get = photo.get('exif', {}),
        ratio = _photo$get.ratio;

    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(className || '', __WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.photo);

    var sizer = {
      paddingBottom: ratio * 100 + '%'
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes, onMouseDown: this.onMouseDown },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.inner, style: sizer },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["J" /* Photo */], {
          className: __WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.image,
          photo: photo,
          backgroundImage: true,
          childBirthday: childBirthday,
          dateFormat: isMonthSpread ? 'MMMM YYYY' : null,
          showUseCount: true
        })
      )
    );
  };

  return FavoritePickerPhoto;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"photo":"photo_2kIiW","inner":"inner_1h_7_","moments":"moments_32RS1","image":"image_EHJ7R","pickedFill":"pickedFill_3Rtg9"};

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Picker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_selectors_orders__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_selectors_photos__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_selectors_books__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);
var _dec, _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var favoritesForPage = __WEBPACK_IMPORTED_MODULE_5_redux_selectors_photos__["b" /* getFilteredForPage */]('favorites');

var Picker = (_dec = __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](function (state, props) {
  return {
    orderId: state.getIn(['app', 'activeOrderId']),
    appWidth: state.getIn(['app', 'dimensions', 'width']),
    favorites: favoritesForPage(state),
    availableMoments: __WEBPACK_IMPORTED_MODULE_6_redux_selectors_books__["a" /* getAvailableMoments */](state),
    activeSpreadIds: state.getIn(['app', 'activeSpreadIds']),
    isMonthSpread: __WEBPACK_IMPORTED_MODULE_6_redux_selectors_books__["g" /* getSpreadInfo */](state).get('isMonthSpread', false),
    childBirthday: __WEBPACK_IMPORTED_MODULE_4_redux_selectors_orders__["e" /* getChildBirthday */](state)
  };
}, {
  setDragging: __WEBPACK_IMPORTED_MODULE_7_redux_reducers_app__["n" /* setDragging */],
  openPicker: __WEBPACK_IMPORTED_MODULE_7_redux_reducers_app__["k" /* openPicker */]
}), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
  _inherits(Picker, _React$PureComponent);

  function Picker() {
    _classCallCheck(this, Picker);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Picker.prototype.render = function render() {
    var _props = this.props,
        orderId = _props.orderId,
        availableMoments = _props.availableMoments,
        setDragging = _props.setDragging,
        favorites = _props.favorites,
        childBirthday = _props.childBirthday,
        appWidth = _props.appWidth,
        activeSpreadIds = _props.activeSpreadIds,
        isMonthSpread = _props.isMonthSpread;
    var bookId = this.context.bookId;

    var photoMoments = availableMoments.filter(function (moment) {
      return moment.get('type') === 'photo';
    });
    var hasPhotoMoments = photoMoments.count() > 0;
    var hasSelectedPhoto = favorites.count() > 0;
    var spreadId = activeSpreadIds.get(orderId);

    var content = null;

    // If there should be a default message for spreads without photos, enter it below.
    var actions = '';

    if (hasPhotoMoments) {
      var favoritesPhotos = favorites.map(function (photo) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["m" /* FavoritePickerPhoto */], {
          key: photo.get('simpleId'),
          photo: photo,
          setDragging: setDragging,
          isMonthSpread: isMonthSpread,
          childBirthday: childBirthday,
          className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.photo
        });
      }).toArray();

      var ctaText = hasSelectedPhoto ? kroostApp.strings.photosChooseMore : kroostApp.strings.photosChoose;
      actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.actionContainer, key: 'choose' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_components__["g" /* Button */],
          { cta: !hasSelectedPhoto, secondary: true, to: '/' + bookId + '/' + orderId + '/assignment' },
          ctaText
        )
      )];

      content = favoritesPhotos.length === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["c" /* AssignmentInstructions */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.empty })
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["c" /* AssignmentInstructions */], { closed: true }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.brickContainer },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["f" /* Bricks */], { key: appWidth, columns: 2, photos: favoritesPhotos })
        )
      );
    } else {
      content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["c" /* AssignmentInstructions */], null);
    }

    //console.log(spreadId);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_components__["O" /* SidebarContent */],
      { key: spreadId, actions: actions, innerClassName: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.removeInnerPadding },
      content
    );
  };

  return Picker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent), _class2.contextTypes = {
  bookId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _temp)) || _class);


/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"actionContainer":"actionContainer_1ZNSE","brickContainer":"brickContainer_1gxyb","photo":"photo_3LYlH","empty":"empty_2fUg8","removeInnerPadding":"removeInnerPadding_3LbQJ"};

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Graphic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers_string__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Graphic = function (_React$PureComponent) {
  _inherits(Graphic, _React$PureComponent);

  function Graphic() {
    _classCallCheck(this, Graphic);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Graphic.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        scale = _props.scale,
        graphic = _props.graphic;


    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.graphic);
    var rotate = parseInt(graphic.getIn(['options', 'rotate'], 0));

    var style = _extends((_extends2 = {
      zIndex: graphic.get('order') ? Math.round(graphic.get('order') * 1000) : 1,
      left: Math.round(graphic.get('x') * scale) + 'px',
      top: Math.round(graphic.get('y') * scale) + 'px',
      width: Math.round(graphic.get('width') * scale) + 'px',
      height: Math.round(graphic.get('height') * scale) + 'px',
      backgroundImage: 'url(' + graphic.get('image') + ')'
    }, _extends2[__WEBPACK_IMPORTED_MODULE_1_helpers_string__["d" /* transformWithPrefix */]] = rotate ? 'rotate(' + rotate + 'deg)' : null, _extends2), __WEBPACK_IMPORTED_MODULE_1_helpers_string__["c" /* stringToCSSObject */](graphic.getIn(['options', 'css'], '')));

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: classes, style: style });
  };

  return Graphic;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"graphic":"graphic_1kkL5"};

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Initializer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Initializer = (_dec = __WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](function (state) {
  return {
    initializing: state.getIn(['app', 'ui', 'initializing'], true)
  };
}, {
  cancelInitialize: __WEBPACK_IMPORTED_MODULE_6_redux_reducers_app__["f" /* cancelInitialize */],
  initialize: __WEBPACK_IMPORTED_MODULE_6_redux_reducers_app__["j" /* initialize */],
  setSidebar: __WEBPACK_IMPORTED_MODULE_6_redux_reducers_app__["t" /* setSidebar */]
}), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
  _inherits(Initializer, _React$PureComponent);

  function Initializer() {
    _classCallCheck(this, Initializer);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Initializer.prototype.getChildContext = function getChildContext() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
    var _props$match$params = props.match.params,
        _props$match$params$o = _props$match$params.orderId,
        orderId = _props$match$params$o === undefined ? null : _props$match$params$o,
        _props$match$params$b = _props$match$params.bookId,
        bookId = _props$match$params$b === undefined ? null : _props$match$params$b;


    return {
      orderId: orderId,
      bookId: bookId ? parseInt(bookId) : null
    };
  };

  Initializer.prototype.componentWillMount = function componentWillMount() {
    var _getChildContext = this.getChildContext(),
        orderId = _getChildContext.orderId,
        bookId = _getChildContext.bookId;

    var setSidebar = this.props.setSidebar;
    var _props$match = this.props.match,
        path = _props$match.path,
        params = _props$match.params;

    var createOrder = false;

    if (path.slice(0, 9) === '/giftcard') {
      var query = __WEBPACK_IMPORTED_MODULE_4_qs__["parse"](this.props.location.search.substring(1));
      setSidebar('giftcard', _extends({}, params, query));
    } else if (path === '/create') {
      var _query = __WEBPACK_IMPORTED_MODULE_4_qs__["parse"](this.props.location.search.substring(1));
      var padLeft = function padLeft(nr) {
        return Array(2 - String(nr).length + 1).join('0') + nr;
      };

      createOrder = {
        book: _query.book,
        name: _query.name,
        birthday: _query.year + '-' + padLeft(_query.month) + '-' + padLeft(_query.day)
      };
    }
    this.props.cancelInitialize();
    this.props.initialize(bookId, orderId, createOrder);
  };

  Initializer.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (this.idsWillChange(nextProps)) {
      var _getChildContext2 = this.getChildContext(nextProps),
          orderId = _getChildContext2.orderId,
          bookId = _getChildContext2.bookId;

      this.props.cancelInitialize();
      this.props.initialize(bookId, orderId);
    }
  };

  Initializer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.idsWillChange(nextProps) || this.props.initializing !== nextProps.initializing || this.props.location.pathname !== nextProps.location.pathname;
  };

  Initializer.prototype.idsWillChange = function idsWillChange(nextProps) {
    var _getChildContext3 = this.getChildContext(),
        orderId = _getChildContext3.orderId,
        bookId = _getChildContext3.bookId;

    var _getChildContext4 = this.getChildContext(nextProps),
        nextOrderId = _getChildContext4.orderId,
        nextBookId = _getChildContext4.bookId;

    return orderId !== nextOrderId || bookId !== nextBookId;
  };

  Initializer.prototype.render = function render() {
    var initializing = this.props.initializing;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.app },
      !initializing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Route */], { path: '/:bookId?/:orderId?', component: __WEBPACK_IMPORTED_MODULE_5_components__["u" /* Maker */] }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.loading },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["r" /* Loader */], { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.loader }),
        kroostApp.strings.loadingFirstMessage
      )
    );
  };

  return Initializer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent), _class2.childContextTypes = {
  orderId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bookId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _temp)) || _class);


/***/ }),
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loading":"loading_tIclQ","loader":"loader_2PETs"};

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Loader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_scss__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Loader = function (_React$PureComponent) {
  _inherits(Loader, _React$PureComponent);

  function Loader() {
    _classCallCheck(this, Loader);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Loader.prototype.render = function render() {
    var _props$className = this.props.className,
        className = _props$className === undefined ? '' : _props$className;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.loader, className) });
  };

  return Loader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loader":"loader_276av","load":"load_lFiac"};

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Login; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_reducers_user__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_scss__);
var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ERROR_CODES = {
  default: kroostApp.strings.loginFailed,
  'user-invalid-role': kroostApp.strings.loginErrorMessage
};

var Login = (_dec = __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](function (state) {
  return {
    validCode: state.getIn(['giftcards', 'code'], false),
    loading: state.getIn(['user', 'loading'], false),
    failedLogin: state.getIn(['user', 'failedLogin'], false)
  };
}, {
  login: __WEBPACK_IMPORTED_MODULE_4_redux_reducers_user__["p" /* login */],
  logout: __WEBPACK_IMPORTED_MODULE_4_redux_reducers_user__["q" /* logout */],
  register: __WEBPACK_IMPORTED_MODULE_4_redux_reducers_user__["r" /* register */],
  requestResetPassword: __WEBPACK_IMPORTED_MODULE_4_redux_reducers_user__["s" /* requestResetPassword */],
  setSidebar: __WEBPACK_IMPORTED_MODULE_3_redux_reducers_app__["t" /* setSidebar */]
}), _dec(_class = function (_React$PureComponent) {
  _inherits(Login, _React$PureComponent);

  function Login(props, context) {
    _classCallCheck(this, Login);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props, context));

    _this.showRegistration = function (e) {
      e.preventDefault();
      _this.setState({
        form: 'registration',
        passwordRequested: false
      });
    };

    _this.showLogin = function (e) {
      e.preventDefault();
      _this.setState({
        form: 'login',
        passwordRequested: false
      });
    };

    _this.showPassword = function (e) {
      e.preventDefault();
      _this.setState({
        form: 'password',
        passwordRequested: false
      });
    };

    _this.register = function (e) {
      e.preventDefault();
      var _this$state = _this.state,
          first_name = _this$state.first_name,
          email = _this$state.email,
          password = _this$state.password;

      _this.props.register(first_name, email, password, 'saveSuccess');
    };

    _this.login = function (e) {
      e.preventDefault();
      var _this$state2 = _this.state,
          email = _this$state2.email,
          password = _this$state2.password;

      _this.props.login(email, password);
    };

    _this.requestResetPassword = function (e) {
      e.preventDefault();
      var email = _this.state.email;

      _this.props.requestResetPassword(email);
      _this.setState({
        passwordRequested: true
      });
    };

    _this.onChange = function (e) {
      var _this$setState;

      var input = e.currentTarget;

      _this.setState((_this$setState = {}, _this$setState[input.name] = input.type === 'checkbox' ? input.checked : input.value, _this$setState));
    };

    _this.toMyOrders = function (e) {
      _this.props.setSidebar('myOrders');
    };

    _this.toGiftcards = function (e) {
      _this.props.setSidebar('giftcard');
    };

    _this.state = {
      form: props.sidebar || 'login',
      passwordRequested: false,
      firstname: null,
      email: null,
      password: null,
      terms: false
    };
    return _this;
  }

  Login.prototype.render = function render() {
    var _state = this.state,
        form = _state.form,
        first_name = _state.first_name,
        terms = _state.terms,
        email = _state.email,
        password = _state.password,
        passwordRequested = _state.passwordRequested;
    var _props = this.props,
        failedLogin = _props.failedLogin,
        validCode = _props.validCode,
        loading = _props.loading;

    var errorMessage = failedLogin ? ERROR_CODES[failedLogin] || ERROR_CODES.default : null;

    if (form === 'login') {
      var action = [];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_components__["O" /* SidebarContent */],
        { title: kroostApp.strings.loginCredentialsTitle, anchorActionsBottom: true, actions: action },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { method: 'POST', onSubmit: this.login },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Input, {
              name: 'email',
              type: 'email',
              label: kroostApp.strings.loginEmailInputLabel,
              onChange: this.onChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Input, {
              name: 'password',
              className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.passwordInput,
              type: 'password',
              label: kroostApp.strings.loginPasswordInput,
              onChange: this.onChange
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_components__["g" /* Button */],
              { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.passwordReset, simple: true, onClick: this.showPassword },
              kroostApp.strings.loginForgot
            )
          ),
          errorMessage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Error,
            null,
            errorMessage
          ) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
            { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.actions },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_components__["g" /* Button */],
              { cta: true, type: 'submit', className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.submit, disabled: !email || !password, onClick: this.login },
              kroostApp.strings.login
            )
          ),
          validCode ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
            { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.actions },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_components__["g" /* Button */],
              { secondary: true, className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.createAccount, onClick: this.showRegistration },
              kroostApp.strings.loginNoAccount
            )
          ) : null,
          !validCode ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
            { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.actions },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_components__["g" /* Button */],
              { secondary: true, className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.createAccount, onClick: this.toGiftcards },
              kroostApp.strings.voucherPersonalCode
            )
          ) : null
        )
      );
    } else if (form === 'password') {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_components__["O" /* SidebarContent */],
        { title: kroostApp.strings.forgotPasswordSectionTitle },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { method: 'POST', onSubmit: this.requestResetPassword },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Input, {
              name: 'email',
              type: 'email',
              label: 'E-mail',
              placeholder: kroostApp.strings.forgotPasswordEmailPlaceholder,
              onChange: this.onChange
            })
          ),
          passwordRequested ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
            null,
            kroostApp.strings.passwordRequestSend,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_components__["g" /* Button */],
              { onClick: this.showLogin },
              kroostApp.strings.backToLogin
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
              { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.actions },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_components__["g" /* Button */],
                {
                  cta: true,
                  type: 'submit',
                  className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.submit,
                  disabled: !email,
                  onClick: this.requestResetPassword },
                kroostApp.strings.loginSendNew
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
              { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.back },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_components__["g" /* Button */],
                { simple: true, onClick: this.showLogin },
                kroostApp.strings.passwordRequestRemember
              )
            )
          )
        )
      );
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_components__["O" /* SidebarContent */],
        { title: kroostApp.strings.makeAccountTitleStep1 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { method: 'POST', onSubmit: this.register },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
            { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.description },
            kroostApp.strings.loginIntro
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Input, {
              name: 'first_name',
              type: 'text',
              label: kroostApp.strings.signupFirstNameInputLabel,
              placeholder: kroostApp.strings.signupFirstNamePlaceholder,
              onChange: this.onChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Input, {
              name: 'email',
              type: 'email',
              label: kroostApp.strings.signupEmailInputLabel,
              placeholder: kroostApp.strings.loginEmailInputLabel,
              onChange: this.onChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Input, {
              name: 'password',
              type: 'password',
              label: kroostApp.strings.signupPasswordInputLabel,
              placeholder: kroostApp.strings.loginPasswordInput,
              onChange: this.onChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Checkbox, {
              name: 'terms',
              checked: terms,
              label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                kroostApp.strings.acceptPrivacyStatementFirstPart,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  {
                    href: 'https://kroost.' + global.kroostApp.domainExtension + '/designer-terms',
                    target: '_blank' },
                  kroostApp.strings.acceptPrivacyStatementSecondPart
                )
              ),
              onChange: this.onChange
            })
          ),
          errorMessage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Error,
            null,
            errorMessage
          ) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
            { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.actions },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_components__["g" /* Button */],
              {
                cta: true,
                type: 'submit',
                className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.submit,
                disabled: loading || !first_name || !email || !password || !terms,
                onClick: this.register },
              kroostApp.strings.accountCreate
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
            { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.back },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_components__["g" /* Button */],
              { secondary: true, onClick: this.showLogin },
              kroostApp.strings.accountAlready
            )
          )
        )
      );
    }
  };

  return Login;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27)))

/***/ }),
/* 443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"description":"description_2410L","actions":"actions_L4Hz9","back":"back_2cAiu","passwordInput":"passwordInput_15Vfs","passwordReset":"passwordReset_3tGJB"};

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = OpenedBook;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





function OpenedBook(props) {
  var payoff = props.payoff,
      rest = _objectWithoutProperties(props, ['payoff']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'svg',
      _extends({ viewBox: '0 0 269 50', className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(props.className, __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.logo) }, rest),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { fill: '#2B363F' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M0.00918054144,0.992974323 C-0.00639825846,0.727223661 0.0839915365,0.467032773 0.257304833,0.278737943 C0.43061813,0.0904431137 0.670107131,-0.00776014794 0.914713547,0.00916531321 L2.00397789,0.00916531321 C2.2485843,-0.00776014794 2.4880733,0.0904431137 2.6613866,0.278737943 C2.8346999,0.467032773 2.92508969,0.727223661 2.90951089,0.992974323 L2.90951089,21.2608657 L23.4349257,0.472553615 C23.744181,0.114585439 24.1953303,-0.0559006641 24.642303,0.016294364 L26.335256,0.016294364 C26.9914394,0.016294364 27.0570577,0.729199444 26.6961569,1.12842629 L5.69829008,22.3088362 L27.3523402,44.8009915 C27.713241,45.1289278 27.595128,45.9131234 26.807708,45.9131234 L24.8850909,45.9131234 C24.3767681,45.932359 23.8900508,45.6891156 23.5727242,45.2572507 L2.90951089,23.4922586 L2.90951089,45.0647663 C2.90951089,45.720639 2.48955356,45.9202524 2.00397789,45.9202524 L0.790038713,45.9202524 C0.576145398,45.9399997 0.365126298,45.8562322 0.213335783,45.6913206 C0.0615452688,45.526409 -0.0155573871,45.297149 0.00261870807,45.0647663 L0.00918054144,0.992974323 Z' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M44.081952,0.856047211 C44.074501,0.626770896 44.155512,0.404451743 44.3056217,0.242228952 C44.4557314,0.0800061613 44.66145,-0.00754206049 44.8736064,0.000510250939 L59.9216358,0.000510250939 C67.3236038,0.000510250939 73.4589249,6.03204582 73.4589249,14.0384459 C73.4589249,20.6617278 69.21038,25.9731864 63.4444976,27.7484256 L72.304429,44.7379638 C72.6078965,45.2655449 72.4891483,45.9214566 71.8822133,45.9214566 L70.0020343,45.9214566 C69.629427,45.9453654 69.2852988,45.7060824 69.1510059,45.3297102 L60.3504486,28.1476762 C59.5587942,28.2118415 58.8924852,28.2118415 58.107428,28.2118415 L46.9319076,28.2118415 L46.9319076,45.0587901 C46.9319076,45.5150765 46.5690661,45.9143271 45.9621311,45.9143271 L44.8670093,45.9143271 C44.4327497,45.9066946 44.0824174,45.5280923 44.0753549,45.0587901 L44.081952,0.856047211 Z M59.8028876,25.4527348 C62.6300136,25.4907751 65.3542192,24.3075883 67.3707197,22.1658465 C69.3872203,20.0241047 70.5291508,17.1010366 70.5429981,14.0455753 C70.5429981,7.81441448 65.6281441,3.02340751 59.7435136,3.02340751 L46.9648932,3.02340751 L46.9648932,25.4527348 L59.8028876,25.4527348 Z' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M109.270282,1.70058616e-05 C121.940327,6.37966784e-05 132.21461,10.2676443 132.226055,22.9408148 C132.237501,35.6139854 121.98178,45.900116 109.311755,45.9230591 C96.6417312,45.9460021 86.3488436,35.6970812 86.3144141,23.0239523 C86.290432,16.9211188 88.699287,11.0604152 93.0077514,6.73917553 C97.3162158,2.41793582 103.168913,-0.00740967946 109.270282,1.70058616e-05 L109.270282,1.70058616e-05 Z M109.270282,43.1152997 C117.424106,43.1152761 124.774128,38.1997068 127.889909,30.6628095 C131.005691,23.1259122 129.272937,14.4536336 123.500366,8.69354041 C117.727796,2.9334472 109.053507,1.22117792 101.526006,4.35589098 C93.9985039,7.49060404 89.1018832,14.8542711 89.1215175,23.0100867 C89.1215019,28.3507397 91.2458592,33.4719476 95.0258866,37.2438046 C98.8059141,41.0156616 103.930964,43.1281909 109.270282,43.1152997 Z' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M166.200948,1.70058616e-05 C178.870993,6.37966784e-05 189.145277,10.2676443 189.156722,22.9408148 C189.168167,35.6139854 178.912446,45.900116 166.242422,45.9230591 C153.572398,45.9460021 143.27951,35.6970812 143.245081,23.0239523 C143.221099,16.9211188 145.629954,11.0604152 149.938418,6.73917553 C154.246883,2.41793582 160.09958,-0.00740967946 166.200948,1.70058616e-05 L166.200948,1.70058616e-05 Z M166.200948,43.1152997 C174.354773,43.1152761 181.704794,38.1997068 184.820576,30.6628095 C187.936358,23.1259122 186.203604,14.4536336 180.431033,8.69354041 C174.658463,2.9334472 165.984174,1.22117792 158.456672,4.35589098 C150.929171,7.49060404 146.03255,14.8542711 146.052184,23.0100867 C146.052169,28.3507397 148.176526,33.4719476 151.956553,37.2438046 C155.736581,41.0156616 160.86163,43.1281909 166.200948,43.1152997 Z' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M204.107826,39.3448304 L204.67675,38.5823337 C205.115439,38.0693814 205.560981,37.8891549 206.047651,38.3258575 C206.678266,38.901196 211.346184,43.2335637 217.700311,43.2335637 C223.437532,43.2335637 228.297377,39.3448304 228.297377,34.6866687 C228.297377,29.0095341 223.691149,26.458636 216.062084,23.8453518 C208.748327,21.2320676 203.888482,18.6187834 203.888482,11.2849514 C203.888482,6.50201743 207.672169,0 217.508385,0 C221.351279,0.0450606684 225.105955,1.17072266 228.352213,3.25100871 C228.572413,3.38503313 228.725861,3.60743412 228.774251,3.86268972 C228.82264,4.11794533 228.761404,4.38196758 228.60583,4.58884386 C228.413974,4.85123315 228.244298,5.12948678 228.098596,5.42065845 C227.978763,5.66881291 227.754511,5.84895919 227.488375,5.91086057 C227.222239,5.97276195 226.942694,5.9097956 226.727695,5.73952072 C226.535769,5.61474853 222.313393,2.74498817 217.460403,2.74498817 C209.701103,2.74498817 206.801647,7.59723998 206.801647,11.2294971 C206.801647,16.6501555 210.91435,19.0069635 217.268477,21.1142272 C225.905154,24.1087597 231.395613,27.1726102 231.395613,34.5688283 C231.395613,40.9460735 224.897542,45.9230975 217.652329,45.9230975 C212.721317,45.8580533 207.977623,44.0031443 204.286043,40.6965291 C203.922755,40.3638033 203.607447,40.044941 204.107826,39.3448304 Z' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M252.897757,2.82432161 L241.366044,2.82432161 C240.762221,2.82432161 240.578449,2.4321256 240.578449,1.84026617 L240.578449,0.85621073 C240.571036,0.626890621 240.651632,0.404529001 240.800972,0.242275222 C240.950312,0.0800214438 241.154976,-0.00754350115 241.366044,0.000510348406 L267.33701,0.000510348406 C267.548079,-0.00754350115 267.752743,0.0800214438 267.902083,0.242275222 C268.051423,0.404529001 268.132019,0.626890621 268.124606,0.85621073 L268.124606,1.96862123 C268.132019,2.19794134 268.051423,2.42030296 267.902083,2.58255674 C267.752743,2.74481051 267.548079,2.83237546 267.33701,2.82432161 L255.739665,2.82432161 L255.739665,45.0673971 C255.739665,45.5237707 255.378683,45.9230975 254.77486,45.9230975 L253.685353,45.9230975 C253.25332,45.9154636 252.904783,45.536789 252.897757,45.0673971 L252.897757,2.82432161 Z' })
      )
    ),
    payoff ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.payoff },
      kroostApp.strings.payoff
    ) : null
  );
}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"logo":"logo_3rkOq","payoff":"payoff_LyLuj"};

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Maker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_selectors_user__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_scss__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var Maker = (_dec = __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](function (state) {
  return {
    authenticated: __WEBPACK_IMPORTED_MODULE_5_redux_selectors_user__["c" /* isAuthenticated */](state),
    profile: __WEBPACK_IMPORTED_MODULE_5_redux_selectors_user__["b" /* getProfile */](state)
  };
}), _dec(_class = (_temp2 = _class2 = function (_React$PureComponent) {
  _inherits(Maker, _React$PureComponent);

  function Maker() {
    var _temp, _this, _ret;

    _classCallCheck(this, Maker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.updateChat = function () {
      var authenticated = _this.props.authenticated;


      try {
        var user = _this.user;
        if (authenticated && window.Chatra && user) {
          window.Chatra('setIntegrationData', user);
        }
      } catch (e) {
        console.log(e);
      }
    }, _this.showMessageOnExit = function () {
      window.onbeforeunload = null;
      if (!false && !_this.props.authenticated) {
        window.onbeforeunload = function () {
          return true;
        };
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Maker.prototype.componentWillMount = function componentWillMount() {
    this.showMessageOnExit();
  };

  Maker.prototype.componentDidUpdate = function componentDidUpdate() {
    this.showMessageOnExit();
    this.updateChat();
  };

  Maker.prototype.render = function render() {
    var orderId = this.context.orderId;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_components__["j" /* Dragzone */],
      { disabled: false },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.maker },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["v" /* Menu */], { orderId: orderId }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["N" /* Sidebar */], { orderId: orderId }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.content },
          orderId ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["e" /* Book */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.noSelection },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["t" /* Logo */], { width: 225, payoff: true })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { path: '/:bookId/:orderId/assignment/:filter?', component: __WEBPACK_IMPORTED_MODULE_4_components__["b" /* Assignment */] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_6__styles_scss___default.a.noMobile },
          kroostApp.strings.smallScreensMessage1,
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          kroostApp.strings.smallScreensMessage2
        )
      )
    );
  };

  _createClass(Maker, [{
    key: 'user',
    get: function get() {
      var _props = this.props,
          authenticated = _props.authenticated,
          profile = _props.profile;


      return authenticated && profile ? {
        name: profile.get('first_name'),
        email: profile.get('email'),
        user_id: profile.get('id', ''),
        user_hash: profile.get('hash', '')
      } : null;
    }
  }]);

  return Maker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent), _class2.contextTypes = {
  bookId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  orderId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _temp2)) || _class);


/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"maker":"maker_3wmGq","content":"content_22Gdo","noSelection":"noSelection_DBsYX","noMobile":"noMobile_3SRms"};

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MenuItem = function (_React$PureComponent) {
  _inherits(MenuItem, _React$PureComponent);

  function MenuItem() {
    _classCallCheck(this, MenuItem);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  MenuItem.prototype.render = function render() {
    var _props = this.props,
        icon = _props.icon,
        children = _props.children,
        props = _objectWithoutProperties(_props, ['icon', 'children']);

    if (this.props.to) {
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        _extends({}, props, { className: __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.item }),
        icon ? icon : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          children
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_components__["g" /* Button */],
      _extends({}, props, { className: __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.item, fillClass: __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.fill, fill: true, activeClassName: __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.active }),
      icon ? icon : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        children
      )
    );
  };

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"item":"item_3_fNs","active":"active_36owo","fill":"fill_1eqYS"};

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Menu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_icons_favorite__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_icons_design__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_icons_pencil__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_icons_save__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_icons_help__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_icons_order__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_icons_profile__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_selectors_user__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux_selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux_selectors_orders__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux_reducers_user__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_scss__);
var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var icons = {
  pencil: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_icons_pencil__["a" /* default */], { width: 35, height: 35 }),
  book: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_icons_design__["a" /* default */], { width: 35, height: 35 }),
  child: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_icons_favorite__["a" /* default */], { width: 35, height: 30 }),
  help: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_icons_help__["a" /* default */], { width: 35, height: 35 }),
  order: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_icons_order__["a" /* default */], { width: 35, height: 42 }),
  profile: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_icons_profile__["a" /* default */], { width: 35, height: 35 }),
  save: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_icons_save__["a" /* default */], { width: 35, height: 35 })
};

var Menu = (_dec = __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](function (state) {
  return {
    authenticated: __WEBPACK_IMPORTED_MODULE_11_redux_selectors_user__["c" /* isAuthenticated */](state),
    canEdit: __WEBPACK_IMPORTED_MODULE_13_redux_selectors_orders__["a" /* canEdit */](state),
    sidebar: __WEBPACK_IMPORTED_MODULE_12_redux_selectors_app__["a" /* forcedSidebar */](state)
  };
}, {
  setSidebar: __WEBPACK_IMPORTED_MODULE_10_redux_reducers_app__["t" /* setSidebar */],
  trackEvent: __WEBPACK_IMPORTED_MODULE_14_redux_reducers_user__["v" /* trackEvent */]
}), _dec(_class = function (_React$PureComponent) {
  _inherits(Menu, _React$PureComponent);

  function Menu() {
    var _temp, _this, _ret;

    _classCallCheck(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.setSidebar = function (e) {
      var item = e.currentTarget.dataset.sidebar;
      _this.props.setSidebar(item);
    }, _this.trackClick = function (e) {
      _this.props.trackEvent('help_clicked', {});
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Menu.prototype.render = function render() {
    var _cx;

    var _props = this.props,
        orderId = _props.orderId,
        canEdit = _props.canEdit,
        sidebar = _props.sidebar,
        authenticated = _props.authenticated;

    var classes = __WEBPACK_IMPORTED_MODULE_15_classnames___default.a(__WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.menu, (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.cantEdit] = !canEdit, _cx));

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.center },
        authenticated ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_components__["w" /* MenuItem */],
            {
              'data-sidebar': 'myOrders',
              active: sidebar === 'myOrders' || sidebar === 'profile' || sidebar === 'login',
              onClick: this.setSidebar,
              icon: icons.profile },
            kroostApp.strings.menuAccount
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_components__["w" /* MenuItem */],
            {
              'data-sidebar': 'makeAccount',
              active: sidebar === 'makeAccount',
              onClick: this.setSidebar,
              icon: icons.profile },
            kroostApp.strings.menuAccount
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: !orderId ? __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.needsEdit : '' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_components__["w" /* MenuItem */],
            { 'data-sidebar': 'order', active: sidebar === 'order', onClick: this.setSidebar, icon: icons.order },
            kroostApp.strings.menuOrder
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.needsEdit },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_components__["w" /* MenuItem */],
            { 'data-sidebar': 'child', active: sidebar === 'child', onClick: this.setSidebar, icon: icons.child },
            kroostApp.strings.menuChild
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.needsEdit },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_components__["w" /* MenuItem */],
            { 'data-sidebar': 'photos', active: sidebar === 'photos', onClick: this.setSidebar, icon: icons.pencil },
            kroostApp.strings.menuPhotos
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { className: __WEBPACK_IMPORTED_MODULE_16__styles_scss___default.a.bottom },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_components__["w" /* MenuItem */],
            {
              to: 'https://kroost.' + global.kroostApp.domainExtension + '/designer-faq',
              target: '_blank',
              icon: icons.help,
              onClick: this.trackClick },
            kroostApp.strings.menuHelp
          )
        )
      )
    );
  };

  return Menu;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27)))

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Layers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Layers(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({
      preserveAspectRatio: "xMidYMid",
      viewBox: "0 0 35 35",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "translate(-15.000000, -397.000000)", fill: "#1B1B1B" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { transform: "translate(0.000000, 397.000000)" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            { transform: "translate(15.000000, 0.000000)" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M34.505625,10.828125 L17.7872917,19.5715625 C17.6822917,19.62625 17.5663542,19.6539583 17.4511458,19.6539583 C17.3359375,19.6539583 17.22,19.62625 17.115,19.5715625 L0.4003125,10.828125 C0.103541667,10.6735417 -0.0495833333,10.3344792 0.030625,10.0085417 C0.0853125,9.7846875 0.240625,9.60677083 0.4396875,9.51708333 L17.1179167,0.792604167 C17.3279167,0.683229167 17.5802083,0.683229167 17.7902083,0.792604167 L34.505625,9.53604167 C34.7455208,9.6621875 34.8957292,9.91083333 34.8957292,10.1820833 C34.8957292,10.4540625 34.7455208,10.7027083 34.505625,10.828125 Z M17.4540625,2.26041667 L2.30854167,10.1828125 L17.4511458,18.10375 L32.5973958,10.1820833 L17.4540625,2.26041667 Z M0.406145833,16.4842708 L2.58635417,15.3628125 C2.94291667,15.1776042 3.38114583,15.3205208 3.56489583,15.6778125 C3.74791667,16.0365625 3.6071875,16.4755208 3.24989583,16.6592708 L2.296875,17.1492708 L17.4540625,25.3822917 L32.6119792,17.15 L31.6582292,16.6592708 C31.3009375,16.4747917 31.1602083,16.0358333 31.3432292,15.6778125 C31.5269792,15.32125 31.96375,15.1790625 32.3225,15.3628125 L34.48375,16.47625 C34.6733333,16.568125 34.8191667,16.7394792 34.8738542,16.953125 C34.9555208,17.276875 34.8089583,17.6144792 34.5165625,17.7727083 L17.8004167,26.8515625 C17.6925,26.9113542 17.5736458,26.9397917 17.4540625,26.9397917 C17.3344792,26.9397917 17.2163542,26.9113542 17.1077083,26.8515625 L0.3915625,17.7727083 C0.154583333,17.6436458 0.00802083333,17.3942708 0.0109375,17.12375 C0.0145833333,16.8539583 0.16625,16.6075 0.406145833,16.4842708 Z M0.406145833,23.7701042 L2.58635417,22.6486458 C2.94291667,22.4641667 3.38114583,22.6063542 3.56489583,22.964375 C3.74791667,23.3223958 3.6071875,23.7620833 3.24989583,23.9451042 L2.296875,24.4358333 L17.4540625,32.6688542 L32.6119792,24.4365625 L31.6582292,23.9451042 C31.3009375,23.760625 31.1602083,23.3216667 31.3432292,22.964375 C31.5269792,22.6070833 31.96375,22.4648958 32.3225,22.6486458 L34.48375,23.7628125 C34.6733333,23.8539583 34.8191667,24.0260417 34.8738542,24.2389583 C34.9555208,24.5627083 34.8089583,24.9003125 34.5165625,25.0585417 L17.8004167,34.138125 C17.6925,34.1971875 17.5736458,34.2263542 17.4540625,34.2263542 C17.3344792,34.2263542 17.2163542,34.1971875 17.1077083,34.138125 L0.3915625,25.0585417 C0.154583333,24.9302083 0.00802083333,24.6801042 0.0109375,24.4095833 C0.0145833333,24.1405208 0.16625,23.8933333 0.406145833,23.7701042 Z" })
          )
        )
      )
    )
  );
}

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Pencil;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Pencil(props) {
  var styles = props.height ? { height: props.height } : null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({
      height: "48.438",
      preserveAspectRatio: "xMidYMid",
      viewBox: "0 0 47.938 48.438",
      width: "47.938",
      xmlns: "http://www.w3.org/2000/svg",
      style: styles
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      d: "m46.3 9.641c-.032.033-.073.046-.108.073-.028.038-.043.082-.077.117l-3.061 3.093s0 .001-.001.001v.001l-30.231 30.548c-.001.001-.002.001-.002.002l-.004.004c-.094.095-.204.169-.324.219l-11.097 4.653c-.123.052-.254.077-.382.077-.26 0-.515-.103-.706-.296-.286-.288-.372-.722-.217-1.099l4.6-11.211c.001 0 .001-.001.001-.002l.002-.005c.024-.057.067-.097.099-.148.038-.06.065-.126.118-.18l.005-.005 30.231-30.551 3.061-3.094c.033-.034.076-.048.112-.075.027-.037.041-.08.074-.113 2.18-2.203 5.727-2.203 7.907 0 1.056 1.067 1.638 2.486 1.637 3.996 0 1.51-.581 2.929-1.637 3.995zm-43.441 35.912 7.489-3.14-4.382-4.43zm9.251-4.213 28.826-29.129-5.084-5.139-28.824 29.13zm32.778-38.263c-1.402-1.416-3.681-1.416-5.083 0-.033.033-.076.047-.112.075-.027.036-.041.079-.074.112l-2.355 2.381 5.084 5.139 2.355-2.38c.032-.032.073-.046.108-.073.029-.038.043-.082.077-.117.679-.685 1.052-1.597 1.052-2.568s-.373-1.883-1.052-2.569z",
      fill: "#1b1b1b",
      fillRule: "evenodd"
    })
  );
}

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSave;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function IconSave(props) {
  var styles = props.height ? { height: props.height } : null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({
      preserveAspectRatio: "xMidYMid",
      viewBox: "0 0 35 30",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      style: styles,
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "translate(-16.000000, -182.000000)", fill: "#1B1B1B" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { transform: "translate(1.000000, 182.000000)" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            { transform: "translate(15.000000, 0.000000)" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M26.25,26.25 L21.875,26.25 C21.4717708,26.25 21.1458333,25.9233333 21.1458333,25.5208333 C21.1458333,25.1176042 21.4717708,24.7916667 21.875,24.7916667 L26.25,24.7916667 C31.0369792,24.7916667 33.5416667,20.6230208 33.5416667,16.5054167 C33.5416667,11.9364583 29.8564583,8.21916667 25.3261458,8.21916667 C25.1642708,8.21916667 25.0016667,8.22864583 24.8397917,8.24760417 C24.4978125,8.28770833 24.1798958,8.085 24.0683333,7.76270833 C22.7565625,3.9921875 19.2179167,1.45833333 15.264375,1.45833333 C10.1179167,1.45833333 5.93104167,5.6809375 5.93104167,10.8711458 C5.93104167,11.3086458 5.96822917,11.7534375 6.04552083,12.2317708 C6.10239583,12.5846875 5.8953125,12.9266667 5.55552083,13.0396875 C3.10479167,13.8548958 1.45833333,16.1532292 1.45833333,18.7592708 C1.45833333,22.085 4.1409375,24.7916667 7.4375,24.7916667 L13.125,24.7916667 C13.5275,24.7916667 13.8541667,25.1176042 13.8541667,25.5208333 C13.8541667,25.9233333 13.5275,26.25 13.125,26.25 L7.4375,26.25 C3.33666667,26.25 0,22.8892708 0,18.7592708 C0,15.7303125 1.79520833,13.0345833 4.5259375,11.8715625 C4.49020833,11.5310417 4.47270833,11.2 4.47270833,10.8711458 C4.47270833,4.87666667 9.31364583,0 15.264375,0 C19.6532292,0 23.5980208,2.695 25.2488542,6.7615625 C30.6038542,6.69229167 35,11.1066667 35,16.5054167 C35,21.3478125 31.994375,26.25 26.25,26.25 Z M12.6094792,20.2030208 C12.324375,19.9179167 12.324375,19.4563542 12.6094792,19.1719792 L16.9844792,14.7969792 C17.0515625,14.7298958 17.1317708,14.6766667 17.2214583,14.6394792 C17.399375,14.5658333 17.600625,14.5658333 17.7785417,14.6394792 C17.8682292,14.6766667 17.9484375,14.7298958 18.0155208,14.7969792 L22.3905208,19.1719792 C22.675625,19.4563542 22.675625,19.9179167 22.3905208,20.2030208 C22.2483333,20.3452083 22.0616667,20.4166667 21.875,20.4166667 C21.6883333,20.4166667 21.5016667,20.3452083 21.3594792,20.2030208 L18.2291667,17.0727083 L18.2291667,28.4375 C18.2291667,28.84 17.9025,29.1666667 17.5,29.1666667 C17.0975,29.1666667 16.7708333,28.84 16.7708333,28.4375 L16.7708333,17.0727083 L13.6405208,20.2030208 C13.3554167,20.4873958 12.8945833,20.4873958 12.6094792,20.2030208 Z",
              id: "Shape"
            })
          )
        )
      )
    )
  );
}

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Help;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Help(props) {
  var styles = props.height ? { height: props.height } : null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({
      preserveAspectRatio: "xMidYMid",
      viewBox: "0 0 35 35",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      style: styles,
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "translate(-14.000000, -630.000000)", fill: "#1B1B1B" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { transform: "translate(-1.000000, 630.000000)" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            { transform: "translate(15.000000, 0.000000)" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M17.5,35 C7.8509375,35 0,27.1490625 0,17.5 C0,16.1583333 0.16625,14.8567708 0.453541667,13.6011458 C0.457916667,13.5880208 0.457916667,13.5734375 0.46375,13.5610417 C1.96364583,7.07510417 7.07072917,1.9665625 13.5566667,0.464479167 C13.593125,0.4484375 13.6346875,0.444791667 13.6747917,0.434583333 C14.9078125,0.158229167 16.1845833,0 17.5,0 C18.8161458,0 20.094375,0.158229167 21.328125,0.434583333 C21.3667708,0.444791667 21.406875,0.4484375 21.4426042,0.464479167 C27.9285417,1.96583333 33.0363542,7.074375 34.53625,13.5610417 C34.5420833,13.5734375 34.5420833,13.5880208 34.5464583,13.6011458 C34.83375,14.8567708 35,16.1583333 35,17.5 C35,27.1490625 27.1490625,35 17.5,35 Z M32.9211458,21.8691667 L25.0694792,21.8691667 C24.3016667,23.1940625 23.1991667,24.2972917 21.875,25.0658333 L21.875,32.9196875 C27.2066667,31.4044792 31.4073958,27.2022917 32.9211458,21.8691667 Z M17.5,10.2083333 C13.479375,10.2083333 10.2083333,13.479375 10.2083333,17.5 C10.2083333,20.3065625 11.8052083,22.7441667 14.135625,23.9626042 C14.1385417,23.9633333 14.1407292,23.9655208 14.1436458,23.96625 C15.1491667,24.4905208 16.2895833,24.7916667 17.5,24.7916667 C18.711875,24.7916667 19.8522917,24.4905208 20.8592708,23.9655208 C20.8607292,23.9640625 20.8621875,23.9633333 20.864375,23.9626042 C23.1947917,22.7441667 24.7916667,20.3065625 24.7916667,17.5 C24.7916667,13.479375 21.520625,10.2083333 17.5,10.2083333 Z M17.5,33.5416667 C18.4975,33.5416667 19.4694792,33.438125 20.4166667,33.263125 L20.4166667,25.7395833 C19.5030208,26.0640625 18.52375,26.25 17.5,26.25 C16.47625,26.25 15.4977083,26.0640625 14.5840625,25.7395833 L14.5840625,33.263125 C15.53125,33.438125 16.5032292,33.5416667 17.5,33.5416667 Z M13.1257292,32.9196875 L13.1257292,25.0665625 C11.8015625,24.2980208 10.6990625,23.1947917 9.93125,21.870625 L2.07885417,21.8698958 C3.59260417,27.2030208 7.7940625,31.4044792 13.1257292,32.9196875 Z M1.45833333,17.5 C1.45833333,18.4953125 1.561875,19.4658333 1.73614583,20.4115625 L9.25895833,20.4122917 C8.93520833,19.499375 8.75,18.5222917 8.75,17.5 C8.75,16.4747917 8.93666667,15.4940625 9.261875,14.5789583 L1.73760417,14.5789583 C1.561875,15.5276042 1.45833333,16.5010417 1.45833333,17.5 Z M2.08104167,13.120625 L9.93635417,13.120625 C10.7041667,11.8008333 11.8044792,10.7005208 13.125,9.93416667 L13.125,2.0803125 C7.79625,3.59479167 3.59697917,7.79260417 2.08104167,13.120625 Z M17.5,1.45833333 C16.5025,1.45833333 15.5305208,1.561875 14.5833333,1.736875 L14.5833333,9.26041667 C15.4969792,8.9359375 16.47625,8.75 17.5,8.75 C18.52375,8.75 19.5022917,8.9359375 20.4159375,9.26041667 L20.4159375,1.736875 C19.46875,1.561875 18.4967708,1.45833333 17.5,1.45833333 Z M21.8742708,2.0803125 L21.8742708,9.9334375 C23.1955208,10.7005208 24.2958333,11.8001042 25.0636458,13.120625 L32.9189583,13.120625 C31.4022917,7.79260417 27.2030208,3.5940625 21.8742708,2.0803125 Z M33.2623958,14.5789583 L25.738125,14.5789583 C26.0633333,15.4940625 26.25,16.4747917 26.25,17.5 C26.25,18.5215625 26.0647917,19.4986458 25.7417708,20.4108333 L33.2638542,20.4108333 C33.438125,19.4651042 33.5416667,18.4953125 33.5416667,17.5 C33.5416667,16.5010417 33.438125,15.5276042 33.2623958,14.5789583 Z" })
          )
        )
      )
    )
  );
}

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Bag;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Bag(props) {
  var styles = props.height ? { height: props.height } : null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({
      preserveAspectRatio: "xMidYMid",
      viewBox: "0 0 35 42",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      style: styles,
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "translate(-15.000000, -249.000000)", fill: "#000" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { transform: "translate(0.000000, 249.000000)" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            { transform: "translate(15.000000, 0.000000)" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M33.25,42 L1.75,42 C0.784875,42 0,41.215125 0,40.25 L0,8.75 C0,7.784875 0.784875,7 1.75,7 L11.375,7 L11.375,3.5 C11.375,1.56975 12.94475,0 14.875,0 L20.125,0 C22.05525,0 23.625,1.56975 23.625,3.5 L23.625,7 L33.25,7 C34.215125,7 35,7.784875 35,8.75 L35,40.25 C35,41.215125 34.215125,42 33.25,42 Z M21.875,3.5 C21.875,2.534875 21.090125,1.75 20.125,1.75 L14.875,1.75 C13.909875,1.75 13.125,2.534875 13.125,3.5 L13.125,7 L21.875,7 L21.875,3.5 Z M23.625,8.75 L23.625,11.375 C23.625,11.858 23.233,12.25 22.75,12.25 C22.267,12.25 21.875,11.858 21.875,11.375 L21.875,8.75 L13.125,8.75 L13.125,11.375 C13.125,11.858 12.733,12.25 12.25,12.25 C11.767,12.25 11.375,11.858 11.375,11.375 L11.375,8.75 L1.75,8.75 L1.75,40.25 L33.247375,40.25 L33.25,8.75 L23.625,8.75 Z",
              id: "Shape"
            })
          )
        )
      )
    )
  );
}

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FemaleUser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function FemaleUser(props) {
  var styles = props.height ? { height: props.height } : null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ preserveAspectRatio: "xMidYMid", viewBox: "0 0 48 48", style: styles }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M45.467,48.000 L2.533,48.000 C1.137,48.000 -0.000,46.864 -0.000,45.467 L-0.000,42.401 C-0.000,42.036 0.200,41.699 0.521,41.524 L16.040,33.058 C16.317,32.907 16.556,32.730 16.730,32.577 C16.585,32.521 16.406,32.470 16.207,32.442 L6.860,31.126 C6.455,31.069 6.126,30.771 6.028,30.374 C5.932,29.976 6.086,29.560 6.419,29.322 C10.490,26.415 11.829,14.500 12.001,10.154 C12.002,10.133 12.014,10.116 12.017,10.095 C12.019,10.070 12.010,10.047 12.015,10.023 C13.021,4.215 18.063,-0.000 24.000,-0.000 C29.937,-0.000 34.979,4.215 35.985,10.023 C35.990,10.047 35.981,10.070 35.983,10.095 C35.986,10.115 35.998,10.133 35.999,10.154 C36.171,14.500 37.510,26.415 41.581,29.322 C41.914,29.560 42.068,29.976 41.972,30.374 C41.874,30.771 41.545,31.069 41.140,31.126 L31.791,32.442 C31.593,32.470 31.414,32.522 31.268,32.577 C31.442,32.731 31.681,32.907 31.957,33.059 L47.479,41.524 C47.800,41.699 48.000,42.036 48.000,42.401 L48.000,45.467 C48.000,46.864 46.863,48.000 45.467,48.000 ZM46.000,42.995 L30.999,34.814 C30.664,34.631 29.000,33.659 29.000,32.436 C29.000,31.326 30.301,30.635 31.510,30.462 L38.875,29.425 C34.682,24.000 34.052,11.434 34.005,10.321 C33.147,5.497 28.948,2.000 24.000,2.000 C19.052,2.000 14.853,5.497 13.995,10.321 C13.948,11.434 13.318,24.000 9.125,29.425 L16.488,30.462 C17.699,30.635 19.000,31.326 19.000,32.436 C19.000,33.660 17.332,34.631 16.997,34.814 L2.000,42.995 L2.000,45.467 C2.000,45.756 2.244,46.001 2.533,46.001 L45.467,46.001 C45.756,46.001 46.000,45.756 46.000,45.467 L46.000,42.995 Z" })
  );
}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"menu":"menu_2o3hY","center":"center_1kzIK","bottom":"bottom_2ZLis","cantEdit":"cantEdit_1NzTE","needsEdit":"needsEdit_3IZ97"};

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MomentEdit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_icons_rotate__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_icons_flip__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_icons_zoom_in__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_icons_zoom_out__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_scss__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var MomentEdit = function (_React$PureComponent) {
  _inherits(MomentEdit, _React$PureComponent);

  function MomentEdit() {
    var _temp, _this, _ret;

    _classCallCheck(this, MomentEdit);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.rotate = function () {
      var _this$props = _this.props,
          orderId = _this$props.orderId,
          momentId = _this$props.momentId,
          transform = _this$props.transform;

      var newRotate = ((transform.rotate || 0) - 90) / 360;
      var rotate = (newRotate - Math.floor(newRotate)) * 360;

      _this.props.updateTransform(orderId, momentId, {
        rotate: rotate
      });
    }, _this.flip = function () {
      var _this$props2 = _this.props,
          orderId = _this$props2.orderId,
          momentId = _this$props2.momentId,
          transform = _this$props2.transform;


      _this.props.updateTransform(orderId, momentId, {
        flip: !transform.flip
      });
    }, _this.zoomIn = function () {
      var _this$props3 = _this.props,
          orderId = _this$props3.orderId,
          momentId = _this$props3.momentId,
          transform = _this$props3.transform;

      if (transform.dpi < 100) return;
      _this.props.updateTransform(orderId, momentId, {
        width: transform.width * 1.1
      });
    }, _this.zoomOut = function () {
      var _this$props4 = _this.props,
          orderId = _this$props4.orderId,
          momentId = _this$props4.momentId,
          transform = _this$props4.transform;

      _this.props.updateTransform(orderId, momentId, {
        width: transform.width * 0.9
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  MomentEdit.prototype.render = function render() {
    var _cx;

    var _props = this.props,
        className = _props.className,
        _props$align = _props.align,
        align = _props$align === undefined ? 'right' : _props$align;

    var classes = __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(className, __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.edit, (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.alignLeft] = align === 'left', _cx[__WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.alignRight] = align !== 'left', _cx));

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.inner },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_components__["g" /* Button */],
          { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.button, onClick: this.rotate, title: kroostApp.strings.rotate },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_icons_rotate__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_components__["g" /* Button */],
          { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.button, onClick: this.flip, title: kroostApp.strings.mirror },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_icons_flip__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_components__["g" /* Button */],
          { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.button, onClick: this.zoomIn, title: kroostApp.strings.zoomIn },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_icons_zoom_in__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_components__["g" /* Button */],
          { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.button, onClick: this.zoomOut, title: kroostApp.strings.zoomOut },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_icons_zoom_out__["a" /* default */], null)
        )
      )
    );
  };

  return MomentEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Refresh;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Refresh(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ preserveAspectRatio: "xMidYMid", viewBox: "0 0 44 48" }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M34.231,40.715 C33.777,41.026 33.153,40.909 32.842,40.452 C32.530,39.996 32.648,39.374 33.104,39.063 C38.508,35.375 42.000,28.678 42.000,22.000 C42.000,10.972 33.028,2.000 22.000,2.000 C10.972,2.000 2.000,10.972 2.000,22.000 C2.000,33.028 10.972,42.000 22.000,42.000 C22.270,42.000 22.537,41.966 22.807,41.956 L20.210,38.614 C19.871,38.178 19.950,37.549 20.387,37.210 C20.822,36.871 21.452,36.951 21.790,37.386 L25.790,42.534 C25.962,42.755 26.033,43.040 25.985,43.316 C25.938,43.593 25.776,43.837 25.540,43.989 L19.540,47.841 C19.373,47.949 19.186,48.000 19.001,48.000 C18.672,48.000 18.350,47.838 18.158,47.540 C17.860,47.076 17.995,46.457 18.460,46.159 L21.835,43.992 C9.780,43.901 0.000,34.075 0.000,22.000 C0.000,9.869 9.869,-0.000 22.000,-0.000 C34.131,-0.000 44.000,9.869 44.000,22.000 C44.000,29.319 40.166,36.666 34.231,40.715 Z" })
  );
}

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Flip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Flip(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({
      preserveAspectRatio: "xMidYMid",
      viewBox: "0 0 48 48",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { id: "Symbols", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { id: "Laptop", transform: "translate(-694.000000, -320.000000)", fill: "#404040" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { id: "mirror", transform: "translate(694.000000, 320.000000)" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M41.7084302,17.3147853 C41.5129783,17.561624 41.2573874,17.6844104 41.0007942,17.6844104 C40.7452032,17.6844104 40.4896123,17.561624 40.2941604,17.3147853 C39.9032566,16.8211079 39.9032566,16.0223632 40.2941604,15.5286858 L44.6612572,10.0096257 L38.0730251,10.0096257 C36.7068666,10.0096257 35.0811078,10.9615369 34.3253605,12.3957331 L17.3380858,44.5847651 C16.2074718,46.7240338 14.3191059,48 12.285404,48 L1.00031273,48 C0.448035862,48 1.13686838e-13,47.4354356 1.13686838e-13,46.7366922 C1.13686838e-13,46.0392147 0.448035862,45.4733844 1.00031273,45.4733844 L12.285404,45.4733844 C13.6495579,45.4733844 14.916487,44.6176769 15.6732366,43.1834808 L23.9463642,27.5073247 L23.9463642,27.5073247 L32.6615137,10.9944488 C33.7881184,8.85644589 35.6764843,7.57921386 37.7141955,7.57921386 L44.5850811,7.57921386 L40.2921558,2.15635755 C39.901252,1.66268015 39.901252,0.863935442 40.2921558,0.370258047 C40.6830596,-0.123419349 41.3155218,-0.123419349 41.7064256,0.370258047 L47.7042927,7.94757315 C47.7975082,8.06403038 47.8706774,8.20453856 47.9217956,8.36023682 C47.9709091,8.51087172 47.9959671,8.67163333 47.9969694,8.83239494 C47.998974,9.2159443 47.8917261,9.51594826 47.7133136,9.72101425",
            id: "Shape"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M41.7084302,17.3147853 C41.5129783,17.561624 41.2573874,17.6844104 41.0007942,17.6844104 C40.7452032,17.6844104 40.4896123,17.561624 40.2941604,17.3147853 C39.9032566,16.8211079 39.9032566,16.0223632 40.2941604,15.5286858 L44.6612572,10.0096257 L38.0730251,10.0096257 C36.7068666,10.0096257 35.0811078,10.9615369 34.3253605,12.3957331 L17.3380858,44.5847651 C16.2074718,46.7240338 14.3191059,48 12.285404,48 L1.00031273,48 C0.448035862,48 1.13686838e-13,47.4354356 1.13686838e-13,46.7366922 C1.13686838e-13,46.0392147 0.448035862,45.4733844 1.00031273,45.4733844 L12.285404,45.4733844 C13.6495579,45.4733844 14.916487,44.6176769 15.6732366,43.1834808 L23.9463642,27.5073247 L23.9463642,27.5073247 L32.6615137,10.9944488 C33.7881184,8.85644589 35.6764843,7.57921386 37.7141955,7.57921386 L44.5850811,7.57921386 L40.2921558,2.15635755 C39.901252,1.66268015 39.901252,0.863935442 40.2921558,0.370258047 C40.6830596,-0.123419349 41.3155218,-0.123419349 41.7064256,0.370258047 L47.7042927,7.94757315 C47.7975082,8.06403038 47.8706774,8.20453856 47.9217956,8.36023682 C47.9709091,8.51087172 47.9959671,8.67163333 47.9969694,8.83239494 C47.998974,9.2159443 47.8917261,9.51594826 47.7133136,9.72101425",
            id: "Shape",
            transform: "translate(23.998498, 24.000000) scale(-1, 1) translate(-23.998498, -24.000000) "
          })
        )
      )
    )
  );
}

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ZoomIn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function ZoomIn(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "47.906",
      height: "48",
      viewBox: "0 0 47.906 48"
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M47.610,47.707 C47.415,47.902 47.160,48.000 46.905,48.000 C46.649,48.000 46.394,47.902 46.199,47.707 L29.921,31.395 C26.740,34.248 22.556,36.000 17.961,36.000 C8.056,36.000 -0.004,27.925 -0.004,18.000 C-0.004,8.075 8.056,0.000 17.961,0.000 C27.869,0.000 35.928,8.075 35.928,18.000 C35.928,22.603 34.180,26.795 31.332,29.981 L47.610,46.293 C48.000,46.684 48.000,47.316 47.610,47.707 ZM33.932,18.000 C33.932,9.178 26.767,2.000 17.961,2.000 C9.156,2.000 1.992,9.178 1.992,18.000 C1.992,26.822 9.156,34.000 17.961,34.000 C26.767,34.000 33.932,26.822 33.932,18.000 ZM25.945,19.000 L18.959,19.000 L18.959,26.000 C18.959,26.552 18.513,27.000 17.961,27.000 C17.409,27.000 17.000,26.552 17.000,26.000 L17.000,19.000 L9.977,19.000 C9.425,19.000 8.979,18.552 8.979,18.000 C8.979,17.448 9.425,17.000 9.977,17.000 L17.000,17.000 L17.000,10.000 C17.000,9.448 17.409,9.000 17.961,9.000 C18.513,9.000 18.959,9.448 18.959,10.000 L18.959,17.000 L25.945,17.000 C26.497,17.000 26.944,17.448 26.944,18.000 C26.944,18.552 26.497,19.000 25.945,19.000 Z" })
  );
}

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ZoomOut;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function ZoomOut(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ preserveAspectRatio: "xMidYMid", viewBox: "0 0 47.906 48" }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M47.610,47.707 C47.415,47.902 47.160,48.000 46.904,48.000 C46.649,48.000 46.394,47.902 46.199,47.707 L29.921,31.395 C26.740,34.248 22.556,36.000 17.961,36.000 C8.055,36.000 -0.004,27.925 -0.004,18.000 C-0.004,8.075 8.055,0.000 17.961,0.000 C27.868,0.000 35.928,8.075 35.928,18.000 C35.928,22.603 34.179,26.795 31.332,29.981 L47.610,46.293 C48.000,46.684 48.000,47.317 47.610,47.707 ZM33.932,18.000 C33.932,9.178 26.767,2.000 17.961,2.000 C9.156,2.000 1.992,9.178 1.992,18.000 C1.992,26.822 9.156,34.000 17.961,34.000 C26.767,34.000 33.932,26.822 33.932,18.000 ZM25.945,19.000 L9.976,19.000 C9.425,19.000 8.978,18.552 8.978,18.000 C8.978,17.448 9.425,17.000 9.976,17.000 L25.945,17.000 C26.497,17.000 26.943,17.448 26.943,18.000 C26.943,18.552 26.497,19.000 25.945,19.000 Z" })
  );
}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"edit":"edit_dDkM9","alignRight":"alignRight_3ktc3","inner":"inner_2nfwE","alignLeft":"alignLeft_a03ep","button":"button_2D_D3","zoom":"zoom_1hMhp"};

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MomentPhoto; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_normalize_wheel__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_normalize_wheel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_normalize_wheel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_photo__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_reducers_orders__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_reducers_photos__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_selectors_design__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _class, _class2, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



//import { Map } from 'immutable';


















var MENU_WIDTH = 40;

var MomentPhoto = (_dec = __WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](function (state, props) {
  return {
    orderId: __WEBPACK_IMPORTED_MODULE_9_redux_selectors_app__["c" /* getActiveOrderId */](state),
    spreadDimensions: __WEBPACK_IMPORTED_MODULE_10_redux_selectors_design__["e" /* getSpreadDimensions */](state),
    draggingPhoto: state.getIn(['app', 'isDragging'], false),
    draggingPreview: state.getIn(['app', 'draggingPreview'], null)
  };
}, {
  pickMoment: __WEBPACK_IMPORTED_MODULE_7_redux_reducers_orders__["v" /* pickMoment */],
  setDraggingPreview: __WEBPACK_IMPORTED_MODULE_6_redux_reducers_app__["o" /* setDraggingPreview */],
  updateTransform: __WEBPACK_IMPORTED_MODULE_7_redux_reducers_orders__["D" /* updateTransform */],
  updatePreview: __WEBPACK_IMPORTED_MODULE_8_redux_reducers_photos__["m" /* updatePreview */]
}), _dec(_class = (_temp2 = _class2 = function (_React$PureComponent) {
  _inherits(MomentPhoto, _React$PureComponent);

  function MomentPhoto() {
    var _temp, _this, _ret;

    _classCallCheck(this, MomentPhoto);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.onMouseEnter = function () {
      var _this$props = _this.props,
          momentId = _this$props.momentId,
          draggingPhoto = _this$props.draggingPhoto;


      if (draggingPhoto) {
        _this.props.setDraggingPreview(momentId);
      }
    }, _this.onMouseLeave = function () {
      var draggingPhoto = _this.props.draggingPhoto;


      if (draggingPhoto) {
        _this.props.setDraggingPreview(null);
      }
    }, _this.onMouseUp = function () {
      var _this$props2 = _this.props,
          orderId = _this$props2.orderId,
          momentId = _this$props2.momentId,
          draggingPhoto = _this$props2.draggingPhoto;


      if (draggingPhoto) {
        _this.props.pickMoment(orderId, momentId, draggingPhoto.get('simpleId'));
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  MomentPhoto.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        preview = _props.preview,
        orderId = _props.orderId,
        momentId = _props.momentId;


    if (!preview || preview.isEmpty()) {
      this.props.updatePreview(orderId, momentId);
    }
  };

  MomentPhoto.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    var _props2 = this.props,
        transform = _props2.transform,
        orderId = _props2.orderId,
        momentId = _props2.momentId,
        updatePreview = _props2.updatePreview,
        photo = _props2.photo;
    var newTransform = nextProps.transform,
        newPhoto = nextProps.photo;


    if (photo === null && newPhoto || photo && newPhoto && photo.get('simpleId') !== newPhoto.get('simpleId') || transform && newTransform && transform.rotate !== newTransform.rotate) {
      updatePreview(orderId, momentId);
    }
  };

  MomentPhoto.prototype.render = function render() {
    var _cx;

    var _props3 = this.props,
        scale = _props3.scale,
        design = _props3.design,
        photo = _props3.photo,
        backAndWhite = _props3.backAndWhite,
        transform = _props3.transform,
        style = _props3.style,
        preview = _props3.preview,
        spreadDimensions = _props3.spreadDimensions,
        draggingPreview = _props3.draggingPreview,
        draggingPhoto = _props3.draggingPhoto,
        orderId = _props3.orderId,
        momentId = _props3.momentId,
        momentWidth = _props3.momentWidth,
        momentHeight = _props3.momentHeight,
        updateTransform = _props3.updateTransform,
        rotate = _props3.rotate;
    var bookId = this.context.bookId;


    var placeholder = null;
    var placeholderImage = design.getIn(['options', 'placeholder_image', 'url'], null);
    if (placeholderImage) {
      placeholder = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.placeholder,
        style: _extends({}, style, {
          backgroundImage: 'url(' + placeholderImage + ')'
        })
      });
    }

    var classes = __WEBPACK_IMPORTED_MODULE_12_classnames___default.a(__WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.moment, (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.blackwhite] = backAndWhite, _cx));

    // const leftAlignedMenu = ((design.get('x') * scale) + momentWidth + MENU_WIDTH) > (spreadDimensions.get('width') * scale);
    var leftAlignedMenu = design.get('x') >= spreadDimensions.get('width') / 2;

    var content = void 0;
    if (momentId === draggingPreview) {
      var t = { width: 1, x: 0, y: 0 };
      var limitedTransform = __WEBPACK_IMPORTED_MODULE_5_helpers_photo__["c" /* limitTransform */](draggingPhoto.get('exif'), t, scale, momentWidth, momentHeight);

      content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DraggablePhoto, {
        key: 'preview',
        imageClassName: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.photo,
        scale: scale,
        photo: draggingPhoto,
        transform: limitedTransform,
        style: style,
        orderId: orderId,
        momentId: momentId,
        momentWidth: momentWidth,
        momentHeight: momentHeight,
        updateTransform: updateTransform
      });
    } else if (photo) {
      content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DraggablePhoto, {
          key: 'draggable',
          imageClassName: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.photo,
          scale: scale,
          photo: photo,
          preview: preview,
          transform: transform,
          style: style,
          orderId: orderId,
          momentId: momentId,
          momentWidth: momentWidth,
          momentHeight: momentHeight,
          updateTransform: updateTransform
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["y" /* MomentEdit */], {
          key: 'edit',
          className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.editMenu,
          orderId: orderId,
          momentId: momentId
          //align={'left'}
          , align: leftAlignedMenu ? 'left' : 'right',
          photo: photo,
          transform: transform,
          updateTransform: updateTransform
        }),
        transform.lowDpi ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_components__["B" /* MomentWarning */],
          { rotate: rotate },
          kroostApp.strings.warningToAdjustPhotoPart1,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            {
              href: 'https://kroost.' + global.kroostApp.domainExtension + '/designer-low-dpi',
              target: '_blank' },
            kroostApp.strings.warningToAdjustPhotoPart2
          )
        ) : null
      );
    } else {
      content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
          { to: '/' + bookId + '/' + orderId + '/assignment' },
          placeholder
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: classes,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onMouseUp: this.onMouseUp },
      content
    );
  };

  return MomentPhoto;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent), _class2.contextTypes = {
  orderId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bookId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _temp2)) || _class);


var DraggablePhoto = function (_React$PureComponent2) {
  _inherits(DraggablePhoto, _React$PureComponent2);

  function DraggablePhoto(props, context) {
    _classCallCheck(this, DraggablePhoto);

    var _this2 = _possibleConstructorReturn(this, _React$PureComponent2.call(this, props, context));

    _this2.onWheel = function (e) {
      var normalized = __WEBPACK_IMPORTED_MODULE_4_normalize_wheel___default.a(e);
      var delta = normalized.pixelX || normalized.pixelY;

      var multiplier = delta > 0 ? -1 : 1;
      var deltaDiff = Math.min(Math.abs(delta), 400);
      var zoom = (0.1 + 0.3 * (deltaDiff / 400)) * multiplier;

      _this2.updateTransform(null, zoom);
    };

    _this2.onMouseDown = function (e) {
      e.preventDefault();

      _this2.setState({
        isDragging: true,
        dimensions: [e.target.clientWidth, e.target.clientHeight],
        draggedTransform: {},
        start: [e.clientX, e.clientY]
      });
    };

    _this2.onMouseMove = function (e) {
      e.preventDefault();
      var _this2$state$start = _this2.state.start,
          x = _this2$state$start[0],
          y = _this2$state$start[1];
      var _this2$props = _this2.props,
          photo = _this2$props.photo,
          transform = _this2$props.transform,
          preview = _this2$props.preview,
          scale = _this2$props.scale,
          momentWidth = _this2$props.momentWidth,
          momentHeight = _this2$props.momentHeight;

      var limitedTransform = __WEBPACK_IMPORTED_MODULE_5_helpers_photo__["c" /* limitTransform */](_extends({}, photo.get('exif'), preview && preview.toJS ? preview.toJS() : {}), transform, scale, momentWidth, momentHeight, [e.clientX - x, e.clientY - y]);

      _this2.setState({
        draggedTransform: limitedTransform
      });
    };

    _this2.onMouseUp = function (e) {
      e.preventDefault();

      var _this2$state$start2 = _this2.state.start,
          startX = _this2$state$start2[0],
          startY = _this2$state$start2[1];

      _this2.updateTransform([e.clientX - startX, e.clientY - startY]);

      _this2.setState({
        isDragging: false
      });
    };

    _this2.updateTransform = function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var _this2$props2 = _this2.props,
          orderId = _this2$props2.orderId,
          photo = _this2$props2.photo,
          preview = _this2$props2.preview,
          transform = _this2$props2.transform,
          momentId = _this2$props2.momentId,
          scale = _this2$props2.scale,
          momentWidth = _this2$props2.momentWidth,
          momentHeight = _this2$props2.momentHeight;


      var limitedTransform = __WEBPACK_IMPORTED_MODULE_5_helpers_photo__["c" /* limitTransform */].apply(undefined, [_extends({}, photo.get('exif'), preview ? preview.toJS() : {}), transform, scale, momentWidth, momentHeight].concat(args));

      _this2.props.updateTransform(orderId, momentId, limitedTransform);
    };

    _this2.state = {
      isDragging: false,
      dimensions: [0, 0],
      start: [0, 0],
      dragged: [0, 0]
    };
    return _this2;
  }

  DraggablePhoto.prototype.componentWillMount = function componentWillMount() {
    var preview = this.props.preview;

    if (preview && !preview.isEmpty()) {
      this.updateTransform();
    }
  };

  DraggablePhoto.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var preview = this.props.preview;
    var prevPreview = prevProps.preview;


    if (!(prevPreview && !prevPreview.isEmpty()) && preview && !preview.isEmpty()) {
      this.updateTransform();
    }
  };

  DraggablePhoto.prototype.render = function render() {
    var _state = this.state,
        isDragging = _state.isDragging,
        draggedTransform = _state.draggedTransform;

    var _props4 = this.props,
        transform = _props4.transform,
        _props4$style = _props4.style,
        style = _props4$style === undefined ? {} : _props4$style,
        preview = _props4.preview,
        scale = _props4.scale,
        momentWidth = _props4.momentWidth,
        momentHeight = _props4.momentHeight,
        props = _objectWithoutProperties(_props4, ['transform', 'style', 'preview', 'scale', 'momentWidth', 'momentHeight']);

    var offsetTransform = transform;
    if (isDragging) {
      offsetTransform = _extends({}, transform, draggedTransform);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: __WEBPACK_IMPORTED_MODULE_13__styles_scss___default.a.draggablePhoto,
        style: style,
        onWheel: this.onWheel,
        onMouseDown: !isDragging ? this.onMouseDown : null,
        onMouseMove: isDragging ? this.onMouseMove : null,
        onMouseUp: isDragging ? this.onMouseUp : null,
        onMouseOut: isDragging ? this.onMouseUp : null },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["J" /* Photo */], _extends({
        transform: offsetTransform,
        preview: preview ? preview.get('preview') : null,
        fullPhoto: true
      }, props))
    );
  };

  return DraggablePhoto;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27)))

/***/ }),
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"moment":"moment_2AVJG","editMenu":"editMenu_3eyoE","blackwhite":"blackwhite_2u_oP","draggablePhoto":"draggablePhoto_3SVGD","photo":"photo_2qPQm","placeholder":"placeholder_SpzDB"};

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MomentText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_reducers_orders__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_selectors_orders__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_string__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_icons_edit__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var PT_PX = 25.4 / 72;

var MomentText = (_dec = __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](function (state) {
  return {
    orderId: __WEBPACK_IMPORTED_MODULE_4_redux_selectors_app__["c" /* getActiveOrderId */](state),
    name: __WEBPACK_IMPORTED_MODULE_5_redux_selectors_orders__["g" /* getChildName */](state),
    birthday: __WEBPACK_IMPORTED_MODULE_5_redux_selectors_orders__["e" /* getChildBirthday */](state)
  };
}, {
  updateText: __WEBPACK_IMPORTED_MODULE_3_redux_reducers_orders__["C" /* updateText */]
}), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
  _inherits(MomentText, _React$PureComponent);

  function MomentText(props, context) {
    _classCallCheck(this, MomentText);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props, context));

    _this.onChange = function (e) {
      var _this$props = _this.props,
          orderId = _this$props.orderId,
          momentId = _this$props.momentId;

      _this.props.updateText(orderId, momentId, e.currentTarget.value);
    };

    _this.onFocus = function () {
      var _this$props2 = _this.props,
          design = _this$props2.design,
          text = _this$props2.text,
          orderId = _this$props2.orderId,
          momentId = _this$props2.momentId,
          scale = _this$props2.scale;

      var removeOnEdit = design.getIn(['options', 'placeholder_text_remove_on_edit']);

      var pointSize = PT_PX * scale;
      var options = design.getIn(['options', 'font_options']);
      var fontSize = options.get('size') * pointSize;
      var zoomScale = 14 / fontSize;

      _this.props.setFocus(true, zoomScale > 1);
      _this.setState({
        zoom: true
      });

      if (removeOnEdit && typeof text === 'undefined') {
        _this.props.updateText(orderId, momentId, '');
      }
    };

    _this.onBlur = function (e) {
      var _this$props3 = _this.props,
          orderId = _this$props3.orderId,
          momentId = _this$props3.momentId;


      var trimmed = e.currentTarget.value.trim();

      _this.props.setFocus(false);
      _this.setState({
        zoom: false
      });

      var updateText = void 0;
      if (trimmed !== e.currentTarget.value) {
        updateText = trimmed;
      }

      if (e.currentTarget.value === '') {
        _this.props.updateText(orderId, momentId, null);
      } else if (updateText) {
        _this.props.updateText(orderId, momentId, updateText);
      }
    };

    _this.state = {
      autoScaleFont: 0,
      zoom: false
    };
    return _this;
  }

  MomentText.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.wrapper.clientHeight < this.sizeCheck.clientHeight - 5) {
      var _props = this.props,
          orderId = _props.orderId,
          momentId = _props.momentId,
          _props$text = _props.text,
          text = _props$text === undefined ? '' : _props$text;
      var _prevProps$text = prevProps.text,
          prevText = _prevProps$text === undefined ? '' : _prevProps$text;


      if (text !== prevText) {
        this.props.updateText(orderId, momentId, text.substring(0, text.length - 1));
      }
    }

    this.autoScaleFont();
  };

  MomentText.prototype.autoScaleFont = function autoScaleFont() {
    if (this.sizeCheck && this.wordLengthCheck) {
      var sizeCheckWidth = this.sizeCheck.offsetWidth;
      var wordCheckWidth = this.wordLengthCheck.offsetWidth;

      this.setState({
        autoScaleFont: sizeCheckWidth / wordCheckWidth * 95
      });
    }
  };

  MomentText.prototype.componentDidMount = function componentDidMount() {
    this.autoScaleFont();
  };

  MomentText.prototype.render = function render() {
    var _cx,
        _cx2,
        _this2 = this;

    var _props2 = this.props,
        className = _props2.className,
        text = _props2.text,
        design = _props2.design,
        scale = _props2.scale,
        name = _props2.name,
        birthday = _props2.birthday,
        onLeftPage = _props2.onLeftPage,
        autoSize = _props2.autoSize,
        autoSizeProps = _props2.autoSizeProps,
        customStyle = _props2.style;
    var canEdit = this.context.canEdit;
    var _state = this.state,
        zoom = _state.zoom,
        autoScaleFont = _state.autoScaleFont;

    var verticalAlign = design.getIn(['options', 'font_options', 'vertical_align']);
    var isSpecialText = design.getIn(['options', 'special_text', 'special_text']);

    var wrapperClasses = __WEBPACK_IMPORTED_MODULE_8_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.wrapper, (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.autoSize] = autoSize, _cx));

    var classes = __WEBPACK_IMPORTED_MODULE_8_classnames___default.a(className, __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.text, (_cx2 = {}, _cx2[__WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.disableEditing] = !canEdit || isSpecialText, _cx2[__WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.verticalCenterAlign] = verticalAlign === 'center', _cx2[__WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.verticalBottomAlign] = verticalAlign === 'bottom', _cx2[__WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.allCaps] = design.getIn(['options', 'font_options', 'capitalize']) === 'upper', _cx2[__WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.empty] = !text, _cx2));
    var style = {};
    var wrapperStyle = {
      color: style.color
    };
    var options = design.getIn(['options', 'font_options']);
    var pointSize = PT_PX * scale;

    var _text = __WEBPACK_IMPORTED_MODULE_6_helpers_string__["b" /* specialText */](text, name, birthday, design.getIn(['options']));

    if (options) {
      if (options.get('autoscale') && autoScaleFont) {
        style.fontSize = Math.min(autoScaleFont, options.get('size')) + 'px';
      } else {
        style.fontSize = options.get('size') * pointSize + 'px';
      }

      style.textAlign = options.get('align');
      style.lineHeight = options.get('leading') * pointSize + 'px';
      style.letterSpacing = options.get('tracking') / 1000 + 'em';
      style.color = options.get('color');

      if (options.get('type')) {
        var _options$get$split = options.get('type', '').split(':'),
            family = _options$get$split[0],
            _options$get$split$ = _options$get$split[1],
            weight = _options$get$split$ === undefined ? 'normal' : _options$get$split$,
            _options$get$split$2 = _options$get$split[2],
            variant = _options$get$split$2 === undefined ? 'normal' : _options$get$split$2;

        style.fontFamily = family;
        style.fontWeight = weight;
        style.fontStyle = variant;
      }
    }

    var dummyText = _text.replace(/\n$/, '<br >&nbsp;').replace(/\n/g, '<br >');

    var textareaStyle = _extends({}, style, autoSize ? autoSizeProps : {});

    if (zoom && style.fontSize) {
      var fontSize = options.get('size') * pointSize;
      var lineHeight = options.get('leading') * pointSize;
      var zoomScale = 16 / fontSize;

      if (zoomScale > 1) {
        textareaStyle = _extends({}, style, {
          width: this.wrapper.offsetWidth * zoomScale,
          minHeight: 80,
          fontSize: 16,
          lineHeight: lineHeight / fontSize + 'em',
          overflow: 'auto',
          marginLeft: onLeftPage ? 0 : -(this.wrapper.offsetWidth * (zoomScale - 1)),
          backgroundColor: 'rgb(245,245,245)',
          color: '#000',
          borderColor: 'transparent',
          padding: '2px 4px'
        }, autoSize ? autoSizeProps : {});
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: wrapperClasses, style: _extends({}, customStyle, autoSize ? autoSizeProps : {}), ref: function ref(c) {
          return _this2.wrapper = c;
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: classes, style: wrapperStyle },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', {
          ref: function ref(c) {
            return _this2.textarea = c;
          },
          readOnly: !canEdit || isSpecialText,
          style: textareaStyle,
          value: _text,
          onChange: this.onChange,
          onFocus: this.onFocus,
          onBlur: this.onBlur
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          ref: function ref(c) {
            return _this2.sizeCheck = c;
          },
          className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.sizeCheck,
          style: _extends({}, style, autoSize ? autoSizeProps : {}, {
            maxHeight: 'none'
          }),
          dangerouslySetInnerHTML: { __html: dummyText }
        }),
        options && options.get('autoscale') ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
          ref: function ref(c) {
            return _this2.wordLengthCheck = c;
          },
          className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.wordLengthCheck,
          style: style,
          dangerouslySetInnerHTML: { __html: dummyText }
        }) : null,
        canEdit && !isSpecialText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_icons_edit__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_9__styles_scss___default.a.icon, width: 16, height: 16 }) : null
      )
    );
  };

  return MomentText;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent), _class2.contextTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, _temp)) || _class);


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Edit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Edit(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({
      preserveAspectRatio: "xMidYMid",
      viewBox: "0 0 48.281 47.969",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M47.045,8.627 C47.037,8.636 47.026,8.638 47.018,8.647 C47.010,8.656 47.007,8.668 46.998,8.677 L26.871,28.676 C26.864,28.684 26.853,28.686 26.845,28.693 C26.797,28.739 26.736,28.768 26.678,28.804 C26.620,28.839 26.567,28.880 26.506,28.902 C26.496,28.906 26.489,28.914 26.478,28.918 L17.421,31.917 C17.317,31.952 17.210,31.969 17.103,31.969 C16.841,31.969 16.583,31.867 16.392,31.676 C16.122,31.408 16.028,31.012 16.148,30.652 L19.167,21.653 C19.171,21.643 19.179,21.636 19.183,21.626 C19.205,21.566 19.245,21.515 19.279,21.459 C19.316,21.399 19.347,21.337 19.394,21.287 C19.401,21.279 19.403,21.270 19.411,21.262 L39.537,1.264 C39.540,1.261 39.544,1.260 39.548,1.257 C39.551,1.254 39.552,1.250 39.555,1.247 C40.433,0.415 41.691,-0.031 42.971,-0.002 C44.363,0.038 45.682,0.649 46.686,1.718 C48.983,4.153 48.522,6.943 47.045,8.627 ZM45.216,3.084 C44.402,2.217 43.513,2.014 42.912,1.997 C42.177,1.979 41.430,2.235 40.944,2.694 L21.002,22.509 L18.694,29.388 L25.617,27.095 L45.537,7.301 C46.347,6.366 46.748,4.707 45.216,3.084 ZM26.160,7.972 L2.008,7.972 L2.008,45.969 L40.000,45.969 L40.000,21.969 C40.000,21.417 40.444,20.969 41.000,20.969 C41.556,20.969 42.000,21.417 42.000,21.969 L42.000,46.969 C42.000,47.521 41.813,47.969 41.257,47.969 L1.002,47.969 C0.446,47.969 -0.004,47.521 -0.004,46.969 L-0.004,6.972 C-0.004,6.420 0.446,5.972 1.002,5.972 L26.160,5.972 C26.716,5.972 27.166,6.420 27.166,6.972 C27.166,7.524 26.716,7.972 26.160,7.972 Z" })
  );
}

/***/ }),
/* 473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper_1sawe","autoSize":"autoSize__sNdZ","verticalCenterAlign":"verticalCenterAlign_2QInS","text":"text_1OLkD","allCaps":"allCaps_1bt3x","verticalBottomAlign":"verticalBottomAlign_1jaQy","empty":"empty_125I7","icon":"icon_33hiZ","disableEditing":"disableEditing_1SmYj","sizeCheck":"sizeCheck_xCSQF","wordLengthCheck":"wordLengthCheck_3h8Ai","flash":"flash_1Xrm0"};

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MomentWarning; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers_string__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_scss__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var MomentWarning = function (_React$PureComponent) {
  _inherits(MomentWarning, _React$PureComponent);

  function MomentWarning() {
    _classCallCheck(this, MomentWarning);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  MomentWarning.prototype.render = function render() {
    var _style;

    var _props = this.props,
        className = _props.className,
        rotate = _props.rotate;

    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.warning, className);

    var style = (_style = {}, _style[__WEBPACK_IMPORTED_MODULE_1_helpers_string__["d" /* transformWithPrefix */]] = rotate ? 'translateX(-50%) rotate(' + (360 - rotate) + 'deg)' : null, _style);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes, style: style },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.marker },
        '!'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.messageWrapper },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.message },
          this.props.children
        )
      )
    );
  };

  return MomentWarning;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"warning":"warning_2ZUwX","messageWrapper":"messageWrapper_3y3pK","marker":"marker_194fY","message":"message_10Ar-"};

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Moment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_string__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_photo__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var DEFAULT_TRANSFORM = { width: 1, x: 0, y: 0 };

var Moment = function (_React$PureComponent) {
  _inherits(Moment, _React$PureComponent);

  function Moment(props, context) {
    _classCallCheck(this, Moment);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props, context));

    _this.setFocus = function (focused) {
      var zoomed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      _this.setState({
        focused: focused,
        zoomed: zoomed
      });
    };

    _this.state = {
      focused: false,
      zoomed: false
    };
    return _this;
  }

  Moment.prototype.render = function render() {
    var _cx, _extends2, _ref;

    var focused = this.state.focused;
    var _props = this.props,
        index = _props.index,
        scale = _props.scale,
        info = _props.info,
        design = _props.design,
        picked = _props.picked,
        preview = _props.preview,
        pageWidth = _props.pageWidth;

    var momentId = info.get('id');
    var transform = picked.get('transform', null);
    var autoSize = design.getIn(['options', 'size_to_content'], false);
    var border = design.getIn(['options', 'border'], false);

    var classes = __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.moment, (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.picked] = picked.get('photo'), _cx[__WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.focused] = focused, _cx[__WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.autoSize] = autoSize, _cx));

    var photo = picked.get('photo', null);
    var momentWidth = Math.round(design.get('width') * scale);
    var momentHeight = Math.round(design.get('height') * scale);
    var momentMaxWidth = design.get('max-width') ? Math.round(design.get('max-width') * scale) : 100000;
    var momentMaxHeight = design.get('max-height') ? Math.round(design.get('max-height', 0) * scale) : 100000;
    var rotate = parseInt(design.getIn(['options', 'rotate'], 0));

    var leftPage = design.get('x') < pageWidth;

    var style = _extends((_extends2 = {
      zIndex: (index + 1) * 1000,
      left: Math.round(design.get('x') * scale) + 'px',
      top: Math.round(design.get('y') * scale) + 'px'
    }, _extends2[__WEBPACK_IMPORTED_MODULE_2_helpers_string__["d" /* transformWithPrefix */]] = rotate ? 'rotate(' + rotate + 'deg)' : null, _extends2), !autoSize ? {
      width: momentWidth + 'px',
      height: momentHeight + 'px'
    } : (_ref = {
      minWidth: momentWidth + 'px',
      minHeight: momentHeight + 'px',
      left: Math.round(design.get('x') * scale * 1.5) + 'px',
      top: Math.round(design.get('y') * scale * 1.5) + 'px'
    }, _ref[__WEBPACK_IMPORTED_MODULE_2_helpers_string__["d" /* transformWithPrefix */]] = 'translate(-50%, -50%)', _ref), momentMaxWidth ? {
      maxWidth: momentMaxWidth + 'px'
    } : {}, momentMaxHeight ? {
      maxHeight: momentMaxHeight + 'px'
    } : {});

    var content = null;
    var customStyle = __WEBPACK_IMPORTED_MODULE_2_helpers_string__["c" /* stringToCSSObject */](design.getIn(['options', 'css'], ''));

    // Photo
    if (info.get('type') === 'photo') {
      var t = transform ? transform.toJS() : DEFAULT_TRANSFORM;
      var limitedTransform = photo ? __WEBPACK_IMPORTED_MODULE_3_helpers_photo__["c" /* limitTransform */](_extends({}, photo.get('exif'), preview.toJS()), t, scale, momentWidth, momentHeight) : t;

      content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["z" /* MomentPhoto */], {
        momentId: momentId,
        scale: scale,
        photo: photo,
        design: design,
        blackAndWhite: design.getIn(['options', 'black_white'], false),
        transform: limitedTransform,
        preview: preview,
        style: customStyle,
        momentWidth: momentWidth,
        momentHeight: momentHeight,
        rotate: rotate
      });

      customStyle = null;
    }
    // Text
    else if (info.get('type') === 'text') {

        content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["A" /* MomentText */], {
          momentId: momentId,
          scale: scale,
          design: design,
          setFocus: this.setFocus,
          text: picked.get('text'),
          autoSize: autoSize,
          onLeftPage: leftPage,
          style: customStyle,
          autoSizeProps: {
            minWidth: momentWidth,
            maxWidth: momentMaxWidth,
            minHeight: momentHeight,
            maxHeight: momentMaxHeight
          }
        });
      }

    var labelStyle = {
      fontSize: Math.round(5 * scale) + 'px'
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes, style: style },
      !!border && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.border,
        style: {
          border: border.get('thickness') * scale + 'px solid ' + border.get('color'),
          width: 'calc(100% + ' + border.get('spacing') * scale * 2 + 'px)',
          height: 'calc(100% + ' + border.get('spacing') * scale * 2 + 'px)',
          top: '-' + border.get('spacing') * scale + 'px',
          left: '-' + border.get('spacing') * scale + 'px'
        }
      }),
      content || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.label, style: labelStyle },
        info.get('label')
      )
    );
  };

  return Moment;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"moment":"moment_1oLia","picked":"picked_2oy1l","focused":"focused_buBof","hover":"hover_2TkD7","autoSize":"autoSize_Z0lz4","label":"label_GoTVT","border":"border_38ms8"};

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MyOrders; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_history__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_reducers_orders__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_reducers_user__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_selectors_user__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_scss__);
var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var MyOrders = (_dec = __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](function (state) {
  return {
    authenticated: __WEBPACK_IMPORTED_MODULE_10_redux_selectors_user__["c" /* isAuthenticated */](state),
    books: state.get('books', __WEBPACK_IMPORTED_MODULE_3_immutable__["List"]()),
    orders: state.get('orders'),
    activeOrderId: __WEBPACK_IMPORTED_MODULE_9_redux_selectors_app__["c" /* getActiveOrderId */](state),
    loading: state.getIn(['app', 'ui', 'loading_orders']) || state.get('books', __WEBPACK_IMPORTED_MODULE_3_immutable__["List"]()).count() === 0
  };
}, {
  getOrders: __WEBPACK_IMPORTED_MODULE_7_redux_reducers_orders__["u" /* getOrders */],
  createOrder: __WEBPACK_IMPORTED_MODULE_7_redux_reducers_orders__["p" /* createOrder */],
  setSidebar: __WEBPACK_IMPORTED_MODULE_6_redux_reducers_app__["t" /* setSidebar */],
  logout: __WEBPACK_IMPORTED_MODULE_8_redux_reducers_user__["q" /* logout */]
}), _dec(_class = function (_React$PureComponent) {
  _inherits(MyOrders, _React$PureComponent);

  function MyOrders(props, context) {
    _classCallCheck(this, MyOrders);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props, context));

    _this.creatingNewOrder = function () {
      _this.setState({
        creatingOrder: true
      });
    };

    _this.cancelCreatingNewOrder = function () {
      _this.setState({
        creatingOrder: false,
        book: '',
        name: '',
        birthday: ''
      });
    };

    _this.newOrder = function () {
      var _this$state = _this.state,
          book = _this$state.book,
          name = _this$state.name,
          birthday = _this$state.birthday;


      _this.props.createOrder({
        book: book,
        name: name,
        birthday: birthday,
        redirect: true
      });

      _this.toPhotos();

      _this.cancelCreatingNewOrder();
    };

    _this.toLogin = function (e) {
      _this.props.setSidebar('login');
    };

    _this.toPhotos = function (e) {
      _this.props.setSidebar('photos');
    };

    _this.toChild = function (e) {
      _this.props.setSidebar('child');
    };

    _this.state = {
      creatingOrder: false,
      book: '',
      name: '',
      birthday: ''
    };
    return _this;
  }

  MyOrders.prototype.componentWillMount = function componentWillMount() {
    if (!this.state.creatingOrder && !this.props.authenticated) {
      this.props.setSidebar('login');
    } else {
      this.props.getOrders();
    }
  };

  MyOrders.prototype.componentDidUpdate = function componentDidUpdate() {
    var _props = this.props,
        activeOrderId = _props.activeOrderId,
        orders = _props.orders;

    // Set latest book when not set yet

    if (!activeOrderId && orders && orders.count() > 0) {
      var orderId = orders.keySeq().first();
      __WEBPACK_IMPORTED_MODULE_4_helpers_history__["a" /* default */].replace('/' + orders.getIn([orderId, 'book']) + '/' + orderId);
      this.props.setSidebar('photos');
    }
  };

  MyOrders.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        books = _props2.books,
        orders = _props2.orders,
        loading = _props2.loading,
        authenticated = _props2.authenticated;
    var _state = this.state,
        book = _state.book,
        name = _state.name,
        birthday = _state.birthday,
        creatingOrder = _state.creatingOrder;

    var actions = [];

    var list = null;
    var content = null;
    var title = null;
    var anchorBottom = true;

    if (creatingOrder) {
      title = kroostApp.strings.openNewBook;

      actions.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_components__["g" /* Button */],
        { key: 'cancel', secondary: true, onClick: this.cancelCreatingNewOrder },
        kroostApp.strings.backButton
      ));
      anchorBottom = false;

      content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["h" /* Child */], {
          book: book,
          name: name,
          birthday: birthday,
          asSidebar: false,
          onChange: function onChange(key, value) {
            var _this2$setState;

            _this2.setState((_this2$setState = {}, _this2$setState[key] = value, _this2$setState));
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_components__["g" /* Button */],
          {
            cta: true,
            type: 'submit',
            className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.submit,
            disabled: books.count() > 1 && !book || !name || !birthday,
            onClick: this.newOrder },
          'Aan de slag'
        )
      );
    }

    // Birthday: ({o.getIn(['child', 'birthday'])})
    if (!loading) {
      list = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.books },
        orders ? orders.map(function (o, id) {
          var onClick = o.getIn(['child', 'name']) ? _this2.toPhotos : _this2.toChild;
          var book = books.find(function (b) {
            return b.get('id') === o.get('book');
          });
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_components__["g" /* Button */],
            { className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.book, to: '/' + o.get('book') + '/' + id, onClick: onClick, key: id },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.inner, __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.existing) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.name },
                book ? book.get('name') : ''
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                o.getIn(['child', 'name']) || '(Nieuw boek)'
              )
            )
          );
        }).toArray() : null
      );
    } else {
      list = kroostApp.strings.loading;
    }

    if (!creatingOrder) {
      if (authenticated) {
        title = kroostApp.strings.account;
        actions.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_components__["g" /* Button */],
          { key: 'logout', secondary: true, onClick: this.props.logout },
          kroostApp.strings.logout
        ));
        content = list;
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_components__["O" /* SidebarContent */],
      {
        anchorActionsBottom: anchorBottom,
        title: title,
        actions: actions,
        className: !authenticated ? __WEBPACK_IMPORTED_MODULE_11__styles_scss___default.a.notLoggedIn : null },
      content
    );
  };

  return MyOrders;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class);


/***/ }),
/* 479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"book":"book_2pQad","inner":"inner_245AP","new":"new_PsSsO","existing":"existing_1mIt_","name":"name_2TJcy","books":"books_18gFX","action":"action_2JxEu","submit":"submit_1S3um","tryOut":"tryOut_3Xts6","notLoggedIn":"notLoggedIn_aFUMl"};

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notifications; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_selectors_design__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_reducers_user__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_scss__);
var _dec, _class, _class2, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Notifications = (_dec = __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](function (state) {
  return {
    notifications: state.getIn(['app', 'notifications'], null),
    designId: __WEBPACK_IMPORTED_MODULE_4_redux_selectors_design__["a" /* getCurrentDesign */](state),
    designs: __WEBPACK_IMPORTED_MODULE_4_redux_selectors_design__["c" /* getDesigns */](state)
  };
}, {
  setSidebar: __WEBPACK_IMPORTED_MODULE_3_redux_reducers_app__["t" /* setSidebar */],
  trackEvent: __WEBPACK_IMPORTED_MODULE_5_redux_reducers_user__["v" /* trackEvent */]
}), _dec(_class = (_temp2 = _class2 = function (_React$PureComponent) {
  _inherits(Notifications, _React$PureComponent);

  function Notifications() {
    var _temp, _this, _ret;

    _classCallCheck(this, Notifications);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.toOrder = function (e) {
      _this.props.setSidebar('order');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Notifications.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _props = this.props,
        showReadyToOrder = _props.showReadyToOrder,
        trackEvent = _props.trackEvent;


    if (showReadyToOrder && prevProps.showReadyToOrder !== showReadyToOrder) {
      trackEvent('product_ready', {});
    }
  };

  Notifications.prototype.render = function render() {
    var _props2 = this.props,
        notifications = _props2.notifications,
        _props2$showReadyToOr = _props2.showReadyToOrder,
        showReadyToOrder = _props2$showReadyToOr === undefined ? false : _props2$showReadyToOr;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.notifications },
      notifications ? notifications.map(function (message, key) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components__["D" /* Notification */], { key: key, message: message });
      }).toArray() : null,
      showReadyToOrder ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components__["D" /* Notification */], {
        message: kroostApp.strings.notificationReady,
        cta: {
          children: kroostApp.strings.notificationGoToOrder,
          onClick: this.toOrder
        }
      }) : null
    );
  };

  return Notifications;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent), _class2.contextTypes = {
  orderId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _temp2)) || _class);


/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Notification = function (_React$PureComponent) {
  _inherits(Notification, _React$PureComponent);

  function Notification() {
    _classCallCheck(this, Notification);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Notification.prototype.render = function render() {
    var _cx;

    var _props = this.props,
        message = _props.message,
        _props$cta = _props.cta,
        cta = _props$cta === undefined ? false : _props$cta;


    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.notification, (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.cta] = cta, _cx));

    var msg = message.split(' --- ').map(function (m, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: 'notificationline' + i },
        m
      );
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.message },
        msg
      ),
      cta ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["g" /* Button */], _extends({ className: __WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.button }, cta)) : null
    );
  };

  return Notification;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"notification":"notification_1mJMo","message":"message_j9Vd2","cta":"cta_ds-sV","button":"button_jYLjx"};

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Order; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_reducers_orders__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_selectors_orders__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_selectors_stats__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_selectors_user__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__global__ = __webpack_require__(136);
var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var BOOK_PRICE = 69.95;
var COUNTRIES = __WEBPACK_IMPORTED_MODULE_11__global__["a" /* LANGUAGE_MAP */].filter(function (country) {
  return country.showSelectOption;
}).map(function (country) {
  return {
    label: global.kroostApp.strings[country.countryCode],
    value: country.selectOption,
    language: country.language
  };
});

var Order = (_dec = __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](function (state) {
  return {
    address: __WEBPACK_IMPORTED_MODULE_6_redux_selectors_orders__["c" /* getAddress */](state),
    amount: __WEBPACK_IMPORTED_MODULE_6_redux_selectors_orders__["d" /* getAmount */](state),
    canEdit: __WEBPACK_IMPORTED_MODULE_6_redux_selectors_orders__["a" /* canEdit */](state),
    canRenewPayment: __WEBPACK_IMPORTED_MODULE_6_redux_selectors_orders__["b" /* canRenewPayment */](state),
    failedValidating: state.getIn(['app', 'ui', 'failed_validating'], false),
    childName: __WEBPACK_IMPORTED_MODULE_6_redux_selectors_orders__["g" /* getChildName */](state),
    isWaiting: __WEBPACK_IMPORTED_MODULE_6_redux_selectors_orders__["m" /* isWaitingForOrder */](state),
    isWaitingForPayment: __WEBPACK_IMPORTED_MODULE_6_redux_selectors_orders__["n" /* isWaitingForPayment */](state),
    orderId: __WEBPACK_IMPORTED_MODULE_7_redux_selectors_app__["c" /* getActiveOrderId */](state),
    paymentForwarding: state.getIn(['app', 'ui', 'payment_forwarding'], false),
    profile: __WEBPACK_IMPORTED_MODULE_9_redux_selectors_user__["b" /* getProfile */](state),
    readyCheck: __WEBPACK_IMPORTED_MODULE_8_redux_selectors_stats__["c" /* readyCheck */](state),
    resettingState: state.getIn(['app', 'ui', 'resetting_state'], false),
    stateMessage: __WEBPACK_IMPORTED_MODULE_6_redux_selectors_orders__["j" /* getOrderStateMessage */](state),
    validating: state.getIn(['app', 'ui', 'validating'], false),
    validation: __WEBPACK_IMPORTED_MODULE_7_redux_selectors_app__["f" /* getOrderValidation */](state),
    withGiftcard: __WEBPACK_IMPORTED_MODULE_6_redux_selectors_orders__["o" /* isWithGiftcard */](state)
  };
}, {
  setOption: __WEBPACK_IMPORTED_MODULE_5_redux_reducers_orders__["z" /* setOption */],
  startPayment: __WEBPACK_IMPORTED_MODULE_5_redux_reducers_orders__["A" /* startPayment */],
  startPaymentRenew: __WEBPACK_IMPORTED_MODULE_5_redux_reducers_orders__["B" /* startPaymentRenew */],
  finish: __WEBPACK_IMPORTED_MODULE_5_redux_reducers_orders__["t" /* finish */],
  setSidebar: __WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["t" /* setSidebar */]
}), _dec(_class = function (_React$PureComponent) {
  _inherits(Order, _React$PureComponent);

  function Order(p) {
    _classCallCheck(this, Order);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, p));

    _this.onChange = function (e) {
      var input = e.currentTarget;
      var _this$props = _this.props,
          orderId = _this$props.orderId,
          setOption = _this$props.setOption;


      var name = input.name;
      var value = input.value;

      setOption(orderId, ['address', name], value);
    };

    _this.preventLetters = function (e) {
      var code = e.keyCode || e.which;
      var TAB = 9;
      var SHIFT = 16;
      var BACKSPACE = 8;

      if (code >= 48 && code <= 57 || code === BACKSPACE || code === SHIFT || code === TAB) {
        // Accepted.
      } else {
        e.preventDefault();
      }
    };

    _this.onAmountChange = function (e) {
      _this.setState({ amount: e.currentTarget.value });
    };

    _this.pay = function (e) {
      var _this$props2 = _this.props,
          orderId = _this$props2.orderId,
          validating = _this$props2.validating;


      if (!validating) {
        _this.props.startPayment(orderId);
      }
    };

    _this.finish = function () {
      var _this$props3 = _this.props,
          orderId = _this$props3.orderId,
          validating = _this$props3.validating;


      if (!validating) {
        _this.props.finish(orderId);
      }
    };

    _this.validateAmount = function (e) {
      var amount = e.currentTarget.value;
      var _this$props4 = _this.props,
          orderId = _this$props4.orderId,
          setOption = _this$props4.setOption;

      if (/^[0-9\b]+$/.test(amount) && amount >= 1 && amount <= 10) {
        setOption(orderId, ['amount'], amount);
      } else {
        setOption(orderId, ['amount'], 1);
        _this.setState({ amount: 1 });
      }
    };

    _this.renewPayment = function (e) {
      var _this$props5 = _this.props,
          orderId = _this$props5.orderId,
          resettingState = _this$props5.resettingState;


      if (!resettingState) {
        _this.props.startPaymentRenew(orderId);
      }
    };

    _this.toLogin = function (e) {
      e.preventDefault();

      _this.props.setSidebar('login');
    };

    _this.state = {
      amount: p.amount || 1
    };
    return _this;
  }

  Order.prototype.render = function render() {
    var _props = this.props,
        address = _props.address,
        profile = _props.profile,
        validation = _props.validation,
        withGiftcard = _props.withGiftcard,
        amount = _props.amount,
        validating = _props.validating,
        failedValidating = _props.failedValidating,
        paymentForwarding = _props.paymentForwarding,
        resettingState = _props.resettingState,
        isWaitingForPayment = _props.isWaitingForPayment,
        readyCheck = _props.readyCheck,
        canEdit = _props.canEdit,
        canRenewPayment = _props.canRenewPayment,
        isWaiting = _props.isWaiting,
        stateMessage = _props.stateMessage;


    var addressValidation = __WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]();
    if (validation.get('address') !== true) {
      addressValidation = validation.get('address') || addressValidation;
    }

    var showWarning = validation.get('address') !== true && addressValidation.count() > 0;
    var canPay = !paymentForwarding && !validating && !showWarning && readyCheck.all;
    var disableForm = !canEdit || paymentForwarding || resettingState;

    var notReadyMessages = [];
    if (!readyCheck.all) {
      if (!readyCheck.authenticated) {
        notReadyMessages.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { key: 'auth' },
          kroostApp.strings.notReadyMessagePart1,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: '#', onClick: this.toLogin },
            kroostApp.strings.notReadyMessagePart2
          ),
          kroostApp.strings.notReadyMessagePart3
        ));
      } else if (readyCheck.uploading || readyCheck.noPhotos) {
        notReadyMessages.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { key: 'uploading' },
          kroostApp.strings.uploadingPhotosMessage
        ));
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_components__["O" /* SidebarContent */],
      { title: kroostApp.strings.orderTitle },
      readyCheck.done ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        { method: 'POST', onSubmit: this.pay },
        stateMessage,
        isWaitingForPayment || canRenewPayment ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components__["g" /* Button */],
            { cta: true, fullWidth: true, onClick: this.renewPayment, disabled: resettingState },
            resettingState ? kroostApp.strings.loading2 : kroostApp.strings.backToPay
          )
        ) : null,
        !isWaitingForPayment && !canRenewPayment && !disableForm ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'hidden', name: 'gender', value: 'Mvr' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              kroostApp.strings.orderIntro
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Input, {
              name: 'first_name',
              className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.hideRequirementMarker,
              type: 'text',
              label: kroostApp.strings.signupFirstNamePlaceholder,
              value: address.get('first_name'),
              invalid: addressValidation.get('first_name', '') !== '',
              onChange: this.onChange
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'hidden', name: 'middle_name', value: '' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Input, {
              name: 'last_name',
              type: 'text',
              className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.hideRequirementMarker,
              label: kroostApp.strings.surname,
              required: true,
              value: address.get('last_name'),
              invalid: addressValidation.get('last_name', '') !== '',
              onChange: this.onChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Input, {
              name: 'street_name',
              type: 'text',
              label: kroostApp.strings.street,
              required: true,
              className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.hideRequirementMarker,
              value: address.get('street_name'),
              invalid: addressValidation.get('street_name', '') !== '',
              onChange: this.onChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Input, {
              name: 'street_nr',
              type: 'text',
              className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.hideRequirementMarker,
              label: kroostApp.strings.houseNumber,
              required: true,
              title: kroostApp.strings.houseNumber,
              value: address.get('street_nr'),
              invalid: addressValidation.get('street_nr', '') !== '',
              onChange: this.onChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Input, {
              name: 'zipcode',
              type: 'text',
              label: kroostApp.strings.postCode,
              className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.hideRequirementMarker,
              required: true,
              value: address.get('zipcode'),
              invalid: addressValidation.get('zipcode', '') !== '',
              onChange: this.onChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Input, {
              name: 'city',
              type: 'text',
              label: kroostApp.strings.city,
              required: true,
              className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.hideRequirementMarker,
              value: address.get('city'),
              invalid: addressValidation.get('city', '') !== '',
              onChange: this.onChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Select, {
              name: 'country',
              type: 'text',
              label: kroostApp.strings.country,
              className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.hideRequirementMarker,
              required: true,
              value: address.get('country'),
              options: COUNTRIES,
              invalid: addressValidation.get('country', '') !== '',
              onChange: this.onChange
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Input, {
              name: 'phone',
              hide: true,
              type: 'phone',
              className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.hideRequirementMarker,
              label: kroostApp.strings.phone,
              value: address.get('phone'),
              invalid: addressValidation.get('phone', '') !== '',
              onChange: this.onChange
            })
          ),
          profile && profile.get('email') ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'hidden', name: 'email', value: profile.get('email') }) : null,
          !withGiftcard ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Row,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Input, {
              name: 'amount',
              type: 'number',
              label: kroostApp.strings.amount,
              value: amount,
              className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.hideRequirementMarker,
              onBlur: this.validateAmount,
              onChange: this.onAmountChange,
              onKeyDown: this.preventLetters
            })
          ) : null,
          !notReadyMessages.all && !isWaiting && notReadyMessages.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Error,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              null,
              notReadyMessages
            )
          ) : null,
          !canEdit && !canRenewPayment && !isWaiting && !isWaitingForPayment ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Error,
            null,
            kroostApp.strings.warningMessageBeforeForNoChanges
          ) : null,
          showWarning || failedValidating ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Error,
            null,
            kroostApp.strings.fillTheFieldsMessage
          ) : null,
          withGiftcard ? canEdit ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Row,
            { className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.actions },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_components__["g" /* Button */],
              { cta: true, className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.submit, onClick: this.finish, disabled: validating || !canPay },
              validating ? kroostApp.strings.checking2 : kroostApp.strings.orderComplete
            )
          ) : null : canRenewPayment || isWaitingForPayment || canEdit ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components__["n" /* Form */].Row,
            { className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.actions },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_components__["g" /* Button */],
              { cta: true, className: __WEBPACK_IMPORTED_MODULE_10__styles_scss___default.a.submit, onClick: this.pay, disabled: validating || !canPay },
              validating ? kroostApp.strings.checking2 : kroostApp.strings.orderComplete
            )
          ) : null
        ) : null
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["G" /* OrderUnfinished */], null)
    );
  };

  return Order;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27)))

/***/ }),
/* 485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"actions":"actions_dYKJK","divider":"divider_2kOzN","submit":"submit_1gp_f","hideRequirementMarker":"hideRequirementMarker_3MZl5","terms":"terms_2Dbd9"};

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrderUnfinished; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var OrderUnfinished = function (_React$PureComponent) {
  _inherits(OrderUnfinished, _React$PureComponent);

  function OrderUnfinished() {
    _classCallCheck(this, OrderUnfinished);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  OrderUnfinished.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        kroostApp.strings.orderUnfinishedFirstPart
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        kroostApp.strings.orderUnfinishedSecondPart
      )
    );
  };

  return OrderUnfinished;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaginationPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_scss__);
var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var PaginationPage = (_temp = _class = function (_React$PureComponent) {
  _inherits(PaginationPage, _React$PureComponent);

  function PaginationPage() {
    _classCallCheck(this, PaginationPage);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  PaginationPage.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var done = nextProps.done,
        spread = nextProps.spread,
        track = nextProps.track;

    var currentDone = this.props.done;

    // Rather have this in a saga
    if (!currentDone && done && spread) {
      track('spread_ready', {
        spread_id: spread.get('id')
      });
    } else if (currentDone && !done) {
      track('spread_unready', {
        spread_id: spread.get('id')
      });
    }
  };

  PaginationPage.prototype.render = function render() {
    var _cx;

    var _props = this.props,
        _props$className = _props.className,
        className = _props$className === undefined ? '' : _props$className,
        spread = _props.spread,
        active = _props.active,
        hideLabel = _props.hideLabel,
        partial = _props.partial,
        seen = _props.seen,
        done = _props.done,
        setActiveSpread = _props.setActiveSpread,
        children = _props.children;

    var id = spread ? '' + spread.get('id') : null;

    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(className, __WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.spread, (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.partial] = partial, _cx[__WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.seen] = seen, _cx[__WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.done] = done, _cx[__WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.active] = active, _cx));

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { onClick: setActiveSpread, 'data-id': id, className: classes },
      children ? children : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null),
      spread && !hideLabel ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.label },
        spread.get('label')
      ) : null
    );
  };

  return PaginationPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent), _class.contextTypes = {
  orderId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _temp);


/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"spread":"spread_3T-Pi","seen":"seen_25L11","partial":"partial_1c0mC","done":"done_2DDPe","active":"active_aQk0E","label":"label_OTIBO"};

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Pagination; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_icons_left__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_icons_right__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_reducers_user__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_selectors_books__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_selectors_stats__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_scss__);
var _dec, _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var iconLeft = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.navIcon },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_icons_left__["a" /* default */], null)
);
var iconRight = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.navIcon },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_icons_right__["a" /* default */], null)
);
var KEY_RIGHT = 39;
var KEY_LEFT = 37;

var Pagination = (_dec = __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](function (state) {
  return {
    spreads: __WEBPACK_IMPORTED_MODULE_7_redux_selectors_books__["d" /* getCurrentBookSpreads */](state),
    currentSpread: __WEBPACK_IMPORTED_MODULE_8_redux_selectors_app__["d" /* getActiveSpreadId */](state),
    progress: __WEBPACK_IMPORTED_MODULE_9_redux_selectors_stats__["a" /* calculateProgress */](state)
  };
}, {
  setActiveSpread: __WEBPACK_IMPORTED_MODULE_5_redux_reducers_app__["m" /* setActiveSpread */],
  track: __WEBPACK_IMPORTED_MODULE_6_redux_reducers_user__["v" /* trackEvent */]
}), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
  _inherits(Pagination, _React$PureComponent);

  function Pagination(p) {
    _classCallCheck(this, Pagination);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, p));

    _this.setActiveSpread = function (e) {
      e.preventDefault();
      var id = e.currentTarget.dataset.id;

      if (id) {
        _this.props.setActiveSpread(id);
      }
    };

    _this._keyBindings = _this._keyBindings.bind(_this);
    return _this;
  }

  Pagination.prototype.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('keydown', this._keyBindings);
  };

  Pagination.prototype.componentDidMount = function componentDidMount() {
    document.addEventListener('keydown', this._keyBindings);
  };

  Pagination.prototype._keyBindings = function _keyBindings(e) {
    // TODO: #185
    switch (e.keyCode) {
      case KEY_RIGHT:
        {
          break;
        }
      case KEY_LEFT:
        {
          break;
        }
      default:
        break;
    }
  };

  Pagination.prototype.render = function render() {
    var _cx,
        _cx2,
        _this2 = this;

    var _props = this.props,
        currentSpread = _props.currentSpread,
        spreads = _props.spreads,
        progress = _props.progress,
        arrowsOnly = _props.arrowsOnly,
        track = _props.track;
    var orderId = this.context.orderId;


    if (!spreads || spreads.count() === 1) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
    }

    var currentSpreadIndex = spreads.findIndex(function (spread) {
      return spread.get('id') === currentSpread;
    });
    var previousSpread = currentSpreadIndex > 0 ? spreads.get(currentSpreadIndex - 1, null) : null;
    var nextSpread = currentSpreadIndex + 1 < spreads.count() ? spreads.get(currentSpreadIndex + 1, null) : null;

    var previousClasses = __WEBPACK_IMPORTED_MODULE_11_classnames___default.a(__WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.nav, __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.left, (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.disabled] = !previousSpread, _cx));
    var nextClasses = __WEBPACK_IMPORTED_MODULE_11_classnames___default.a(__WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.nav, __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.right, (_cx2 = {}, _cx2[__WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.disabled] = !nextSpread, _cx2));

    return arrowsOnly ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_components__["I" /* PaginationPage */],
        {
          className: previousClasses + ' ' + __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.pageMargin,
          spread: previousSpread,
          hideLabel: true,
          track: track,
          setActiveSpread: this.setActiveSpread },
        iconLeft
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_components__["I" /* PaginationPage */],
        {
          className: nextClasses + ' ' + __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.pageMargin,
          spread: nextSpread,
          hideLabel: true,
          track: track,
          setActiveSpread: this.setActiveSpread },
        iconRight
      )
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.pagination },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_components__["I" /* PaginationPage */],
        {
          className: previousClasses,
          spread: previousSpread,
          track: track,
          setActiveSpread: this.setActiveSpread },
        iconLeft
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.spreads },
        spreads.map(function (spread) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["I" /* PaginationPage */], {
            key: orderId + '-' + spread.get('id') + '-' + spread.get('monthIndex', '') + '-' + spread.get('monthSpreadIndex', ''),
            track: track,
            spread: spread,
            partial: progress.getIn([spread.get('id'), 'partial']),
            seen: progress.getIn([spread.get('id'), 'seen']),
            done: progress.getIn([spread.get('id'), 'done']),
            active: spread.get('id') === currentSpread,
            setActiveSpread: _this2.setActiveSpread
          });
        }).toArray()
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_components__["I" /* PaginationPage */],
        {
          className: nextClasses,
          spread: nextSpread,
          track: track,
          setActiveSpread: this.setActiveSpread },
        iconRight
      )
    );
  };

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent), _class2.contextTypes = {
  orderId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _temp)) || _class);


/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Left;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Left(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ viewBox: "0 0 40 40" }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M25.7 12.34L18.05 20l7.65 7.66L23.36 30l-10-10 10-10z" })
  );
}

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Right;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Right(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ viewBox: "0 0 40 40" }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M16.64 10l10 10-10 10-2.34-2.34L21.95 20l-7.65-7.66z" })
  );
}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"pagination":"pagination_30K3g","spreads":"spreads_3oxR0","nav":"nav_32xwX","navIcon":"navIcon_7eeS1","disabled":"disabled_1CV-L","pageMargin":"pageMargin_26liD","left":"left_24Ktt","right":"right_Laeuo"};

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Photo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_string__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_time__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_api__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var Photo = function (_React$PureComponent) {
  _inherits(Photo, _React$PureComponent);

  function Photo(props, context) {
    _classCallCheck(this, Photo);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props, context));

    _this.toggleDate = function () {
      _this.setState({
        showFullDate: !_this.state.showFullDate
      });
    };

    _this.state = {
      showFullDate: false
    };
    return _this;
  }

  Photo.prototype.render = function render() {
    var _cx;

    var _props = this.props,
        photo = _props.photo,
        backgroundImage = _props.backgroundImage,
        preview = _props.preview,
        _props$className = _props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$imageClassName = _props.imageClassName,
        imageClassName = _props$imageClassName === undefined ? '' : _props$imageClassName,
        childBirthday = _props.childBirthday,
        transform = _props.transform,
        dateFormat = _props.dateFormat,
        _props$showUseCount = _props.showUseCount,
        showUseCount = _props$showUseCount === undefined ? false : _props$showUseCount;
    var showFullDate = this.state.showFullDate;

    var _photo$get = photo.get('exif', {}),
        DateTime = _photo$get.DateTime;

    var uploadUrl = photo.get('uploadUrl', null);
    var previewUrl = preview ? preview : photo.get('preview', null);

    var classes = __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.photo, className, (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.backgroundImage] = backgroundImage, _cx));

    // Use preview blob if available
    var src = void 0;
    if (previewUrl) {
      src = previewUrl;
    } else {
      src = uploadUrl;
    }

    var style = {};
    if (transform) {
      var _style;

      var width = transform.width,
          x = transform.x,
          y = transform.y;


      style = (_style = {
        width: width * 100 + '%',
        left: '50%',
        top: '50%'
      }, _style[__WEBPACK_IMPORTED_MODULE_2_helpers_string__["d" /* transformWithPrefix */]] = 'translate(' + (x - 0.5) * 100 + '%, ' + (y - 0.5) * 100 + '%) ' + (transform.flip ? 'scaleX(-1)' : ''), _style);
    }

    if (backgroundImage) {
      style.backgroundImage = 'url(\'' + src + '\')';
    }

    var date = null;
    if (childBirthday && DateTime) {
      var label = dateFormat ? __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default.a(__WEBPACK_IMPORTED_MODULE_3_helpers_time__["d" /* exifDateToDate */](DateTime), dateFormat) : __WEBPACK_IMPORTED_MODULE_3_helpers_time__["b" /* dateToWords */](childBirthday, DateTime);

      date = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { onClick: this.toggleDate, className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.date, title: !showFullDate ? DateTime : label },
        showFullDate ? DateTime : label
      );
    }

    var count = photo.get('useCount');
    var photoTitle = count > 1 ? kroostApp.strings.usedPhotoMessagePlural.replace('{count}', count) : kroostApp.strings.usedPhotoMessageSingular;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes, style: style, onClick: this.props.callback },
      !backgroundImage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: imageClassName, src: src }) : null,
      date,
      showUseCount && photo.get('useCount', 0) > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.useCount, title: photoTitle },
        photo.get('useCount', 0) > 1 ? count : null
      ) : null
    );
  };

  return Photo;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"photo":"photo_1J2_C","backgroundImage":"backgroundImage_y_frN","date":"date_3rXDS","useCount":"useCount_1oc_N"};

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Profile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_reducers_user__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_scss__);
var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Profile = (_dec = __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](function (state) {
  return {
    profile: state.getIn(['user', 'profile']) || __WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]()
  };
}, {
  logout: __WEBPACK_IMPORTED_MODULE_3_redux_reducers_user__["q" /* logout */]
}), _dec(_class = function (_React$PureComponent) {
  _inherits(Profile, _React$PureComponent);

  function Profile() {
    _classCallCheck(this, Profile);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Profile.prototype.render = function render() {
    var profile = this.props.profile;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.profile },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          'name'
        ),
        ': ',
        profile.get('fullname')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          'email'
        ),
        ': ',
        profile.get('email')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        { onClick: this.props.logout },
        kroostApp.strings.logout2
      )
    );
  };

  return Profile;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class);


/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"profile":"profile_lwmDv"};

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResetPassword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_reducers_user__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_scss__);
var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ResetPassword = (_dec = __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](function (state) {
  return {
    failedPasswordReset: state.getIn(['user', 'failedPasswordReset'], false)
  };
}, {
  resetPassword: __WEBPACK_IMPORTED_MODULE_3_redux_reducers_user__["t" /* resetPassword */]
}), _dec(_class = function (_React$PureComponent) {
  _inherits(ResetPassword, _React$PureComponent);

  function ResetPassword(props, context) {
    _classCallCheck(this, ResetPassword);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props, context));

    _this.resetPassword = function (e) {
      e.preventDefault();
      var password = _this.state.password;
      var _this$props$match$par = _this.props.match.params,
          user_id = _this$props$match$par.user_id,
          token = _this$props$match$par.token;


      _this.props.resetPassword(user_id, token, password);
    };

    _this.onChange = function (e) {
      var _this$setState;

      var input = e.currentTarget;

      _this.setState((_this$setState = {}, _this$setState[input.name] = input.type === 'checkbox' ? input.checked : input.value, _this$setState));
    };

    _this.state = {
      password: null
    };
    return _this;
  }

  ResetPassword.prototype.render = function render() {
    var password = this.state.password;
    var failedPasswordReset = this.props.failedPasswordReset;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_4__styles_scss___default.a.reset },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        { method: 'POST', onSubmit: this.resetPassword },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Input, {
            name: 'password',
            type: 'password',
            label: kroostApp.strings.newPasswordLabel,
            placeholder: kroostApp.strings.newPasswordPlaceholder,
            onChange: this.onChange
          })
        ),
        failedPasswordReset ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Error,
          null,
          kroostApp.strings.formErrorMessage
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["g" /* Button */],
            { type: 'submit', disabled: !password, onClick: this.resetPassword },
            kroostApp.strings.passwordButtonSubmit
          )
        )
      )
    );
  };

  return ResetPassword;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class);


/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"designs":"designs_2-iA7","book":"book_30Stk","active":"active_3hSA8","thumbnail":"thumbnail_37An4","label":"label_2Ydfd"};

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SaveSuccess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__ = __webpack_require__(9);
var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// import styles from './styles.scss';

var SaveSuccess = (_dec = __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](function (state) {
  return {
    sidebar: __WEBPACK_IMPORTED_MODULE_3_redux_selectors_app__["a" /* forcedSidebar */](state)
  };
}, {
  setSidebar: __WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["t" /* setSidebar */]
}), _dec(_class = function (_React$PureComponent) {
  _inherits(SaveSuccess, _React$PureComponent);

  function SaveSuccess() {
    var _temp, _this, _ret;

    _classCallCheck(this, SaveSuccess);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.setSidebar = function (e) {
      var item = e.currentTarget.dataset.sidebar;
      _this.props.setSidebar(item);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  SaveSuccess.prototype.render = function render() {
    var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_components__["g" /* Button */],
      { key: 'werkverder', 'data-sidebar': 'child', cta: true, fullWidth: true, onClick: this.setSidebar },
      kroostApp.strings.enterTheNameOfChildButton
    )];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_components__["O" /* SidebarContent */],
      { title: kroostApp.strings.saveSuccessTitle, actions: actions },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        kroostApp.strings.saveSuccessMessagePart1
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        kroostApp.strings.saveSuccessMessagePart2
      )
    );
  };

  return SaveSuccess;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class);


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SidebarContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_scss__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var SidebarContent = function (_React$PureComponent) {
  _inherits(SidebarContent, _React$PureComponent);

  function SidebarContent() {
    _classCallCheck(this, SidebarContent);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  SidebarContent.prototype.render = function render() {
    var _cx;

    var _props = this.props,
        _props$className = _props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$innerClassName = _props.innerClassName,
        innerClassName = _props$innerClassName === undefined ? '' : _props$innerClassName,
        title = _props.title,
        _props$actions = _props.actions,
        actions = _props$actions === undefined ? null : _props$actions,
        anchorActionsBottom = _props.anchorActionsBottom;


    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.content, className);
    var innerClasses = __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.inner, innerClassName, (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.anchorBottom] = anchorActionsBottom, _cx));

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes },
      title ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.header },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          null,
          title
        )
      ) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: innerClasses },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.children },
          this.props.children
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.actions },
          actions
        )
      )
    );
  };

  return SidebarContent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"content_2cEnC","header":"header_w1gyq","inner":"inner_XCbZm","innerNoPadding":"innerNoPadding_1XB-O","anchorBottom":"anchorBottom_ytQBB","children":"children_2J4R1","actions":"actions_9fd2x"};

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Sidebar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_selectors_stats__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_scss__);
var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ITEMS = null;

var Sidebar = (_dec = __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](function (state) {
  return {
    sidebar: __WEBPACK_IMPORTED_MODULE_2_redux_selectors_app__["a" /* forcedSidebar */](state),
    readyCheck: __WEBPACK_IMPORTED_MODULE_3_redux_selectors_stats__["d" /* readyCheckDone */](state)
  };
}), _dec(_class = function (_React$PureComponent) {
  _inherits(Sidebar, _React$PureComponent);

  function Sidebar(props, context) {
    _classCallCheck(this, Sidebar);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props, context));

    ITEMS = {
      giftcard: __WEBPACK_IMPORTED_MODULE_4_components__["o" /* Giftcard */],
      myOrders: __WEBPACK_IMPORTED_MODULE_4_components__["C" /* MyOrders */],
      login: __WEBPACK_IMPORTED_MODULE_4_components__["s" /* Login */],
      registration: __WEBPACK_IMPORTED_MODULE_4_components__["s" /* Login */],
      profile: __WEBPACK_IMPORTED_MODULE_4_components__["K" /* Profile */],
      design: __WEBPACK_IMPORTED_MODULE_4_components__["i" /* Design */],
      photos: __WEBPACK_IMPORTED_MODULE_4_components__["l" /* FavoritePicker */],
      child: __WEBPACK_IMPORTED_MODULE_4_components__["h" /* Child */],
      order: __WEBPACK_IMPORTED_MODULE_4_components__["F" /* Order */],
      saveSuccess: __WEBPACK_IMPORTED_MODULE_4_components__["M" /* SaveSuccess */]
    };
    return _this;
  }

  Sidebar.prototype.render = function render() {
    var _props = this.props,
        readyCheck = _props.readyCheck,
        sidebar = _props.sidebar;

    var SidebarComponent = ITEMS[sidebar];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.sidebar },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SidebarComponent, { sidebar: sidebar }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components__["E" /* Notifications */], { showReadyToOrder: readyCheck && ['order', 'myOrders'].indexOf(sidebar) === -1 })
    );
  };

  return Sidebar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class);


/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sidebar":"sidebar_3nfAf"};

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_scss__);
var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Slider = (_temp = _class = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props, context) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleNoop = function (e) {
      e.stopPropagation();
      e.preventDefault();
    };

    _this.handleFormat = function (value) {
      var format = _this.props.format;

      return format ? format(value) : value;
    };

    _this.handleUpdate = function () {
      var orientation = _this.props.orientation;

      var dimension = capitalize(constants.orientation[orientation].dimension);
      var sliderPos = _this.slider['offset' + dimension];
      var handlePos = _this.handle['offset' + dimension];

      _this.setState({
        limit: sliderPos - handlePos,
        grab: handlePos / 2
      });
    };

    _this.handleStart = function () {
      document.addEventListener('mousemove', _this.handleDrag);
      document.addEventListener('mouseup', _this.handleEnd);
    };

    _this.handleDrag = function (e) {
      _this.handleNoop(e);
      var onChange = _this.props.onChange;
      var target = e.target;

      if (!onChange) return;

      var value = _this.position(e);
      if (target.classList.contains(__WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.label) && target.dataset.value) {
        value = parseFloat(target.dataset.value);
      }

      onChange && onChange(value, e);
    };

    _this.handleEnd = function (e) {
      var onChangeComplete = _this.props.onChangeComplete;

      onChangeComplete && onChangeComplete(e);
      document.removeEventListener('mousemove', _this.handleDrag);
      document.removeEventListener('mouseup', _this.handleEnd);
    };

    _this.getPositionFromValue = function (value) {
      var limit = _this.state.limit;
      var _this$props = _this.props,
          min = _this$props.min,
          max = _this$props.max;

      var diffMaxMin = max - min;
      var diffValMin = value - min;
      var percentage = diffValMin / diffMaxMin;
      return Math.round(percentage * limit);
    };

    _this.getValueFromPosition = function (pos) {
      var value = null;
      var limit = _this.state.limit;
      var _this$props2 = _this.props,
          orientation = _this$props2.orientation,
          min = _this$props2.min,
          max = _this$props2.max,
          step = _this$props2.step;

      var percentage = clamp(pos, 0, limit) / (limit || 1);
      var baseVal = step * Math.round(percentage * (max - min) / step);

      if (orientation === 'horizontal') {
        value = baseVal + min;
      } else {
        value = max - baseVal;
      }

      if (value >= max) value = max;
      if (value <= min) value = min;

      return value;
    };

    _this.position = function (e) {
      var grab = _this.state.grab;
      var _this$props3 = _this.props,
          orientation = _this$props3.orientation,
          reverse = _this$props3.reverse;


      var node = _this.slider;
      var coordinateStyle = constants.orientation[orientation].coordinate;
      var directionStyle = reverse ? constants.orientation[orientation].reverseDirection : constants.orientation[orientation].direction;
      var clientCoordinateStyle = 'client' + capitalize(coordinateStyle);
      var coordinate = !e.touches ? e[clientCoordinateStyle] : e.touches[0][clientCoordinateStyle];
      var direction = node.getBoundingClientRect()[directionStyle];
      var pos = reverse ? direction - coordinate - grab : coordinate - direction - grab;
      return _this.getValueFromPosition(pos);
    };

    _this.coordinates = function (pos) {
      var fillPos = null;
      var _this$state = _this.state,
          limit = _this$state.limit,
          grab = _this$state.grab;
      var orientation = _this.props.orientation;
      // const dimension = constants.orientation[orientation].dimension

      var value = _this.getValueFromPosition(pos);
      var handlePos = _this.getPositionFromValue(value);
      var sumHandleposGrab = orientation === 'horizontal' ? handlePos + grab : handlePos;

      if (orientation === 'horizontal') {
        fillPos = sumHandleposGrab;
      } else {
        fillPos = limit - sumHandleposGrab;
      }

      // if (this.handle && orientation === 'vertical') {
      //   labelPos = handlePos
      //   labelPos = handlePos - (this.handle.getBoundingClientRect()[dimension] * 0.75)
      // } else {
      //   labelPos = handlePos
      // }

      return {
        fill: fillPos,
        handle: handlePos,
        label: handlePos
      };
    };

    _this.state = {
      limit: 0,
      grab: 0
    };
    return _this;
  }

  Slider.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.handleUpdate);
    this.handleUpdate();
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleUpdate);
  };

  /**
   * Prevent default event and bubbling
   * @param  {Object} e - Event object
   * @return {void}
   */


  /**
   * Format label/tooltip value
   * @param  {Number} - value
   * @return {Formatted Number}
   */


  /**
   * Update slider state on change
   * @return {void}
   */


  /**
   * Attach event listeners to mousemove/mouseup events
   * @return {void}
   */


  /**
   * Handle drag/mousemove event
   * @param  {Object} e - Event object
   * @return {void}
   */


  /**
   * Detach event listeners to mousemove/mouseup events
   * @return {void}
   */


  /**
   * Calculate position of slider based on its value
   * @param  {number} value - Current value of slider
   * @return {position} pos - Calculated position of slider based on value
   */


  /**
   * Translate position of slider to slider value
   * @param  {number} pos - Current position/coordinates of slider
   * @return {number} value - Slider value
   */


  /**
   * Calculate position of slider based on value
   * @param  {Object} e - Event object
   * @return {number} value - Slider value
   */


  /**
   * Grab coordinates of slider
   * @param  {Object} pos - Position object
   * @return {Object} - Slider fill/handle coordinates
   */


  Slider.prototype.render = function render() {
    var _fillStyle,
        _handleStyle,
        _this2 = this,
        _cx;

    var _props = this.props,
        value = _props.value,
        orientation = _props.orientation,
        className = _props.className,
        tooltip = _props.tooltip,
        reverse = _props.reverse;

    var dimension = constants.orientation[orientation].dimension;
    var direction = reverse ? constants.orientation[orientation].reverseDirection : constants.orientation[orientation].direction;
    var position = this.getPositionFromValue(value);
    var coords = this.coordinates(position);
    var fillStyle = (_fillStyle = {}, _fillStyle[dimension] = coords.fill + 'px', _fillStyle);
    var handleStyle = (_handleStyle = {}, _handleStyle[direction] = coords.handle + 'px', _handleStyle);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        ref: function ref(s) {
          _this2.slider = s;
        },
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.slider, __WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a[orientation], (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.reverse] = reverse, _cx), className),
        onMouseDown: this.handleDrag,
        onMouseUp: this.handleEnd,
        onTouchStart: this.handleDrag,
        onTouchEnd: this.handleEnd },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.fill, style: fillStyle }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          ref: function ref(sh) {
            _this2.handle = sh;
          },
          className: __WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.handle,
          onMouseDown: this.handleStart,
          onTouchMove: this.handleDrag,
          onTouchEnd: this.handleEnd,
          style: handleStyle },
        tooltip && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            ref: function ref(c) {
              _this2.tooltip = c;
            },
            className: __WEBPACK_IMPORTED_MODULE_3__styles_scss___default.a.tooltip },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            this.handleFormat(value)
          )
        )
      )
    );
  };

  return Slider;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.PropTypes = {
  min: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  step: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tooltip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  reverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChangeComplete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class.defaultProps = {
  min: 0,
  max: 100,
  step: 1,
  value: 0,
  orientation: 'horizontal',
  tooltip: true,
  reverse: false
}, _temp);

/**
 * Capitalize first letter of string
 * @private
 * @param  {string} - String
 * @return {string} - String with first letter capitalized
 */


function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.substr(1);
}

/**
 * Clamp position between a range
 * @param  {number} - Value to be clamped
 * @param  {number} - Minimum value in range
 * @param  {number} - Maximum value in range
 * @return {number} - Clamped value
 */
function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

var constants = {
  orientation: {
    horizontal: {
      dimension: 'width',
      direction: 'left',
      reverseDirection: 'right',
      coordinate: 'x'
    },
    vertical: {
      dimension: 'height',
      direction: 'top',
      reverseDirection: 'bottom',
      coordinate: 'y'
    }
  }
};

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"slider":"slider_1xVH6","fill":"fill_2MIZI","handle":"handle_269vf","tooltip":"tooltip_3wnYB","vertical":"vertical_2BEZh"};

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Spread; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_selectors_photos__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_selectors_books__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_selectors_design__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_helpers_string__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var Spread = (_dec = __WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](function (state, props) {
  return {
    appWidth: state.getIn(['app', 'dimensions', 'width']),
    appHeight: state.getIn(['app', 'dimensions', 'height']),
    info: __WEBPACK_IMPORTED_MODULE_7_redux_selectors_books__["g" /* getSpreadInfo */](state, props.id),
    design: __WEBPACK_IMPORTED_MODULE_8_redux_selectors_design__["d" /* getSpreadDesign */](state),
    spreadDimensions: __WEBPACK_IMPORTED_MODULE_8_redux_selectors_design__["e" /* getSpreadDimensions */](state),
    pickedMoments: __WEBPACK_IMPORTED_MODULE_6_redux_selectors_photos__["e" /* getPickedMoments */](state),
    previews: state.getIn(['app', 'previews', __WEBPACK_IMPORTED_MODULE_5_redux_selectors_app__["c" /* getActiveOrderId */](state)], __WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]()),
    printType: __WEBPACK_IMPORTED_MODULE_7_redux_selectors_books__["f" /* getPrintType */](state)
  };
}), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
  _inherits(Spread, _React$PureComponent);

  function Spread(props, context) {
    _classCallCheck(this, Spread);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props, context));

    _this.state = {
      wrapper: null,
      scale: 1
    };
    return _this;
  }

  Spread.prototype.componentDidMount = function componentDidMount() {
    var wrapper = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.wrapper);
    this.updateScale(this.props, wrapper);
  };

  Spread.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.spreadDimensions !== this.props.spreadDimensions || nextProps.appWidth !== this.props.appWidth || nextProps.appHeight !== this.props.appHeight) {
      this.updateScale(nextProps);
    }
  };

  Spread.prototype.updateScale = function updateScale() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
    var wrapper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.wrapper;
    var spreadDimensions = props.spreadDimensions;


    var newState = {
      wrapper: wrapper
    };

    // Get dimensions
    var width = wrapper.offsetWidth;
    var height = wrapper.offsetHeight;

    var spreadRatio = spreadDimensions.get('width') / spreadDimensions.get('height');
    var wrapperRatio = width / height;

    // Scale by height
    if (spreadRatio < wrapperRatio) {
      newState.scale = height / spreadDimensions.get('height');
    }
    // Scale by width
    else {
        newState.scale = width / spreadDimensions.get('width');
      }

    if (newState.wrapper !== this.state.wrapper || this.state.scale !== newState.scale) {
      this.setState(newState);
    }
  };

  Spread.prototype.render = function render() {
    var _cx,
        _this2 = this;

    var _props = this.props,
        info = _props.info,
        spreadDimensions = _props.spreadDimensions,
        pickedMoments = _props.pickedMoments,
        previews = _props.previews,
        design = _props.design,
        printType = _props.printType;
    var canEdit = this.context.canEdit;
    var scale = this.state.scale;


    var classes = __WEBPACK_IMPORTED_MODULE_11_classnames___default.a(__WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.wrapper, (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.disableEditing] = !canEdit, _cx));

    var spreadLabel = info && info.get('label');
    var spreadStyle = _extends({
      height: Math.round(spreadDimensions.get('height') * scale) + 'px',
      width: Math.round(spreadDimensions.get('width') * scale) + 'px'
    }, __WEBPACK_IMPORTED_MODULE_10_helpers_string__["c" /* stringToCSSObject */](design.get('css', '')));
    var pageWidth = spreadDimensions.get('width') / 2;

    var moments = info.get('moments', null);
    var designMoments = design.get('moments', null);
    var graphics = design.get('graphics', null);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.spreadWrapper, ref: function ref(c) {
            return _this2.wrapper = c;
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.spread, style: spreadStyle },
          graphics ? graphics.map(function (graphic) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["p" /* Graphic */], { key: graphic.get('id'), scale: scale, graphic: graphic });
          }).toArray() : null,
          moments && designMoments ? moments.map(function (moment) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["x" /* Moment */], {
              key: moment.get('id'),
              index: designMoments.findIndex(function (m) {
                return m.get('id') === moment.get('id');
              }),
              scale: scale,
              info: moment,
              picked: pickedMoments.get(moment.get('id'), __WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]()),
              preview: previews.get(moment.get('id'), __WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]()),
              design: designMoments.find(function (m) {
                return m.get('id') === moment.get('id');
              }),
              pageWidth: pageWidth
            });
          }).toArray() : null,
          printType === 'book' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.fold }) : null
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_12__styles_scss___default.a.label },
        spreadLabel
      ),
      this.props.children
    );
  };

  return Spread;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent), _class2.contextTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
}, _temp)) || _class);


/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper_pUpIs","disableEditing":"disableEditing_15FGa","spreadWrapper":"spreadWrapper_fpv8F","spread":"spread_yzeHB","fold":"fold_1fFVr","label":"label_gZmlY"};

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Widget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_scss__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Widget = function (_React$PureComponent) {
  _inherits(Widget, _React$PureComponent);

  function Widget(props, context) {
    _classCallCheck(this, Widget);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props, context));

    _this.onChange = function (e) {
      var _this$setState;

      var input = e.currentTarget;
      var name = input.name;
      var value = input.value;

      _this.setState((_this$setState = {
        canSubmit: _this.state.birthday && value
      }, _this$setState[name] = value, _this$setState));
    };

    _this.onDateChange = function (date) {
      _this.setState({
        canSubmit: _this.state.name && date,
        birthday: date
      });
    };

    _this.onSubmit = function (e) {
      e.preventDefault();

      var canSubmit = _this.state.canSubmit;


      if (canSubmit) {
        _this.form.submit();
      } else {
        p('cant Submit');
      }
    };

    _this.state = {
      canSubmit: false,
      name: '',
      birthday: ''
    };
    return _this;
  }

  Widget.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        name = _state.name,
        birthday = _state.birthday,
        canSubmit = _state.canSubmit;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.widget },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        { ref: function ref(c) {
            return _this2.form = c;
          }, method: 'GET', onSubmit: this.onSubmit },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["n" /* Form */].Input, {
          name: 'name',
          label: kroostApp.strings.preferdName,
          value: name,
          placeholder: '...',
          onChange: this.onChange
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["n" /* Form */].DatePicker, {
          name: 'birthday',
          label: kroostApp.strings.dateOfBirth,
          value: birthday,
          onChange: this.onDateChange
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_components__["g" /* Button */],
          { onClick: this.onSubmit, disabled: !canSubmit },
          kroostApp.strings.makeYourBook
        )
      )
    );
  };

  return Widget;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Giftcard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_reducers_giftcards__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_scss__);
var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var Giftcard = (_dec = __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](function (state) {
  return {
    checking: state.getIn(['giftcards', 'checking'], false),
    invalid: state.getIn(['giftcards', 'invalid']),
    sidebarParams: state.getIn(['app', 'sidebarParams'])
  };
}, {
  setSidebar: __WEBPACK_IMPORTED_MODULE_3_redux_reducers_app__["t" /* setSidebar */],
  check: __WEBPACK_IMPORTED_MODULE_4_redux_reducers_giftcards__["b" /* check */]
}), _dec(_class = function (_React$PureComponent) {
  _inherits(Giftcard, _React$PureComponent);

  function Giftcard(props, context) {
    _classCallCheck(this, Giftcard);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props, context));

    _this.check = function (e) {
      e.preventDefault();

      var code = _this.state.code;
      var check = _this.props.check;


      check(code);
    };

    _this.onChange = function (e) {
      var _this$setState;

      var input = e.currentTarget;

      _this.setState((_this$setState = {}, _this$setState[input.name] = input.value, _this$setState));
    };

    _this.toLogin = function () {
      _this.props.setSidebar('login');
    };

    _this.state = {
      code: props.sidebarParams.code || null
    };
    return _this;
  }

  Giftcard.prototype.render = function render() {
    var code = this.state.code;
    var _props = this.props,
        invalid = _props.invalid,
        checking = _props.checking;


    var isInvalid = invalid.indexOf(code) > -1;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_components__["O" /* SidebarContent */],
      { title: kroostApp.strings.cachedVoucherTitle },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.notes },
        kroostApp.strings.voucherIntro
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        { method: 'POST', onSubmit: this.check },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Input, {
            name: 'code',
            type: 'text',
            label: kroostApp.strings.personalGiftCodeLabel,
            placeholder: 'xxxx-xxxx-xxxx',
            onChange: this.onChange,
            value: code
          })
        ),
        isInvalid ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Error,
          null,
          kroostApp.strings.voucherInvalid
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
          { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.actions },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["g" /* Button */],
            { cta: true, type: 'submit', className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.submit, disabled: !code || checking, onClick: this.check },
            checking ? kroostApp.strings.checking : kroostApp.strings.cash
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components__["n" /* Form */].Row,
          { className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.actions },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components__["g" /* Button */],
            { secondary: true, className: __WEBPACK_IMPORTED_MODULE_5__styles_scss___default.a.createAccount, onClick: this.toLogin },
            kroostApp.strings.toLogin
          )
        )
      )
    );
  };

  return Giftcard;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class);


/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"actions":"actions_IOcuC"};

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpreadExtraButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_selectors_books__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_selectors_app__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_reducers_orders__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_icons_add__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_icons_remove__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);
var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var SpreadExtraButton = (_dec = __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](function (state, _ref) {
  var id = _ref.id;
  return {
    orderId: __WEBPACK_IMPORTED_MODULE_3_redux_selectors_app__["c" /* getActiveOrderId */](state),
    spreads: __WEBPACK_IMPORTED_MODULE_2_redux_selectors_books__["d" /* getCurrentBookSpreads */](state),
    currentSpread: __WEBPACK_IMPORTED_MODULE_3_redux_selectors_app__["d" /* getActiveSpreadId */](state),
    isExtraSpread: __WEBPACK_IMPORTED_MODULE_2_redux_selectors_books__["i" /* isExtraSpread */](state, id),
    extraSpreadAfterId: __WEBPACK_IMPORTED_MODULE_2_redux_selectors_books__["e" /* getExtraSpreadIdAfter */](state, id)
  };
}, {
  setActiveSpread: __WEBPACK_IMPORTED_MODULE_4_redux_reducers_app__["m" /* setActiveSpread */],
  enableExtraSpread: __WEBPACK_IMPORTED_MODULE_5_redux_reducers_orders__["s" /* enableExtraSpread */],
  disableExtraSpread: __WEBPACK_IMPORTED_MODULE_5_redux_reducers_orders__["r" /* disableExtraSpread */]
}), _dec(_class = function (_React$PureComponent) {
  _inherits(SpreadExtraButton, _React$PureComponent);

  function SpreadExtraButton() {
    var _temp, _this, _ret;

    _classCallCheck(this, SpreadExtraButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.addSpread = function () {
      var _this$props = _this.props,
          orderId = _this$props.orderId,
          enableExtraSpread = _this$props.enableExtraSpread,
          extraSpreadAfterId = _this$props.extraSpreadAfterId,
          setActiveSpread = _this$props.setActiveSpread;


      if (extraSpreadAfterId) {
        enableExtraSpread(orderId, extraSpreadAfterId);
        setActiveSpread(extraSpreadAfterId);
      }
    }, _this.removeSpread = function () {
      var _this$props2 = _this.props,
          orderId = _this$props2.orderId,
          spreads = _this$props2.spreads,
          isExtraSpread = _this$props2.isExtraSpread,
          currentSpread = _this$props2.currentSpread,
          disableExtraSpread = _this$props2.disableExtraSpread,
          setActiveSpread = _this$props2.setActiveSpread;


      if (isExtraSpread) {
        var previousSpread = spreads.get(spreads.findIndex(function (spread) {
          return spread.get('id') === currentSpread;
        }) - 1);
        setActiveSpread(previousSpread.get('id'));
        disableExtraSpread(orderId, currentSpread);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  SpreadExtraButton.prototype.render = function render() {
    var _props = this.props,
        isExtraSpread = _props.isExtraSpread,
        extraSpreadAfterId = _props.extraSpreadAfterId;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.buttons },
      isExtraSpread || extraSpreadAfterId ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        { onClick: this.addSpread, disabled: !extraSpreadAfterId },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.inner },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_icons_add__["a" /* default */], null)
        )
      ) : null,
      isExtraSpread ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        { onClick: this.removeSpread },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_8__styles_scss___default.a.inner },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_icons_remove__["a" /* default */], null)
        )
      ) : null
    );
  };

  return SpreadExtraButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)) || _class);


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Add;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Add(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ preserveAspectRatio: "xMidYMid", viewBox: "0 0 24 24" }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" })
  );
}

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Remove;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Remove(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    _extends({ preserveAspectRatio: "xMidYMid", viewBox: "0 0 24 24" }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M19 13H5v-2h14v2z" })
  );
}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttons":"buttons_3hKWq","inner":"inner_1opeF"};

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__input__ = __webpack_require__(517);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return __WEBPACK_IMPORTED_MODULE_0__input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__select__ = __webpack_require__(518);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Select", function() { return __WEBPACK_IMPORTED_MODULE_1__select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datepicker__ = __webpack_require__(519);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DatePicker", function() { return __WEBPACK_IMPORTED_MODULE_2__datepicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__radio__ = __webpack_require__(520);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Radio", function() { return __WEBPACK_IMPORTED_MODULE_3__radio__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__checkbox__ = __webpack_require__(521);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return __WEBPACK_IMPORTED_MODULE_4__checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__row__ = __webpack_require__(522);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Row", function() { return __WEBPACK_IMPORTED_MODULE_5__row__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error__ = __webpack_require__(523);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Error", function() { return __WEBPACK_IMPORTED_MODULE_6__error__["a"]; });








/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Input; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Input = function (_React$PureComponent) {
  _inherits(Input, _React$PureComponent);

  function Input() {
    _classCallCheck(this, Input);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Input.prototype.render = function render() {
    var _cx;

    var _props = this.props,
        label = _props.label,
        _props$className = _props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$size = _props.size,
        size = _props$size === undefined ? 'full' : _props$size,
        invalid = _props.invalid,
        required = _props.required,
        hide = _props.hide,
        rest = _objectWithoutProperties(_props, ['label', 'className', 'size', 'invalid', 'required', 'hide']);

    var forId = 'input_' + this.props.name;

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(className, __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.input, __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a[size], (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.invalid] = invalid, _cx[__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.hide] = hide, _cx));

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { htmlFor: forId },
        label ? label : '',
        '\xA0',
        required ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'i',
          null,
          '*'
        ) : null
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({ id: forId }, rest))
    );
  };

  return Input;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Select; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Select = function (_React$PureComponent) {
  _inherits(Select, _React$PureComponent);

  function Select() {
    _classCallCheck(this, Select);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Select.prototype.render = function render() {
    var _cx;

    var _props = this.props,
        label = _props.label,
        _props$className = _props.className,
        className = _props$className === undefined ? '' : _props$className,
        options = _props.options,
        _props$size = _props.size,
        size = _props$size === undefined ? 'full' : _props$size,
        placeholder = _props.placeholder,
        invalid = _props.invalid,
        hide = _props.hide,
        required = _props.required,
        rest = _objectWithoutProperties(_props, ['label', 'className', 'options', 'size', 'placeholder', 'invalid', 'hide', 'required']);

    var forId = 'input_' + this.props.name;

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(className, __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.input, __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a[size], (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.invalid] = invalid, _cx[__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.hide] = hide, _cx));

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes },
      label ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { htmlFor: forId },
        label ? label : '',
        '\xA0',
        required ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'i',
          null,
          '*'
        ) : null
      ) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.group, __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.select) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'select',
          _extends({ id: forId }, rest, { className: __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.singleSelect }),
          placeholder ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: '' },
            placeholder
          ) : null,
          options.map(function (option) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'option',
              { key: option.value, value: option.value },
              option.label || option.value
            );
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.arrow },
          '\u25BE'
        )
      )
    );
  };

  return Select;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DatePicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_toDate__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_toDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_toDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_locale_nl__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_locale_nl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_locale_nl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_locale_de__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_locale_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_locale_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_locale_en_US__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_locale_en_US___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_locale_en_US__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_scss__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var DatePicker = function (_React$PureComponent) {
  _inherits(DatePicker, _React$PureComponent);

  function DatePicker() {
    var _temp, _this, _ret;

    _classCallCheck(this, DatePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.onChange = function () {
      var day = parseInt(_this.day.value);
      var result = _this.getDate(_this.year.value, _this.month.value, day > 0 ? day : 1);
      _this.props.onChange(result);
    }, _this.getDate = function (year, month, day) {
      return __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default.a(new Date(year, month, day), 'YYYY-MM-DD');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  DatePicker.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        label = _props.label,
        value = _props.value,
        name = _props.name;

    var p = this.props;
    var thisYear = new Date().getFullYear();
    var parsedDate = __WEBPACK_IMPORTED_MODULE_2_date_fns_toDate___default.a(value);
    var validDate = isFinite(parsedDate);
    var date = validDate ? parsedDate : new Date();
    var setYear = date.getFullYear();
    var setMonth = validDate ? date.getMonth() : 0;
    var setDay = validDate ? date.getDate() : -1;
    var languages = {
      nl: __WEBPACK_IMPORTED_MODULE_4_date_fns_locale_nl___default.a,
      de: __WEBPACK_IMPORTED_MODULE_5_date_fns_locale_de___default.a,
      en: __WEBPACK_IMPORTED_MODULE_6_date_fns_locale_en_US___default.a
    };

    var days = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'option',
      { key: 0, value: -1 },
      '-'
    )];
    for (var day = 1; day <= 31; day++) {
      days.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'option',
        { key: day, value: day },
        day
      ));
    }

    var years = [];
    for (var year = thisYear + 1; year > thisYear - 10; year--) {
      years.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'option',
        { key: year, value: year },
        year
      ));
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.input, p.className, __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.datepicker) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'hidden', name: name, value: this.getDate(setYear, setMonth, setDay) }),
      label ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        null,
        label
      ) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.group },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.select },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'select',
            { ref: function ref(c) {
                return _this2.day = c;
              }, onChange: this.onChange, value: setDay },
            days
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.arrow },
            '\u25BE'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.select },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'select',
            { ref: function ref(c) {
                return _this2.month = c;
              }, onChange: this.onChange, value: setMonth },
            Array.from({ length: 12 }, function (_, i) {
              return __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default.a(new Date(2023, i, 1), 'MMMM', { locale: languages[kroostApp.language] });
            }).map(function (month, i) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { key: i, value: i },
                month
              );
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.arrow },
            '\u25BE'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.select },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'select',
            { ref: function ref(c) {
                return _this2.year = c;
              }, onChange: this.onChange, value: setYear },
            years
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: __WEBPACK_IMPORTED_MODULE_7__styles_scss___default.a.arrow },
            '\u25BE'
          )
        )
      )
    );
  };

  return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Radio; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Radio = function (_React$PureComponent) {
  _inherits(Radio, _React$PureComponent);

  function Radio() {
    _classCallCheck(this, Radio);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Radio.prototype.render = function render() {
    var _cx,
        _this2 = this;

    var _props = this.props,
        _props$size = _props.size,
        size = _props$size === undefined ? 'full' : _props$size,
        invalid = _props.invalid,
        value = _props.value,
        options = _props.options,
        rest = _objectWithoutProperties(_props, ['size', 'invalid', 'value', 'options']);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.radio, __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a[size], (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.invalid] = invalid, _cx));

    var labels = options.map(function (label) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { key: label.value },
        label.label,
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({ type: 'radio', checked: value === label.value, name: _this2.props.name, value: label.value }, rest))
      );
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes },
      labels
    );
  };

  return Radio;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checkbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Checkbox = function (_React$PureComponent) {
  _inherits(Checkbox, _React$PureComponent);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Checkbox.prototype.render = function render() {
    var _cx;

    var _props = this.props,
        className = _props.className,
        name = _props.name,
        _props$size = _props.size,
        size = _props$size === undefined ? 'full' : _props$size,
        invalid = _props.invalid,
        checked = _props.checked,
        value = _props.value,
        label = _props.label,
        rest = _objectWithoutProperties(_props, ['className', 'name', 'size', 'invalid', 'checked', 'value', 'label']);

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(className, __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.checkbox, __WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a[size], (_cx = {}, _cx[__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.invalid] = invalid, _cx));

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { key: label.value },
        label,
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({ type: 'checkbox', checked: checked, name: name, value: value }, rest))
      )
    );
  };

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Row; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_scss__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Row = function (_React$PureComponent) {
  _inherits(Row, _React$PureComponent);

  function Row() {
    _classCallCheck(this, Row);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Row.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_2__styles_scss___default.a.row, this.props.className || '') },
      this.props.children
    );
  };

  return Row;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Error; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_scss__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_scss__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Error = function (_React$PureComponent) {
  _inherits(Error, _React$PureComponent);

  function Error() {
    _classCallCheck(this, Error);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Error.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1__styles_scss___default.a.error },
      this.props.children
    );
  };

  return Error;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);



/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[174]);


// WEBPACK FOOTER //
// main.b687674681945283d8cc.js